{
  "activities": {
    "addTask": "Attività",
    "allPersons": "Tutte le persone",
    "empty": "Nessuna attività",
    "filterByPerson": "Filtra per persona",
    "hideCompleted": "Nascondi completate",
    "open": "aperte",
    "showCompleted": "Mostra {{count}} completate",
    "title": "Attività",
    "viaContact": "tramite {{name}}"
  },
  "addresses": {
    "tabCompanies": "Organizzazioni",
    "tabContacts": "Contatti",
    "title": "Indirizzi"
  },
  "agb": {
    "footer": {
      "address": "Uniplacement GmbH · c/o S&K Partners AG · Samstagernstrasse 55 · 8832 Wollerau · Schweiz",
      "registration": "UID CHE-265.053.706 · Handelsregister Kanton Schwyz"
    },
    "notice": "Fa fede la versione tedesca. Onorari e condizioni sono disciplinati dal vostro contratto individuale.",
    "sections": {
      "account": "§ 3 Konto und Zugang",
      "availability": "§ 10 Verfügbarkeit und Änderungen",
      "circumvention": "§ 12 Umgehungsverbot (Plattformebene)",
      "dataProtection": "§ 8 Datenschutz und KI-Verarbeitung",
      "finalProvisions": "§ 14 Schlussbestimmungen",
      "identification": "§ 7 Identifikation und Sorgfaltspflichten",
      "liability": "§ 11 Haftung",
      "offers": "§ 5 Angebote und Verkaufsverfahren",
      "scope": "§ 1 Geltungsbereich",
      "services": "§ 2 Leistungen der Plattform",
      "signature": "§ 6 Elektronische Signatur",
      "teaserNda": "§ 4 Teaser, NDA und Dossiers",
      "terms": "§ 13 Laufzeit, Sperrung, Änderungen der AGB",
      "usageRights": "§ 9 Nutzungsrechte und Daten"
    },
    "serviceItems": {
      "communication": "Kommunikation zwischen den Beteiligten",
      "contracts": "Generierung und elektronische Signatur von Verträgen",
      "dataRoom": "Datenraum, Dossiers und Dokumentenverwaltung",
      "objectInfo": "Aufbereitung und Bereitstellung von Objektinformationen",
      "offers": "Abgabe und Verwaltung von Angeboten"
    },
    "subtitle": "Plattform-Nutzungsbedingungen der Uniplacement GmbH (Betreiberin der Plattform «Immotron») · Gültig ab 1. Oktober 2026",
    "title": "Condizioni generali (AGB)",
    "version": "Version 1.1 · Gültig ab 1. Oktober 2026"
  },
  "ai": {
    "aiAccuracy": "IA media",
    "cliUnavailable": "CLI non disponibile",
    "confirmed": "Confermato",
    "disabled": "Disattivato",
    "enabled": "Attivo",
    "error": "Si e verificato un errore",
    "fieldsBetter": "campi migliori",
    "images": {
      "loadFailed": "Bild konnte nicht geladen werden",
      "notAvailable": "Bild nicht verfügbar",
      "primaryImage": "Hauptbild",
      "removeImage": "Bild entfernen",
      "selectAll": "Alle",
      "selectLabel": "Auswählen",
      "selectNone": "Keine",
      "selectRelevant": "Relevante",
      "selectedLabel": "Ausgewählt",
      "setAsPrimary": "Als Hauptbild setzen",
      "title": "Bilder"
    },
    "jobs": {
      "active": "Aktiv",
      "addWarning": "Hinweis hinzufügen",
      "archive": "Archivieren",
      "cancelFailed": "Abbrechen fehlgeschlagen",
      "cancelStarted": "Job wird abgebrochen",
      "core": "Pflicht",
      "cost": "Kosten",
      "coverage": "Abdeckung",
      "createProperty": "Objekt erstellen",
      "createPropertyFailed": "Objekt konnte nicht erstellt werden",
      "createPropertyRecovered": "L'oggetto #{{id}} è stato creato (la connessione si è interrotta brevemente)",
      "creating": "Erstellen...",
      "deleteConfirm": "Job endgültig löschen? Dies kann nicht rückgängig gemacht werden.",
      "deleteFailed": "Löschen fehlgeschlagen",
      "dismissFailed": "Konnte nicht abgeschlossen werden",
      "documentCoverage": "Dokumenten-Abdeckung",
      "documentMapping": "Dokumentenzuordnung",
      "documents": "Dokumente",
      "done": "Fertig",
      "duration": "Dauer",
      "error": "Fehler",
      "feedbackResetFailed": "Feedback konnte nicht zurückgesetzt werden",
      "feedbackSendFailed": "Feedback konnte nicht gesendet werden",
      "feedbackSent": "Feedback gesendet",
      "files": "Dateien",
      "goToProperty": "Zum Objekt",
      "helpful": "hilfreich",
      "listRefreshed": "Liste aktualisiert",
      "model": "Modell",
      "noJobsFound": "Keine Jobs gefunden",
      "optional": "Optional",
      "pipeline": {
        "jumpToLatest": "Vai al piu recente",
        "live": "Live",
        "loadFailed": "Impossibile caricare gli eventi",
        "loading": "Caricamento eventi...",
        "logTitle": "Log di elaborazione",
        "noEvents": "Nessun evento finora",
        "stages": {
          "classification": "Classificazione",
          "extraction": "Estrazione",
          "persistence": "Persistenza",
          "upload": "Caricamento",
          "validation": "Validazione"
        },
        "title": "Pipeline IA"
      },
      "processing": "Verarbeitung...",
      "quality": {
        "charsExtracted": "{{formatted}} caratteri estratti",
        "docType": "Tipo",
        "encryptedPdf": "Crittografato",
        "encryptedShort": "crittografati",
        "encryptedWarning": "PDF crittografato — estrazione non possibile. Caricare una versione non protetta.",
        "pages": "{{formatted}} pagine",
        "scanPdf": "PDF scansionato",
        "scanShort": "scansioni",
        "scanWarning": "Documento scansionato — l'estrazione può essere incompleta.",
        "summary": "Riepilogo",
        "textPdf": "PDF testo",
        "title": "Qualità PDF"
      },
      "reactivate": "Reaktivieren",
      "reactivateFailed": "Reaktivierung fehlgeschlagen",
      "recommended": "Empfohlen",
      "refreshFailed": "Aktualisierung fehlgeschlagen",
      "reset": "Zurücksetzen",
      "resetConfirm": "Job zurücksetzen? Das Ergebnis wird gelöscht.",
      "resetFailed": "Zurücksetzen fehlgeschlagen",
      "resetShort": "Reset",
      "retry": "Wiederholen",
      "retryFailed": "Retry fehlgeschlagen — Originaldateien evtl. nicht mehr vorhanden",
      "retryStarted": "Job wird wiederholt",
      "saveFailed": "Speichern fehlgeschlagen",
      "showAll": "Alle Jobs anzeigen",
      "showCompleted": "Auch abgeschlossene anzeigen",
      "startNewUpload": "Neuen Upload starten",
      "statistics": "Statistik",
      "status": {
        "cancelled": "Abgebrochen",
        "pending": "Wartend"
      },
      "timeAgo": {
        "justNow": "gerade eben"
      },
      "title": "KI-Extraktions-Jobs",
      "titleShort": "KI-Jobs",
      "tokens": "Tokens",
      "unhelpful": "nicht hilfreich",
      "warnings": "Hinweise",
      "warningsSaved": "Hinweise gespeichert"
    },
    "learningDescription": "Confronto: estrazione IA vs. fonti statiche (GeoAdmin)",
    "learningHint": "Il sistema impara automaticamente con ogni estrazione confermata.",
    "learningMode": "Modalita apprendimento IA",
    "model": "Modello",
    "noComparisonData": "Nessun dato di confronto disponibile",
    "noComparisonDataHint": "I dati vengono raccolti automaticamente dopo ogni estrazione IA + conferma.",
    "prompt": "Prompt",
    "promptPlaceholder": "Fai una domanda...",
    "response": "Risposta",
    "send": "Invia",
    "sending": "Invio in corso...",
    "staticAccuracy": "Statico media",
    "status": "Stato",
    "subtitle": "Ambiente di test Claude AI",
    "title": "Assistente IA",
    "totalExtractions": "Estrazioni",
    "upload": {
      "addMoreDocs": "Weitere Dokumente ergänzen",
      "addMoreDocsHint": "Fehlende Dokumente hochladen — bestehende Daten werden ergänzt, nicht überschrieben.",
      "addMoreHint": "Weitere Dateien/Ordner oben hinzufügen, dann Analyse starten",
      "backOtherDocs": "Zurück / Andere Dokumente",
      "backToProperties": "Zurück zu Objekte",
      "batchFailed": "fehlgeschlagen",
      "batchObjectsProcessed": "Objekten verarbeitet",
      "batchOf": "von",
      "batchProcessing": "Portfolio-Verarbeitung",
      "batchResult": "Portfolio-Ergebnis",
      "batchSuccessful": "erfolgreich",
      "catCore": "Kern-Dokumente",
      "catOptional": "Optional",
      "catRecommended": "Empfohlen",
      "chooseDirectory": "Verzeichnis wählen",
      "clickToEdit": "Klicken zum Bearbeiten",
      "collapseAll": "Alle zuklappen",
      "confidence": "Confidence",
      "confidenceExplain": "Confidence-Score erklären",
      "confirmCreate": "Erstellen",
      "confirmTitle": "Objekt erstellen?",
      "coreComplete": "Kern komplett",
      "createProperty": "Objekt erstellen",
      "createdSuccess": "Objekt erfolgreich erstellt!",
      "detectedDocTypes": "Erkannte Dokumenttypen",
      "docTypesDetected": "Dokumenttypen erkannt",
      "documentCoverage": "Dokumenten-Abdeckung",
      "documentMapping": "Dokumenten-Zuordnung",
      "documentPlural": "Dokumente",
      "documentSingular": "Dokument",
      "dropzoneHint": "Trascina qui PDF, immagini, Excel o Word oppure scegli una cartella/file",
      "dropzoneTitle": "Objekt-Unterlagen hochladen",
      "editProperty": "Objekt bearbeiten",
      "expandAll": "Alle aufklappen",
      "feedbackFailed": "Feedback konnte nicht gesendet werden",
      "feedbackSent": "Feedback gesendet",
      "filePlural": "Dateien",
      "fileSingular": "Datei",
      "filterAll": "Alle",
      "filterOpen": "Offen",
      "filterRated": "Bewertet",
      "groupingFiles": "Dateien werden gruppiert und hochgeladen",
      "headerAncillary": "NK",
      "headerAreaFrom": "Fläche von",
      "headerAreaSqm": "Fläche m²",
      "headerAreaTo": "Fläche bis",
      "headerFloor": "Etage",
      "headerNetRent": "Nettomiete",
      "headerRented": "Vermietet",
      "headerRooms": "Zimmer",
      "headerRooms2": "Zimmer",
      "headerStatus": "Status",
      "headerTotal": "Total",
      "helpful": "Hilfreich",
      "hints": "Hinweise",
      "individualFiles": "Einzelne Dateien",
      "locationAnalysis": "Standort-Analyse",
      "lowConfidenceWarning": "Niedrige Confidence — manuelle Prüfung der Daten wird empfohlen.",
      "metaCost": "Kosten",
      "metaDuration": "Dauer",
      "metaModel": "Modell",
      "metaTokens": "Tokens",
      "newUpload": "Neuer Upload",
      "noData": "Keine Daten",
      "noPdfInDirectory": "Nessun file PDF trovato nella cartella",
      "noSupportedInDirectory": "Nessun file supportato trovato nella cartella (PDF, immagini, Excel o Word)",
      "noValidFiles": "Nessun file valido selezionato",
      "unsupportedFormat": "Tipo di file non supportato — consentiti: PDF, e-mail (.eml), immagini (JPEG/PNG/WebP/GIF), Excel (.xlsx/.xls) e Word (.docx/.doc)",
      "notHelpful": "Nicht hilfreich",
      "objectCreatedEmail": "Objekt erstellt — E-Mail mit offenen Fragen wurde gesendet",
      "objectUpdatedEmail": "Objekt aktualisiert — E-Mail mit offenen Fragen wurde gesendet",
      "ofDocTypes": "von",
      "openHints": "Offene Hinweise",
      "preparing": "KI-Analyse wird vorbereitet...",
      "processingDirectory": "Verzeichnis wird verarbeitet...",
      "qualityGood": "Gute Datenqualität — bereit zur Bestätigung",
      "qualityLow": "Wenige Daten extrahiert — manuelle Eingabe empfohlen",
      "qualityPartial": "Teilweise Daten extrahiert — bitte prüfen",
      "ready": "bereit",
      "redirecting": "Sie werden zur Bearbeitungsseite weitergeleitet...",
      "removeAll": "Alle entfernen",
      "rentRollStats": "Mieterspiegel-Statistik",
      "retry": "Wiederholen",
      "retryAction": "Erneut versuchen",
      "retryFailed": "Wiederholung konnte nicht gestartet werden",
      "retryNotPossible": "Wiederholung nicht möglich",
      "retryStarted": "Wiederholung gestartet",
      "saveFailed": "Speichern fehlgeschlagen",
      "saving": "Objekt wird gespeichert...",
      "scoreCurrent": "Aktuell",
      "scoreHigh": "Alle wichtigen Felder extrahiert, Daten plausibel.",
      "scoreLow": "Wenige Daten — prüfen oder manuell ergänzen.",
      "scoreMedium": "Einige Felder fehlen oder Unstimmigkeiten.",
      "scoreTitle": "Was bedeutet der Score?",
      "sectionAnalysis": "Immobilienanalyse",
      "sectionFinance": "Finanzen",
      "sectionGeoAdmin": "Behörden-Daten (swisstopo)",
      "sectionImages": "Bilder",
      "sectionInsurance": "Versicherung",
      "sectionParking": "Parkierung",
      "sectionProperty": "Objekt",
      "sectionRentRoll": "Mieterspiegel",
      "sectionUnitMix": "Wohnungsmix",
      "startAnalysis": "KI-Analyse starten",
      "submitting": "Dokumente werden übermittelt...",
      "subtitle": "Laden Sie die relevanten Dateien hoch: Mieterspiegel, Baubeschrieb, Grundbuchauszug, Gebäudeversicherungsnachweis, Marktwertschätzungen — die KI extrahiert automatisch alle Objektdaten.",
      "supplement": "Ergänzen",
      "supplementDocs": "Dokumente ergänzen",
      "title": "KI-Objekterfassung",
      "uploadFailed": "Upload fehlgeschlagen",
      "uploadedFiles": "Hochgeladene Dateien",
      "uploading": "Hochladen...",
      "waitProcessing": "Bitte warten — Upload/Verarbeitung läuft noch.",
      "whatIsWrong": "Was stimmt nicht? (optional)",
      "whyHelpful": "Warum hilfreich? (optional)"
    }
  },
  "aiClauses": {
    "cancel": "Annulla",
    "confirmDelete": "Eliminare?",
    "confirmYes": "Conferma",
    "delete": "Elimina",
    "edit": "Modifica",
    "editClause": "Modifica clausola",
    "generate": "Genera",
    "generateFailed": "Impossibile generare la clausola",
    "generateSuccess": "Clausola generata con successo",
    "generating": "Generazione in corso...",
    "hint": "Il generatore di clausole IA crea clausole personalizzate e le assegna alla sezione contrattuale selezionata. È possibile modificare il testo generato e regolare l'ordine in seguito.",
    "moveDown": "Sposta giù",
    "moveUp": "Sposta su",
    "noClauses": "Nessuna clausola generata",
    "prompt": "Descrivi la clausola",
    "promptPlaceholder": "Descrivi la clausola desiderata, es. 'Diritto di recesso con riserva di finanziamento'",
    "save": "Salva",
    "section": "Sezione",
    "sections": {
      "BROKER_CONDITIONS": "Condizioni speciali mediatore",
      "BUYER_CONDITIONS": "Condizioni speciali acquirente",
      "GENERAL_CONDITIONS": "Condizioni generali",
      "PAYMENT_TERMS": "Condizioni di pagamento",
      "SELLER_CONDITIONS": "Condizioni speciali venditore",
      "TERMINATION": "Condizioni di risoluzione"
    },
    "templates": "Modelli",
    "title": "Generatore di clausole IA"
  },
  "app": {
    "name": "Immotron",
    "tagline": "Piattaforma di Investimento Immobiliare"
  },
  "pwa": {
    "newVersionAvailable": "Nuova versione disponibile",
    "update": "Aggiorna"
  },
  "auth": {
    "errors": {
      "accountInactive": "Il tuo account non è ancora attivato",
      "accountInactiveDescription": "Firma prima il contratto che ti abbiamo inviato via e-mail. Dopo la firma, riceverai un link per impostare la tua password.",
      "accountInactiveTitle": "Account non ancora attivato",
      "invalidCredentials": "Email o password non validi",
      "networkError": "Errore di rete. Riprova.",
      "sessionExpired": "La tua sessione è scaduta"
    },
    "forgotPassword": {
      "backToLogin": "Torna al login",
      "email": "Indirizzo email",
      "networkError": "Errore di connessione. Riprova.",
      "submit": "Invia link",
      "subtitle": "Inserisci il tuo indirizzo email",
      "success": "Se esiste un account, riceverai un'email.",
      "title": "Password dimenticata"
    },
    "login": {
      "email": "Indirizzo email",
      "emailPlaceholder": "tua@email.ch",
      "forgotPassword": "Password dimenticata?",
      "noAccount": "Non hai un account?",
      "password": "Password",
      "passwordError": "Indirizzo email o password non corretti.",
      "passwordPlaceholder": "La tua password",
      "register": "Registrati",
      "rememberMe": "Ricordami",
      "selectCompany": "Seleziona azienda",
      "selectCompanySubtitle": "Scegli l'azienda per cui desideri accedere",
      "submit": "Accedi",
      "subtitle": "Bentornato",
      "title": "Accedi",
      "withPassword": "Accedi con password"
    },
    "logout": "Esci",
    "magicLink": {
      "continueToApp": "Continua alla piattaforma",
      "emailFallbackHint": "Inserisci il tuo indirizzo email affinché possiamo inviarti un nuovo link.",
      "expiredMessage": "Per motivi di sicurezza questo link è valido solo per un tempo limitato.",
      "expiredTitle": "Link di accesso scaduto",
      "networkError": "Errore di connessione. Riprova.",
      "newLinkSent": "Abbiamo inviato un nuovo link di accesso al tuo indirizzo email registrato. Controlla la tua casella di posta.",
      "resend": "Invia di nuovo",
      "sendNewLink": "Invia nuovo link",
      "sentHint": "Nessun link ricevuto? Controlla la cartella spam.",
      "sentMessage": "Abbiamo inviato un link di accesso a {{email}}.",
      "sentTitle": "Link in arrivo!",
      "stillSignedIn": "Hai già effettuato l'accesso.",
      "submit": "Richiedi link di accesso",
      "subtitle": "Ti invieremo un link di accesso al tuo indirizzo email.",
      "switchedUser": "Prima eri connesso come {{from}} — ora sei connesso come {{to}}",
      "title": "Accedi",
      "verifyingSubtitle": "Attenda un momento.",
      "verifyingTitle": "Accesso in corso…",
      "wrongAddress": "Indirizzo errato? Torna all'inserimento"
    },
    "passkey": {
      "cancelled": "Accesso con Passkey annullato.",
      "divider": "o",
      "error": "Accesso con Passkey fallito. Riprova.",
      "login": "Accedi con Passkey",
      "registerSuccess": "Passkey configurato con successo!",
      "setupAction": "Configura ora",
      "setupDialog": {
        "cancelled": "Configurazione del passkey annullata.",
        "created": "Passkey creato. Inserisci un nome del dispositivo se desideri.",
        "description": "Con un passkey puoi accedere rapidamente e in sicurezza tramite impronta digitale, riconoscimento facciale o blocco del dispositivo.",
        "deviceNameHint": "Un nome ti aiuta a identificare questo passkey in seguito.",
        "deviceNameLabel": "Nome del dispositivo (opzionale)",
        "deviceNamePlaceholder": "es. iPhone di Max",
        "error": "Impossibile configurare il passkey. Riprova.",
        "notSupported": "Il tuo browser non supporta i passkey. Usa un browser aggiornato.",
        "register": "Configura Passkey",
        "saveError": "Il passkey è stato creato localmente ma non è stato possibile salvarlo. Riprova.",
        "skipName": "Salta",
        "success": "Passkey configurato con successo!",
        "title": "Configura Passkey"
      },
      "setupDismiss": "Più tardi",
      "setupMessage": "Configura un passkey per un accesso più veloce e sicuro.",
      "setupTitle": "Configura Passkey"
    },
    "passwordSetup": {
      "backToLogin": "Torna al login",
      "confirmPassword": "Conferma password",
      "emailPlaceholder": "Inserire l'indirizzo e-mail",
      "error": "Impossibile salvare la password. Riprovi.",
      "expiredMessage": "Questo link è scaduto. La preghiamo di contattarci per un nuovo link.",
      "expiredMessageNew": "Questo link e scaduto. La preghiamo di richiederne uno nuovo.",
      "expiredTitle": "Link scaduto",
      "invalidMessage": "Questo link non è valido o è già stato utilizzato.",
      "invalidTitle": "Link non valido",
      "magicLinkError": "Il link magico non ha potuto essere inviato.",
      "magicLinkSentHint": "Controlli la Sua casella di posta e clicchi sul link.",
      "magicLinkSentMessage": "Un link di accesso e stato inviato al Suo indirizzo e-mail.",
      "magicLinkSentTitle": "Link inviato",
      "newPassword": "Nuova password",
      "reqDigit": "Una cifra",
      "reqLowercase": "Una lettera minuscola",
      "reqMinLength": "Almeno 8 caratteri",
      "reqUppercase": "Una lettera maiuscola",
      "requestNewLink": "Richiedere un nuovo link",
      "requirementsNotMet": "La password non soddisfa tutti i requisiti",
      "settingUpFor": "Configurazione password per",
      "submit": "Salva password",
      "subtitle": "Crea la tua password per accedere alla piattaforma",
      "successMessage": "La password è stata salvata. Verrai reindirizzato al login.",
      "successTitle": "Password configurata con successo",
      "title": "Configura password",
      "weakPassword": "La password non soddisfa i requisiti."
    },
    "profile": "Profilo",
    "resetPassword": {
      "confirmPassword": "Conferma password",
      "error": "Link non valido o scaduto",
      "newPassword": "Nuova password",
      "submit": "Imposta password",
      "subtitle": "Inserisci la tua nuova password",
      "success": "Password modificata con successo. Verrai reindirizzato al login.",
      "title": "Imposta nuova password"
    },
    "settings": "Impostazioni",
    "twoFactor": {
      "backToLogin": "Torna all'accesso",
      "codeLabel": "Codice di verifica",
      "codeSent": "È stato inviato un nuovo codice",
      "expiredCode": "Il codice è scaduto. Richiedine uno nuovo.",
      "invalidCode": "Codice non valido",
      "maxAttempts": "Troppi tentativi. Effettua nuovamente l'accesso.",
      "resend": "Invia di nuovo il codice",
      "resendCooldown": "Invia di nuovo tra {{seconds}}s",
      "resendSuccess": "Un nuovo codice è stato inviato.",
      "submit": "Verifica",
      "subtitle": "Abbiamo inviato un codice di verifica a {{email}}",
      "title": "Inserisci il codice di verifica",
      "verify": "Verificare",
      "wrongCode": "Il codice inserito non è valido."
    }
  },
  "buyerProfile": {
    "title": "Profilo investitore (IA)",
    "relevance": "Rilevanza",
    "notProfiled": "Non ancora profilata",
    "notProfiledHint": "Per questa organizzazione non è ancora stato creato un profilo investitore.",
    "badgeTooltip": "Rilevanza immobiliare: {{score}}/100",
    "scoreOutOf": "{{score}} su 100",
    "profiledAtValue": "Profilata il {{date}}",
    "openSearchProfile": "Apri il profilo di ricerca",
    "run": "Crea profilo",
    "rerun": "Crea nuovo profilo",
    "runSuccess": "Profilo investitore aggiornato",
    "runError": "Impossibile creare il profilo investitore",
    "groupRun": "Crea profili investitore per il gruppo",
    "batchSummary": "{{profiled}} profilate · {{skipped}} saltate · {{errors}} errori",
    "batchStarted": "{{count}} organizzazioni vengono profilate in background — aggiornare la pagina più tardi",
    "filterLabel": "Filtra per rilevanza investitore",
    "filterAll": "Rilevanza: tutte",
    "filterProfiled": "Solo profilate",
    "filterMin": "Punteggio ≥ {{min}}"
  },
  "campaigns": {
    "blocks": {
      "add": "Aggiungi blocco",
      "fields": {
        "addItem": "Aggiungi elemento",
        "addRow": "Aggiungi riga",
        "alt": "Testo alternativo",
        "body": "Testo",
        "buttonColor": "Colore pulsante",
        "buttonText": "Testo pulsante",
        "buttonUrl": "URL pulsante",
        "caption": "Didascalia",
        "cardColor": "Colore scheda",
        "cardText": "Testo scheda",
        "cardTitle": "Titolo scheda",
        "heading": "Intestazione",
        "imageHeight": "Altezza immagine",
        "imageOpacity": "Opacità immagine",
        "imageUrl": "URL immagine",
        "itemText": "Testo elemento",
        "itemTitle": "Titolo elemento",
        "label": "Etichetta",
        "leftImage": "Immagine sinistra",
        "leftText": "Testo sinistro",
        "list": "Elenco",
        "overlayOpacity": "Oscuramento",
        "rightImage": "Immagine destra",
        "rightText": "Testo destro",
        "subtitle": "Sottotitolo",
        "textAlign": "Allineamento",
        "textOffsetY": "Posizione testo (verticale)",
        "title": "Titolo",
        "value": "Valore"
      },
      "moveDown": "Sposta giù",
      "moveUp": "Sposta su",
      "remove": "Rimuovi blocco",
      "title": "Blocchi di contenuto",
      "types": {
        "contract_details": "Dettagli contratto",
        "cta": "Call-to-Action",
        "divider": "Separatore",
        "expiry_notice": "Avviso di scadenza",
        "feature": "Sezione Feature",
        "hero": "Immagine hero",
        "image": "Immagine",
        "key_value": "Tabella dati",
        "text": "Testo",
        "two_column": "Due colonne"
      }
    },
    "company": "Azienda",
    "confirmDelete": "Vuoi davvero eliminare questa campagna?",
    "confirmDeleteDescription": "E sicuro/a di voler eliminare questa campagna?",
    "createSuccess": "Campagna creata con successo",
    "deleteCampaign": "Elimina campagna",
    "deleteFailed": "La campagna non ha potuto essere eliminata.",
    "deleteSuccess": "Campagna eliminata con successo",
    "editCampaign": "Modifica campagna",
    "errors": {
      "createFailed": "Impossibile creare la campagna",
      "deleteFailed": "Impossibile eliminare la campagna",
      "loadFailed": "Impossibile caricare le campagne",
      "noRecipients": "Nessun destinatario aggiunto",
      "previewFailed": "Impossibile caricare l'anteprima",
      "sendFailed": "Impossibile inviare la campagna",
      "updateFailed": "Impossibile aggiornare la campagna"
    },
    "footer": {
      "address": "Indirizzo",
      "companyName": "Nome azienda",
      "email": "E-mail",
      "phone": "Telefono",
      "title": "Piè di pagina",
      "website": "Sito web"
    },
    "fromEmail": "E-mail del mittente",
    "fromName": "Nome del mittente",
    "header": {
      "backgroundColor": "Colore di sfondo",
      "headerSubtitle": "Slogan / Sottotitolo",
      "headerTitle": "Titolo intestazione",
      "logoUrl": "URL logo",
      "textColor": "Colore del testo",
      "title": "Intestazione"
    },
    "imagePicker": {
      "confirmDelete": "Sei sicuro di voler eliminare questa immagine?",
      "delete": "Elimina immagine",
      "deleteFailed": "L'immagine non ha potuto essere eliminata.",
      "deleteSuccess": "Immagine eliminata",
      "empty": "Nessuna immagine caricata",
      "title": "Scegli immagine",
      "upload": "Carica immagine",
      "uploading": "Caricamento..."
    },
    "list": {
      "empty": {
        "description": "Crea la tua prima campagna e-mail",
        "title": "Nessuna campagna"
      }
    },
    "name": "Nome",
    "newCampaign": "Nuova campagna",
    "noTemplate": "Senza modello",
    "pause": {
      "button": "Pausa",
      "confirm": "Mettere in pausa l'invio? Il destinatario corrente verrà comunque inviato.",
      "failed": "La campagna non ha potuto essere messa in pausa.",
      "success": "La campagna e stata messa in pausa.",
      "title": "Mettere in pausa la campagna"
    },
    "preview": {
      "refresh": "Aggiorna anteprima",
      "title": "Anteprima"
    },
    "recipients": {
      "actions": "Azioni",
      "add": "Aggiungi",
      "added": "{{count}} destinatari aggiunti",
      "clear": "Rimuovi tutti",
      "company": "Azienda",
      "confirmClear": "Vuole rimuovere tutti i destinatari?",
      "confirmDelete": "Rimuovere davvero questo destinatario?",
      "delete": "Rimuovi",
      "deleteFailed": "Il destinatario non ha potuto essere rimosso.",
      "deleteSuccess": "Destinatario rimosso",
      "existingCount": "{{count}} destinatari già aggiunti",
      "filterAll": "Tutti",
      "filterType": "Filtra per tipo",
      "limitReached": "Limite di invio raggiunto ({{sent}}/{{limit}})",
      "mode": "Modalità",
      "modeAll": "Tutti i contatti",
      "modeByCompany": "Per azienda",
      "modeManual": "Selezione manuale",
      "modeUpload": "Importa Excel/CSV",
      "noRecipients": "Nessun destinatario",
      "onlyWithEmail": "Solo con e-mail",
      "previewTitle": "Anteprima destinatari",
      "reset": "Reimpostare",
      "resetConfirm": "Ripristinare lo stato di {{email}}?",
      "resetFailed": "I destinatari non hanno potuto essere reimpostati.",
      "resetStatus": "Ripristina",
      "resetSuccess": "Stato ripristinato",
      "search": "Cerca destinatari...",
      "searchCompanies": "Cerca azienda...",
      "selectCompanies": "Seleziona aziende",
      "selectContacts": "Seleziona contatti",
      "selected": "{{count}} selezionati",
      "send": "Inviare",
      "sendConfirm": "Inviare email a {{email}} adesso?",
      "sendFailed": "La campagna non ha potuto essere inviata.",
      "sendLimit": "Limite di invio",
      "sendLimitHint": "Max. destinatari per invio (vuoto = tutti)",
      "sendSingle": "Invia",
      "sendSuccess": "Email inviata",
      "statusTitle": "Stato destinatari",
      "syncStatus": "Sincronizza",
      "title": "Destinatari",
      "total": "{{count}} destinatari totali",
      "uploadBtn": "Carica file",
      "uploadErrors": "errori",
      "uploadHint": "Carica un file Excel (.xlsx) o CSV con indirizzi e-mail",
      "uploadResult": "{{added}} aggiunti, {{skipped}} ignorati ({{total}} totale)",
      "viewAll": "Mostra tutti i {{count}} destinatari"
    },
    "replyTo": "Indirizzo di risposta",
    "resume": {
      "button": "Riprendi",
      "confirm": "Riprendere l'invio a {{count}} destinatari rimanenti?",
      "failed": "La campagna non ha potuto essere ripresa.",
      "success": "La campagna e stata ripresa.",
      "title": "Riprendere la campagna"
    },
    "selectTemplate": "Scegli modello",
    "send": {
      "confirmSend": "Inviare la campagna a {{count}} destinatari adesso?",
      "paused": "In pausa",
      "progress": "Progresso: {{sent}} di {{total}}",
      "rateHint": "5-120 e-mail al minuto (predefinito: 30)",
      "rateLabel": "Velocità di invio",
      "send": "Inviare la campagna",
      "sendNow": "Invia ora",
      "sending": "Invio in corso...",
      "testEmail": "Indirizzo e-mail di test",
      "testSend": "Invia e-mail di test",
      "title": "Invia"
    },
    "sendLimit": {
      "saveFailed": "Il limite di invio non ha potuto essere salvato.",
      "saved": "Limite di invio salvato."
    },
    "sendLimitSaved": "Limite di invio salvato.",
    "sendSuccess": "La campagna è in fase di invio",
    "stats": {
      "bounced": "Rimbalzati",
      "clicked": "Cliccati",
      "delivered": "Consegnati",
      "failed": "Falliti",
      "opened": "Aperti",
      "recipients": "Destinatari",
      "sent": "Inviati"
    },
    "statuses": {
      "CANCELLED": "Annullata",
      "DRAFT": "Bozza",
      "PARTIALLY_SENT": "Parzialmente inviata",
      "PAUSED": "In pausa",
      "SENDING": "In invio",
      "SENT": "Inviata"
    },
    "subject": "Oggetto",
    "subtitle": "Gestisci e invia campagne e-mail",
    "syncStatus": "Aggiorna stato",
    "template": "Modello",
    "testSendSuccess": "E-mail di prova inviata a {{email}}",
    "title": "Campagne",
    "updateSuccess": "Campagna aggiornata con successo"
  },
  "ceoAgent": {
    "batch": {
      "description": "Elabora più attività aperte con l'IA in una volta.",
      "run": "Elabora 5 attività",
      "title": "Elaborazione batch"
    },
    "results": {
      "title": "Risultati"
    },
    "status": {
      "available": "IA disponibile",
      "openTasks": "Attività aperte",
      "pendingAI": "In attesa dell'IA",
      "processedToday": "Elaborate oggi"
    },
    "subtitle": "Assistente IA autonomo per le attività",
    "suggestions": {
      "empty": "Nessun suggerimento — tutto fatto!",
      "process": "Elabora",
      "title": "Suggerimenti"
    },
    "title": "Assistente attività"
  },
  "ceoComposer": {
    "refine": {
      "label": "Cosa devo modificare?",
      "placeholder": "es. rimuovere le proposte di appuntamento/telefono, chiedere una risposta scritta",
      "apply": "Modifica",
      "regenerate": "Rigenera",
      "regenerateHint": "Genera di nuovo l'e-mail — include le note bloccate",
      "hint": "Il testo di base viene mantenuto — viene applicata solo la modifica richiesta. La versione precedente resta nella cronologia."
    },
    "emptyState": {
      "contextAnchor": "Conosco questa pendenza:",
      "loading": "Caricamento dei suggerimenti …",
      "quickStartHeading": "Inizia subito",
      "linkCardTitle": "Collega un contatto, un'azienda o un oggetto",
      "linkCardDesc": "Collega un'entità affinché l'assistente possa fornire suggerimenti mirati ed eseguibili.",
      "linkContact": "Collega contatto",
      "linkCompany": "Collega azienda",
      "linkProperty": "Collega oggetto",
      "inlineEmpty": "Al momento nessun suggerimento concreto disponibile."
    },
    "suggestions": {
      "button": "Suggerimenti"
    },
    "selection": {
      "asPostit": "📌 Come post-it",
      "created": "Salvato come post-it",
      "error": "Impossibile salvare il post-it"
    },
    "investorMatch": {
      "manualButton": "Individua acquirenti IA",
      "title": "Individuazione acquirenti IA",
      "hint": "Trova gli acquirenti adatti dal CRM — prefiltro strutturato e valutazione IA.",
      "run": "Individua acquirenti IA",
      "rerun": "Ricalcola",
      "confirmAction": "Conferma ed esegui",
      "linkProperty": "Collega un oggetto",
      "loading": "Individuazione acquirenti …",
      "loadFailed": "Individuazione non riuscita.",
      "retry": "Riprova",
      "empty": "Nessun acquirente corrispondente trovato.",
      "close": "Chiudi",
      "selectPropertyHint": "Questa attività non è collegata a nessun oggetto. Scegli un oggetto per l'individuazione degli acquirenti.",
      "searchPlaceholder": "Cerca immobile…",
      "change": "Modifica",
      "candidateCount": "{{count}} candidati",
      "aiUsed": "Valutato da IA",
      "aiNotUsed": "Solo prefiltro",
      "fitScore": "Punteggio di idoneità: {{score}}%",
      "showReasoning": "Mostra motivazione",
      "hideReasoning": "Nascondi motivazione",
      "prefilterOnly": "Punteggio di prefiltro (senza valutazione IA)",
      "rankedHint": "Migliore corrispondenza per prima — punteggio come nel Quality Gate.",
      "entityCompany": "Azienda",
      "entityContact": "Persona",
      "recommendation": {
        "strong": "Corrispondenza forte",
        "possible": "Corrispondenza possibile",
        "weak": "Corrispondenza debole",
        "none": "Nessuna corrispondenza"
      },
      "rankLabel": "Posizione {{rank}}"
    },
    "trace": {
      "title": "Cosa ha fatto l'assistente",
      "sectionLink": "Collegamento",
      "sectionSearch": "Ricerca semantica",
      "sectionSources": "Fonti utilizzate",
      "sectionPortfolio": "Contesto portafoglio",
      "linkContact": "Contatto",
      "linkCompany": "Azienda",
      "linkProperty": "Immobile",
      "noLink": "nessun collegamento",
      "searchHits": "Ricerca {{count}} risultati",
      "searchUsed": "{{count}} utilizzati",
      "searchNotRun": "Ricerca non eseguita",
      "query": "Query",
      "relevance": "Rilevanza {{pct}}%",
      "sourcesUsed": "{{count}} fonte/i utilizzata/e",
      "noCrmContext": "nessun contesto CRM",
      "portfolioIncluded": "Dati del portafoglio inclusi",
      "portfolioRequested": "Portafoglio richiesto ma non incluso",
      "showWeakHits_one": "Mostra {{count}} altro risultato",
      "showWeakHits_other": "Mostra {{count}} altri risultati",
      "hideWeakHits": "Nascondi gli altri risultati"
    },
    "aiUnavailable": "L'IA non è configurata. Aggiungi la chiave API in Admin > Sistema.",
    "assignedTo": "Assegnato a",
    "attachments": {
      "add": "Aggiungi allegato",
      "contextCount": "{{count}}/{{total}} nel contesto",
      "deleted": "Allegato eliminato",
      "excludedFromContext": "Non nel contesto",
      "fileTooLarge": "File troppo grande: {{name}}",
      "inContext": "Nel contesto",
      "uploadError": "Impossibile caricare l'allegato",
      "uploaded": "Allegato caricato"
    },
    "backToTasks": "Torna alle attività",
    "bccPlaceholder": "bcc@example.com",
    "ccPlaceholder": "cc1@example.com, cc2@example.com",
    "chatReset": "Chatverlauf zurückgesetzt",
    "chatResetError": "Chatverlauf konnte nicht zurückgesetzt werden",
    "chips": {
      "email": "Componi e-mail",
      "followup": "Follow-up",
      "noContact": "Nessun contatto collegato. Assegna prima un contatto.",
      "noEmail": "Il contatto non ha un indirizzo e-mail registrato.",
      "research": "Ricerca contatto",
      "summary": "Riepilogo",
      "companyResearch": "Firma recherchieren"
    },
    "chunks": {
      "title": "Note",
      "save": "Salva come nota",
      "alreadySaved": "Già salvata come nota",
      "saved": "Nota salvata",
      "saveError": "Impossibile salvare la nota",
      "delete": "Elimina nota",
      "deleted": "Nota eliminata",
      "deleteError": "Impossibile eliminare la nota",
      "deleteConfirm": "Eliminare davvero questa nota?",
      "empty": "Nessuna nota — fissa le risposte della chat per salvare conoscenze",
      "sourceCompany": "Azienda",
      "sourcePerson": "Persona",
      "sourceManual": "Manuale",
      "sourceUserNote": "Nota",
      "sourceEmailContext": "E-mail",
      "sourceAi": "IA",
      "sourceChat": "Chat",
      "emailNoSubject": "(Senza oggetto)",
      "emailFrom": "Da:",
      "emailTo": "A:",
      "emailCc": "CC:",
      "emailExpand": "Espandi e-mail",
      "emailCollapse": "Comprimi e-mail",
      "addNote": "Aggiungi nota",
      "edit": "Modifica nota",
      "expand": "Mostra di più",
      "collapse": "Mostra meno",
      "detach": "Rimuovi collegamento",
      "notePlaceholder": "Nota per il contesto IA (es. «niente videocall», «tono formale») — Invio per salvare, Maiusc+Invio per andare a capo",
      "noteHint": "Considerata automaticamente nel contesto IA",
      "noteAdded": "Nota salvata",
      "noteAddError": "Impossibile salvare la nota",
      "pinFromChat": "Salva come nota",
      "pinnedFromChat": "Salvata come nota",
      "pinnedFromChatBadge": "Già salvata come nota",
      "pinFromChatError": "Impossibile salvare la nota",
      "researchSaved": "{{count}} note di ricerca create",
      "researchSavedRaw": "Ricerca salvata come nota",
      "researchSaveError": "Impossibile salvare le note di ricerca",
      "sourceAiResponse": "Risposta chat",
      "sourceStrategyCards": "Strategia",
      "sourceChatCard": "Carta chat",
      "sourceContract": "Contratto",
      "sourceAppKnowledge": "Conoscenze dell'app",
      "sourceCrmProfile": "Profilo CRM",
      "sourceDocument": "Documento",
      "sourceResearchQuestion": "Domanda di ricerca",
      "sourceEmailSent": "Email inviata",
      "sourceOfficialData": "Dati ufficiali",
      "noteUpdated": "Nota aggiornata",
      "noteUpdateError": "Impossibile aggiornare la nota",
      "emptyWithNotes": "Nessuna nota — scrivi una nota sopra o fissa le risposte della chat",
      "scopeLocal": "Locale (solo questa pendenza)",
      "scopeLocalBadge": "Solo qui",
      "scopeAtProperty": "Sull'immobile #{{id}}",
      "scopeAtPropertyLabel": "Sull'immobile: {{label}}",
      "scopeAtContact": "Sul contatto: {{name}}",
      "scopeAtContactId": "Sul contatto #{{id}}",
      "scopeAtCompany": "Sull'organizzazione: {{name}}",
      "scopeAtCompanyId": "Sull'organizzazione #{{id}}",
      "pin": "Contrassegna come rilevante",
      "unpin": "Rimuovi il segnaposto",
      "pinned": "Nota fissata",
      "unpinned": "Segnaposto rimosso",
      "pinError": "Impossibile fissare la nota",
      "pinnedSection": "Fissati ({{count}})",
      "historyShow": "Mostra cronologia ({{count}})",
      "historyHide": "Nascondi cronologia",
      "historyBadge": "Cronologia",
      "historyBadgeHint": "Salvato automaticamente dalla chat — non fissato come nota",
      "pinToCompany": "Fissa all'azienda",
      "pinToCompanyNamed": "Fissa all'azienda «{{name}}»",
      "pinToCompanyShort": "All'azienda",
      "pinToContact": "Fissa al contatto",
      "pinToContactNamed": "Fissa al contatto «{{name}}»",
      "pinToContactShort": "Al contatto",
      "pinToProperty": "Fissa all'immobile",
      "pinToPropertyNamed": "Fissa all'immobile «{{label}}»",
      "pinToPropertyShort": "All'immobile",
      "createContact": "Crea contatto nel CRM",
      "createContactShort": "Contatto",
      "createCompany": "Crea organizzazione nel CRM",
      "createCompanyShort": "Organizzazione",
      "createSubtask": "Crea sotto-attività",
      "attachToExisting": "Allega a una voce esistente",
      "attachShort": "Allega",
      "dragHandle": "Sposta nota",
      "dragHint": "Trascina e rilascia le note nell'area di destinazione — l'ordine determina il layout dell'e-mail",
      "pinnedEmptyDropHint": "Trascina le note qui per definire l'ordine dell'e-mail",
      "reorderSaved": "Ordine salvato",
      "reorderError": "Impossibile salvare l'ordine",
      "a11yDragStart": "La nota {{id}} è in fase di trascinamento",
      "a11yDragOverPinned": "Nota {{id}} sopra l'area di destinazione",
      "a11yDragOverUnpinned": "Nota {{id}} sopra l'area di ricerca",
      "a11yDragEndPinned": "Nota {{id}} rilasciata nell'area di destinazione",
      "a11yDragEndUnpinned": "Nota {{id}} rimossa dall'area di destinazione",
      "a11yDragCancel": "Spostamento annullato",
      "pinnedToMain": "Aggiunto alla pendenza principale",
      "convertedToSubtask": "→ Sotto-pendenza #{{id}}",
      "convertedToSubtaskHint": "Vai alla sotto-pendenza"
    },
    "clearContext": "Kontext-Auswahl leeren",
    "contextIncluded": "Pendenzen als Kontext",
    "contextView": {
      "agentPreview": "Was der CEO-Agent sieht",
      "ancestors": "Pfad im Baum",
      "inherited": "Vererbter Kontext",
      "own": "Eigener Kontext",
      "placeholder": "Kontext für diese Pendenz definieren...\\n\\nz.B. Warum existiert diese Aufgabe? Welche Informationen soll der CEO-Agent berücksichtigen?",
      "treeSelector": "Kontext-Auswahl im Baum"
    },
    "createdBy": "Creato da",
    "creating": "Creazione...",
    "edit": "Modifica",
    "emailPreview": "Anteprima e-mail",
    "emailSettings": {
      "title": "Impostazioni e-mail",
      "options": "Opzioni",
      "tone": "Tono",
      "length": "Lunghezza",
      "purpose": "Scopo",
      "language": "Lingua",
      "contextHint": "Contesto: {{docs}} documento/i, {{nodes}} attività selezionata/e. Controllabile tramite la selezione degli allegati e del contesto.",
      "brief": "Incarico",
      "briefPlaceholder": "Cosa deve ottenere l'e-mail? (lasciare vuoto per solo contesto)",
      "recipient": "Destinatario",
      "noRecipient": "Nessun contatto collegato",
      "emailsInHistory": "{{count}} e-mail nella cronologia",
      "autoContext": {
        "pinnedKnowledge": "{{count}} note fissate"
      },
      "create": "Crea e-mail",
      "fromContext": "Crea e-mail da obiettivo e contesto",
      "tones": {
        "visionary": "Visionario",
        "pragmatic": "Pragmatico",
        "formal": "Formale"
      },
      "lengths": {
        "short": "Breve",
        "medium": "Media",
        "detailed": "Dettagliata"
      },
      "purposes": {
        "first_contact": "Primo contatto",
        "follow_up": "Follow-up",
        "offer": "Offerta",
        "forward": "Inoltro"
      },
      "languages": {
        "de": "Tedesco",
        "en": "Inglese",
        "fr": "Francese",
        "it": "Italiano"
      }
    },
    "error": "Errore durante l'elaborazione. Riprova.",
    "errorInvalidInput": "Input non valido — riprova.",
    "findings": "Erkenntnisse",
    "from": "Da",
    "fromCompany": "Azienda",
    "fromDefault": "Predefinito",
    "fromPrivate": "Privato",
    "hierarchy": "Hierarchie",
    "hint": "Scrivi liberamente — l'agente aiuta con e-mail, ricerche, follow-up e altro.",
    "noEmail": "Nessuna e-mail generata. Chiedi all'agente di comporre un'e-mail.",
    "noResearch": "Nessun risultato di ricerca. Chiedi all'agente di ricercare un contatto o un'azienda.",
    "panel": {
      "actionPreview": "Aktions-Vorschau",
      "companyResearch": "Ricerca IA",
      "contextView": "Kontext",
      "details": "Details",
      "email": "Anteprima e-mail",
      "findings": "Erkenntnisse",
      "overview": "Übersicht",
      "research": "Ricerca",
      "subtasks": "Sotto-attività",
      "treeDetail": "Baum-Navigation",
      "workflow": "Workflow",
      "contactOrg": "Contatto/Azienda"
    },
    "panels": {
      "companyResearch": "KI Recherche",
      "details": "Details",
      "email": "E-Mail",
      "overview": "Übersicht",
      "research": "Recherche"
    },
    "participantHint": "Partecipanti disponibili come suggerimenti — digita nel campo CC",
    "pinError": "Pin konnte nicht gesetzt werden",
    "pinRemoved": "Pin entfernt",
    "pinSaved": "Erkenntnis gespeichert",
    "placeholder": "Inserisci messaggio...",
    "preview": "Anteprima",
    "removePin": "Pin entfernen",
    "researchPanel": {
      "keyPersons": "Schlüsselpersonen (aus Recherche)"
    },
    "richMarkdown": {
      "miniCardsLabel": "Dati strutturati",
      "nextStepsTitle": "Prossimi passi"
    },
    "saveInsight": "Als Erkenntnis speichern",
    "send": "Invia",
    "sendError": "Impossibile inviare l'e-mail.",
    "sendNow": "Invia ora",
    "sending": "Invio in corso...",
    "sent": "Inviato",
    "skills": {
      "actionError": "Aktion konnte nicht ausgeführt werden",
      "addNote": "Notiz erstellen",
      "companyUpdated": "Firmendaten aktualisiert",
      "contactUpdated": "Kontaktdaten aktualisiert",
      "createSubtask": "Sub-Pendenz erstellen",
      "enrichCompany": "Firma anreichern",
      "enrichContact": "Kontakt anreichern",
      "noteSaved": "Notiz gespeichert",
      "subtaskCreated": "Sub-Pendenz erstellt"
    },
    "skillChips": {
      "ariaLabel": "Competenza per il prossimo messaggio",
      "modeHint": "Modalità: {{mode}}",
      "research": "Ricerca",
      "email": "E-mail",
      "companyResearch": "Ricerca azienda",
      "personResearch": "Ricerca persona",
      "textGenerate": "Genera testo",
      "contextResearch": "Ricerca contesto",
      "emailDraft": "Scrivi e-mail",
      "noteCreate": "Crea nota",
      "subtask": "Sotto-attività",
      "summarize": "Riassumi",
      "matchInvestors": "Acquirenti IA"
    },
    "researchType": {
      "label": "Tipo di ricerca",
      "auto": "rilevato automaticamente",
      "autoReset": "Rilevamento automatico",
      "menuAria": "Scegli il tipo di ricerca",
      "deepRunning": "Ricerca approfondita in corso …",
      "types": {
        "firmen_profil": "Azienda",
        "person": "Persona",
        "produkt_api": "Prodotto/API",
        "preise": "Prezzi",
        "markt": "Mercato"
      }
    },
    "strategyPostIts": {
      "title": "Proposte — come note",
      "subtitle": "Appuntare, creare una sotto-attività o collegare a contatto / azienda / immobile.",
      "types": {
        "research": "Ricerca",
        "email": "E-mail",
        "note": "Nota",
        "subtask": "Sotto-attività"
      },
      "actions": {
        "pin": "Appunta a obiettivo/contesto",
        "subtask": "Crea sotto-attività",
        "attach": "Collega a contatto / azienda / immobile",
        "attachShort": "Collega a…"
      },
      "pinned": "Proposta appuntata come nota",
      "pinError": "Impossibile appuntare la proposta",
      "subtaskCreated": "Sotto-attività creata",
      "subtaskError": "Impossibile creare la sotto-attività",
      "attachError": "Collegamento non riuscito"
    },
    "postItCard": {
      "kinds": {
        "advice": "Raccomandazione",
        "strategy": "Strategia",
        "research": "Ricerca",
        "fact": "Fatto",
        "action": "Azione"
      },
      "handled": "Fatto",
      "attachedTo": "📎 fissato a {{label}}",
      "actions": {
        "pin": "Appunta",
        "subtask": "Sotto-attività",
        "attach": "Collega a…"
      },
      "notFound": "Nota non trovata",
      "pinned": "Appuntata come nota",
      "pinError": "Impossibile appuntare la carta",
      "subtaskCreated": "Sotto-attività creata",
      "subtaskError": "Impossibile creare la sotto-attività",
      "attachError": "Collegamento non riuscito"
    },
    "statusChangeError": "Status konnte nicht geändert werden",
    "subject": "Oggetto",
    "subjectPlaceholder": "E-Mail-Betreff",
    "taskNotFound": "Attività non trovata",
    "template": "Modello",
    "progress": {
      "queued": "Preparazione …",
      "elapsed": "{{seconds}} s",
      "longRunning": "È in corso una ricerca approfondita – il risultato apparirà automaticamente. Puoi annullare in qualsiasi momento."
    },
    "thinking": "Sto pensando...",
    "to": "A",
    "treeNav": {
      "addToContext": "Zum Kontext hinzufügen",
      "contextSelected": "im Kontext ausgewählt",
      "hint": "Klick = Details, Doppelklick = Öffnen",
      "navigateTo": "Zur Pendenz navigieren",
      "noHierarchy": "Keine Hierarchie verfügbar",
      "openTask": "Pendenz öffnen",
      "removeFromContext": "Aus Kontext entfernen",
      "selectHint": "Klicke auf einen Eintrag im Baum, um die Details zu sehen.",
      "title": "Pendenzen-Baum"
    },
    "ttsError": "Lettura ad alta voce non riuscita.",
    "ttsPlay": "Leggi la risposta ad alta voce",
    "ttsStop": "Interrompi lettura",
    "voiceDenied": "Accesso al microfono negato. Consentirlo nelle impostazioni del browser.",
    "voiceError": "Errore nel riconoscimento vocale.",
    "voiceMaxDurationHint": "Max. {{minutes}} min",
    "voiceMicError": "Impossibile attivare il microfono.",
    "voiceNoSpeech": "Nessuna voce rilevata. Riprova.",
    "voiceNotSupported": "L'input vocale non è supportato in questo browser. Utilizzare Chrome o Edge.",
    "voiceStart": "Avvia input vocale",
    "voiceStop": "Interrompi registrazione",
    "voiceTimeout": "Registrazione troppo lunga – la trascrizione è scaduta. Effettua registrazioni più brevi.",
    "voiceTooLong": "Registrazione troppo lunga (max. 25 MB / ~25 min). Effettua registrazioni più brevi.",
    "voiceTranscribing": "Trascrizione in corso...",
    "voiceTranscribingShort": "Trascrizione…",
    "welcome": "Cosa vorresti fare con questa attività?",
    "workflow": {
      "advanceError": "Workflow-Schritt konnte nicht fortgesetzt werden",
      "completed": "Workflow abgeschlossen!",
      "startError": "Workflow konnte nicht gestartet werden"
    },
    "pinTarget": {
      "title": "Dove fissare?",
      "description": "Ti trovi in una sotto-pendenza. Scegli in quale pendenza deve apparire la nota.",
      "sub": "A questa sotto-pendenza",
      "main": "Alla pendenza principale",
      "mainFallback": "Pendenza principale"
    },
    "company": "Azienda",
    "contact": "Contatto",
    "property": "Immobile",
    "noContactLinked": "Nessun contatto o azienda collegato.",
    "demoMessage": {
      "label": "Messaggio dell'interessato"
    }
  },
  "changelog": {
    "title": "Novità",
    "typeFixed": "Corretto",
    "typeImproved": "Migliorato",
    "typeNew": "Nuovo"
  },
  "chunkAttach": {
    "attachAction": "Collega a un'entità",
    "attachError": "Impossibile collegare la nota",
    "attached": "Nota collegata",
    "badgeCompany": "Organizzazione",
    "badgeContact": "Contatto",
    "badgeProperty": "Immobile",
    "badgeTask": "Attività",
    "detachConfirm": "Rimuovere davvero il collegamento?",
    "detachError": "Impossibile rimuovere il collegamento",
    "detachHint": "Clicca per rimuovere",
    "detached": "Collegamento rimosso",
    "minChars": "Inserisci almeno 2 caratteri",
    "noResults": "Nessun risultato trovato",
    "searchCompany": "Cerca organizzazione...",
    "searchContact": "Cerca contatto...",
    "searchProperty": "Cerca immobile...",
    "startTyping": "Inizia a digitare per cercare.",
    "subtitle": "A quale entità deve essere collegata la nota?",
    "tabCompany": "Organizzazione",
    "tabContact": "Contatto",
    "tabProperty": "Immobile",
    "tabsAriaLabel": "Seleziona il tipo di entità",
    "title": "Collega nota"
  },
  "createFromChunk": {
    "headerContact": "Crea contatto nel CRM",
    "headerCompany": "Crea organizzazione nel CRM",
    "subtitle": "Da questa nota",
    "chunkSource": "Nota",
    "parsing": "Analisi della nota...",
    "parseError": "Impossibile analizzare la nota.",
    "parseFailed": "Analisi fallita",
    "parsedContact": "Contatto rilevato",
    "parsedCompany": "Organizzazione rilevata",
    "unnamed": "Senza nome",
    "possibleDuplicates": "Possibili duplicati ({{count}})",
    "duplicateHint": "Esistono già voci con questo nome. Scegli un'azione:",
    "actionMerge": "Unisci",
    "actionAttach": "Allega come nota",
    "actionCreateContact": "Crea contatto",
    "actionCreateCompany": "Crea organizzazione",
    "actionCreateAnyway": "Crea comunque",
    "created": "Nuova voce creata.",
    "createdToast": "Voce creata",
    "createError": "Impossibile creare la voce",
    "merged": "La voce è stata aggiornata con nuove informazioni.",
    "mergedToast": "Voce arricchita",
    "mergeError": "Arricchimento fallito",
    "attached": "La nota è stata allegata.",
    "attachedToast": "Allegato come nota",
    "attachError": "Allegato fallito",
    "success": "Fatto!"
  },
  "commissions": {
    "chart": {
      "atPrice": "a",
      "commission": "Onorario",
      "rate": "Aliquota eff.",
      "title": "Curva onorari"
    },
    "default": "Predefinito",
    "loading": "Caricamento modelli di onorario...",
    "settings": {
      "addBracket": "Aggiungi scaglione",
      "bracketFrom": "Da",
      "bracketRate": "Aliquota",
      "bracketTo": "A",
      "brackets": "scaglioni",
      "bracketsHint": "Il primo scaglione inizia sempre a CHF 0. Ogni aliquota si applica solo all'importo compreso nel suo scaglione.",
      "bracketsLabel": "Scaglioni marginali",
      "createNew": "Nuovo modello",
      "createSuccess": "Modello di onorario creato con successo",
      "createTitle": "Crea modello di onorario",
      "default": "Predefinito",
      "defaultBadge": "Predefinito",
      "deleteConfirm": "Vuoi davvero eliminare il modello «{{name}}»? Questa azione non può essere annullata.",
      "deleteError": "Errore durante l'eliminazione",
      "deleteSuccess": "Modello di onorario eliminato con successo",
      "deleteTitle": "Elimina modello di onorario",
      "editTitle": "Modifica modello di onorario",
      "flatRate": "Aliquota fissa",
      "namePlaceholder": "es. Modello marginale standard",
      "noModels": "Nessun modello di onorario trovato",
      "rate": "Aliquota / Scaglioni",
      "saveError": "Errore durante il salvataggio",
      "setActive": "Attivo",
      "setDefault": "Imposta come modello predefinito",
      "subtitle": "Creare e gestire i modelli di onorario per i contratti",
      "title": "Modelli di onorario",
      "type": "Tipo",
      "typeHints": {
        "FLAT": "Aliquota unica",
        "MARGINAL": "Scaglioni degressivi"
      },
      "types": {
        "FLAT": "Aliquota fissa",
        "MARGINAL": "Marginale"
      },
      "updateSuccess": "Modello di onorario aggiornato con successo"
    },
    "source": {
      "appendix_b": "Allegato B",
      "property": "Oggetto",
      "framework": "Contratto quadro",
      "default": "Standard",
      "none": "Nessuna",
      "hint": "Fonte delle condizioni applicabili: {{source}}"
    }
  },
  "common": {
    "actions": "Azioni",
    "active": "Attivo",
    "add": "Aggiungi",
    "address": "Indirizzo",
    "all": "Tutti",
    "back": "Indietro",
    "cancel": "Annulla",
    "check": "Verifica",
    "city": "Ort",
    "clearFilters": "Reimpostare i filtri",
    "clearSelection": "Annullare la selezione",
    "close": "Chiudi",
    "confirm": "Conferma",
    "copy": "Kopieren",
    "create": "Crea",
    "createNew": "Crea nuovo",
    "date": "Data",
    "days": "giorni",
    "delete": "Elimina",
    "deleted": "Rimosso",
    "description": "Descrizione",
    "deselectAll": "Deseleziona tutto",
    "details": "Dettagli",
    "done": "Fatto",
    "download": "Herunterladen",
    "edit": "Modifica",
    "email": "Email",
    "employees": "Mitarbeiter",
    "error": "Errore",
    "export": "Esporta",
    "field": "Campo",
    "filter": "Filtra",
    "filtered": "filtrato",
    "firstName": "Vorname",
    "import": "Importa",
    "inactive": "Inattivo",
    "industry": "Branche",
    "info": "Info",
    "languages": {
      "de": "Deutsch",
      "en": "English",
      "fr": "Français",
      "it": "Italiano"
    },
    "lastName": "Nachname",
    "less": "Meno",
    "linkedin": "LinkedIn",
    "loading": "Caricamento...",
    "location": "Standort",
    "merge": "Unisci",
    "more": "Di più",
    "name": "Nome",
    "new": "NEU",
    "next": "Avanti",
    "no": "No",
    "noResults": "Nessun risultato",
    "none": "Nessuno",
    "notFound": "Nicht gefunden",
    "notes": "Note",
    "nothingRecorded": "Ancora nessun dato",
    "phone": "Telefono",
    "pin": "Fissa",
    "position": "Position",
    "preview": "Anteprima",
    "previous": "Precedente",
    "refresh": "Aggiorna",
    "refreshed": "Aktualisiert",
    "remove": "Rimuovi",
    "required": "Campo obbligatorio",
    "reset": "Reimpostare",
    "resizeColumn": "Ridimensiona colonna (doppio clic per ripristinare)",
    "resizePanes": "Ridimensiona i riquadri (frecce per regolare)",
    "retry": "Riprova",
    "revenue": "Umsatz",
    "save": "Salva",
    "saveAndClose": "Salva e chiudi",
    "saved": "Salvato",
    "saving": "Salvataggio in corso...",
    "saveStatus": {
      "idle": "Sincronizzato",
      "pending": "Modifiche in sospeso",
      "saving": "Salvataggio…",
      "saved": "Salvato",
      "error": "Salvataggio non riuscito"
    },
    "unsavedChanges": {
      "title": "Modifiche non salvate",
      "description": "Hai modifiche non salvate. Vuoi annullarle e chiudere?",
      "discard": "Annulla e chiudi",
      "keepEditing": "Continua a modificare"
    },
    "search": "Cerca",
    "select": "Selezionare",
    "selectAll": "Seleziona tutto",
    "showAll": "Mostra tutto",
    "skip": "Salta",
    "status": "Stato",
    "street": "Strasse",
    "success": "Successo",
    "uid": "UID",
    "unknown": "Unbekannt",
    "unknownError": "Errore sconosciuto",
    "unpin": "Rimuovi fissaggio",
    "view": "Visualizzare",
    "warning": "Avviso",
    "website": "Website",
    "yes": "Sì",
    "zip": "PLZ",
    "optional": "Optional",
    "print": "Drucken",
    "clear": "Cancella"
  },
  "companies": {
    "merge": {
      "activities": "Attività",
      "campaigns": "Campagne",
      "clickToSelect": "Clicca su un valore per selezionarlo",
      "contacts": "Contatti",
      "contracts": "Contratti",
      "dataMergeDirection": "Daten werden in die Hauptfirma uebernommen",
      "emailAccounts": "Account e-mail",
      "emails": "Indirizzi e-mail",
      "investorGroups": "Gruppi di investitori",
      "listings": "Annunci",
      "mergeButton": "Unisci",
      "offers": "Offerte",
      "phones": "Numeri di telefono",
      "previewError": "Impossibile caricare il confronto",
      "previewFailed": "Anteprima non riuscita.",
      "properties": "Immobili",
      "relatedRecords": "Record collegati",
      "secondaryDeactivated": "Le organizzazioni secondarie vengono disattivate, non eliminate.",
      "tasks": "Pendenze",
      "companiesSelected": "{{count}} organizzazioni selezionate"
    },
    "name": "Nome dell'azienda"
  },
  "company": {
    "all": "Tutte le aziende",
    "count": "{{count}} aziende",
    "done": "Fatto",
    "filter": "Filtro aziende",
    "noSelection": "Nessuna azienda",
    "switch": "Cambia azienda",
    "switchError": "Impossibile cambiare azienda"
  },
  "companyContacts": {
    "columns": {
      "actions": "Azioni",
      "email": "E-mail",
      "functions": "Funzione/i",
      "name": "Nome",
      "organisation": "Organizzazione",
      "signature": "Firma",
      "source": "Fonte",
      "status": "Stato",
      "verified": "Verificato"
    },
    "duplicate": {
      "dialogLabel": "Unisci contatti",
      "hint": "Forse la stessa persona",
      "merge": "Unisci",
      "mergeSuccess": "Contatti uniti",
      "mergeWith": "Unisci con {{name}}",
      "notSame": "Non è la stessa persona",
      "notSameAs": "Non è la stessa persona di {{name}}",
      "notSameSaved": "Salvato come persone diverse",
      "reasonFirstName": "Stesso cognome, nome simile",
      "reasonInitial": "Stesso cognome, iniziale corrispondente"
    },
    "filters": {
      "active": "Attivo",
      "import": "Importazione",
      "inactive": "Inattivo",
      "label": "Filtra contatti",
      "labelCompanies": "Filtra organizzazioni",
      "manual": "Manuale",
      "search": "Cerca contatti",
      "searchCompanies": "Cerca organizzazioni",
      "withoutEmail": "Senza e-mail",
      "zefix": "Registro di commercio"
    },
    "functions": {
      "add": "Aggiungi funzione",
      "empty": "Nessuna funzione registrata",
      "listLabel": "Funzioni registrate",
      "remove": "Rimuovi la funzione «{{name}}»"
    },
    "groups": {
      "inactive": "Inattivi ({{count}})",
      "other": "Altri contatti",
      "otherCompanies": "Altre organizzazioni",
      "register": "Persone con diritto di firma (registro di commercio)",
      "registerCompanies": "Diritto di firma (registro di commercio)"
    },
    "noResults": "Nessun contatto per questi filtri",
    "noResultsCompanies": "Nessuna organizzazione per questi filtri",
    "removeCompany": "Rimuovi organizzazione",
    "removeFromContact": "rimuovere da questo contatto?",
    "tableCaption": "Contatti di questa organizzazione",
    "tableCaptionCompanies": "Organizzazioni di questo contatto",
    "verified": "Verificato",
    "verifiedOn": "Verificato il {{date}}"
  },
  "companyDedup": {
    "fieldComparison": "Confronto dei campi",
    "loadingPreview": "Caricamento del confronto...",
    "mergeSuccess": "Organizzazioni unite con successo",
    "mergeTitle": "Unisci organizzazioni"
  },
  "companyLookup": {
    "address": "Adresse",
    "createError": "Kontakte konnten nicht erstellt werden",
    "creating": "Kontakte werden erstellt...",
    "legalForm": "Rechtsform",
    "noSignatories": "Keine Zeichnungsberechtigten gefunden",
    "noSignatoriesHint": "Die SHAB-Daten für diese Firma sind nicht verfügbar (ältere Firmen oder fehlende Publikationen). Bitte tragen Sie die Zeichnungsberechtigten manuell ein.",
    "purpose": "Zweck",
    "searchLabel": "Firma aus Handelsregister suchen",
    "searchPlaceholder": "Firmenname oder UID eingeben...",
    "uid": "UID"
  },
  "companyRelations": {
    "add": "Collega",
    "added": "Organizzazione collegata",
    "addTitle": "Collega organizzazione",
    "auditedBy": "Ufficio di revisione",
    "audits": "revisiona",
    "confirmDelete": "Rimuovere davvero il collegamento?",
    "editTitle": "Modifica collegamento",
    "empty": "Nessuna organizzazione collegata",
    "emptyHint": "Collega organizzazioni che appartengono insieme (p. es. madre/figlia, partner o società sorella).",
    "loadFailed": "Impossibile caricare i collegamenti",
    "notesLabel": "Nota",
    "notesPlaceholder": "Nota facoltativa sulla relazione (p. es. filiale, società sorella)...",
    "removed": "Collegamento rimosso",
    "targetLabel": "Organizzazione",
    "title": "Organizzazioni collegate",
    "types": {
      "auditor": "Ufficio di revisione",
      "customer": "Cliente",
      "other": "Altro",
      "parent_subsidiary": "Madre/figlia",
      "partner": "Partner",
      "predecessor": "Predecessore",
      "sister": "Società sorella",
      "supplier": "Fornitore"
    },
    "updated": "Collegamento aggiornato"
  },
  "companyResearch": {
    "approveError": "Fehler beim Anlegen",
    "approved": "Firma und Kontakte wurden angelegt",
    "approving": "Wird angelegt...",
    "extracting": "Extrahiere Firma und Kontakte...",
    "unknownCompany": "Firma",
    "openFullProfile": "Vollständiges Profil anzeigen",
    "companyDraft": "Firma-Entwurf",
    "name": "Firmenname",
    "legalForm": "Rechtsform",
    "street": "Strasse",
    "houseNr": "Nr.",
    "zip": "PLZ",
    "city": "Ort",
    "canton": "Kanton",
    "website": "Website",
    "phone": "Telefon",
    "email": "E-Mail",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "role": "Funktion",
    "results": "Recherche-Ergebnis",
    "contacts": "Kontakte",
    "addContact": "Kontakt hinzufügen",
    "approve": "Firma + Kontakte anlegen",
    "empty": "Keine KI-Recherche vorhanden. Frage den Agenten, eine Firma oder Person zu recherchieren."
  },
  "contactDedup": {
    "assignCompany": "Associa un'altra azienda (opzionale)",
    "backToScan": "Torna alla scansione",
    "companySection": "Associazioni aziendali",
    "companySectionDesc": "Tutte le associazioni aziendali verranno trasferite al contatto principale.",
    "companyWillBeAssigned": "Verrà associata dopo l'unione",
    "contactsAffected": "Contatti interessati",
    "empty": "(leer)",
    "executeMerge": "Unisci",
    "field": "Feld",
    "fieldComparison": "Confronto campi",
    "fieldComparisonDesc": "Scegli quale valore mantenere per ogni campo.",
    "groupsFound": "Gruppi di duplicati",
    "loadingCompanies": "Caricamento aziende...",
    "loadingPreview": "Vergleich wird geladen...",
    "merge": "Unisci",
    "mergeError": "Errore durante l'unione:",
    "mergeSuccess": "Contatti uniti con successo!",
    "mergeWarning": "I contatti secondari verranno disattivati (non eliminati).",
    "minScore": "Punteggio min.",
    "noCompanyLinks": "Nessuna associazione aziendale trovata",
    "noDuplicates": "Nessun duplicato trovato",
    "noDuplicatesDesc": "Tutti i contatti sono unici.",
    "primaryContact": "Contatto principale",
    "related": {
      "activities": "Attività",
      "campaignRecipients": "Kampagnen-Empfänger",
      "companyAssignments": "Firmen-Zuordnungen",
      "contracts": "Verträge",
      "emailAddresses": "E-Mail-Adressen",
      "infoOwners": "Autorizzazioni informative",
      "investorGroups": "Gruppi di investitori",
      "knowledgeChunks": "Sezioni di conoscenza",
      "notifications": "Benachrichtigungen",
      "propertyRefs": "Collegamenti agli oggetti",
      "signatures": "Unterschriften",
      "syncedEmails": "E-mail sincronizzate",
      "tags": "Tags",
      "tasks": "Pendenzen",
      "tokens": "Link di accesso",
      "userAccount": "Account utente"
    },
    "relatedSection": "Verrà trasferito",
    "relatedSectionDesc": "Questi record dei contatti secondari verranno trasferiti al contatto principale.",
    "scan": "Cerca duplicati",
    "scanMore": "Cerca altri duplicati",
    "searchCompany": "Cerca e associa un'azienda...",
    "selectPrimary": "Seleziona il contatto principale",
    "selectPrimaryDesc": "Il contatto principale verrà mantenuto. Tutti gli altri verranno uniti.",
    "setAsPrimary": "Als Hauptkontakt",
    "source": "Fonte",
    "step1": "Cerca duplicati",
    "step2": "Verifica e unisci",
    "step3": "Risultato",
    "subtitle": "Rileva e unisci i duplicati",
    "title": "Deduplicazione contatti",
    "totalContacts": "Contatti totali",
    "userAccountConflictDesc": "Un contatto può avere un solo account utente, quindi l'unione viene rifiutata. Disattiva prima uno dei due account oppure scegli come contatto principale quello con l'account desiderato.",
    "userAccountConflictTitle": "Entrambi i contatti hanno un account utente"
  },
  "contactImport": {
    "backToOverview": "Torna alla panoramica",
    "clickToExclude": "Klicke auf einen Kontakt um ihn vom Import auszuschliessen.",
    "confirmImport": "Import bestätigen",
    "connected": "Connesso",
    "continueImport": "Import fortsetzen",
    "duplicates": "Duplikate",
    "enrichExisting": "Bestehende anreichern:",
    "enrichableLabel": "Anreicherbar",
    "errorLoading": "Fehler beim Laden",
    "finishAnyway": "Trotzdem abschliessen",
    "goToContacts": "Zu den Kontakten",
    "goToSettings": "Vai alle impostazioni",
    "google": {
      "checkAccount": "Bitte Google-Konto prüfen.",
      "contacts": "Google Kontakte",
      "enrichExisting": "Bestehende Kontakte mit Google-Daten anreichern",
      "loading": "Google Kontakte werden geladen...",
      "subtitle": "Importiere Kontakte aus deinem verbundenen Google-Konto in Immotron.",
      "title": "Google Kontakte importieren",
      "titleShort": "Google Import"
    },
    "importButton": "Importa",
    "importComplete": "Import abgeschlossen",
    "importFailed": "Import fehlgeschlagen",
    "importNow": "Jetzt importieren",
    "importing": "Importiere...",
    "inImmotron": "In Immotron",
    "inactive": "Disattivato",
    "linkedinDesc": "Caricamento JSON o estensione browser",
    "microsoft": {
      "allFolders": "Alle Ordner (empfohlen)",
      "allFoldersHint": "Durchsucht das gesamte Postfach — alle Kontaktordner ab Root rekursiv",
      "backToFolders": "Zurück zur Ordnerübersicht",
      "changeFolder": "Ordner wechseln",
      "checkAccount": "Bitte Microsoft-Konto prüfen.",
      "chooseAnotherFolder": "Anderen Ordner wählen",
      "chooseFolderHint": "Wähle den Kontaktordner oder nutze «Alle Ordner» um das gesamte Postfach ab Root rekursiv zu durchsuchen.",
      "contacts": "Microsoft Kontakte",
      "empty": "Leer",
      "emptyFolderHint": "Der gewählte Ordner ist leer — versuche «Alle Ordner» um das gesamte Postfach zu durchsuchen.",
      "enrichExisting": "Bestehende Kontakte mit Microsoft-Daten anreichern",
      "expiredHint": "Die Microsoft-Verbindung ist abgelaufen — verbinde dein Konto unter Einstellungen neu.",
      "includeSubfolders": "Unterordner einschliessen",
      "includeSubfoldersHint": "Beim Import eines Ordners werden auch alle darunter liegenden Ordner durchsucht.",
      "loading": "Microsoft Kontakte werden geladen...",
      "loadingFolders": "Kontaktordner werden geladen...",
      "noContactsFound": "Keine Kontakte gefunden",
      "noContactsHint": "Dieser Ordner enthält keine Kontakte. Das kann folgende Gründe haben:",
      "reconnectAccount": "Konto neu verbinden",
      "subtitle": "Importiere Kontakte aus deinem verbundenen Microsoft 365 Konto in Immotron.",
      "title": "Microsoft 365 Kontakte importieren",
      "titleShort": "Microsoft Import",
      "tokenExpired": "Microsoft-Verbindung abgelaufen",
      "tokenExpiredDetail": "Der Zugriff auf dein Microsoft-Konto ist abgelaufen. Bitte verbinde dein Konto unter Einstellungen neu und versuche es erneut."
    },
    "needsReauth": "Riconnessione richiesta",
    "newContacts": "Neue Kontakte",
    "newContactsToImport": "Neue Kontakte importieren:",
    "newImport": "Neu importieren",
    "nextConfirm": "Weiter: Import bestätigen",
    "nextReview": "Weiter: Kontakte prüfen",
    "noAccounts": "Nessun account e-mail collegato",
    "noAccountsHint": "Collega un account Google o Microsoft in Impostazioni → Account e-mail per importare i contatti.",
    "noEmail": "Ohne E-Mail",
    "noLastName": "Ohne Nachnamen",
    "noLastNameBadge": "Kein Nachname",
    "noLastNameDescription": "Diese Kontakte haben keinen Nachnamen und werden standardmässig nicht importiert. Klicke um einzelne hinzuzufügen.",
    "notInImmotron": "noch nicht in Immotron",
    "onlyInImmotron": "Nur in Immotron",
    "partiallyDone": "Import teilweise abgeschlossen",
    "progressSoFar": "Bisheriger Fortschritt:",
    "refresh": "Aggiorna",
    "selectSeparately": "separat auswählbar",
    "skipped": "Übersprungen:",
    "steps": {
      "analyze": "Analysieren",
      "done": "Fertig",
      "folders": "Ordner",
      "import": "Import",
      "review": "Prüfen"
    },
    "subtitle": "Importa contatti da account collegati o LinkedIn",
    "summary": "Import-Zusammenfassung",
    "title": "Importazione contatti"
  },
  "contacts": {
    "addAddress": "Aggiungi indirizzo",
    "addCompany": "Aggiungi organizzazione",
    "addContact": "Nuovo contatto",
    "addInfoOwner": "Aggiungi proprietario info",
    "newContactPlaceholder": "Nuovo contatto",
    "addTagPlaceholder": "Aggiungi tag...",
    "address": "Indirizzo",
    "addressAdded": "Indirizzo aggiunto",
    "addressCity": "Città",
    "addressCountry": "Paese",
    "addressRemoved": "Indirizzo rimosso",
    "addressStreet": "Via",
    "addressZip": "CAP",
    "allCompanies": "Tutte le aziende",
    "allTags": "Tag",
    "alreadyRecorded": "Già registrato",
    "privatePerson": "Persona",
    "assignedViaCompanies": "Über Firmen zugeordnet",
    "birthday": "Data di nascita",
    "companies": "Organizzazioni",
    "company": "Azienda",
    "companyAdded": "Organizzazione aggiunta con successo",
    "companyAssignments": "Firmenzuordnungen",
    "companyCreated": "Azienda creata da Zefix",
    "companyOnly": "Solo con azienda",
    "companyRemoved": "Associazione rimossa",
    "companyRoles": "Associazioni organizzative",
    "companyUpdated": "Associazione aggiornata",
    "confirmDelete": "Sei sicuro di voler eliminare questo contatto?",
    "confirmRemoveCompany": "Sei sicuro di voler rimuovere questa associazione?",
    "contact": "Kontakt",
    "createNewCompany": "Crea come azienda: «{{query}}»",
    "createNewPerson": "Crea come persona: «{{query}}»",
    "createSuccess": "Contatto creato con successo",
    "createUser": "Crea utente",
    "createdAt": "Creato",
    "creatingCompany": "Creazione azienda...",
    "currentPosition": "Aktuelle Position",
    "deleteContact": "Elimina contatto",
    "deleteSuccess": "Contatto eliminato con successo",
    "detailsLoadFailed": "Impossibile caricare i dettagli",
    "directlyAssigned": "Direkt zugeordnet",
    "duplicateBannerHint": "Verifica ed eventualmente unisci.",
    "duplicateBannerMany": "{{count}} possibili duplicati",
    "duplicateBannerOne": "1 possibile duplicato",
    "duplicateCheckAria": "Verifica il duplicato {{name}}",
    "editContact": "Modifica contatto",
    "email": "Email",
    "emailOptional": "E-Mail (optional)",
    "emailStatuses": {
      "BOUNCED": "Respinto",
      "CLICKED": "Cliccato",
      "DELIVERED": "Consegnato",
      "FAILED": "Fallito",
      "OPENED": "Aperto",
      "PENDING": "In attesa",
      "SENT": "Inviato"
    },
    "emails": {
      "campaign": "Campagna",
      "contract": "Contratto",
      "empty": "Nessuna e-mail inviata",
      "property": "Immobile",
      "resend": "Rinvia",
      "resendSuccess": "L'e-mail è stata rinviata",
      "source": "Fonte",
      "subject": "Oggetto",
      "title": "E-mail"
    },
    "existingCompanies": "Aziende esistenti",
    "firstName": "Nome",
    "function": "Funktion",
    "functionPlaceholder": "p. es. direttore generale",
    "gender": "Genere",
    "genderFemale": "Femminile",
    "genderMale": "Maschile",
    "genderNotSet": "Non specificato",
    "googleImport": "Google Import",
    "hasAccount": "Attivo",
    "import": "Import",
    "infoOwnerAdded": "Proprietario info aggiunto",
    "infoOwnerRemoved": "Proprietario info rimosso",
    "infoOwners": "Proprietari info",
    "langDe": "Deutsch",
    "langEn": "English",
    "langFr": "Français",
    "langIt": "Italiano",
    "languageAuto": "Automatico (tedesco)",
    "lastName": "Cognome",
    "lastNameRequired": "Nachname *",
    "localOnly": "Locale",
    "location": "Ort",
    "manuallySelected": "Manuell ausgewählt",
    "markVerified": "Segna come verificato",
    "merge": {
      "assessment": "Bewertung",
      "businessModel": "Geschäftsmodell",
      "company": "Firma",
      "contact": "Kontakt",
      "createAndImport": "Neu erstellen & Importieren",
      "enrichCompany": "Bestehende Firma wird mit neuen Infos ergänzt (leere Felder)",
      "enrichContact": "Bestehender Kontakt wird mit neuen Infos ergänzt",
      "existingRecord": "Bestand (Immotron)",
      "field": "Feld",
      "leadResearch": "Lead (Recherche)",
      "loadingComparison": "Lade Vergleichsdaten...",
      "match": "Übereinstimmung",
      "matchLabel": "Match",
      "mergeAndImport": "Zusammenführen & Importieren",
      "newEntry": "Neuer Eintrag",
      "researchExtras": "Zusatzinfos aus der Recherche",
      "source": "Quelle",
      "subtitleCompare": "Prüfe die Übereinstimmung vor dem Import",
      "subtitleNew": "Kein bestehendes Match gefunden — wird neu erstellt",
      "titleCompare": "Lead importieren — Vergleich",
      "titleNew": "Lead als neu importieren",
      "whatHappens": "Was passiert beim Import?",
      "willBeCreated": "wird neu erstellt",
      "willBeCreatedShort": "Wird neu erstellt"
    },
    "mergeSuccess": "Kontakte erfolgreich zusammengeführt",
    "metadata": "Metadati",
    "microsoftImport": "Microsoft Import",
    "name": "Name",
    "noAccount": "Nessun account",
    "noCompanies": "Nessuna assegnazione a organizzazioni",
    "noCompaniesFound": "Nessuna società trovata",
    "noCompanyAssignment": "Keine Firmenzuordnung",
    "noCompanyAssignmentHint": "Fügen Sie eine Firma hinzu, um Rollen und Zeichnungsrechte zu definieren.",
    "noContacts": "Nessun contatto trovato",
    "noContactsFound": "Keine Kontakte gefunden",
    "noLinkedinData": "Keine LinkedIn-Daten",
    "noLinkedinDataHint": "Dieser Kontakt wurde noch nicht mit LinkedIn synchronisiert.",
    "noTags": "Nessun tag",
    "notes": "Note",
    "notesPlaceholder": "Note interne sul contatto...",
    "openProfile": "Profil öffnen",
    "owner": "Proprietario principale",
    "ownerAll": "Tutti i proprietari",
    "personsRegistered": "{{count}} persone registrate",
    "phone": "Telefono",
    "position": "Posizione",
    "possibleDuplicate": "Mögliches Duplikat",
    "possibleDuplicates": "Mögliche Duplikate",
    "preferredLanguage": "Lingua",
    "primaryAddress": "Indirizzo principale",
    "rawDataJson": "Rohdaten (JSON)",
    "reSyncPending": "Re-Sync angefordert",
    "reSyncRequested": "Re-Sync angefordert. Starten Sie einen neuen Sync im LinkedIn Scraper.",
    "requestReSync": "Re-Sync anfordern",
    "resultsLabel": "Contatti",
    "searchCompanyPlaceholder": "Cerca azienda...",
    "searchContact": "Cerca contatto...",
    "searchCriteria": {
      "areaRange": "Superficie m²",
      "areaRangePlaceholder": "p. es. 800–2'500",
      "cantons": "Cantoni",
      "condition": "Stato",
      "constructionYear": "Anno di costruzione",
      "constructionYearPlaceholder": "p. es. dal 1990 o nuova costruzione",
      "decisionProcess": "Processo decisionale",
      "energyRequirements": "Energia / sostenibilità",
      "excluded": "Escluso",
      "grossYieldMin": "Rendimento lordo min.",
      "grossYieldMinPercent": "Rendimento lordo min. (%)",
      "location": "Posizione",
      "locationNotes": "Note sulla posizione",
      "macro": "Macro",
      "macroLocation": "Posizione macro",
      "micro": "Micro",
      "microLocation": "Posizione micro",
      "minUnits": "Dimensione minima",
      "minUnitsPlaceholder": "p. es. 6 appartamenti",
      "netYieldTarget": "Rendimento netto obiettivo",
      "noGos": "Criteri escludenti",
      "price": "Prezzo (mio CHF)",
      "priceMax": "Prezzo max. (mio CHF)",
      "priceMin": "Prezzo min. (mio CHF)",
      "priceMinHard": "Escludi sotto il prezzo min. (limite rigido)",
      "priceNotes": "Nota sul prezzo",
      "propertyTypes": "Tipi di immobile",
      "regions": "Regioni",
      "sought": "Ricercato",
      "specialRequirements": "Requisiti particolari",
      "timeline": "Tempistica"
    },
    "searchFailed": "Ricerca fallita",
    "searchNameOrEmail": "Name oder E-Mail suchen...",
    "searchPlaceholder": "Cerca per nome o email...",
    "selectCompany": "Firma wählen...",
    "selectMergeTarget": "Kontakt zum Zusammenführen auswählen",
    "sendPasswordReset": "Invia reset password",
    "setPrimary": "Imposta come principale",
    "showCampaignContacts": "Contatti campagna",
    "signature": "Firma",
    "signatureCollectiveMore": "Kollektivunterschrift zu mehreren",
    "signatureCollectiveTwo": "Kollektivunterschrift zu zweit",
    "signatureNone": "Keine",
    "signatureSingle": "Einzelunterschrift",
    "signatureType": "Zeichnungsberechtigung",
    "signatures": "Firme",
    "source": "Quelle",
    "sourceAll": "Fonte",
    "sourceCampaign": "Campagna",
    "sourceGoogle": "Google",
    "sourceLabel": "Fonte",
    "sourceManual": "Manuale",
    "subtitle": "Tutti i firmatari autorizzati e le persone di contatto",
    "syncStatus": "Sync Status",
    "synced": "Synchronisiert",
    "contracts": {
      "empty": "Nessun contratto disponibile",
      "propertyLabel": "Immobile"
    },
    "tabs": {
      "addressContact": "Adresse & Kontakt",
      "companies": "Organizzazioni",
      "contracts": "Contratti",
      "knowledge": "Conoscenze",
      "linkedin": "LinkedIn",
      "masterData": "Stammdaten",
      "notes": "Notizen",
      "responsibility": "Zuständigkeit"
    },
    "tagAdded": "Tag assegnato",
    "tagRemoved": "Tag rimosso",
    "tags": "Tag",
    "title": "Contatti",
    "tryZefix": "Cerca in Zefix",
    "typeNameOrEmail": "Tippen Sie einen Namen oder eine E-Mail-Adresse...",
    "unverified": "Non verificato",
    "updateSuccess": "Contatto aggiornato con successo",
    "userAccount": "Account utente",
    "verified": "Verificato",
    "verifiedSuccess": "Associazione verificata",
    "verifiedVia": "Verificato tramite",
    "website": "Sito web",
    "withUser": "Con account utente",
    "withUserOnly": "Solo con utente",
    "withoutUser": "Senza account utente",
    "zefixSearch": "Ricerca Zefix",
    "zefixSearchPlaceholder": "Cerca azienda in Zefix (nome o UID)...",
    "phoneAdded": "Telefonnummer hinzugefuegt",
    "phoneRemoved": "Telefonnummer entfernt",
    "phones": "Telefonnummern",
    "noCompanyAssigned": "Keine Firma zugeordnet",
    "addresses": "Adressen",
    "researchSuccess": "Recherche abgeschlossen",
    "researchFailed": "Recherche fehlgeschlagen",
    "researching": "Recherchiere...",
    "startResearch": "KI-Recherche starten",
    "researchError": "Recherche fehlgeschlagen. Bitte erneut versuchen.",
    "researchResult": "Recherche-Ergebnis",
    "lastResearch": "Letzte Recherche",
    "noResearchYet": "Noch keine KI-Recherche durchgeführt",
    "researchDescription": "Perplexity durchsucht das Web nach Informationen zu dieser Person",
    "infoOwnerRole": "Info",
    "noOwner": "-- Nessun proprietario principale --",
    "notesAutoSaveHint": "Le modifiche vengono salvate automaticamente.",
    "removeInfoOwner": "Rimuovi proprietario info"
  },
  "contractTermination": {
    "clause": "Clausola",
    "clauseLabel": "Clausola violata (opzionale)",
    "confirmButton": "Rescindi ora",
    "confirmSummary": "Riepilogo:",
    "contract": "Contratto",
    "description": "Il contratto {{number}} verrà rescisso. Indicare il motivo.",
    "error": "Errore durante la rescissione del contratto",
    "reason": "Motivo",
    "reasonLabel": "Motivo",
    "reasonPlaceholder": "Descrivere il motivo della rescissione...",
    "reasonRequired": "Indicare un motivo",
    "selectClause": "-- Seleziona clausola --",
    "success": "Il contratto è stato rescisso",
    "title": "Rescindere contratto",
    "warningText": "Dopo la rescissione, tutte le clausole di protezione (§6 Protezione contatti, §7 Penale contrattuale) restano in vigore per ulteriori 6 mesi.",
    "warningTitle": "Attenzione: Periodo di decorrenza"
  },
  "contractWizard": {
    "errors": {
      "generateFailed": "Impossibile generare il contratto",
      "loadCompaniesFailed": "Impossibile caricare le aziende",
      "loadSignatoriesFailed": "I firmatari non hanno potuto essere caricati",
      "noCompany": "La preghiamo di selezionare un'azienda",
      "noPartner": "La preghiamo di indicare un partner contrattuale",
      "noPartnerContact": "La preghiamo di selezionare un firmatario del partner contrattuale",
      "noRoles": "La preghiamo di selezionare almeno un ruolo",
      "noSignatories": "La preghiamo di selezionare almeno un firmatario"
    },
    "hidePreview": "Nascondi anteprima",
    "navigation": {
      "back": "Indietro",
      "cancel": "Annulla",
      "next": "Avanti"
    },
    "showPreview": "Mostra anteprima",
    "signatories": {
      "loading": "Caricamento dei firmatari...",
      "none": "Nessun firmatario disponibile",
      "subtitle": "Seleziona i firmatari per questo contratto",
      "title": "Firmatari"
    },
    "step1": {
      "loading": "Caricamento aziende...",
      "subtitle": "Scegli l'azienda che emette il contratto",
      "title": "Seleziona azienda"
    },
    "step2": {
      "city": "Città",
      "contactName": "Persona di contatto (firmatario)",
      "email": "E-mail",
      "manualEntry": "Inserimento manuale",
      "name": "Nome / Azienda",
      "partnerSignatory": "Firmatario del partner contrattuale",
      "partnerSignatoryHint": "In caso di firma collettiva, selezionare piu persone.",
      "searchPartner": "Cerca partner contrattuale (persona/azienda — CRM & Zefix)",
      "searchPartnerPlaceholder": "Cerca per nome, azienda o Zefix...",
      "searchPartnerHint": "Cerca nei contatti CRM, nelle aziende CRM e nel registro di commercio Zefix. Non trovato? Crea direttamente un nuovo record CRM.",
      "creatingPartner": "Creazione del partner contrattuale nel CRM...",
      "partnerCreated": "Partner contrattuale creato nel CRM",
      "partnerCreateFailed": "Impossibile creare il partner contrattuale",
      "personBadge": "Persona privata (CRM)",
      "companyBadge": "Azienda (CRM/Zefix)",
      "personIsSignatory": "Questa persona è il firmatario del contratto.",
      "signerEmail": "E-mail del firmatario",
      "emailSavedToCrm": "E-mail salvata nel CRM",
      "sourceCrm": "Nel CRM",
      "sourceZefixNew": "Zefix — non ancora nel CRM",
      "sourceCrmGone": "Nel CRM — non più nel registro",
      "noSignatoriesFound": "Nessun firmatario trovato. Registrarlo prima nel CRM.",
      "searchCompany": "Cerca azienda (Zefix)",
      "searchPlaceholder": "Cercare un'azienda...",
      "signingEmailPlaceholder": "E-mail per il link di firma",
      "street": "Via",
      "subtitle": "Cerca un partner esistente o creane uno nuovo",
      "title": "Partner contrattuale",
      "zipCode": "CAP"
    },
    "step3": {
      "broker": "Mediatore",
      "brokerDesc": "Co-mediazione, accesso rete, suddivisione onorario",
      "brokerDescription": "Divisione onorari con mediatore partner",
      "buyer": "Acquirente",
      "buyerDesc": "Accesso a immobili off-market, profilo di ricerca, supporto due diligence",
      "buyerDescription": "Contratto d'acquisto con onorario e profilo di ricerca",
      "seller": "Venditore",
      "sellerDesc": "Commercializzazione immobili, matching acquirenti, supporto transazione",
      "sellerDescription": "Mandato di mediazione con onorario ed esclusiva",
      "subtitle": "Qual è il ruolo del partner?",
      "title": "Scegli tipo di contratto"
    },
    "step4": {
      "brokerCommission": "Onorario",
      "brokerSection": "Condizioni mediatore",
      "buyerSection": "Condizioni acquirente",
      "commission": "Onorario di mediazione",
      "commissionMode": "Condizioni",
      "commissionModeFixed": "Fisse nel contratto",
      "commissionModeFixedDesc": "Le percentuali sono fissate nel contratto.",
      "commissionModeFixedRequired": "Inserire un tasso superiore allo 0 % per ogni ruolo selezionato.",
      "commissionModeVariable": "Per oggetto (allegato B)",
      "commissionModeVariableDesc": "Le condizioni sono concordate per oggetto.",
      "commissionModeVariableHint": "Senza percentuali fisse nel contratto: le condizioni sono concordate per oggetto nell'allegato B e confermate prima dell'accesso all'oggetto.",
      "conditions": "Condizioni di mediazione",
      "contractDuration": "Durata contratto",
      "exclusivity": "Esclusiva",
      "exclusivityDuration": "Durata esclusiva",
      "exclusivityHint": "Mandato di commercializzazione esclusivo",
      "findersFee": "Onorario",
      "globalSection": "Condizioni generali",
      "ourShare": "La nostra quota",
      "partnerShare": "Quota del partner",
      "protectionDuration": "Durata di protezione (mesi)",
      "searchProfile": "Profilo di ricerca",
      "sellerSection": "Condizioni venditore",
      "subtitle": "Impostazioni specifiche per tipo",
      "title": "Configurazione"
    },
    "step5": {
      "company": "Azienda",
      "configuration": "Configurazione",
      "contractType": "Tipo di contratto",
      "generate": "Genera contratto",
      "generating": "Generazione in corso...",
      "partner": "Partner",
      "subtitle": "Verifica i dati e genera il contratto",
      "title": "Riepilogo e generazione"
    },
    "steps": {
      "company": "Azienda",
      "config": "Configurazione",
      "partner": "Partner",
      "preview": "Anteprima",
      "type": "Tipo di contratto"
    },
    "subtitle": "Crea un nuovo contratto",
    "success": "Contratto creato con successo",
    "title": "Nuovo contratto",
    "validation": {
      "collectiveMore": "Firma collettiva: La preghiamo di selezionare almeno 2 firmatari.",
      "collectiveTwo": "Firma collettiva a due: La preghiamo di selezionare esattamente 2 firmatari.",
      "singleOnly": "Firma individuale: La preghiamo di selezionare esattamente 1 firmatario."
    },
    "searchMandate": {
      "companyLoadError": "Firma konnte nicht geladen werden",
      "onlyImages": "Nur Bilddateien erlaubt (PNG, JPG, WebP)",
      "fileTooLarge": "Maximale Dateigroesse: 2 MB",
      "logoUploaded": "Logo hochgeladen",
      "logoUploadFailed": "Logo-Upload fehlgeschlagen",
      "letterGenerated": "Anschreiben-Text generiert",
      "letterGenerateFailed": "Text konnte nicht generiert werden",
      "mandateCreated": "Suchmandat erstellt!",
      "createError": "Fehler beim Erstellen des Suchmandats",
      "title": "Suchmandat erstellen",
      "ourCompany": "Unsere Firma",
      "client": "Auftraggeber (Investor)",
      "searchCompany": "Firma suchen (Zefix)",
      "manualEntry": "Manuell eingeben",
      "signatories": "Unterzeichner des Vertragspartners",
      "signatoriesHint": "Bei Kollektivunterschrift mehrere Personen auswählen.",
      "clientLogo": "Logo des Auftraggebers",
      "clientLogoHint": "Das Logo erscheint oben rechts im Anschreiben. Das Anschreiben wird im Namen des Auftraggebers erstellt.",
      "logoUploadHint": "Logo hochladen oder hierhin ziehen (PNG, JPG, max. 2 MB)",
      "aiCoverLetter": "Anschreiben — KI-Textgenerator",
      "aiCoverLetterHint": "Stichworte zum Auftraggeber eingeben — die KI generiert ein professionelles Anschreiben.",
      "clientKeywords": "Stichworte zum Auftraggeber",
      "generating": "Wird generiert...",
      "generateLetter": "Anschreiben generieren",
      "generatedText": "Generierter Text (bearbeitbar)",
      "textEditable": "Text kann vor dem Erstellen angepasst werden.",
      "searchCriteria": "Suchkriterien",
      "propertyType": "Objektart",
      "noGoCriteria": "No-Go Kriterien",
      "noGoHint": "Was kommt fuer den Investor nicht in Frage?",
      "noGoCustom": "Weitere No-Gos (Freitext)",
      "regionLabel": "Region (Mehrfachauswahl)",
      "cantonsLabel": "Kantone (Mehrfachauswahl)",
      "macroLocation": "Makrolage",
      "noRestriction": "Keine Einschraenkung",
      "macroA": "A — Top-Standort (Zuerich, Genf, Basel)",
      "macroB": "B — Guter Standort (Agglomeration, Mittelstaedte)",
      "macroC": "C — Peripherer Standort (laendlich, Kleinstaedte)",
      "microLocation": "Mikrolage",
      "microA": "A — Beste Mikrolage (zentral, ruhig, top Anbindung)",
      "microB": "B — Gute Mikrolage (durchschnittlich, solide)",
      "microC": "C — Einfache Mikrolage (Randlage, maessige Anbindung)",
      "investmentVolume": "Investitionsvolumen",
      "investmentAndYield": "Investitionsvolumen & Rendite",
      "priceRange": "Kaufpreis-Bandbreite",
      "minimum": "Minimum",
      "maximum": "Maximum",
      "grossYieldMin": "Bruttorendite min.",
      "netYieldTarget": "Nettorendite Ziel",
      "timeline": "Zeitrahmen",
      "buildingAndTimeline": "Gebaeude & Zeitrahmen",
      "conditionLabel": "Zustand (Mehrfachauswahl)",
      "timelineNow": "Sofort",
      "timeline3m": "Innerhalb 3 Monaten",
      "timeline6m": "Innerhalb 6 Monaten",
      "timeline12m": "Innerhalb 12 Monaten",
      "timelineFlexible": "Flexibel",
      "specialRequirements": "Besondere Anforderungen",
      "conditions": "Konditionen",
      "feeNote": "des Kaufpreises, zzgl. MWST",
      "protectionDuration": "Kontaktschutz (Monate)",
      "contractDuration": "Mandatsdauer (Monate)",
      "hidePreview": "Vorschau ausblenden",
      "showPreview": "Vorschau anzeigen",
      "tabCoverLetter": "Anschreiben",
      "tabCriteria": "Suchkriterien",
      "tabAgreement": "Mandatsvereinbarung",
      "creating": "Wird erstellt...",
      "createMandate": "Suchmandat erstellen"
    }
  },
  "contracts": {
    "actions": {
      "cancel": "Annullare il contratto",
      "createNew": "Nuovo contratto",
      "downloadPdf": "Scarica PDF",
      "generate": "Crea",
      "preview": "Anteprima",
      "proceedToSign": "Procedi alla firma",
      "send": "Inviare il contratto",
      "terminate": "Disdire il contratto"
    },
    "cancel": "Annulla",
    "cancelFailed": "Il contratto non ha potuto essere annullato.",
    "cancelSuccess": "Il contratto e stato annullato.",
    "categories": {
      "compliance": "Conformità",
      "contracts": "Contratti",
      "legitimation": "Legittimazioni",
      "v2": "Nuovi contratti"
    },
    "collectiveSignatureWarning": "Firma collettiva a due: selezionare almeno 2 persone.",
    "complete": {
      "contractNumber": "Numero di contratto",
      "createdAt": "Creato il",
      "description": "Il tuo contratto {{number}} è stato generato.",
      "sentDescription": "Il contratto {{number}} è stato inviato per la firma. I firmatari riceveranno un'email.",
      "sentTitle": "Contratto inviato!",
      "signedDescription": "Il contratto {{number}} è stato firmato da tutte le parti.",
      "signedTitle": "Contratto firmato con successo!",
      "status": "Stato",
      "title": "Contratto creato con successo!",
      "usersCreated": "{{count}} account utente creati automaticamente"
    },
    "confirmCancel": "Sei sicuro di voler annullare questo contratto?",
    "confirmCancelCustomerSigned": "ATTENZIONE: Parti esterne hanno già firmato questo contratto. Vuoi comunque annullarlo?",
    "confirmCancelSent": "Questo contratto è già stato inviato. I firmatari hanno ricevuto il link. Annullare comunque?",
    "confirmDelete": "Sei sicuro di voler eliminare questo contratto?",
    "confirmDeleteDescription": "E sicuro/a di voler eliminare questo contratto?",
    "confirmSend": "E sicuro/a di voler inviare questo contratto?",
    "confirmTerminate": "Sei sicuro di voler disdire questo contratto? Questa azione non può essere annullata.",
    "confirmTerminateDescription": "E sicuro/a di voler disdire questo contratto?",
    "deleteFailed": "Il contratto non ha potuto essere eliminato.",
    "deleteSuccess": "Il contratto e stato eliminato.",
    "detail": {
      "aiSuggest": "Suggerimento IA",
      "aiSuggestFailed": "Il suggerimento IA non e riuscito",
      "appendices": "Allegati ({{count}})",
      "appendicesInvestorHint": "Gli allegati fissano le condizioni valide per un singolo immobile.",
      "appendixProperty": "Immobile n. {{id}}",
      "autoRenewal": "automatische Verlängerung",
      "brokerCommission": "Onorario del mediatore",
      "buyer": "Acquirente",
      "buyerCommission": "Onorario dell'acquirente",
      "cancelContract": "Annulla contratto",
      "commissionRate": "Onorario",
      "companyLink": "Mostra azienda",
      "companyName": "Azienda",
      "config": "Configurazione",
      "confirmSend": "Inviare il contratto?",
      "confirmSendDescription": "Il contratto verrà inviato a tutti i firmatari via email.",
      "contactLink": "Mostra contatto",
      "contractDuration": "Durata del contratto",
      "contractNumber": "Numero di contratto",
      "contractTerms": "Condizioni contrattuali",
      "createdAt": "Creato il",
      "deleteContract": "Elimina contratto",
      "documents": "Documenti",
      "downloadPdf": "Scarica PDF",
      "emailStatus": "Consegna e-mail",
      "exclusive": "Mandato esclusivo",
      "exclusivity": "Esclusività",
      "expiresAt": "Valido fino al",
      "goToCountersign": "Controfirmare",
      "hidePdf": "Nascondi PDF",
      "months": "mesi",
      "noAppendices": "Questo contratto non ha ancora allegati.",
      "noData": "Nessun dato disponibile",
      "nonExclusive": "Non esclusivo",
      "parties": "Parti contrattuali",
      "partner": "Partner",
      "pdfNotAvailable": "PDF non disponibile",
      "pdfNotSupported": "PDF-Vorschau wird auf diesem Gerät nicht unterstützt.",
      "pdfPreviewNotSupported": "PDF-Vorschau wird auf diesem Gerät nicht unterstützt.",
      "personalMessage": "Messaggio personale (opzionale)",
      "personalMessagePlaceholder": "es. Si prega di firmare entro venerdì...",
      "plotNumber": "N. parcella",
      "property": "Immobile",
      "propertyDetails": "Dettagli immobile",
      "propertyType": "Tipo di oggetto",
      "protectionDuration": "Durata di protezione",
      "resetSignaturesConfirm": "Zurücksetzen & neu versenden",
      "resetSignaturesDescription": "Alle Unterschriften werden gelöscht und neue Unterzeichnungslinks per E-Mail versendet. Die Unterzeichner müssen erneut unterschreiben.",
      "resetSignaturesFailed": "Zurücksetzen fehlgeschlagen",
      "resetSignaturesTitle": "Unterschriften zurücksetzen?",
      "roles": "Ruoli",
      "seller": "Venditore",
      "sellerCommission": "Onorario del venditore",
      "sendContract": "Invia contratto",
      "sentAt": "Inviato il",
      "signatures": "Firme",
      "signedAt": "Firmato il",
      "template": "Modello",
      "terminateContract": "Disdire il contratto",
      "title": "Dettagli del contratto",
      "viewDetails": "Vedi dettagli",
      "viewPdf": "Mostra PDF"
    },
    "download": "Scarica",
    "downloadFailed": "Il download non e riuscito.",
    "errors": {
      "downloadFailed": "Download fallito",
      "generateFailed": "Impossibile creare il contratto",
      "loadFailed": "Impossibile caricare i modelli",
      "missingEmails": "Email mancante per",
      "missingSignatures": "Firme mancanti",
      "previewFailed": "Impossibile generare l'anteprima",
      "sendFailed": "Impossibile inviare il contratto",
      "signingFailed": "Firma fallita"
    },
    "form": {
      "agentEmail": "Email del mandatario",
      "agentName": "Mandatario",
      "authorizedEmail": "Email della persona",
      "authorizedPerson": "Persona autorizzata",
      "buyerAddress": "Indirizzo dell'acquirente",
      "buyerCommissionRate": "Tasso di onorario acquirente",
      "buyerEmail": "Email dell'acquirente",
      "buyerName": "Nome dell'acquirente",
      "commissionRate": "Tasso di onorario",
      "companyAddress": "Indirizzo dell'azienda",
      "companyName": "Nome dell'azienda",
      "exclusive": "Esclusivo",
      "exclusiveDescription": "Mandato esclusivo: Il venditore si impegna a non incaricare terzi per la commercializzazione e a non contattare direttamente i potenziali acquirenti identificati da Immotron.",
      "exclusivity": "Esclusività",
      "exclusivityDescription": "§5 Esclusività — Determina se il venditore può incaricare altri intermediari durante la durata del contratto.",
      "exclusivityDuration": "Durata dell'esclusività",
      "groups": {
        "agent": "Rappresentanza",
        "buyer": "Acquirente",
        "company": "Organizzazione",
        "config": "Configurazione",
        "general": "Generale",
        "partner": "Partner",
        "property": "Immobile",
        "seller": "Venditore"
      },
      "nonExclusive": "Non esclusivo",
      "nonExclusiveDescription": "Mandato non esclusivo: Il venditore resta obbligato a segnalare immediatamente a Immotron qualsiasi contatto o richiesta avviata tramite Immotron.",
      "partnerAddress": "Indirizzo del partner",
      "partnerEmail": "Email del partner",
      "partnerName": "Nome del partner",
      "plotNumber": "N. di parcella",
      "principalName": "Mandante",
      "propertyAddress": "Indirizzo dell'immobile",
      "propertyType": "Tipo di immobile",
      "protectionDuration": "Durata di protezione",
      "protectionDurationBuyerDescription": "§8 Non-circumvenzione — Clausola di protezione contro l'elusione. Qualsiasi transazione con un venditore o un immobile presentato dalla piattaforma è considerata intermediata. Penale: onorario doppio.",
      "protectionDurationSellerDescription": "§7 Non-circumvenzione — Clausola di protezione contro l'elusione. Qualsiasi transazione con un acquirente presentato dalla piattaforma è considerata intermediata. Penale: onorario doppio.",
      "sellerAddress": "Indirizzo del venditore",
      "sellerCommissionRate": "Tasso di onorario venditore",
      "sellerEmail": "Email del venditore",
      "sellerName": "Nome del venditore"
    },
    "generate": "Genera contratto",
    "generateClause": "Genera clausola IA",
    "generatingClause": "Generazione...",
    "generator": {
      "subtitle": "Crea contratti professionali in pochi passaggi",
      "title": "Generatore di contratti"
    },
    "issuer": "Emittente del contratto",
    "list": {
      "allSigned": "alle",
      "appendix": "Allegato",
      "appendixTypes": {
        "ANHANG_A": "Allegato A",
        "ANHANG_B": "Allegato B"
      },
      "buyer": "Acquirente",
      "contractNumber": "Numero di contratto",
      "created": "Erstellt",
      "createdAt": "Creato il",
      "dates": "Datum",
      "empty": {
        "description": "Crea il tuo primo contratto",
        "title": "Nessun contratto"
      },
      "page": "Pagina {{current}} di {{total}}",
      "parties": "Parteien",
      "searchMandate": "Suchmandat",
      "searchNoResults": "Nessun contratto trovato",
      "searchPlaceholder": "Cerca per numero, acquirente, venditore...",
      "seller": "Venditore",
      "sent": "Versendet",
      "signatories": "Unterzeichner",
      "signed": "unterschrieben",
      "signedDate": "Unterschrieben",
      "subtitle": "Gestisci i tuoi contratti creati",
      "template": "Modello",
      "toParentContract": "al contratto quadro",
      "typeFilter": "Tipo di contratto",
      "typeGroups": {
        "ALL": "Tutti",
        "BROKER": "Intermediario",
        "BUYER": "Acquirente",
        "OTHER": "Altro",
        "SELLER": "Venditore"
      },
      "us": "Uns"
    },
    "livePreview": {
      "error": "Impossibile aggiornare l'anteprima.",
      "hidePreview": "Mostra modulo",
      "loading": "Generazione anteprima...",
      "pages": "pagine",
      "placeholder": "Compilare i dati del modulo per attivare l'anteprima.",
      "previewLabel": "Anteprima",
      "print": "Stampa",
      "printTitle": "Anteprima contratto",
      "showPreview": "Mostra anteprima",
      "title": "Anteprima in tempo reale"
    },
    "loadingSignatories": "Caricamento firmatari...",
    "newContract": "Nuovo contratto",
    "newSearchMandate": "Mandato di ricerca",
    "noContracts": "Nessun contratto",
    "ourCompany": "La nostra azienda",
    "preview": {
      "document": "Anteprima del documento",
      "title": "Anteprima"
    },
    "resultsLabel": "Contratti",
    "roles": {
      "BROKER": "Mediatore",
      "BUYER": "Acquirente",
      "SELLER": "Venditore",
      "buyer": "Käufer",
      "partner": "Partner",
      "seller": "Verkäufer"
    },
    "selectSignatoriesFor": "Selezionare i firmatari autorizzati per {{company}}:",
    "selectedPersons": "{{count}} persona/e selezionata/e",
    "send": "Inviare",
    "sendFailed": "Impossibile inviare il contratto.",
    "sendSuccess": "Il contratto e stato inviato.",
    "sign": "Firma",
    "signatoryLoadError": "Impossibile caricare i firmatari.",
    "signatoryTypes": {
      "AGENT": "Mandatario",
      "BUYER": "Acquirente",
      "COMPANY_REP": "Organo autorizzato",
      "IMMOTRON": "Intermediaria",
      "PARTNER": "Partner",
      "SELLER": "Venditore",
      "USER": "Utente"
    },
    "signaturePad": {
      "complete": "Finalizza contratto",
      "description": "Si prega di firmare nei campi sottostanti. Tutte le firme sono obbligatorie.",
      "placeholder": "firma qui",
      "signaturesRequired": "firma/e richiesta/e",
      "signed": "firmato",
      "skipAndSaveDraft": "Salva come bozza",
      "title": "Raccolta firme"
    },
    "signing": {
      "modeDescription": "Come deve essere firmato il contratto?",
      "modeTitle": "Scegli la modalità di firma",
      "onsite": "Firma sul posto",
      "onsiteDescription": "Raccogli le firme direttamente sul dispositivo (es. iPad, tablet).",
      "remote": "Invia per la firma",
      "remoteDescription": "Invia il contratto via email ai firmatari."
    },
    "slider": {
      "months": "Mesi",
      "monthsUnit": "me.",
      "months_one": "{{count}} mese",
      "months_other": "{{count}} mesi",
      "noProtection": "Nessuna protezione",
      "years": "Anni",
      "yearsAndMonths": "{{years}} anno/i e {{months}} mese/i",
      "years_one": "{{count}} anno",
      "years_other": "{{count}} anni"
    },
    "specialConditions": "Condizioni particolari",
    "statuses": {
      "CANCELLED": "Annullato",
      "CUSTOMER_SIGNED": "Firmato dal cliente",
      "DRAFT": "Bozza",
      "EXPIRED": "Scaduto",
      "PARTIALLY_SIGNED": "Parzialmente firmato",
      "PENDING": "In sospeso",
      "SENT": "Inviato",
      "SIGNED": "Firmato",
      "TERMINATED": "Rescisso"
    },
    "steps": {
      "complete": "Completato",
      "form": "Dati",
      "preview": "Anteprima",
      "select": "Modello",
      "sign": "Firma"
    },
    "terminate": "Disdire",
    "terminateFailed": "La disdetta non e riuscita.",
    "terminateSuccess": "Il contratto e stato disdetto.",
    "termination": {
      "clause": "Clausola di disdetta",
      "clauseLabel": "Selezionare una clausola",
      "confirmButton": "Confermare la disdetta",
      "confirmSummary": "Riepilogo della disdetta",
      "contract": "Contratto",
      "description": "La preghiamo di indicare il motivo della disdetta.",
      "error": "La disdetta non ha potuto essere eseguita.",
      "reason": "Motivo della disdetta",
      "reasonLabel": "Motivo",
      "reasonPlaceholder": "La preghiamo di inserire il motivo della disdetta...",
      "reasonRequired": "E necessario indicare un motivo per la disdetta.",
      "selectClause": "Selezionare una clausola",
      "success": "Il contratto e stato disdetto con successo.",
      "title": "Disdire il contratto",
      "warningText": "Questa azione non puo essere annullata.",
      "warningTitle": "Attenzione"
    },
    "title": "Contratti",
    "types": {
      "BROKER_AGREEMENT": "Contratto di mediazione",
      "PLATFORM_AGREEMENT": "Contratto piattaforma",
      "SEARCH_MANDATE": "Mandato di ricerca"
    },
    "v2": {
      "addAppendixB": "Crea nuovo Allegato B",
      "aiClause": {
        "clauseNumber": "Clausola {{number}}",
        "confirmDelete": "Eliminare?",
        "context": "Contesto (opzionale)",
        "contextPlaceholder": "es. ritardo di ristrutturazione, comunità ereditaria, diritto di superficie...",
        "defaultDescription": "Disposizione speciale",
        "editClause": "Modifica clausola",
        "empty": "Nessuna clausola. Inserisci un contesto e genera.",
        "error": "Errore nella generazione della clausola",
        "generate": "Genera clausola",
        "generating": "Generazione...",
        "hint": "Il generatore di clausole IA crea clausole speciali personalizzate basate sui dati dell'immobile. È possibile modificare il testo generato in seguito.",
        "placeholder": "Le clausole speciali generate dall'IA appariranno qui...",
        "regenerate": "Rigenera",
        "tags": {
          "buildingRight": "Diritto di superficie",
          "divorce": "Divorzio",
          "estateManagement": "Amministrazione successoria",
          "forcedSale": "Vendita forzata",
          "heirsCompany": "Comunità ereditaria",
          "liquidityShortfall": "Carenza di liquidità",
          "relocation": "Trasferimento",
          "renovationBacklog": "Ritardo di ristrutturazione"
        },
        "title": "Generatore di clausole IA"
      },
      "appendices": "Allegati",
      "appendix": {
        "b": "Anhang B: Objektfreigabe"
      },
      "appendixB": {
        "add": "Aggiungi rilascio oggetto",
        "commissionModel": "Modello di onorario",
        "description": "Rilasciare gli immobili da commercializzare tramite la piattaforma.",
        "empty": "Nessun rilascio oggetto. È possibile aggiungere l'Allegato B al contratto quadro in seguito.",
        "exclusivity": "Esclusività",
        "inheritedFromParent": "dal contratto quadro",
        "newProperty": {
          "canton": "Cantone",
          "city": "Località",
          "cityPlaceholder": "es. Lugano",
          "create": "Crea nuovo immobile",
          "createError": "Errore nella creazione dell'immobile",
          "hint": "I dettagli dell'immobile possono essere aggiunti in seguito.",
          "propertyType": "Tipo di immobile",
          "streetAddress": "Indirizzo",
          "streetAddressPlaceholder": "es. Via Esempio 1",
          "submit": "Crea & seleziona",
          "title": "Crea nuovo immobile"
        },
        "overrideExclusivity": "Diverso dal contratto quadro",
        "protectionDuration": "Durata di protezione",
        "selectCommissionModel": "Scegli modello...",
        "selectProperty": "Seleziona immobile",
        "selectPropertyPlaceholder": "Scegli un immobile...",
        "title": "Rilascio oggetto"
      },
      "buyerPlatform": "Contratto piattaforma acquirente",
      "noAppendices": "Nessun allegato disponibile.",
      "parentContract": "Appartiene al contratto quadro",
      "sellerFramework": "Contratto quadro venditore",
      "viewParent": "Visualizza contratto quadro"
    },
    "validation": {
      "collectiveRequiresTwo": "Firma collettiva: sono necessarie almeno 2 persone autorizzate"
    },
    "searchMandate": "Suchauftrag",
    "countersign": "Gegenzeichnung"
  },
  "countersignPage": {
    "breadcrumb": {
      "contracts": "Contratti",
      "countersign": "Controfirma"
    },
    "buyer": "Acquirente",
    "contractDetails": "Dettagli del contratto",
    "contractNumber": "Numero di contratto",
    "contractType": "Tipo di contratto",
    "customerSignedAt": "Cliente firmato il",
    "days": "giorni",
    "error": {
      "loadFailed": "Impossibile caricare i dati del contratto.",
      "noSlots": "Nessuno slot di firma disponibile per il quale sei autorizzato.",
      "notFound": "Contratto non trovato.",
      "submitFailed": "La controfirma non è stata inviata. Riprova.",
      "title": "Errore",
      "unauthorized": "Non sei autorizzato a firmare questo slot di firma.",
      "wrongStatus": "Questo contratto non è pronto per la controfirma."
    },
    "geoConsent": "Condividere la posizione per la documentazione legale",
    "hidePdf": "Nascondi contratto",
    "legalNotice": "Con la controfirma confermate, in qualità di rappresentante autorizzato, che il contratto è stato esaminato e approvato.",
    "loading": "Caricamento dei dati del contratto...",
    "pdfTitle": "Anteprima del contratto",
    "selectSlot": "Seleziona",
    "selectedSlot": "Selezionato",
    "seller": "Venditore",
    "signatureLabel": "Firma",
    "signatureSlots": "Slot di firma",
    "signatureTitle": "La tua controfirma",
    "slotAvailable": "Disponibile per te",
    "slotLocked": "Non autorizzato",
    "slotSigned": "Già firmato",
    "submit": "Controfirmare",
    "submitting": "Controfirma in corso...",
    "subtitle": "Controfirma interna del contratto",
    "success": {
      "allComplete": "Tutte le firme sono complete. Il contratto è ora giuridicamente vincolante.",
      "description": "La controfirma è stata inviata con successo.",
      "moreRequired": "Sono ancora necessarie ulteriori firme interne.",
      "title": "Controfirma riuscita!"
    },
    "title": "Controfirma",
    "viewPdf": "Mostra contratto",
    "waitingDays": "Tempo di attesa"
  },
  "crm": {
    "activities": {
      "placeholder": "Gestione attività",
      "placeholderDescription": "La gestione delle attività CRM sarà disponibile in una futura versione.",
      "title": "Attività"
    },
    "contacts": {
      "addFirst": "Vai ai contatti",
      "backToContacts": "Torna ai contatti",
      "backToList": "Torna all’elenco",
      "companySearchCriteria": "Suchprofile verknüpfter Firmen",
      "contactInfo": "Dati di contatto",
      "dedup": "Deduplicazione",
      "details": "Details",
      "emptyDescription": "Erstellen Sie Ihren ersten Kontakt, um mit der CRM-Verwaltung zu beginnen.",
      "emptyTitle": "Noch keine Kontakte",
      "filterAll": "Tutti",
      "filterWithCompany": "Con azienda",
      "filterWithoutCompany": "Senza azienda",
      "goToCompany": "Zur Firma",
      "import": "Importa",
      "keyFigures": "Indicatori chiave",
      "lastActivity": "Letzte Aktivität",
      "noCompanyCriteria": "Keine Suchkriterien hinterlegt",
      "noResults": "Keine Kontakte gefunden",
      "notFound": "Contatto non trovato",
      "openDetail": "Apri",
      "ownSearchCriteria": "Eigenes Suchprofil",
      "ownership": "Responsabilità",
      "personalData": "Kontaktdaten",
      "placeholder": "Gestione contatti",
      "placeholderDescription": "La gestione dei contatti CRM sarà disponibile in una futura versione.",
      "previewTitle": "Anteprima rapida",
      "searchPlaceholder": "Cerca per nome, e-mail, telefono o azienda...",
      "subtitle": "Gestione contatti CRM",
      "tabOverview": "Panoramica",
      "tabResearch": "KI-Recherche",
      "tabSearchCriteria": "Profilo di ricerca",
      "tabTimeline": "Attività",
      "title": "Contatti",
      "tryDifferentSearch": "Prova un altro termine di ricerca",
      "unverifyConfirmText": "Questa persona perderà la verifica CRM per la firma dei contratti. Senza potere di firma Zefix, il portale di onboarding la rifiuterà. Questa modifica è rilevante ai fini dell'audit.",
      "unverifyConfirmTitle": "Rimuovere la verifica?",
      "verificationSection": "Verifica",
      "verifiedBadge": "Verificato per la firma dei contratti",
      "verifiedForSigningHint": "Apre la richiesta di contratto self-service per questa persona anche senza potere di firma Zefix.",
      "verifiedForSigningLabel": "Verificato per la firma dei contratti",
      "verifiedRemovedSuccess": "Verifica rimossa",
      "verifiedSetSuccess": "Verifica impostata",
      "verifiedUpdateError": "Impossibile aggiornare la verifica",
      "verifyConfirmText": "Questa persona sarà abilitata alla firma dei contratti e potrà completare l'onboarding anche senza iscrizione Zefix. Questa modifica è rilevante ai fini dell'audit.",
      "verifyConfirmTitle": "Impostare la verifica?",
      "masterDataCard": "Dati anagrafici",
      "channelsCard": "Indirizzo e recapiti",
      "rolesCard": "Ruoli aziendali",
      "addRole": "Aggiungi ruolo",
      "roleAlreadyLinked": "Questa organizzazione è già collegata",
      "rolePersonNotAllowed": "Seleziona un'organizzazione, non una persona",
      "contractsCard": "Contratti",
      "linkedinCard": "LinkedIn",
      "knowledgeTab": "Conoscenze"
    },
    "organizations": {
      "addContact": "Aggiungi contatto",
      "addFirst": "Vai alle organizzazioni",
      "addInvestorGroup": "Assegna gruppo di investitori",
      "addNew": "Nuova organizzazione",
      "addSearchCriteria": "Inserisci profilo di ricerca",
      "address": "Indirizzo",
      "allContacts": "Contatti: tutti",
      "canton": "Cantone",
      "capital": "Capitale",
      "contactAdded": "Contatto aggiunto",
      "contactCreatedAndLinked": "Contatto creato e collegato",
      "contactInfo": "Dati di base",
      "contactRemoved": "Contatto rimosso",
      "createdAt": "Creato il",
      "details": "Dettagli",
      "employees": "Dipendenti",
      "emptyDescription": "Crea la tua prima organizzazione per iniziare la gestione CRM.",
      "emptyTitle": "Nessuna organizzazione ancora",
      "hasContacts": "Con contatti",
      "hasSearchCriteria": "Profilo di ricerca disponibile",
      "industry": "Settore",
      "industryPlaceholder": "Scegli un settore...",
      "industriesFilter": "Settori",
      "removeIndustry": "Rimuovi settore",
      "investorGroupsTab": "Gruppi di investitori",
      "investorGroupsFilter": "Gruppi di investitori",
      "lastActivity": "Ultima attività",
      "lastResearched": "Ultima ricerca",
      "legalForm": "Forma giuridica",
      "newContact": "Nuovo contatto",
      "noContacts": "Senza contatti",
      "noContactsFound": "Nessun contatto trovato",
      "noInvestorGroups": "Nessun gruppo di investitori assegnato",
      "noResults": "Nessuna organizzazione trovata",
      "noResultsDescription": "Prova a modificare i termini di ricerca o i filtri.",
      "noSearchCriteria": "Nessun profilo di ricerca registrato",
      "notes": "Note",
      "overviewTab": "Panoramica",
      "ownership": "Responsabilità",
      "parentCompany": "Società madre",
      "pendingProposal": "Proposta di ricerca in sospeso — clicca per verificare",
      "placeholder": "Gestione organizzazioni",
      "placeholderDescription": "La gestione delle organizzazioni CRM sarà disponibile in una futura versione.",
      "primaryContact": "Contatto principale",
      "properties": {
        "contractActive": "Contratto attivo",
        "contractExpired": "Contratto scaduto",
        "contractMissing": "Nessun contratto",
        "empty": "Nessun immobile per questa organizzazione",
        "groupBy": "Raggruppa per",
        "groupByCanton": "Cantone",
        "groupByNone": "nessuno",
        "groupByStatus": "Stato",
        "groupByType": "Uso",
        "groupByVia": "Collegamento",
        "groupCount": "{{count}} immobili",
        "groupCountOne": "1 immobile",
        "groupNoValue": "Non indicato",
        "groupSumMillions": "CHF {{value}} mln",
        "groupTotal": "{{count}} immobili · {{sum}}",
        "groupTotalOne": "1 immobile · {{sum}}",
        "groupViaCompany": "Società",
        "groupViaContact": "tramite contatto",
        "propertyLabel": "Immobile",
        "sectionImmotron": "Su Immotron",
        "viaContact": "tramite contatto: {{name}}"
      },
      "propertiesTab": "Immobili",
      "purpose": "Scopo",
      "registerDetails": "Estratto del registro di commercio",
      "removeContact": "Rimuovi contatto",
      "removeFromOrg": "rimuovere da questa organizzazione?",
      "removePrimaryContact": "Rimuovi contatto principale",
      "knowledgeTab": "Conoscenze",
      "researchTab": "Ricerca IA",
      "roleUpdated": "Ruolo aggiornato",
      "searchContact": "Cerca contatto...",
      "searchCriteriaTab": "Profilo di ricerca",
      "nlSearch": {
        "placeholder": "Chiedi liberamente, ad es. «tutti quelli che cercano commerciale a Zurigo»",
        "ariaLabel": "Ricerca di organizzazioni in linguaggio naturale",
        "submit": "Cerca",
        "understoodAs": "Interpretato come:",
        "reset": "Reimposta",
        "searchIn": "Cerca in:",
        "sourceCriteria": "Mandati di ricerca",
        "sourcePurpose": "Scopo Zefix",
        "onlyWithCriteria": "solo con mandato",
        "parseError": "Impossibile interpretare la domanda. Riprova.",
        "unrecognizedHint": "Non attribuito con chiarezza — non applicato come filtro",
        "removeChip": "Rimuovi filtro",
        "reasonMandate": "Corrispondenza mandato di ricerca",
        "reasonPurpose": "Corrispondenza scopo Zefix",
        "noMandate": "nessun mandato di ricerca registrato",
        "chipType": "Tipo di immobile",
        "chipRegion": "Regione",
        "chipCanton": "Cantone",
        "chipYield": "Rendimento da",
        "chipPriceMin": "Prezzo da",
        "chipPriceMax": "Prezzo fino a",
        "chipUnits": "Unità min.",
        "chipText": "Testo",
        "noResultsTitle": "Nessun risultato",
        "noResultsHelp": "Prova ad allentare un filtro:",
        "loosenRemove": "Senza «{{label}}»",
        "loosenSources": "Cerca in entrambe le fonti",
        "loosenMandate": "Anche senza mandato"
      },
      "searchPlaceholder": "Cerca nome, IDE o settore...",
      "selectGroup": "Scegli un gruppo...",
      "setPrimaryContact": "Imposta come contatto principale",
      "subtitle": "Gestisci aziende e organizzazioni",
      "title": "Organizzazioni",
      "backToList": "Torna all’elenco",
      "notFound": "Organizzazione non trovata",
      "openDetail": "Apri",
      "previewTitle": "Anteprima rapida",
      "keyFigures": "Indicatori",
      "recentActivities": "Ultime attività",
      "noActivities": "Nessuna attività registrata",
      "zefixRevert": "Rimuovi collegamento Zefix",
      "zefixRevertTitle": "Annulla i dati Zefix",
      "zefixRevertConfirm": "Tutti i contatti Zefix di questa organizzazione vengono disattivati e il collegamento Zefix viene rimosso. I contatti fissati vengono conservati.",
      "zefixRevertConfirmLabel": "Annulla",
      "zefixRevertFailed": "Annullamento del collegamento Zefix non riuscito"
    },
    "createOrganization": {
      "stepSearch": "Passo 1 di 2 — Ricerca",
      "stepDetails": "Passo 2 di 2 — Dati",
      "searchIntro": "Prima cerca nel CRM e nel registro di commercio — così eviti i doppioni.",
      "manualEntry": "Inserire senza cercare",
      "existingCompany": "Questa organizzazione esiste già",
      "existingContact": "Questa voce esiste già come persona",
      "openExisting": "Vai alla voce esistente",
      "duplicateGeneric": "Questa organizzazione esiste già.",
      "fromZefix": "Ripreso dal registro di commercio",
      "nameRequired": "Il nome è obbligatorio",
      "seat": "Sede",
      "seatRequired": "La sede è obbligatoria",
      "detailsHint": "Tutto il resto — indirizzi, contatti, note — si completa poi nella pagina di dettaglio.",
      "submit": "Crea organizzazione"
    },
    "createContact": {
      "subtitle": "Solo i dati essenziali — tutto il resto nella pagina di dettaglio.",
      "duplicateEmail": "Questo indirizzo e-mail esiste già",
      "openExisting": "Vai alla voce esistente",
      "lastNameRequired": "Il cognome è obbligatorio",
      "firstNameRequired": "Il nome è obbligatorio",
      "emailOptional": "E-mail (facoltativo)",
      "checkingEmail": "Verifica dell'e-mail...",
      "organizationOptional": "Organizzazione (facoltativo)",
      "personPicked": "Questa è una persona — seleziona un'organizzazione.",
      "companyWillBeCreated": "Questa organizzazione verrà creata e collegata.",
      "submit": "Crea persona"
    }
  },
  "crmActivities": {
    "activityType": "Tipo",
    "addFailed": "Impossibile creare l'attività",
    "addSuccess": "Attività creata",
    "description": "Descrizione",
    "descriptionPlaceholder": "Dettagli opzionali...",
    "emptyTimeline": "Nessuna attività",
    "emptyTimelineHint": "Nessuna attività registrata per questa voce.",
    "entityCompany": "Azienda",
    "entityContact": "Contatto",
    "filterActivities": "Attività",
    "filterEmails": "E-mail",
    "filterTasks": "Compiti",
    "loadFailed": "Impossibile caricare le attività",
    "newActivity": "Nuova attività",
    "searchPlaceholder": "Cerca contatto o azienda...",
    "selectEntity": "Seleziona contatto o azienda",
    "selectEntityHint": "Cerca un contatto o un'azienda per visualizzare la cronologia delle attività.",
    "subject": "Oggetto",
    "subjectPlaceholder": "Breve descrizione...",
    "subtitle": "Cronologia CRM per contatti e aziende",
    "title": "Attività",
    "types": {
      "call": "Chiamata",
      "email": "E-mail",
      "meeting": "Riunione",
      "note": "Nota",
      "task": "Compito"
    }
  },
  "dashboard": {
    "actions": {
      "addProperty": "Aggiungi proprietà",
      "createContract": "Crea contratto",
      "manageUsers": "Gestisci utenti",
      "searchProperties": "Cerca proprietà"
    },
    "activity": {
      "daysAgo": "{{count}}g fa",
      "hoursAgo": "{{count}}h fa",
      "justNow": "Ora"
    },
    "awaitingCountersign": "Controfirma",
    "conversionRate": "Tasso di conversione",
    "countersign": "Controfirma richiesta",
    "customize": "Personalizza dashboard",
    "dealflowPipeline": "Pipeline Dealflow",
    "errors": {
      "loadFailed": "Impossibile caricare la dashboard"
    },
    "investor": {
      "availableProperties": "Altri immobili disponibili",
      "dossierAccess": "Accesso al dossier",
      "goToSearch": "Vai alla ricerca",
      "kpi": {
        "activeListings": "Teasers attivi",
        "availableForYou": "Disponibili per te",
        "buying": "Acquisto",
        "inPreparation": "In preparazione",
        "inSale": "In vendita",
        "myProperties": "I miei immobili",
        "selling": "Vendita",
        "sold": "Venduti",
        "viewed": "Consultati"
      },
      "myProperties": "I miei immobili approvati",
      "noProperties": "Nessun immobile disponibile",
      "noPropertiesHint": "Al momento non ci sono immobili visibili per lei.",
      "pendingAccess": "Senza accesso",
      "propertiesAvailable": "Immobili disponibili",
      "recentlyViewed": "Visitati di recente",
      "recentlyViewedEmpty": "Nessun oggetto visitato finora — inizia dalla ricerca!",
      "ndaSigned": "NDA firmato",
      "favorites": "Preferiti",
      "newlyAdded": "Nuovi inserimenti"
    },
    "noActivity": "Nessuna attività recente",
    "overdue": "In ritardo",
    "pendingSignatures": "Inviati — in attesa di firma",
    "quickActions": "Azioni rapide",
    "recentActivity": "Attività recente",
    "resetLayout": "Ripristina",
    "role": "Ruolo: {{role}}",
    "showAll": "Mostra tutto",
    "statistics": "Statistiche",
    "stats": {
      "contactsTotal": "Contatti totali",
      "contractsDraft": "Bozze",
      "contractsPending": "Contratti in sospeso",
      "contractsSigned": "Firmati",
      "contractsTotal": "Contratti totali",
      "propertiesActive": "Proprietà attive",
      "propertiesTotal": "Proprietà totali"
    },
    "statusBreakdown": "Panoramica stati contratti",
    "statusCancelled": "Annullato",
    "statusDraft": "Bozza",
    "statusPending": "In sospeso",
    "statusSigned": "Firmato",
    "title": "Dashboard",
    "welcome": "Benvenuto, {{name}}",
    "widgets": {
      "activity": "Attività recente",
      "countersign": "Controfirma",
      "dealflow": "Pipeline Dealflow",
      "investorAvailable": "Immobili disponibili",
      "investorKpi": "Panoramica KPI",
      "investorNetflix": "Scopri immobili",
      "investorProperties": "I miei immobili",
      "pendingSignatures": "Firme in sospeso",
      "statCards": "Schede statistiche",
      "tasks": "Attività"
    },
    "colSpan": {
      "title": "Spaltenbreite"
    },
    "customizeHint": "Widgets per Drag & Drop sortieren. Klicke auf das Spalten-Icon für die Breite."
  },
  "deals": {
    "actions": {
      "cancel": "Annulla deal"
    },
    "confirmCancel": "Vuoi davvero annullare questo deal?",
    "confirmDelete": "Vuoi davvero eliminare questo deal?",
    "confirmPhaseChange": "Cambiare fase a {{phase}}?",
    "create": "Nuovo Deal",
    "detail": {
      "dealNumber": "N. Deal",
      "financingPhase": "Fase di finanziamento",
      "listing": "Teaser / Immobile",
      "ourCompany": "La nostra azienda",
      "phaseDetails": "Dettagli delle fasi",
      "qaPhase": "Fase Q&A",
      "seller": "Venditore",
      "title": "Titolo"
    },
    "documents": {
      "noneRequired": "Nessun documento richiesto.",
      "progress": "Completezza",
      "title": "Documenti"
    },
    "empty": {
      "description": "Crea un nuovo deal per iniziare.",
      "title": "Nessun deal"
    },
    "errors": {
      "cancelFailed": "Impossibile annullare il deal.",
      "loadFailed": "Impossibile caricare i deals.",
      "phaseChangeFailed": "Cambio fase fallito."
    },
    "phases": {
      "ACTIVE": "Attivo",
      "CANCELLED": "Annullato",
      "CLOSING": "Chiusura",
      "COMPLETED": "Completato",
      "DRAFT": "Bozza",
      "DUE_DILIGENCE": "Due Diligence",
      "FINANCING": "Finanziamento",
      "QA_PHASE": "Q&A"
    },
    "searchPlaceholder": "Cerca per numero o titolo...",
    "subtitle": "Gestire le transazioni immobiliari",
    "timeline": {
      "addEvent": "Aggiungi evento",
      "empty": "Nessun evento ancora.",
      "eventPlaceholder": "Descrizione dell'evento...",
      "title": "Cronologia"
    },
    "title": "Deals"
  },
  "deletionBlockers": {
    "description": "non può essere eliminato/a perché esistono ancora dipendenze:",
    "forceDelete": "Elimina comunque (Admin)",
    "hint": "Rimuovere o riassegnare le dipendenze elencate sopra.",
    "title": "Eliminazione non possibile"
  },
  "deletionWizard": {
    "actionDelete": "Elimina",
    "actionIgnore": "Ignora",
    "actionReassign": "Riassegna",
    "confirmDelete": "Elimina definitivamente",
    "confirmDescription": "«{{name}}» e le dipendenze selezionate verranno eliminate in modo irreversibile.",
    "confirmWarning": "Attenzione: questa azione non può essere annullata!",
    "continue": "Continua",
    "deleteSuccess": "Organizzazione e dipendenze eliminate",
    "dependencySummary": "Questa organizzazione ha {{count}} dipendenza/e. Scegli un'azione per ogni gruppo.",
    "endpointNotReady": "La verifica delle dipendenze non è ancora disponibile.",
    "loadError": "Errore durante il caricamento delle dipendenze.",
    "loadingDependencies": "Verifica delle dipendenze in corso…",
    "noDependencies": "Nessuna dipendenza trovata — l'organizzazione può essere eliminata.",
    "selectTargetCompany": "Cerca azienda di destinazione…",
    "stepActions": "Scegli le azioni",
    "stepConfirm": "Conferma",
    "title": "Elimina organizzazione — Dipendenze"
  },
  "developer": {
    "booking": {
      "amount": "Importo (CHF)",
      "amountInvalid": "La ricarica deve essere maggiore di 0, la correzione non può essere 0.",
      "forbidden": "Non puoi registrare credito per questa azienda.",
      "kind": "Tipo",
      "kindCorrection": "Correzione",
      "kindTopupInvoice": "Ricarica su fattura",
      "note": "Nota",
      "open": "Registra credito",
      "reference": "Riferimento (numero fattura)",
      "saved": "Registrato — nuovo saldo CHF {{balance}}",
      "sectionTitle": "Credito di questa azienda",
      "submit": "Registra"
    },
    "credits": {
      "amount": "Importo (CHF)",
      "balance": "Credito attuale",
      "bookings": "Movimenti",
      "colAmount": "Importo",
      "colBalance": "Saldo dopo",
      "colDate": "Data",
      "colKind": "Tipo",
      "colReference": "Riferimento",
      "empty": "Nessun movimento finora.",
      "kinds": {
        "charge": "Valutazione oggetto",
        "correction": "Correzione",
        "topup_card": "Ricarica carta/Twint",
        "topup_invoice": "Ricarica su fattura"
      },
      "low": "Credito quasi esaurito — si prega di ricaricare.",
      "noCompany": "A questo accesso non è associata alcuna azienda.",
      "paymentsDisabled": "Il pagamento non è al momento disponibile. Si prega di contattare Immotron.",
      "receipt": "Ricevuta",
      "tab": "Credito",
      "topup": "Ricarica credito",
      "topupCancelled": "Pagamento annullato.",
      "topupHint": "Pagamento con carta di credito o Twint tramite Stripe. Il credito viene accreditato subito dopo il pagamento.",
      "topupSuccess": "Pagamento ricevuto — il credito è stato accreditato."
    },
    "guide": {
      "copied": "Copiato",
      "copy": "Copia",
      "intro": "Tre passi per collegare il suo assistente.",
      "priceNote": "Ogni valutazione oggetto è una chiamata che detrae CHF 30 dal credito. Ricarica nella scheda «Credito»; l'utilizzo è visibile nella scheda «Utilizzo».",
      "step1": "Crei una chiave nella scheda «Chiavi API» e la copi subito — viene mostrata una sola volta.",
      "step1Title": "Creare una chiave API",
      "step2": "Il suo assistente si collega a questo indirizzo (MCP, streamable HTTP) e invia la chiave come token Bearer.",
      "step2Title": "Indirizzo del servizio",
      "step3": "Esempi per gli assistenti più diffusi — inserisca indirizzo e chiave, poi lo strumento «Valutazione oggetto» è disponibile.",
      "step3Title": "Configurare l'assistente"
    },
    "navLabel": "Sviluppatore",
    "signup": {
      "acceptTerms": "Accetto le <0>CG</0>.",
      "acceptTermsRequired": "Si prega di accettare le CG.",
      "backToLogin": "Torna al login",
      "companyName": "Azienda",
      "email": "E-mail",
      "firstName": "Nome",
      "intro": "Collega il tuo assistente IA a Immotron e ottieni valutazioni oggetto via API. Dopo la conferma dell'indirizzo e-mail crei le tue chiavi API e ricarichi il credito.",
      "lastName": "Cognome",
      "loginLink": "Richiedi accesso sviluppatore",
      "sentHint": "Il link è valido per 72 ore. Nessuna e-mail? Controlla la cartella spam.",
      "sentMessage": "Abbiamo inviato un'e-mail a {{email}}. Imposta la password tramite il link per attivare l'accesso.",
      "sentTitle": "E-mail in arrivo",
      "submit": "Richiedi accesso",
      "title": "Richiedi accesso sviluppatore",
      "unavailable": "La richiesta non è attualmente disponibile. Riprovare più tardi."
    },
    "subtitle": "Gestisca le chiavi API e colleghi il suo assistente IA a Immotron.",
    "tabs": {
      "guide": "Guida",
      "keys": "Chiavi API",
      "usage": "Utilizzo"
    },
    "title": "Accesso sviluppatore",
    "usage": {
      "colCalls": "Chiamate",
      "colChf": "CHF",
      "colMonth": "Mese",
      "colTool": "Strumento",
      "csv": "Scarica CSV",
      "empty": "Nessuna chiamata nel periodo selezionato.",
      "forbidden": "Nessuna autorizzazione per questa azienda.",
      "mandantTitle": "Utilizzo sviluppatore (API)",
      "rangeLastMonth": "Mese scorso",
      "rangeThisMonth": "Questo mese",
      "rangeThisYear": "Quest'anno",
      "title": "Utilizzo",
      "tools": {
        "property_evaluate": "Valutazione oggetto"
      },
      "total": "Totale"
    }
  },
  "documentViewer": {
    "deselectAll": "Deseleziona tutto",
    "downloadComplete": "Download completato",
    "downloadDossier": "Scarica dossier completo",
    "downloadFailed": "Download fallito",
    "downloading": "Download in corso...",
    "exitFullscreen": "Esci da schermo intero",
    "fullscreen": "Schermo intero",
    "noDocuments": "Nessun documento disponibile",
    "of": "di",
    "page": "Documento",
    "selectDocuments": "Seleziona documenti",
    "selectedCount": "{{count}} documenti",
    "viewer": "Visualizzatore documenti",
    "zoomIn": "Ingrandisci",
    "zoomOut": "Riduci"
  },
  "documents": {
    "addCustomCategory": "Aggiungi categoria",
    "allCategories": "Tutte le categorie",
    "categories": {
      "bo": "BO – offerta vincolante",
      "grundbuchauszug": "Estratto del registro fondiario",
      "korrespondenz": "Corrispondenza",
      "legitimation": "Legittimazione",
      "nbo": "NBO – offerta indicativa",
      "nda": "NDA",
      "sonstiges": "Altro",
      "vertrag": "Contratto"
    },
    "categoriesFilled": "{{done}} di {{total}} categorie compilate",
    "category": "Categoria",
    "categoryChanged": "Categoria modificata",
    "changeCategory": "Modifica categoria",
    "combinedDownload": "Download combinato",
    "customCategoryPlaceholder": "Nome della categoria...",
    "delete": "Eliminare documento",
    "deleteConfirm": "Vuole davvero eliminare «{{name}}»?",
    "deleteSuccess": "Documento eliminato",
    "description": "Descrizione",
    "documentPlural": "documenti",
    "documentSingular": "documento",
    "documentsCount": "documento/i",
    "dossierCategories": {
      "amtliche_schaetzung": "Stima ufficiale",
      "baubeschrieb": "Descrizione dell'edificio",
      "bewertungsgutachten": "Perizia di valutazione",
      "grundbuchauszug": "Estratto del registro fondiario",
      "grundrisse": "Planimetrie / Piani",
      "investitionen": "Investimenti",
      "investorendossier": "Exposé",
      "katasterplan": "Piano catastale / RDPP",
      "liegenschaftenabrechnung": "Rendiconto immobiliare",
      "mieterspiegel": "Specchio degli affitti",
      "mietvertraege": "Contratti di locazione",
      "renovationen": "Ristrutturazioni"
    },
    "dossierGroups": {
      "custom": "Personalizzato",
      "investor_dossier": "Exposé",
      "supplementary": "Documenti integrativi",
      "valuation": "Documenti di valutazione"
    },
    "dossierProgress": "Completezza del dossier",
    "dossierSummary": "{{total}} documento/i in {{categories}} di {{totalCategories}} categorie",
    "dossierTooltips": {
      "amtliche_schaetzung": "Rapporto di stima ufficiale attuale dell'autorità fiscale cantonale o dell'assicurazione degli edifici.",
      "baubeschrieb": "Descrizione ufficiale dell'edificio secondo la domanda di costruzione o la documentazione di vendita, con indicazioni su modalità costruttiva, materiali e standard di finitura.",
      "bewertungsgutachten": "Perizia indipendente del valore venale o di mercato di un esperto estimatore riconosciuto.",
      "grundbuchauszug": "Estratto attuale del registro fondiario dell'ufficio competente (non più vecchio di 6 mesi). Il documento deve contenere proprietario, numero di particella, servitù e pegni immobiliari.",
      "grundrisse": "Piante in scala di tutti i piani con indicazioni delle superfici.",
      "investitionen": "Investimenti documentati degli ultimi anni con fatture o riepilogo delle ristrutturazioni principali.",
      "investorendossier": "Exposé completo con descrizione dell'oggetto, cifre chiave finanziarie e analisi della posizione.",
      "katasterplan": "Piano catastale ufficiale dell'ufficio di misurazione con confini di particella, numeri di mappale e designazione della posizione. Incluso estratto RDPP se disponibile.",
      "liegenschaftenabrechnung": "Ultimo rendiconto annuale dell'immobile con costi di gestione e manutenzione.",
      "mieterspiegel": "Panoramica di tutti gli inquilini con affitto, superficie e inizio del contratto.",
      "mietvertraege": "Contratti di locazione completi e firmati di tutti i rapporti di locazione esistenti, inclusi integrazioni e accordi.",
      "renovationen": "Panoramica o documentazione delle ristrutturazioni effettuate con data e portata dei lavori."
    },
    "download": "Scaricare",
    "fileSize": "Dimensione",
    "fileTooLarge": "Il file «{{name}}» è troppo grande (max. 50 MB)",
    "filename": "Nome file",
    "generate": "Genera",
    "generateFailed": "Generazione del documento fallita",
    "generated": "{{type}} generato con successo",
    "generatedAt": "Generato il",
    "immotronDocuments": "Documenti Immotron",
    "inCategories": "in {{count}} categorie",
    "link": "Collega",
    "linkExisting": "Collega documento",
    "linkNoResults": "Nessun documento trovato",
    "linkSearchPlaceholder": "Cerca documento...",
    "linkSuccess": "Documento collegato",
    "mergingDocuments": "Unione dei documenti...",
    "noCategory": "Senza categoria",
    "noDocuments": "Nessun documento",
    "noDocumentsShort": "Nessun documento",
    "notGenerated": "Non ancora generato",
    "onlyMissing": "Solo mancanti",
    "openInBrowser": "Apri nel browser",
    "originalDocuments": "Documenti originali",
    "pageOf": "Pagina {{current}} di {{total}}",
    "preview": "Anteprima",
    "previewUnavailable": "Anteprima non disponibile",
    "regenerate": "Rigenera",
    "requiredDocsTitle": "Documenti obbligatori",
    "requiredDocsProgress": "{{done}} di {{total}} documenti obbligatori disponibili",
    "saveAsDraft": "Salva come bozza",
    "saveFirstForDocuments": "Salvare prima l'immobile per poter caricare i documenti.",
    "selectCategory": "Scegliere la categoria",
    "showOnlyMissing": "Mostra solo documenti mancanti",
    "subgroup": {
      "label": "Sottogruppo",
      "placeholder": "p. es. estratti ÖREB",
      "saved": "Sottogruppo salvato"
    },
    "title": "Documenti",
    "uncategorized": "Documenti non classificati",
    "unsupportedType": "Il tipo di file di «{{name}}» non è supportato",
    "upload": "Caricare documento",
    "uploadCategory": "Categoria per i nuovi documenti",
    "uploadDragDrop": "Trascinare i file qui o cliccare per caricare",
    "uploadFirst": "Carichi il primo documento",
    "uploadHint": "PDF, Word, Excel, immagini. Max. 50 MB.",
    "uploadMore": "Caricare altri file",
    "uploadSuccess": "Documento caricato",
    "uploadedAt": "Caricato il",
    "viaContact": "tramite {{name}}"
  },
  "emailAccounts": {
    "addImap": "Aggiungi account IMAP",
    "autoFillHint": "I campi sono stati precompilati dal tuo profilo",
    "cancel": "Annulla",
    "changeScope": "Firmenzuordnung ändern",
    "company": "Firma",
    "companyAccounts": "Caselle aziendali",
    "connect": "Connetti",
    "connectGoogle": "Google verbinden",
    "connectMicrosoft": "Microsoft verbinden",
    "connected": "Verbunden",
    "connecting": "Connessione...",
    "deactivated": "Deaktiviert",
    "disconnect": "Konto trennen",
    "displayName": "Nome visualizzato",
    "emailAddress": "Indirizzo e-mail",
    "errors": {
      "connectFailed": "Connessione fallita",
      "deleteFailed": "Errore durante la disconnessione",
      "invalidOAuthState": "Ungültiger OAuth-State — bitte erneut versuchen",
      "loadFailed": "Impossibile caricare gli account e-mail",
      "oauthFailed": "OAuth-Verbindung fehlgeschlagen",
      "scopeChangeFailed": "Impossibile modificare l'assegnazione",
      "tokenRefreshFailed": "Token-Erneuerung fehlgeschlagen — erneut verbinden"
    },
    "goToSettings": "Zu den Einstellungen",
    "imapFormTitle": "Aggiungi manualmente un account IMAP/SMTP",
    "imapHost": "Server IMAP",
    "imapPort": "Porta IMAP",
    "loadError": "E-Mail-Konten konnten nicht geladen werden",
    "loading": "Konten werden geladen...",
    "noAccounts": "Nessun account e-mail collegato",
    "noAccountsHint": "Collega un account Google, Microsoft o IMAP",
    "notSynced": "Noch nicht synchronisiert",
    "password": "Password",
    "private": "Privat",
    "privateAccounts": "Caselle private",
    "reconnect": "Erneut verbinden",
    "refreshToken": "Token erneuern",
    "scope": "Assegnazione",
    "scopePrivate": "Privato (solo per me)",
    "smtpHost": "Server SMTP",
    "smtpPort": "Porta SMTP",
    "subtitle": "Collega caselle Google, Microsoft o IMAP",
    "success": {
      "connected": "Account e-mail collegato",
      "deleted": "Account e-mail disconnesso",
      "scopeChanged": "Assegnazione aggiornata",
      "tokenRefreshed": "Token erneuert"
    },
    "syncTime": {
      "justNow": "gerade eben"
    },
    "thisCompany": "diese Firma",
    "title": "Account e-mail",
    "useTls": "Usa TLS"
  },
  "emailScore": {
    "level": "Punteggio e-mail: {{level}}/5",
    "star1": "Sintassi valida",
    "star2": "Dominio esistente",
    "star3": "Record MX presente",
    "star4": "Casella raggiungibile",
    "star5": "Consegna confermata"
  },
  "emailAttachments": {
    "addShort": "Allega",
    "all": "Tutti",
    "confirm": "Conferma",
    "empty": "Nessun documento disponibile. Carica un file.",
    "emptyFilter": "Nessun documento in questa categoria.",
    "selected": "{{count}} selezionato/i",
    "sourceCompany": "Azienda",
    "sourceContact": "Contatto",
    "sourceProperty": "Oggetto",
    "sourceTask": "Attività",
    "title": "Allega documenti",
    "uploadHint": "Carica file",
    "uploading": "Caricamento..."
  },
  "emailSignature": {
    "defaultTemplate": "Modello predefinito",
    "emailHint": "Preso dal tuo account e-mail (scheda «Account e-mail»).",
    "errors": {
      "loadFailed": "Impossibile caricare le firme",
      "previewFailed": "Impossibile caricare l'anteprima",
      "saveFailed": "Impossibile salvare la firma"
    },
    "fields": {
      "email": "E-mail",
      "function": "Funzione",
      "name": "Nome",
      "phone": "Telefono"
    },
    "fullPreview": "Anteprima e-mail completa",
    "infoText": "Configura la tua firma e-mail personale per mandante. Nome, funzione ed e-mail vengono dal tuo profilo. Puoi modificare il numero di telefono e il modello qui.",
    "livePreview": "Anteprima dal vivo",
    "noCompanies": "Nessuna affiliazione aziendale",
    "noCompaniesDesc": "Non sei assegnato a nessun mandante. Chiedi a un amministratore di aggiungerti.",
    "noSignatureYet": "Nessun dato di firma disponibile. Completa il tuo profilo.",
    "noTemplate": "Nessun modello (solo firma)",
    "personal": "Personale",
    "preview": "Anteprima",
    "previewTitle": "Anteprima e-mail — {{company}}",
    "saved": "Firma e-mail salvata",
    "signatureDetails": "Dettagli firma",
    "signaturePreview": "Anteprima firma",
    "subtitle": "Configura la tua firma e-mail e il modello predefinito per mandante",
    "tabLabel": "Firma e-mail",
    "template": "Modello",
    "templateHint": "Vengono mostrati solo i modelli personali. Il modello viene utilizzato per le e-mail dell'Agente CEO.",
    "templateReadonlyHint": "Il modello è gestito dall'amministratore in Impostazioni > Modelli e-mail.",
    "title": "Firma e-mail personale"
  },
  "emailTemplates": {
    "active": "Attivo",
    "allCompanies": "Tutti i mandanti",
    "categories": {
      "all": "Tutti",
      "contract-signing": "Firma contratto",
      "marketing": "Marketing",
      "notification": "Notifiche"
    },
    "category": "Categoria",
    "categoryPlaceholder": "z.B. Immobilien, Newsletter",
    "confirmDelete": "Vuoi davvero eliminare questo modello?",
    "confirmDeleteDescription": "E sicuro/a di voler eliminare questo modello?",
    "createSuccess": "Modello creato con successo",
    "deleteSuccess": "Modello eliminato con successo",
    "deleteTemplate": "Elimina modello",
    "deleted": "Il modello e stato eliminato.",
    "description": "Descrizione",
    "editTemplate": "Modifica modello",
    "errors": {
      "deleteFailed": "Il modello non ha potuto essere eliminato.",
      "loadFailed": "Impossibile caricare i modelli",
      "saveFailed": "Il modello non ha potuto essere salvato."
    },
    "inactive": "Inattivo",
    "list": {
      "empty": {
        "description": "Crea il tuo primo modello",
        "title": "Nessun modello"
      }
    },
    "name": "Nome",
    "newTemplate": "Nuovo modello",
    "personalOnly": "Persönliche Vorlage (nur für mich sichtbar)",
    "saved": "Il modello e stato salvato.",
    "scopeCompany": "Firmenvorlage",
    "scopeCompanyLabel": "Firma",
    "scopePersonal": "Persönliche Vorlage",
    "scopePersonalLabel": "Persönlich",
    "search": "Cerca modelli...",
    "subtitle": "Modelli riutilizzabili per campagne",
    "title": "Modelli e-mail",
    "updateSuccess": "Modello aggiornato con successo"
  },
  "emailTracking": {
    "expired": "Scaduto",
    "pending": "In sospeso",
    "resend": "Reinviare",
    "resendConfirm": "Reinviare l'e-mail di firma a {{name}}?",
    "resendFailed": "Impossibile inviare l'e-mail",
    "resendSuccess": "E-mail reinviata a {{email}}",
    "steps": {
      "clicked": "Link cliccato",
      "opened": "Aperto",
      "sent": "Inviato",
      "signed": "Firmato"
    },
    "title": "Firme & consegna"
  },
  "emails": {
    "account": "Konto:",
    "attachments": "Anhänge",
    "bulkDeleteConfirmDescription": "Die ausgewählten Emails werden dauerhaft gelöscht und können nicht wiederhergestellt werden. Sie werden auch beim E-Mail-Provider entfernt.",
    "bulkDeleteConfirmLabel": "Alle löschen",
    "bulkDeleteFailed": "Emails konnten nicht gelöscht werden",
    "classification": {
      "actionable": "Aktion",
      "ignored": "Ignoriert"
    },
    "createTask": "Pendenz erstellen",
    "date": "Datum:",
    "deleteConfirmDescription": "Die Email wird dauerhaft gelöscht und kann nicht wiederhergestellt werden. Sie wird auch beim E-Mail-Provider entfernt.",
    "deleteConfirmTitle": "Email löschen?",
    "deleteEmail": "Email löschen",
    "deleteFailed": "Email konnte nicht gelöscht werden",
    "deleted": "Email gelöscht",
    "deselectAll": "Auswahl aufheben",
    "detailLoadFailed": "Email konnte nicht geladen werden",
    "editor": {
      "bold": "Fett (Ctrl+B)",
      "bulletList": "Aufzählung",
      "enterImageUrl": "Bild-URL eingeben:",
      "enterUrl": "URL eingeben:",
      "heading1": "Überschrift 1",
      "heading2": "Überschrift 2",
      "heading3": "Überschrift 3",
      "insertImage": "Bild einfügen (URL)",
      "insertLink": "Link einfügen",
      "italic": "Kursiv (Ctrl+I)",
      "orderedList": "Nummerierte Liste",
      "redo": "Wiederholen (Ctrl+Shift+Z)",
      "removeColor": "Farbe entfernen",
      "removeLink": "Link entfernen",
      "textColor": "Textfarbe",
      "underline": "Unterstrichen (Ctrl+U)",
      "undo": "Rückgängig (Ctrl+Z)"
    },
    "enrichContact": "Kontakt anreichern",
    "filters": {
      "actionable": "Aktion nötig",
      "alert": "Alert",
      "allAccounts": "Alle Konten",
      "allDirections": "Alle Richtungen",
      "allTypes": "Alle Typen",
      "ignored": "Ignoriert",
      "inbound": "Eingehend",
      "informational": "Info",
      "outbound": "Gesendet",
      "read": "Gelesen",
      "unread": "Ungelesen"
    },
    "from": "Von:",
    "goToTask": "Zur Pendenz",
    "loadFailed": "Emails konnten nicht geladen werden",
    "markRead": "Als gelesen markieren",
    "markUnread": "Als ungelesen markieren",
    "noContent": "Kein Inhalt verfügbar",
    "noEmails": "Keine Emails vorhanden",
    "noResults": "Keine Ergebnisse",
    "noSubject": "(Kein Betreff)",
    "replyNotAvailable": "Le risposte si inviano dal tuo account e-mail — Immotron mostra solo la conversazione.",
    "searchPlaceholder": "Emails durchsuchen...",
    "syncFailed": "Sync fehlgeschlagen",
    "taskCreateFailed": "Pendenz konnte nicht erstellt werden",
    "thread": {
      "empty": "Nessun messaggio in questa conversazione",
      "inbound": "Ricevuta",
      "loadFailed": "Impossibile caricare la conversazione",
      "messages": "{{count}} messaggi",
      "openEmail": "Apri e-mail: {{subject}}",
      "openInInbox": "Apri nella casella di posta",
      "outbound": "Inviata",
      "reply": "Rispondi",
      "title": "Conversazione"
    },
    "title": "Emails",
    "to": "An:",
    "updateFailed": "Fehler beim Aktualisieren"
  },
  "entityInput": {
    "addPersonManually": "Person manuell hinzufügen",
    "address": "Adresse",
    "addressPlaceholder": "Strasse, PLZ Ort",
    "available": "verfügbar",
    "buyerName": "Name des Käufers",
    "capital": "Kapital",
    "clearSelection": "Auswahl löschen",
    "collectiveMoreRequired": "Kollektivunterschrift: mindestens 2 Personen erforderlich",
    "collectiveTwoRequired": "Kollektivunterschrift zu zweien: mindestens 2 Personen erforderlich",
    "company": "Firma",
    "companyName": "Firmenname",
    "crmBadge": "CRM",
    "crmContactsSection": "Contatti CRM",
    "deselectAll": "Keine auswählen",
    "email": "E-Mail",
    "emailForSignature": "E-Mail-Adresse für Vertragsunterschrift",
    "emailPlaceholder": "E-Mail-Adresse eingeben",
    "emailRequiredForSignature": "E-Mail wird für die Signatur benötigt",
    "fetchPdfFromRegister": "PDF vom Handelsregister abrufen",
    "fetchedAt": "Abgerufen",
    "fullNamePlaceholder": "Vor- und Nachname",
    "loadingCrmContacts": "Caricamento contatti CRM...",
    "manualPersonHint": "Erfassen Sie eine Person, die gemäss internem Kontrollsystem (IKS) zeichnungsberechtigt ist, aber nicht im Handelsregister eingetragen.",
    "manuallyAdded": "Manuell erfasst (IKS)",
    "noSignatoriesFound": "Keine Zeichnungsberechtigten in der Zefix-API gefunden.",
    "noSignatoriesInPdf": "Keine Zeichnungsberechtigten im PDF gefunden",
    "partnerName": "Name des Partners",
    "pdfFetchFailed": "PDF konnte nicht abgerufen werden",
    "pdfFetchHint": "Dies kann einige Sekunden dauern",
    "pdfFetching": "PDF wird abgerufen...",
    "private": "Privatperson",
    "searchCommercialRegister": "Firma im Handelsregister suchen",
    "searchPlaceholder": "Firmenname oder UID eingeben...",
    "selectAll": "Alle auswählen",
    "selectSignatories": "Zeichnungsberechtigte auswählen",
    "sellerName": "Name des Verkäufers",
    "signatories": "Zeichnungsberechtigte",
    "signatureType": "Unterschriftstyp",
    "zefixBadge": "Zefix",
    "zefixRevert": "Rimuovi Zefix",
    "zefixRevertTitle": "Annulla i dati Zefix",
    "zefixRevertConfirm": "Tutti i contatti Zefix di questa organizzazione verranno disattivati e il collegamento Zefix rimosso. I contatti fissati verranno mantenuti.",
    "zefixRevertConfirmLabel": "Annulla",
    "zefixRevertFailed": "Revert Zefix fallito"
  },
  "entityAttachPicker": {
    "title": "Fissa la nota",
    "subtitle": "A quale entità fissare la nota?",
    "tabsAriaLabel": "Scegli il tipo di entità",
    "tabContact": "Contatto",
    "tabCompany": "Azienda",
    "tabProperty": "Immobile",
    "searchContact": "Cerca contatto...",
    "searchCompany": "Cerca azienda...",
    "searchProperty": "Cerca immobile...",
    "minChars": "Inserisci almeno 2 caratteri",
    "noResults": "Nessun risultato",
    "startTyping": "Inizia a digitare per cercare.",
    "suggestionsHeading": "Dal contesto della pendenza",
    "suggestionCount": "{{count}} suggerimento",
    "suggestionCount_other": "{{count}} suggerimenti",
    "attached": "Nota fissata a {{label}}",
    "attachError": "Fissaggio fallito"
  },
  "entityKnowledge": {
    "createdBy": "Inserito da {{name}}",
    "emptyCompany": "Ancora nessuna conoscenza per questa azienda. Fissa le note in una pendenza all'azienda affinché compaiano qui.",
    "emptyContact": "Ancora nessuna conoscenza per questo contatto. Fissa le note in una pendenza al contatto affinché compaiano qui.",
    "emptyProperty": "Ancora nessuna conoscenza per questo immobile. Fissa le note in una pendenza all'immobile affinché compaiano qui.",
    "loadError": "Impossibile caricare le conoscenze.",
    "openTask": "Apri pendenza",
    "subtitle": "{{count}} note — fissate dalle pendenze."
  },
  "errors": {
    "duplicateEmail": {
      "companyTitle": "E-mail già associata a un'organizzazione",
      "contactTitle": "E-mail già associata a un contatto",
      "existingEntry": "Voce esistente",
      "openCompany": "Apri organizzazione",
      "openContact": "Apri contatto"
    },
    "forbidden": "Accesso negato",
    "general": "Si è verificato un errore",
    "network": "Errore di rete",
    "notFound": "Non trovato",
    "server": "Errore del server",
    "unauthorized": "Non autorizzato",
    "unexpected": "Errore imprevisto",
    "unexpectedDescription": "Si e verificato un errore imprevisto. La preghiamo di riprovare.",
    "validation": "Errore di validazione"
  },
  "favorites": {
    "addToList": "Aggiungi alla lista preferiti",
    "added": "Aggiunto alla lista preferiti",
    "allCantons": "Tutti i cantoni",
    "allStatuses": "Tutti gli stati",
    "allTypes": "Tutti i tipi",
    "browseProperties": "Sfogliare gli immobili",
    "empty": "Nessun preferito salvato",
    "emptyHint": "Contrassegna gli immobili con l'icona cuore per vederli qui",
    "filterCanton": "Cantone",
    "filterStatus": "Stato",
    "filterType": "Tipo di immobile",
    "notifications": {
      "active": "attivo",
      "award": "Aggiudicazione",
      "disableAll": "Disattivare tutto",
      "enableAll": "Attivare tutto",
      "newDocuments": "Nuovi documenti",
      "offerPhase": "Fase d'offerta",
      "priceChange": "Variazioni di prezzo",
      "statusChange": "Variazioni di stato",
      "title": "Notifiche"
    },
    "properties": "Immobili",
    "removeFromList": "Rimuovi dalla lista preferiti",
    "removed": "Rimosso dalla lista preferiti",
    "sortBy": "Ordina per",
    "sortCity": "Città",
    "sortDate": "Data",
    "sortPrice": "Prezzo",
    "title": "Lista preferiti",
    "toggleFailed": "Errore durante l'aggiornamento della lista preferiti"
  },
  "fundRadar": {
    "asOf": "Aggiornato al: {{date}}",
    "capacity": "Capacità di acquisto",
    "capacityGreen": "denaro fresco",
    "capacityGrey": "nessun indizio",
    "capacityRed": "bloccata",
    "capacityYellow": "possibile",
    "colAgio": "Premio",
    "colAsOf": "Aggiornato",
    "colAum": "AUM",
    "colCompany": "Società",
    "colFund": "Veicolo",
    "colLtv": "LTV",
    "colReason": "Perché",
    "colSignals": "Semafori",
    "empty": "Nessun veicolo con questo segnale.",
    "filterAll": "Tutti",
    "filterAria": "Filtra per segnale",
    "filterBuy": "Acquista",
    "filterNone": "Senza segnale",
    "filterSell": "Vende",
    "noValue": "Nessuna indicazione",
    "openCompany": "Apri l’organizzazione «{{name}}»",
    "pressure": "Pressione di vendita",
    "pressureGrey": "nessun indizio",
    "pressureRed": "alta",
    "pressureYellow": "media",
    "searchLabel": "Cerca veicolo o società",
    "searchPlaceholder": "Cerca veicolo o società …",
    "subtitle": "Pressione di vendita rossa = fine della durata, fusione o rimborsi. Capacità di acquisto verde = denaro fresco (aumento di capitale, sottoscrizioni aperte). Un disaggio significa che il veicolo non può raccogliere capitale proprio, ma non è obbligato a vendere.",
    "title": "Radar dei fondi"
  },
  "help": {
    "close": "Chiudi",
    "contacts": {
      "description": "Gestisci tutte le persone di contatto e i firmatari autorizzati.",
      "steps": [
        "Crea nuovi contatti con 'Nuovo contatto'",
        "Assegna contatti a una o più aziende",
        "Crea un account utente per il contatto se necessario"
      ],
      "tips": [
        "I contatti possono essere assegnati a più aziende",
        "L'autorità di firma è impostata per azienda",
        "Gli account utente permettono l'accesso alla piattaforma"
      ],
      "title": "Contatti"
    },
    "contextual": "Aiuto per questa pagina",
    "contractGenerator": {
      "description": "Crea contratti professionali in pochi passaggi.",
      "steps": [
        "Passo 1: Seleziona un modello (CGC, Contratto acquirente, ecc.)",
        "Passo 2: Compila i dati richiesti",
        "Passo 3: Verifica l'anteprima del contratto",
        "Passo 4: Raccogli le firme",
        "Passo 5: Scarica il PDF finale"
      ],
      "tips": [
        "Usa la ricerca Zefix per caricare automaticamente i dati aziendali",
        "Le firme possono essere fatte con il mouse o con il dito sui dispositivi touch",
        "Gli indirizzi email sono validati (controllo MX)"
      ],
      "title": "Generatore di contratti"
    },
    "contracts": {
      "description": "Crea e gestisci i tuoi contratti digitalmente.",
      "steps": [
        "Clicca su 'Nuovo contratto' per creare un contratto",
        "Seleziona un modello di contratto",
        "Compila le parti e i dati",
        "Verifica l'anteprima",
        "Raccogli le firme digitali"
      ],
      "tips": [
        "I contratti possono essere eliminati solo in stato 'Bozza'",
        "Puoi salvare i contratti come bozze e firmarli in seguito",
        "Tutte le firme sono salvate con timestamp e opzionalmente con posizione"
      ],
      "title": "Contratti"
    },
    "dashboard": {
      "description": "La tua panoramica centrale di tutte le informazioni importanti e azioni rapide.",
      "steps": [
        "Visualizza le tue statistiche a colpo d'occhio",
        "Usa le azioni rapide per le attività frequenti",
        "Passa tra le tue aziende assegnate"
      ],
      "tips": [
        "Usa il filtro azienda in alto a destra per filtrare i dati per azienda"
      ],
      "title": "Dashboard"
    },
    "general": "Aiuto generale",
    "organizations": {
      "description": "Gestisci le aziende e i loro firmatari autorizzati.",
      "steps": [
        "Le aziende vengono registrate automaticamente alla conclusione dei contratti",
        "Clicca su un'azienda per vedere i contatti",
        "Usa 'Aggiorna da Zefix' per caricare i dati attuali del registro di commercio"
      ],
      "tips": [
        "I contatti fissati non vengono disattivati durante la sincronizzazione Zefix",
        "I contatti manuali sono automaticamente fissati",
        "I contatti con firme contrattuali non possono essere eliminati"
      ],
      "title": "Organizzazioni"
    },
    "properties": {
      "description": "Gestisci il tuo portfolio immobiliare.",
      "steps": [
        "Aggiungi nuove proprietà con tutti i dettagli",
        "Carica immagini e documenti",
        "Gestisci lo stato (Bozza, Attivo, Riservato, Venduto)"
      ],
      "tips": [
        "Le proprietà in stato 'Bozza' non sono visibili pubblicamente",
        "Le descrizioni multilingue sono possibili"
      ],
      "title": "Proprietà"
    },
    "settings": {
      "description": "Configurazione e amministrazione del sistema.",
      "steps": [
        "Gestisci i firmatari autorizzati interni",
        "Visualizza lo schema del database"
      ],
      "tips": [
        "I firmatari autorizzati interni sono gestiti qui"
      ],
      "title": "Impostazioni"
    },
    "signatories": {
      "description": "Gestisci i firmatari autorizzati interni della tua azienda.",
      "steps": [
        "Seleziona un contatto esistente",
        "Imposta la funzione (es. CEO)",
        "Definisci l'autorità di firma (Individuale o Collettiva)"
      ],
      "tips": [
        "Queste persone appaiono come firmatari sui contratti Immotron",
        "Il testo della firma appare sotto la firma nel PDF"
      ],
      "title": "Firmatari autorizzati"
    },
    "title": "Aiuto",
    "users": {
      "description": "Gestisci gli account utente e i permessi.",
      "steps": [
        "Crea nuovi utenti con 'Aggiungi utente'",
        "Assegna un ruolo (Admin, Vendite, Investitore)",
        "Opzionale: Collega l'utente a un contatto"
      ],
      "tips": [
        "Gli admin hanno accesso a tutte le funzioni",
        "Gli utenti Vendite possono gestire contratti e proprietà",
        "Gli investitori possono solo cercare e vedere il loro portfolio"
      ],
      "title": "Gestione utenti"
    }
  },
  "investor": {
    "access": {
      "accessCount": "{{count}} investitore/i con accesso",
      "accessGranted": "Accesso concesso",
      "accessViaDirect": "diretto",
      "accessViaGroup": "via gruppo {{name}}",
      "date": "Data",
      "emailBounced": "E-mail non consegnabile",
      "emailClicked": "Link cliccato",
      "emailNotSent": "E-mail non inviata",
      "emailOpened": "E-mail aperta",
      "emailSent": "E-mail inviata",
      "grantAccess": "Concedere accesso",
      "grantSuccess": "Accesso concesso con successo",
      "grantSuccessWithEmail": "Accesso concesso — l'investitore sarà notificato via e-mail",
      "groupAccessHint": "Accesso via gruppo — può essere revocato solo rimuovendo dal gruppo",
      "manual": "Manuale",
      "noInvestors": "Nessun investitore con accesso",
      "revokeAccess": "Revocare accesso",
      "revokeConfirm": "Vuole davvero revocare l'accesso per questo investitore?",
      "revokeSuccess": "Accesso revocato con successo",
      "searchHint": "Cerca per nome o e-mail",
      "searchInvestor": "Cercare investitore...",
      "selfService": "Autonomo",
      "source": "Origine",
      "title": "Accesso investitori"
    },
    "activity": {
      "bounced": "Non consegnabile",
      "clicked": "Cliccato",
      "failed": "Fallito",
      "noActivity": "Nessuna notifica per il momento",
      "opened": "Aperto",
      "sent": "Inviato",
      "title": "Notifiche",
      "type": {
        "ACCESS_GRANTED": "Accesso concesso",
        "DOSSIER_UPDATE": "Nuovo documento",
        "INTEREST_EXPRESSED": "Interesse confermato",
        "INTEREST_SALES_NOTIFY": "Team commerciale informato"
      }
    },
    "dossier": {
      "backToTeaser": "Torna alla panoramica",
      "clearSelection": "Annullare la selezione",
      "documentsCount": "{{count}} documento/i",
      "documentsLabel": "Documenti",
      "download": "Scaricare",
      "downloadPdf": "Dossier in PDF",
      "downloadUnavailable": "Download non disponibile",
      "groups": {
        "custom": "Personalizzato",
        "investor_dossier": "Exposé",
        "supplementary": "Documenti integrativi",
        "valuation": "Documenti di valutazione"
      },
      "lastUpload": "Ultimo caricamento",
      "newBadge": "Nuovo",
      "newCount": "{{count}} nuovo(i)",
      "noAccess": "Nessun accesso",
      "noAccessHint": "Ha bisogno dell'accesso all'exposé. Manifesti prima il suo interesse.",
      "noDocuments": "Nessun documento in questa categoria",
      "offerHint": "Vendita a prezzo fisso — inoltri la sua offerta nella pagina dell’immobile.",
      "pdfDownloaded": "PDF del dossier scaricato",
      "pdfFailed": "Il download del PDF non e riuscito",
      "previewSelected": "Anteprima",
      "selected": "selezionato/i",
      "subtitle": "Documentazione completa",
      "title": "Exposé"
    },
    "expose": {
      "pages": "{{count}} pagine",
      "read": "Leggi l'exposé",
      "title": "Exposé"
    },
    "interest": {
      "agbNote": "Manifestando il suo interesse, conferma che le CGC e le disposizioni di riservatezza del suo abbonamento alla piattaforma sono applicabili.",
      "alreadyExpressed": "Ha già manifestato interesse per questo immobile.",
      "confirm": "Confermare interesse",
      "description": "Con la presente manifesta il suo interesse per il seguente immobile:",
      "salesNotified": "Il team commerciale è stato informato del suo interesse.",
      "success": "Interesse manifestato con successo",
      "successHint": "Ora ha accesso all'exposé completo.",
      "successWithEmail": "Conferma inviata via e-mail. Ora ha accesso al dossier.",
      "title": "Manifestare interesse"
    },
    "listing": {
      "includedProperties": "Immobili inclusi",
      "ndaConfirmAccess": "Conferma NDA e ottieni l'accesso",
      "ndaConfirmHint": "Conferma l'accordo di riservatezza per accedere al dossier completo.",
      "properties": "Immobili",
      "propertyIndex": "Immobile {{index}}",
      "submitOffer": "Invia offerta",
      "totalPrice": "Prezzo totale"
    },
    "nda": {
      "bracketFrom": "da {{from}}",
      "bracketRange": "da {{from}} a {{to}}",
      "bracketsTitle": "Provvigione dell'acquirente (scaglioni sul prezzo d'acquisto):",
      "checkbox": "Ho letto l'accordo di riservatezza e lo accetto.",
      "commissionModel": "Modello di provvigione",
      "conditionsCheckbox": "Ho letto le condizioni per questo immobile e le accetto.",
      "conditionsLoading": "Caricamento delle condizioni …",
      "conditionsTitle": "Condizioni per questo immobile",
      "confidentialityText": "Tutte le informazioni messe a sua disposizione nell'ambito di questo exposé sono strettamente riservate. Si impegna a non divulgare queste informazioni a terzi e a utilizzarle esclusivamente per valutare l'opportunità di investimento.",
      "confidentialityTitle": "Riservatezza",
      "confirm": "Confermare e aprire il dossier",
      "criteriaText": "Conferma che questo immobile corrisponde ai suoi criteri di investimento e che dispone dei mezzi finanziari necessari per realizzare un'eventuale transazione.",
      "criteriaTitle": "Criteri di investimento",
      "decline": "Indietro",
      "dueNote": "La provvigione è dovuta al momento del rogito del contratto di compravendita.",
      "findersFeeText": "In caso di conclusione di una transazione, sarà dovuta una commissione di intermediazione secondo le condizioni concordate. Aggirare l'intermediario non è consentito.",
      "findersFeeTitle": "Commissione di intermediazione",
      "flatRate": "Tasso unico: {{rate}} del prezzo d'acquisto.",
      "noModel": "Per questo immobile non è attualmente registrato alcun modello di provvigione. Le condizioni sono disciplinate dal contratto quadro dell'acquirente o dall'allegato B relativo all'immobile.",
      "sourceAppendixB": "Specifico per l'immobile (allegato B)",
      "sourceDefault": "Condizioni standard",
      "specialConditionsTitle": "Condizioni particolari",
      "successContinue": "Vai al dossier",
      "successText": "La sua conferma è stata registrata. Ha accettato queste condizioni:",
      "successTitle": "NDA e condizioni confermati",
      "title": "Accordo di riservatezza (NDA)",
      "vatNote": "Tutti gli importi delle provvigioni si intendono IVA di legge esclusa.",
      "objection": {
        "button": "Non accettare le condizioni",
        "title": "Rifiutare le condizioni",
        "intro": "Indichi il tasso desiderato e motivi la sua obiezione. La parte venditrice esamina la controproposta: fino ad allora non riceve accesso ai dati dell'oggetto.",
        "rateLabel": "Tasso desiderato (facoltativo)",
        "ratePlaceholder": "p. es. 2.5",
        "rateHint": "Percentuale del prezzo d'acquisto. Senza indicazione viene trasmessa solo la motivazione.",
        "reasonLabel": "Motivazione",
        "reasonPlaceholder": "Perché non accetta le condizioni?",
        "reasonRequired": "Senza motivazione l'obiezione non può essere inviata.",
        "back": "Indietro",
        "submit": "Invia obiezione",
        "sentTitle": "Obiezione trasmessa",
        "sentText": "La sua obiezione è stata registrata. La parte venditrice esamina la controproposta e la contatterà. Fino ad allora i dati dell'oggetto restano chiusi."
      }
    },
    "search": {
      "accessGranted": "Accesso concesso",
      "allCantons": "Tutti i cantoni",
      "allTypes": "Tutti i tipi",
      "areaFrom": "Superficie da (m²)",
      "areaTo": "Superficie fino a (m²)",
      "canton": "Cantone",
      "clearFilters": "Reimpostare i filtri",
      "contractError": {
        "CONTRACT_EXPIRED": {
          "message": "Il suo contratto di piattaforma è scaduto. Contatti il suo referente per il rinnovo.",
          "title": "Contratto di piattaforma scaduto"
        },
        "NO_ACTIVE_CONTRACT": {
          "message": "Non è presente un contratto di piattaforma attivo. Contatti il suo referente.",
          "title": "Nessun contratto di piattaforma attivo"
        }
      },
      "errorTitle": "Errore di caricamento",
      "filters": "Filtri",
      "loadError": "Gli immobili non hanno potuto essere caricati. Riprovi.",
      "noResults": "Nessun immobile trovato",
      "noResultsHint": "Modifichi i criteri di ricerca",
      "placeholder": "Città, regione o CAP...",
      "priceFrom": "Prezzo da (CHF)",
      "priceRange": "Fascia di prezzo",
      "priceTo": "Prezzo fino a (CHF)",
      "resultsCount": "{{count}} immobili trovati",
      "sortNewest": "Più recenti",
      "sortPriceAsc": "Prezzo crescente",
      "sortPriceDesc": "Prezzo decrescente",
      "sortSizeDesc": "Più grandi",
      "subtitle": "Trovi il suo prossimo investimento",
      "title": "Ricerca immobiliare"
    },
    "teaser": {
      "accessGranted": "Accesso concesso",
      "accessGrantedHint": "Hai accesso all'exposé completo di questo immobile.",
      "approximateLocation": "Posizione approssimativa",
      "atAGlance": "In sintesi",
      "backToSearch": "Torna alla ricerca",
      "buildingPermit": "Permesso di costruzione",
      "confirmNda": "Confermo l'accordo di riservatezza (NDA)",
      "description": "Descrizione",
      "emptyGallery": "Immagini in arrivo",
      "exclusiveMandate": "Mandato esclusivo off-market",
      "financial": {
        "title": "Indicatori finanziari",
        "grossYield": "Rendimento lordo",
        "netYield": "Rendimento netto",
        "annualIncome": "Reddito locativo p.a.",
        "factor": "Fattore (× pigione annua)",
        "vacancy": "Sfitto",
        "pricePerSqm": "Prezzo/m²",
        "rentPerSqm": "Pigione/m² p.a.",
        "netYieldAssumption": "Ipotesi: 18% costi di gestione"
      },
      "locked": "Dopo NDA",
      "lockedLocation": "Posizione dopo NDA",
      "lockedLocationHint": "La posizione esatta diventa visibile dopo la firma dell'accordo di riservatezza.",
      "region": "Regione {{canton}}",
      "regionAddress": "{{region}} · indirizzo esatto dopo NDA",
      "ndaRequired": "NDA richiesto",
      "lockedLocationPlaceholder": "L'immobile è situato in posizione comoda in un comune consolidato, con buoni collegamenti ai trasporti pubblici nonché negozi e scuole nelle immediate vicinanze.",
      "signNda": "Firma NDA",
      "technicalDetails": "Dettagli tecnici",
      "detailLabels": {
        "buildingCount": "Numero di edifici",
        "cadastreNumber": "N. catastale",
        "commercialUnits": "Unità commerciali",
        "condition": "Condizione",
        "constructionYear": "Anno di costruzione",
        "egridNumber": "N. E-GRID",
        "garageParking": "Parcheggio in garage",
        "heatingSystem": "Impianto di riscaldamento",
        "lotSize": "Superficie del terreno",
        "outdoorParking": "Parcheggio esterno",
        "propertyType": "Categoria / Tipo di utilizzo",
        "renovation": "Ristrutturazione",
        "residentialUnits": "Unità residenziali",
        "usableArea": "Superficie utile",
        "utilizationFactor": "Indice di sfruttamento",
        "volume": "Volume"
      },
      "details": "Dettagli",
      "expressInterest": "Manifestare interesse",
      "grossYield": "Rendimento lordo",
      "highlights": "Punti di forza dell'investimento",
      "interestedHint": "Manifesta il tuo interesse per accedere al dossier completo.",
      "interestedTitle": "Interessato a questo immobile?",
      "keyFacts": "Dati chiave",
      "location": "Posizione",
      "macroLocation": "Macro posizione",
      "microLocation": "Micro posizione",
      "netYield": "Rendimento netto",
      "ownership": "Tipo di proprietà",
      "openInGoogleMaps": "Apri in Google Maps",
      "price": "Prezzo",
      "privateListingNotice": "Questo immobile è un'offerta privata ed è accessibile solo agli investitori selezionati.",
      "salesContact": "Il vostro interlocutore",
      "title": "Panoramica dell'immobile",
      "type": "Tipo",
      "usableArea": "Superficie utile",
      "viewDossier": "Vai al dossier",
      "viewOnMaps": "Visualizza su Google Maps",
      "yearBuilt": "Anno di costruzione",
      "gallery": {
        "openFullscreen": "Apri la galleria a schermo intero",
        "close": "Chiudi schermo intero"
      },
      "preview": {
        "previewAs": "Anteprima come",
        "levels": {
          "buyer_no_nda": "Acquirente senza NDA",
          "buyer_nda": "Acquirente con NDA",
          "internal": "Interno"
        },
        "internalBlockTitle": "Sezione interna",
        "internalBlockHint": "Visibile solo agli utenti interni — non fa parte della vista acquirente.",
        "investorGroups": "Gruppi di investitori",
        "noInvestorGroups": "Nessun gruppo di investitori assegnato.",
        "memberCount": "{{count}} membri",
        "noMembers": "Nessun membro",
        "memberType": {
          "user": "Utente",
          "company": "Azienda",
          "contact": "Contatto"
        }
      }
    },
    "viewer": {
      "close": "Chiudi anteprima",
      "exitFullscreen": "Esci dalla modalità a schermo intero",
      "fullscreen": "Schermo intero",
      "loadError": "Impossibile caricare l'anteprima.",
      "page": "Pagina {{current}} di {{total}}"
    },
    "dealStage": {
      "bo": "BO abgegeben",
      "nbo": "NBO abgegeben",
      "offer": "Angebot abgegeben",
      "nda": "NDA unterzeichnet",
      "teaser": "Teaser verfügbar"
    }
  },
  "investorContracts": {
    "active": "Contratti attivi",
    "expired": "Contratti scaduti",
    "subtitle": "Panoramica dei Suoi contratti",
    "title": "I miei contratti"
  },
  "investorGroups": {
    "addGroupAccess": "Concedi accesso al gruppo",
    "addMember": "Aggiungi membro",
    "addMemberSuccess": "Membro aggiunto con successo",
    "createGroup": "Crea gruppo",
    "createSuccess": "Gruppo creato con successo",
    "deleteConfirm": "Vuoi davvero eliminare il gruppo «{{name}}»? Tutti gli accessi del gruppo saranno revocati.",
    "deleteGroup": "Elimina gruppo",
    "deleteSuccess": "Gruppo eliminato con successo",
    "description": "Descrizione",
    "editGroup": "Modifica gruppo",
    "grantAccessSuccess": "Accesso di gruppo concesso con successo",
    "groupAccess": "Accesso di gruppo",
    "hideRecipients": "Nascondi i destinatari di {{name}}",
    "memberCompanyCount": "{{count}} aziende",
    "memberCount": "{{count}} membro/i",
    "memberTypeCompany": "Azienda",
    "memberTypeContact": "Contatto",
    "members": "Membri",
    "name": "Nome",
    "noGroups": "Nessun gruppo di investitori creato",
    "noMembers": "Nessun membro in questo gruppo",
    "noRecipients": "nessun destinatario",
    "recipientCount": "{{count}} destinatario/i",
    "removeGroupAccess": "Revoca accesso del gruppo",
    "removeMember": "Rimuovi membro",
    "removeMemberConfirm": "Vuoi davvero rimuovere questo investitore dal gruppo?",
    "removeMemberSuccess": "Membro rimosso con successo",
    "revokeAccessSuccess": "Accesso di gruppo revocato con successo",
    "searchInvestor": "Cerca contatto o azienda …",
    "searchNoResults": "Nessun contatto o azienda trovato",
    "selectGroup": "Seleziona gruppo",
    "showRecipients": "Mostra i destinatari di {{name}}",
    "skippedWithoutEmail": "{{count}} contatti senza e-mail",
    "subtitle": "Raggruppare investitori e gestire gli accessi in blocco",
    "title": "Gruppi di investitori",
    "updateSuccess": "Gruppo aggiornato con successo"
  },
  "investorSettings": {
    "activities": {
      "empty": "Nessuna attività in questo periodo",
      "emptyAll": "Ancora nessuna attività",
      "emptyHint": "Prova un periodo più lungo o seleziona «Tutto» per vedere più voci.",
      "entries": "Voci",
      "errorHint": "Verifica la tua connessione internet e riprova.",
      "errorRetry": "Riprova",
      "filter30d": "30 giorni",
      "filter7d": "7 giorni",
      "filter90d": "90 giorni",
      "filterAll": "Tutto",
      "filterLabel": "Periodo",
      "loadError": "Impossibile caricare le attività",
      "title": "Le mie attività",
      "type": {
        "CONTRACT_SIGNED": "Contratto firmato",
        "DOCUMENTS_RECEIVED": "Documenti ricevuti",
        "FAVORITE_ADDED": "Preferito aggiunto",
        "INQUIRY_RECEIVED": "Nuova richiesta ricevuta",
        "INTEREST_EXPRESSED": "Interesse espresso",
        "INVESTOR_INTEREST_RECEIVED": "Nuovo interesse investitore ricevuto",
        "LISTING_CREATED": "Annuncio creato",
        "LISTING_PUBLISHED": "Annuncio pubblicato",
        "MESSAGE_RECEIVED": "Messaggio ricevuto",
        "NDA_CONFIRMED": "NDA confermato",
        "OFFER_SUBMITTED": "Offerta inviata",
        "PROFILE_UPDATED": "Profilo aggiornato",
        "PROPERTY_CREATED": "Immobile creato",
        "VIEWING_CONFIRMED": "Visita confermata"
      }
    },
    "contracts": {
      "contactUs": "Contattaci",
      "downloadPdf": "Scarica il contratto in PDF",
      "empty": "Nessun contratto trovato",
      "expiredNotice": "Questo contratto è scaduto. Contattaci per il rinnovo.",
      "expiresAt": "Scade il",
      "signedAt": "Firmato il",
      "status": {
        "CANCELLED": "Annullato",
        "CUSTOMER_SIGNED": "Firmato dal cliente",
        "DRAFT": "Bozza",
        "EXPIRED": "Scaduto",
        "SENT": "Inviato",
        "SIGNED": "Firmato",
        "TERMINATED": "Risolto"
      },
      "type": {
        "BROKER_AGREEMENT": "Contratto di mediazione",
        "PLATFORM_AGREEMENT": "Contratto piattaforma",
        "SEARCH_MANDATE": "Mandato di ricerca"
      }
    },
    "passkeys": {
      "addPasskey": "Aggiungi passkey",
      "confirmDelete": "Rimuovere davvero?",
      "confirmDeleteBtn": "Conferma rimozione",
      "deleteError": "Impossibile rimuovere il passkey",
      "deleteSuccess": "Passkey rimosso con successo",
      "deviceName": "Nome del dispositivo",
      "deviceNamePlaceholder": "es. iPhone di Max",
      "editName": "Modifica nome",
      "empty": "Nessun passkey registrato",
      "lastPasskeyWarning": "Questo è il tuo unico passkey. Dopo la rimozione, potrai comunque accedere con la tua password.",
      "lastUsed": "Ultimo accesso",
      "notSupported": "Il tuo browser non supporta i passkey. Utilizza un browser aggiornato.",
      "registerError": "Impossibile registrare il passkey",
      "registerSuccess": "Passkey registrato con successo",
      "registeredAt": "Registrato",
      "registrationCancelled": "Registrazione del passkey annullata",
      "removePasskey": "Rimuovi passkey",
      "renameError": "Impossibile salvare il nome del dispositivo",
      "renameSuccess": "Nome del dispositivo salvato",
      "subtitle": "Gestisci i passkey per un accesso più veloce e sicuro",
      "title": "Metodi di accesso",
      "unnamedDevice": "Dispositivo senza nome"
    },
    "profile": {
      "changePassword": "Cambia password",
      "changePasswordBtn": "Cambia password",
      "companies": "Appartenenza all'azienda",
      "confirmPassword": "Conferma password",
      "currentPassword": "Password attuale",
      "currentPasswordWrong": "La password attuale non è corretta",
      "email": "Indirizzo e-mail",
      "firstName": "Nome",
      "forgotCurrentPassword": "Password attuale sconosciuta? Imposta una nuova password via e-mail",
      "hidePassword": "Nascondi password",
      "lastName": "Cognome",
      "newPassword": "Nuova password",
      "noPasswordSet": "Per questo account non è impostata alcuna password. Impostala tramite il link via e-mail.",
      "passwordError": "Impossibile cambiare la password. Verifica la password attuale.",
      "passwordLinkError": "Non è stato possibile inviare il link. Riprova più tardi.",
      "passwordLinkSent": "Abbiamo inviato un link a {{email}}. Con questo puoi impostare la tua password.",
      "passwordMismatch": "Le password non corrispondono",
      "passwordSuccess": "Password cambiata con successo",
      "personalInfo": "Informazioni personali",
      "readOnly": "Solo lettura",
      "saveError": "Impossibile salvare il profilo",
      "saveSuccess": "Profilo salvato con successo",
      "sendPasswordLink": "Invia il link via e-mail",
      "setPassword": "Imposta password",
      "setPasswordHint": "Per questo account non è ancora impostata alcuna password: accedi tramite link, passkey o firma dal cellulare. Ti inviamo un link via e-mail per impostare una password.",
      "showPassword": "Mostra password",
      "weakPassword": "La password non soddisfa i requisiti"
    },
    "subtitle": "Gestisci il tuo account e i tuoi contratti",
    "tabs": {
      "activities": "Attività",
      "contracts": "Contratti",
      "invoices": "Fatture",
      "notifications": "Notifiche",
      "privacy": "Privacy",
      "profile": "Profilo"
    },
    "title": "Impostazioni"
  },
  "invoices": {
    "columns": {
      "actions": "Azioni",
      "amount": "Importo",
      "date": "Data",
      "dueDate": "Scadenza",
      "number": "N. fattura",
      "property": "Immobile",
      "status": "Stato"
    },
    "download": "Scarica PDF",
    "downloadFailed": "Download PDF fallito",
    "empty": "Nessuna fattura disponibile",
    "emptyHint": "Le tue fatture appariranno qui una volta create",
    "filters": {
      "allStatuses": "Tutti gli stati",
      "fromDate": "Dal",
      "status": "Stato",
      "toDate": "Al"
    },
    "loadFailed": "Impossibile caricare le fatture",
    "openWarning": "Hai {{count}} fattura/e aperta/e o in ritardo",
    "statuses": {
      "CANCELLED": "Annullata",
      "OPEN": "Aperta",
      "OVERDUE": "In ritardo",
      "PAID": "Pagata"
    },
    "title": "Fatture"
  },
  "kyc": {
    "badge": {
      "exempt": "Nessuna identificazione necessaria",
      "exemptHint": "La vostra società è sottoposta a vigilanza (FINMA o simili) — un'identificazione personale non è necessaria.",
      "pending": "Identificazione in sospeso",
      "verified": "Identificato"
    },
    "capture": {
      "analysis": {
        "continueAnyway": "Continuare comunque",
        "critiqueTitle": "La preghiamo di riprendere la foto: {{slot}}.",
        "prefilled": "Abbiamo letto il suo documento d'identità — la preghiamo di verificare.",
        "quality": {
          "blurry": "La foto è sfocata.",
          "cut_off": "Il documento d'identità non è completamente visibile.",
          "glare": "La foto presenta un riflesso — la riprenda senza fonti di luce diretta.",
          "not_document": "Non abbiamo riconosciuto alcun documento d'identità."
        },
        "retake": "Riprendere la foto",
        "skip": "Continuare senza verifica e compilare manualmente",
        "waitHint": "Può richiedere un momento.",
        "waitTitle": "Il suo documento d'identità è in lettura …"
      },
      "camera": {
        "backDefault": "Fotocamera posteriore (predefinita)",
        "denied": "Non possiamo accedere alla sua fotocamera. Consenta l'accesso nel browser o carichi invece delle foto.",
        "deniedFallback": "Non possiamo accedere alla sua fotocamera. Carichi invece le riprese come file.",
        "documentHint": "Tutti e quattro gli angoli visibili, senza riflessi.",
        "frameHint": "Posizioni il documento esattamente nella cornice.",
        "frontDefault": "Fotocamera frontale (predefinita)",
        "lowResolution": "La ripresa è piccola ({{width}} × {{height}} px). Si avvicini al documento o scelga una fotocamera migliore.",
        "numbered": "Fotocamera {{n}}",
        "previewAlt": "Anteprima della ripresa",
        "retake": "Ripeti",
        "select": "Fotocamera",
        "selfieGuideHint": "Viso nell'ovale, mano nel contorno.",
        "selfieHint": "Il suo viso ben visibile, senza copricapo.",
        "shutter": "Scatta foto",
        "starting": "Avvio della fotocamera …",
        "unavailable": "Non troviamo alcuna fotocamera su questo dispositivo. Carichi invece foto o una copia PDF.",
        "unavailableFallback": "Non troviamo alcuna fotocamera su questo dispositivo. Carichi invece le riprese come file.",
        "use": "Utilizza"
      },
      "details": {
        "country": "Paese di rilascio",
        "countryHint": "Due lettere, ad es. CH, DE o FR.",
        "expiry": "Valido fino al",
        "lead": "Manca solo il Paese di rilascio — numero e data di scadenza sono facoltativi.",
        "number": "Numero del documento",
        "submit": "Inviare per la verifica",
        "title": "Dati del documento"
      },
      "documentTypes": {
        "ID_CARD": "Carta d'identità",
        "OTHER": "Altro documento ufficiale",
        "PASSPORT": "Passaporto",
        "RESIDENCE_PERMIT": "Permesso per stranieri"
      },
      "errors": {
        "allSlotsFilled": "Tutte le pagine sono già state acquisite. Usi «Sostituisci» per scambiare una ripresa.",
        "alreadySubmitted": "Questa identificazione è già stata inviata ed è in corso di verifica.",
        "expired": "Questo documento è scaduto. Utilizzi un documento valido.",
        "incomplete": "Mancano ancora delle riprese:",
        "submitFailed": "L'invio non è riuscito. Riprovi.",
        "tooLarge": "Il file è troppo grande. Sono ammessi file fino a 15 MB.",
        "uploadFailed": "Non è stato possibile trasmettere il file. Riprovi.",
        "wrongType": "Non possiamo leggere questo formato. Sono ammessi JPG, PNG, HEIC e PDF."
      },
      "face": {
        "loading": "Preparazione del riconoscimento del volto …",
        "multiple": "Una sola persona nell'immagine.",
        "none": "Nessun volto rilevato.",
        "offCenter": "Metta il viso nell'ovale.",
        "showFingersNow_one": "Mostri ora {{count}} dito",
        "showFingersNow_other": "Mostri ora {{count}} dita",
        "steady": "Stia fermo …",
        "tooLarge": "Un po' più lontano.",
        "tooSmall": "Un po' più vicino."
      },
      "liveness": {
        "LOOK_UP": "Guardare verso l’alto",
        "SHOW_FINGERS": "Mostrare {{count}} dita",
        "SHOW_TWO_FINGERS": "Mostrare due dita",
        "TURN_HEAD_LEFT": "Girare la testa a sinistra",
        "TURN_HEAD_RIGHT": "Girare la testa a destra",
        "instructions": {
          "LOOK_UP": "Guardi brevemente verso l'alto",
          "SHOW_FINGERS_one": "Tenga {{count}} dito accanto al viso",
          "SHOW_FINGERS_other": "Tenga {{count}} dita accanto al viso",
          "SHOW_TWO_FINGERS": "Tenga due dita accanto al viso",
          "TURN_HEAD_LEFT": "Giri leggermente la testa a sinistra",
          "TURN_HEAD_RIGHT": "Giri leggermente la testa a destra"
        },
        "title": "Il suo compito per il selfie"
      },
      "scanner": {
        "backgroundHint": "Consiglio: appoggi il documento su una superficie scura e uniforme — oppure scatti a mano con «Scatta foto».",
        "closer": "Si avvicini.",
        "loading": "Caricamento dello scanner …",
        "searching": "Tenga il documento d'identità nel riquadro.",
        "steady": "Tenga fermo …",
        "straightened": "Documento d'identità raddrizzato automaticamente"
      },
      "setup": {
        "documentType": "Quale documento presenta?",
        "lead": "Ci serve un'immagine del suo documento e un selfie. Può riprenderli direttamente o caricarli come file.",
        "live": "Riprendi con la fotocamera",
        "liveDesc": "Fotocamera del telefono o webcam — documento e selfie in due minuti.",
        "title": "Acquisire il documento",
        "upload": "Carica file",
        "uploadDesc": "Foto (JPG, PNG, HEIC) o una copia PDF del suo documento."
      },
      "slots": {
        "back": "Retro del documento",
        "front": "Fronte del documento",
        "pdf": "Copia PDF del documento",
        "selfie": "Selfie"
      },
      "summary": {
        "lead": "Queste sono le riprese che abbiamo salvato. Se qualcosa è sfocato o tagliato, la riprenda.",
        "pdfNote": "Copia PDF",
        "previewUnavailable": "Anteprima non disponibile — il file è salvato.",
        "retake": "Riprendi",
        "title": "Le sue riprese"
      },
      "upload": {
        "choose": "Seleziona file",
        "dropHint": "Trascini qui i file oppure li selezioni",
        "formats": "JPG, PNG, HEIC o PDF — fino a 15 MB per file.",
        "lead": "Foto di fronte e retro — oppure una copia PDF del documento. Un selfie ci aiuta nella verifica, ma qui è facoltativo.",
        "nativeCamera": "Riprendi con la fotocamera",
        "pdfHint": "Ha una copia PDF del suo documento? Carichi semplicemente il PDF — fronte e retro non sono più necessari.",
        "replace": "Sostituisci",
        "select": "Seleziona file",
        "title": "Carica file"
      }
    },
    "choice": {
      "autoIdent": "Documento + selfie (2 min.)",
      "autoIdentDesc": "Mostri la carta d'identità o il passaporto alla telecamera, poi scatti un selfie.",
      "regulated": "La mia azienda è vigilata o quotata",
      "regulatedDesc": "Banca, assicurazione, fondo, cassa pensioni o società quotata — basta una conferma.",
      "swissId": "Accedi con SwissID",
      "swissIdDesc": "Già identificato? Con SwissID è tutto risolto subito.",
      "title": "Come desidera identificarsi?"
    },
    "done": {
      "generic": "La sua identificazione è registrata e vale a tempo indeterminato.",
      "regulatedConfirmed": "{{company}} è registrata come controparte vigilata.",
      "title": "Grazie — è tutto",
      "verifiedAt": "Identificato il {{date}}",
      "yourCompany": "La sua azienda"
    },
    "errors": {
      "declareFailed": "Non è stato possibile salvare la conferma. Riprovi più tardi.",
      "startFailed": "Non è stato possibile avviare l'identificazione. Riprovi più tardi."
    },
    "handoff": {
      "continueHere": "Continuare qui sul computer",
      "expired": "Questo codice è scaduto. Generi un nuovo codice.",
      "failed": "Il codice non è stato generato. Ne generi uno nuovo o continui qui sul computer.",
      "lead": "Scansioni il codice con la fotocamera del cellulare. Il codice è valido {{minutes}} minuti.",
      "phoneStarted": "Aperto sul cellulare — la preghiamo di concludere lì. Questa finestra si aggiorna da sola.",
      "qrAlt": "Codice QR per l’identificazione sul cellulare",
      "regenerate": "Generare un nuovo codice",
      "regenerateHint": "Un nuovo codice rende non valido quello precedente.",
      "remaining": "Codice valido ancora {{time}}",
      "title": "Desidera effettuare l’identificazione sul suo cellulare?"
    },
    "intro": {
      "bodyAfter": "È la prima volta che accede. Dal 1° ottobre 2026 la legge svizzera sul riciclaggio di denaro ci obbliga a identificare una volta i nostri partner contrattuali — come la sua banca. Richiede due minuti e vale a tempo indeterminato.",
      "bodyBefore": "È la prima volta che accede. A partire dal 1° ottobre 2026 la legge svizzera sul riciclaggio di denaro ci obbliga a identificare una volta i nostri partner contrattuali — come la sua banca. Richiede due minuti e vale a tempo indeterminato.",
      "pointDuration": "Due minuti, nessun modulo.",
      "pointOnce": "Una volta sola — valida a tempo indeterminato.",
      "start": "Identificati ora",
      "title": "Benvenuto in Immotron — identificazione unica"
    },
    "later": "Più tardi",
    "methods": {
      "AUTO_IDENT": "Documento + selfie",
      "CHECK_RUN": "Verifica",
      "MANUAL": "Registrazione manuale",
      "REGULATED_SELF_DECLARATION": "Autodichiarazione come controparte vigilata",
      "SWISSID": "SwissID"
    },
    "mobile": {
      "done": {
        "body": "Grazie — verifichiamo i suoi dati. Può tornare al computer.",
        "title": "Inviato, in verifica"
      },
      "errors": {
        "alreadySubmitted": "La sua identificazione è già stata inviata.",
        "expired": "Questo codice è scaduto.",
        "generic": "La pagina non è stata aperta. La preghiamo di riprovare.",
        "hint": "Apra un nuovo codice QR sul computer.",
        "sessionExpired": "La sessione è scaduta.",
        "unknown": "Codice non valido.",
        "used": "Questo codice è già stato utilizzato."
      },
      "greeting": "Buongiorno {{name}}",
      "greetingAnonymous": "Buongiorno",
      "lead": "Poi ha finito — il computer si aggiorna da solo.",
      "loading": "Un momento, stiamo aprendo la sua identificazione …",
      "title": "Identificazione sul cellulare"
    },
    "pending": {
      "body": "La sua identificazione è stata avviata ma non è ancora confermata. Appena il risultato sarà disponibile lo vedrà qui e nelle impostazioni.",
      "refresh": "Aggiorna stato",
      "resume": "Continuare l'identificazione",
      "resumeBody": "La sua identificazione è stata avviata ma non è ancora stata inviata. Può riprendere da dove si è interrotto.",
      "resumeTitle": "Identificazione non conclusa",
      "title": "Identificazione in corso"
    },
    "progress": {
      "cards": {
        "seco": "0 risultati nella lista di sanzioni della Confederazione (SECO)",
        "signature": "Iscrizione nel registro di commercio",
        "uid": "IDI"
      },
      "continue": "Avanti",
      "doneTitle": "Identificato",
      "failed": "Non è stato possibile avviare la verifica. Verifichiamo i suoi dati manualmente e la contatteremo.",
      "followUpBody": "Stiamo ancora verificando manualmente i suoi dati e la contatteremo entro un giorno lavorativo.",
      "followUpTitle": "Ci siamo quasi",
      "heading": "Un momento — stiamo verificando la sua identità",
      "lead": "Vede in diretta con che cosa confrontiamo i suoi dati. Bastano pochi secondi.",
      "starting": "Un momento, stiamo verificando la sua identità …",
      "state": {
        "error": "In verifica",
        "hit": "In verifica",
        "ok": "Verificato",
        "pending": "In verifica",
        "running": "In corso",
        "skipped": "Non necessario",
        "waiting": "In attesa"
      },
      "title": "Fasi della verifica"
    },
    "regulated": {
      "authority": "Autorità di vigilanza o fonte",
      "authorityPlaceholder": "p. es. FINMA, CAV PP, SIX",
      "categories": {
        "LISTED": "Società quotata",
        "PUBLIC_LAW": "Ente di diritto pubblico",
        "REGULATED": "Vigilata da FINMA o CAV PP (banca, assicurazione, fondo, cassa pensioni)"
      },
      "category": "Categoria",
      "company": "Azienda",
      "confirm": "Confermo che l'azienda indicata è vigilata, quotata o di diritto pubblico.",
      "description": "Se la sua azienda è vigilata, quotata o di diritto pubblico, basta la sua conferma — non serve un'identificazione personale.",
      "noCompany": "Al suo account non è collegata alcuna azienda. Si identifichi come persona o ci contatti.",
      "reference": "Numero di autorizzazione o di registro",
      "submit": "Conferma",
      "title": "Controparte vigilata"
    },
    "review": {
      "title": "Verificare le identificazioni",
      "subtitle": "Verificare le auto-identificazioni inoltrate e approvarle o respingerle. Un’identificazione non viene mai confermata automaticamente.",
      "forbidden": "Riservato ad amministratori / responsabili LRD.",
      "empty": "Nessuna identificazione aperta.",
      "emptyAll": "Nessuna identificazione disponibile.",
      "selectHint": "Selezionare un caso a sinistra.",
      "submittedAt": "Inoltrata il",
      "unknownPerson": "Persona sconosciuta",
      "captureModeLabel": "Modalità di acquisizione",
      "checkRunLabel": "Controllo automatico",
      "livenessLabel": "Compito di vivacità",
      "fingerCountLabel": "Numero di dita richiesto",
      "fingerCountCheck": "Il numero di dita nel selfie corrisponde?",
      "openInNewTab": "Aprire in una nuova scheda",
      "zoom": "Ingrandire {{slot}}",
      "uploadHint": "Le immagini caricate non sono state riprese dal vivo — verificarle con particolare attenzione.",
      "correct": "Correggere",
      "correctHint": "Le correzioni vengono salvate insieme alla sua decisione.",
      "nationalityHint": "Codice paese di tre lettere (ISO 3166), ad es. CHE per la Svizzera.",
      "nationalityInvalid": "Inserisca esattamente tre lettere, ad es. CHE.",
      "approve": "Approvare",
      "reject": "Respingere",
      "reasonLabel": "Motivazione",
      "reasonPlaceholder": "Perché l’identificazione viene respinta?",
      "reasonHint": "Almeno 5 caratteri.",
      "rejectSubmit": "Inviare il rifiuto",
      "approveSuccess": "Identificazione approvata.",
      "rejectSuccess": "Identificazione respinta.",
      "filter": {
        "open": "Aperte",
        "all": "Tutte"
      },
      "captureMode": {
        "live": "Ripresa dal vivo",
        "upload": "Caricata"
      },
      "fieldsSource": {
        "ai": "dall’IA",
        "reviewer": "corretto dal verificatore",
        "customer": "inserito dal cliente"
      },
      "state": {
        "OPEN": "Aperta",
        "FIRST_APPROVED": "1a approvazione concessa — serve una seconda persona",
        "APPROVED": "Approvata",
        "REJECTED": "Respinta"
      },
      "checkRun": {
        "CLEAN": "Controllo senza riscontri",
        "HIT": "Riscontro in lista — verificare attentamente",
        "INCOMPLETE": "Controllo incompleto"
      },
      "files": {
        "title": "Documento e selfie",
        "none": "Nessun file disponibile."
      },
      "slot": {
        "front": "Documento fronte",
        "back": "Documento retro",
        "selfie": "Selfie",
        "pdf": "Documento (PDF)"
      },
      "document": {
        "title": "Dati del documento",
        "type": "Tipo di documento",
        "country": "Paese di rilascio",
        "number": "Numero del documento",
        "expiry": "Valido fino al",
        "nationality": "Cittadinanza",
        "expired": "scaduto"
      },
      "documentType": {
        "ID_CARD": "Carta d’identità",
        "PASSPORT": "Passaporto",
        "RESIDENCE_PERMIT": "Permesso di dimora",
        "OTHER": "Altro documento"
      },
      "contact": {
        "title": "Contatto",
        "name": "Nome",
        "email": "E-mail",
        "birthday": "Data di nascita",
        "company": "Azienda",
        "open": "Aprire il contatto"
      },
      "decisions": {
        "title": "Decisioni precedenti",
        "first": "Prima verifica",
        "second": "Seconda verifica",
        "reason": "Motivazione",
        "none": "Nessuna decisione finora."
      },
      "decision": {
        "APPROVE": "Approvata",
        "REJECT": "Respinta"
      },
      "errors": {
        "fourEyes": "La seconda approvazione deve essere concessa da un’altra persona.",
        "ownIdentification": "Non è possibile approvare la propria identificazione.",
        "alreadyDecided": "Questo caso è già stato deciso.",
        "reasonRequired": "È necessaria una motivazione (almeno 5 caratteri).",
        "decisionFailed": "Non è stato possibile salvare la decisione."
      },
      "ai": {
        "title": "Controllo IA",
        "hintOnly": "Proposta dell’IA — l’approvazione resta una decisione umana",
        "pending": "Controllo IA in corso …",
        "approve": "Approvare (raccomandato dall’IA)",
        "recommendation": {
          "approve": "Approvazione raccomandata",
          "review": "Da verificare",
          "reject": "Rifiuto raccomandato"
        },
        "checks": {
          "face_match": "Confronto dei volti",
          "finger_count": "Numero di dita nel selfie",
          "mrz_checksum": "Zona leggibile a macchina (MRZ)",
          "not_expired": "Validità del documento",
          "identity_match": "Nome e data di nascita",
          "sanctions": "Liste di sanzioni"
        },
        "result": {
          "ok": "in ordine",
          "failed": "non in ordine",
          "unknown": "non verificabile"
        }
      },
      "extraction": {
        "title": "Letto dal documento d’identità (IA, solo indicazione)",
        "hintOnly": "Solo indicazione — l’approvazione resta una decisione umana",
        "pending": "Lettura dei dati del documento in corso …",
        "failed": "Non è stato possibile leggere i dati del documento.",
        "retry": "Leggere di nuovo",
        "match": "Corrisponde al contatto",
        "mismatchCount": "{{count}} differenze rispetto al contatto",
        "mismatchCount_one": "Una differenza rispetto al contatto",
        "disabled": "La lettura automatica è disattivata.",
        "running": "La lettura è già in corso — attendere.",
        "fields": {
          "lastName": "Cognome",
          "firstNames": "Nome/i",
          "birthDate": "Data di nascita",
          "nationality": "Nazionalità",
          "documentType": "Tipo di documento",
          "documentNumber": "Numero del documento",
          "expiryDate": "Data di scadenza",
          "mrz": "Zona leggibile a macchina (MRZ)"
        },
        "flags": {
          "LAST_NAME_MISMATCH": "Il cognome differisce da quello del contatto",
          "FIRST_NAME_MISMATCH": "Il nome differisce da quello del contatto",
          "BIRTH_DATE_MISMATCH": "La data di nascita differisce da quella del contatto",
          "DOCUMENT_EXPIRED": "Documento scaduto"
        }
      }
    },
    "settings": {
      "declareRegulated": "Segnala l'azienda come vigilata",
      "lastRun": "Ultima verifica",
      "lastRunAt": "Eseguita il {{date}}",
      "legalHintAfter": "Dal 1° ottobre 2026 la legge svizzera sul riciclaggio di denaro ci obbliga a identificare una volta i nostri partner contrattuali. L'identificazione vale a tempo indeterminato.",
      "legalHintBefore": "A partire dal 1° ottobre 2026 la legge svizzera sul riciclaggio di denaro ci obbliga a identificare una volta i nostri partner contrattuali. L'identificazione vale a tempo indeterminato.",
      "method": "Metodo: {{method}}",
      "open": "Identificazione in sospeso",
      "openHint": "Non si è ancora identificato. Richiede circa due minuti.",
      "pending": "Identificazione in corso",
      "pendingHint": "Il risultato non è ancora disponibile.",
      "regulated": "Controparte vigilata",
      "regulatedHint": "{{company}} è segnalata come vigilata — non serve un'identificazione personale.",
      "restart": "Identificati di nuovo",
      "runChecks": "Esegui verifica",
      "start": "Identificati ora",
      "title": "Identificazione",
      "verified": "Identificato",
      "verifiedAt": "Identificato il {{date}}",
      "verifiedHint": "La sua identificazione vale a tempo indeterminato."
    },
    "stepper": {
      "identification": "1 Identificazione",
      "label": "Avanzamento della verifica di conformità",
      "lexKoller": "2 Diritto d'acquisto"
    },
    "steps": {
      "IDENT": {
        "error": "La verifica dell'identità non è riuscita. La preghiamo di riavviarla.",
        "ok": "Documento d'identità e selfie confermati.",
        "pending": "Il risultato del fornitore di identificazione non è ancora disponibile.",
        "running": "Stiamo verificando la sua identità.",
        "title": "Identità",
        "waiting": "Documento d'identità e selfie tramite il fornitore di identificazione."
      },
      "REGULATED": {
        "ok": "{{COMPANY_NAME}} è registrata come controparte vigilata.",
        "running": "Stiamo verificando se la sua azienda è vigilata.",
        "skipped": "Nessuna vigilanza dichiarata — si applica la verifica ordinaria.",
        "title": "Controparte vigilata",
        "waiting": "Verifica se la sua azienda è vigilata o quotata."
      },
      "SECO": {
        "error": "Il confronto non è momentaneamente possibile. Verifichiamo manualmente.",
        "hit": "Stiamo ancora verificando manualmente i suoi dati e la contatteremo.",
        "ok": "Nessuna voce nella lista di sanzioni della Confederazione.",
        "running": "Stiamo confrontando con la lista di sanzioni della Confederazione.",
        "title": "Lista di sanzioni SECO",
        "waiting": "Confronto con la lista di sanzioni della Confederazione."
      },
      "SIGNATORY": {
        "error": "Chiariremo personalmente con lei il diritto di firma.",
        "ok": "Ha diritto di firma per {{COMPANY_NAME}}.",
        "running": "Stiamo verificando il diritto di firma.",
        "skipped": "Nessun diritto di firma da verificare — agisce come persona privata.",
        "title": "Diritto di firma",
        "waiting": "Verifica se può firmare per la sua azienda."
      },
      "TRANSPARENCY_REGISTER": {
        "error": "Il registro della trasparenza non è momentaneamente raggiungibile. Verifichiamo manualmente.",
        "ok": "Nessuna anomalia nel registro della trasparenza.",
        "running": "Stiamo verificando il registro della trasparenza.",
        "skipped": "Il confronto avverrà a partire dal 1° ottobre 2026.",
        "title": "Registro della trasparenza",
        "waiting": "Confronto con il registro federale della trasparenza."
      },
      "ZEFIX": {
        "error": "Il registro di commercio non è momentaneamente raggiungibile. Verifichiamo manualmente.",
        "ok": "{{COMPANY_NAME}} è iscritta nel registro di commercio svizzero.",
        "running": "Stiamo confrontando con il registro di commercio.",
        "skipped": "Nessun confronto necessario — agisce come persona privata.",
        "title": "Registro di commercio (Zefix)",
        "waiting": "Confronto della sua azienda con il registro di commercio svizzero."
      }
    },
    "stub": {
      "back": "Torna all'app",
      "description": "Questa pagina sostituisce il fornitore di identificazione sull'ambiente di test. Un clic conclude l'identificazione — in produzione non è possibile.",
      "failed": "Non è stato possibile completare la simulazione.",
      "reference": "Riferimento",
      "simulate": "Simula identificazione",
      "success": "Identificazione completata. Verrà reindirizzato.",
      "title": "Simula identificazione",
      "unavailable": "La simulazione non è disponibile in questo ambiente."
    },
    "submitted": {
      "body": "Verifichiamo i suoi dati e la ricontattiamo. Può continuare a utilizzare la piattaforma.",
      "title": "Inviato, in corso di verifica"
    },
    "title": "Identificazione unica"
  },
  "layout": {
    "endImpersonation": "Torna all'admin",
    "footer": {
      "allRightsReserved": "Tutti i diritti riservati.",
      "build": "Build"
    },
    "impersonating": "Connesso come {{name}}",
    "reloadNow": "Aggiorna ora",
    "updateAvailable": "È disponibile una nuova versione."
  },
  "compliance": {
    "hint": {
      "action": "Inizia ora",
      "pendingText": "La contatteremo appena la verifica sarà conclusa. Non deve fare altro.",
      "pendingTitle": "La sua identificazione è in verifica",
      "retryAction": "Ricomincia",
      "retryText": "L’ultima verifica non è stata completata. La preghiamo di eseguire di nuovo l’identificazione.",
      "retryTitle": "La preghiamo di ripetere l’identificazione",
      "statusLink": "Vedere lo stato",
      "textIdent": "Una sola volta e in circa due minuti: documento d’identità e breve valutazione sull’acquisto di immobili (Lex Koller). Successivamente vedrà tutti i documenti.",
      "textLexKoller": "Manca solo la breve valutazione sull’acquisto di immobili (Lex Koller).",
      "title": "La preghiamo di completare la sua identificazione"
    }
  },
  "lexKoller": {
    "company": {
      "domicile": "Sede in Svizzera?",
      "domicilePrefilled": "La sede in Svizzera dell'azienda è confermata tramite Zefix.",
      "foreignOwnership": "Partecipazione estera superiore al 33%?",
      "foreignOwnershipDesc": "Quota di capitale o diritti di voto detenuti da persone all'estero.",
      "title": "Dati aziendali"
    },
    "details": {
      "canton": "Cantone",
      "noPermit": "Nessuno",
      "permit": "Permesso di soggiorno",
      "permitB": "B — Dimora",
      "permitC": "C — Domicilio",
      "permitG": "G — Frontaliere",
      "permitL": "L — Breve durata",
      "residence": "Domicilio in Svizzera?",
      "selectCanton": "Scegli un cantone...",
      "title": "Soggiorno e permesso"
    },
    "disclaimer": "Questa è una valutazione informativa e non costituisce consulenza legale. Per informazioni vincolanti, consultare un notaio o un avvocato.",
    "entityType": {
      "company": "Azienda / Società",
      "companyDesc": "SA, Sagl o altra persona giuridica",
      "description": "Indicare se acquista come persona privata o come azienda.",
      "person": "Persona privata",
      "personDesc": "Persona fisica",
      "title": "Chi desidera acquistare?"
    },
    "errors": {
      "assessFailed": "Non è stato possibile salvare la valutazione. Riprovare più tardi.",
      "declareFailed": "Non è stato possibile salvare la conferma. Riprovare più tardi."
    },
    "institutional": {
      "confirm": "La società non è controllata da persone all'estero per più di un terzo (art. 5 LAFE).",
      "description": "{{company}} è registrata come istituzione vigilata/iscritta ({{source}}). La Lex Koller non è quindi applicabile.",
      "doneBody": "La sua conferma è registrata. Per {{company}} non valgono restrizioni Lex Koller.",
      "submit": "Conferma",
      "title": "La Lex Koller non è applicabile",
      "unknownSource": "registro pubblico",
      "yourCompany": "la sua società"
    },
    "later": "Più tardi",
    "nationality": {
      "ch": "Svizzera",
      "chDesc": "Cittadino svizzero (incl. doppia cittadinanza)",
      "companyDesc": "Nazionalità degli aventi diritto economici.",
      "euEfta": "UE / AELS",
      "euEftaDesc": "Cittadino UE o AELS",
      "other": "Altro paese",
      "otherDesc": "Cittadino di uno Stato terzo",
      "personDesc": "Seleziona la tua nazionalità.",
      "title": "Nazionalità"
    },
    "prefill": {
      "fromIdent": "Abbiamo ripreso la sua cittadinanza dalla sua identificazione — chiediamo solo ciò che manca.",
      "fromDocument": "Ripreso dal suo documento d’identità — verifichi e modifichi se necessario."
    },
    "result": {
      "cantonalApproval": "Autorizzazione cantonale necessaria",
      "commercial": "Immobile commerciale",
      "investmentProperty": "Immobile d'investimento",
      "primaryResidence": "Residenza principale"
    },
    "settings": {
      "assessedInfo": "Valutazione completata",
      "editAssessment": "Modifica valutazione",
      "noAssessment": "Nessuna valutazione disponibile",
      "startAssessment": "Avvia valutazione"
    },
    "status": {
      "conditional": "Ammesso condizionatamente",
      "notApplicableInstitutional": "Non applicabile (istituzionale)",
      "restricted": "Limitato",
      "unrestricted": "Senza restrizioni"
    },
    "title": "Valutazione Lex Koller",
    "auto": {
      "title": "Determinato automaticamente: cittadino svizzero — nessuna limitazione",
      "description": "La sua cittadinanza proviene dal suo documento d’identità. La Lex Koller non la limita quindi — non deve compilare nulla.",
      "edit": "Modificare i dati"
    }
  },
  "linkedinImport": {
    "confirm": {
      "create": "creare",
      "execute": "Esegui importazione",
      "merge": "unire",
      "skip": "saltare",
      "summary": "{{total}} contatti verranno elaborati:",
      "title": "Conferma importazione",
      "warningCreate": "Verranno creati nuovi contatti e aziende",
      "warningMerge": "Le voci esistenti verranno arricchite con nuove informazioni",
      "warningSkip": "Le voci saltate non verranno modificate",
      "warningTitle": "Cosa succede durante l'importazione?"
    },
    "detail": {
      "error": "Errore nel caricamento dei dettagli",
      "loading": "Caricamento dettagli...",
      "records": "record",
      "title": "Dettagli importazione"
    },
    "history": {
      "clickHint": "Clicca per dettagli",
      "colCreated": "Creati",
      "colDate": "Data",
      "colMerged": "Uniti",
      "colName": "Nome",
      "colRecords": "Record",
      "colSkipped": "Saltati",
      "colStatus": "Stato",
      "detailColAction": "Aktion",
      "detailColCompany": "Organizzazione",
      "detailColMatch": "Abgleich",
      "detailColName": "Kontakt",
      "detailJobChanges": "Jobwechsel",
      "detailMerged": "Zusammengeführt",
      "detailNew": "Neu erstellt",
      "detailSkipped": "Übersprungen",
      "detailUpdated": "Aktualisiert",
      "loading": "Details werden geladen...",
      "noDetails": "Keine Details verfügbar",
      "statusCompleted": "Completato",
      "statusFailed": "Fallito",
      "statusPending": "In sospeso",
      "title": "Cronologia importazioni",
      "viewDetail": "Details anzeigen"
    },
    "preview": {
      "aiParsed": "Riconosciuto da IA",
      "autoMerge": "Unione automatica",
      "colAction": "Azione",
      "colCompany": "Azienda",
      "colCompanyJob": "Azienda / Posizione",
      "colEmail": "E-mail",
      "colMatch": "Corrispondenza",
      "colName": "Nome",
      "company": "Firma",
      "crmMatch": "Corrispondenza CRM",
      "decideAll": "Decidi per tutte le voci da verificare",
      "executeImport": "Esegui importazione",
      "importData": "Dati di importazione",
      "jobChangeDetected": "Cambio di lavoro rilevato",
      "jobChanges": "Cambi di lavoro",
      "matchMethod": "Metodo",
      "matchScore": "Punteggio",
      "matchedCompany": "Azienda (CRM)",
      "matchedContact": "Contatto",
      "needsReview": "Revisione necessaria",
      "newContacts": "Nuovi contatti",
      "noMatch": "Nuovo",
      "noMatchFound": "Nessun contatto esistente trovato",
      "parsedFromHeadline": "Estratto dal titolo",
      "position": "Jobtitel"
    },
    "result": {
      "backToOverview": "Torna alla panoramica",
      "colAction": "Azione",
      "colName": "Nome",
      "colStatus": "Stato",
      "created": "Creati",
      "errors": "Errori",
      "merged": "Uniti",
      "skipped": "Saltati",
      "title": "Importazione completata"
    },
    "scraper": {
      "batchSize": "Dimensione batch: 5-100 contatti per esecuzione",
      "directSync": "Sincronizzazione diretta: l'estensione può anche inviare i contatti direttamente a Immotron",
      "step1Desc": "Carica l'estensione Chrome dal repository Immotron e attivala in Chrome",
      "step1Title": "Installa l'estensione",
      "step2Desc": "Apri LinkedIn, avvia l'estensione e lascia catturare i contatti automaticamente",
      "step2Title": "Scraping dei contatti",
      "step3Desc": "Scarica l'esportazione come file JSON e caricalo qui sotto o sincronizza direttamente con Immotron",
      "step3Title": "Esporta JSON & importa qui",
      "subtitle": "Esporta i contatti direttamente da LinkedIn",
      "title": "Estensione Chrome LinkedIn Scraper"
    },
    "steps": {
      "confirm": "Conferma",
      "preview": "Anteprima",
      "result": "Risultato",
      "upload": "Caricamento"
    },
    "subtitle": "Importa i contatti LinkedIn e confrontali con gli indirizzi esistenti",
    "title": "Importazione LinkedIn",
    "toast": {
      "importFailed": "Import fehlgeschlagen"
    },
    "upload": {
      "contactsFound": "{{count}} contatti rilevati",
      "emptyArray": "Array vuoto — nessun contatto trovato",
      "fileButton": "Carica file JSON",
      "fileHint": "Accetta file .json",
      "fileReadError": "Datei konnte nicht gelesen werden",
      "importName": "Nome dell'importazione (opzionale)",
      "invalidJson": "Formato JSON non valido",
      "namePlaceholder": "z.B. LinkedIn Export März 2026",
      "pasteLabel": "Incolla JSON",
      "placeholder": "[\n  {\n    \"linkedinUrl\": \"https://linkedin.com/in/...\",\n    \"firstName\": \"Mario\",\n    \"lastName\": \"Rossi\",\n    \"email\": \"mario@example.com\",\n    \"currentCompany\": \"Azienda SA\",\n    \"headline\": \"CEO presso Azienda SA\"\n  }\n]",
      "previewFailed": "Vorschau fehlgeschlagen",
      "startPreview": "Avvia anteprima",
      "validationError": "Validierungsfehler",
      "wrongFormat": "Falsches JSON-Format. Erwartet: [{linkedinUrl, firstName, lastName, ...}]"
    }
  },
  "listings": {
    "addListing": "Nuovo teaser",
    "addProperty": "Aggiungi immobile",
    "assignedBuyers": {
      "activeBadge": "Accesso attivo",
      "companyGroup": "Azienda {{name}}",
      "conditionDeviates": "differisce dal contratto quadro",
      "conditionOwnForProperty": "condizione propria per questo immobile",
      "conditionUnknown": "Nessuna condizione definita",
      "emailLabelFor": "Indirizzo e-mail di {{name}}",
      "emailMissing": "Indirizzo e-mail mancante",
      "emailPlaceholder": "nome@azienda.ch",
      "emailSave": "Salva",
      "emailSaveFailed": "Impossibile salvare l'indirizzo e-mail.",
      "emailSaveFor": "Salvare l'indirizzo e-mail di {{name}}",
      "emailSaved": "Indirizzo e-mail salvato.",
      "empty": "Nessun acquirente assegnato",
      "inviteCount": "({{count}} inviti)",
      "inviteNever": "non ancora contattato",
      "inviteSent": "invitato il {{date}}",
      "inviteUsed": "link aperto il {{date}}",
      "mixedBadge": "Misto",
      "pendingBadge": "Onboarding in sospeso",
      "pendingHint": "Saltato all'approvazione: nessun contratto acquirente attivo. L'accesso verrà concesso automaticamente dopo la firma del contratto.",
      "personCount": "{{count}} persona/e",
      "plannedCondition": "previsto: {{model}}",
      "remove": "Rimuovi",
      "removeConfirm": "Rimuovere l'assegnazione?",
      "removeConfirmGroup": "Tutte le {{count}} persone di «{{name}}» perderanno l’accesso a questo immobile.",
      "removeConfirmPerson": "«{{name}}» perderà l’accesso a questo immobile. L’assegnazione può essere ricreata in qualsiasi momento.",
      "removeDone": "Assegnazione rimossa.",
      "removeFailed": "Rimozione non riuscita.",
      "removeFor": "Rimuovi l'assegnazione di {{name}}",
      "removeGroup": "Rimuovi tutte le assegnazioni di {{name}}",
      "resend": "Invia di nuovo l’e-mail",
      "resendConfirm": "Inviare di nuovo l’invito?",
      "resendConfirmText": "{{count}} destinatari sono già stati invitati. Un nuovo invio rende non validi i link inviati in precedenza.",
      "resendDone": "Invito inviato di nuovo.",
      "resendFailed": "Invio non riuscito.",
      "resendFor": "Invia di nuovo l’e-mail a {{name}}",
      "resendGroupCount": "Contattare tutte le persone in sospeso di {{name}} ({{count}})",
      "resendNoPending": "Nessuno in questo gruppo è in attesa dell'onboarding",
      "resendSkipped": "Nessun invito inviato: {{reason}}",
      "resendSkippedUnknown": "Nessun motivo indicato",
      "sendAfterApproval": "Invio dopo il rilascio",
      "singlePersons": "Persone singole",
      "skipReason": {
        "no_active_contract": "Nessun contratto acquirente attivo",
        "no_contact": "Nessuna persona di contatto registrata",
        "no_email": "Nessun indirizzo e-mail registrato"
      },
      "statusOnApproval": "Accesso al rilascio",
      "title": "Acquirenti assegnati",
      "viaGroup": "tramite il gruppo {{name}}"
    },
    "bundle": "Pacchetto",
    "bundleCreated": "Il pacchetto e stato creato.",
    "confirmDelete": "Vuole davvero eliminare questo teaser? Gli immobili contenuti verranno conservati.",
    "confirmDeleteDescription": "E sicuro/a di voler eliminare questo teaser?",
    "confirmRemoveProperty": "Vuole rimuovere questo immobile dal teaser? Verrà assegnato a un nuovo teaser singolo.",
    "confirmRemovePropertyDescription": "E sicuro/a di voler rimuovere questo immobile?",
    "createBundle": "Crea pacchetto",
    "deleteSuccess": "Il teaser e stato eliminato.",
    "errors": {
      "addPropertyFailed": "Impossibile aggiungere l'immobile",
      "deleteFailed": "Impossibile eliminare il teaser",
      "loadFailed": "Impossibile caricare i teasers",
      "notFound": "Teaser non trovato",
      "removePropertyFailed": "Impossibile rimuovere l'immobile",
      "saveFailed": "Impossibile salvare il teaser"
    },
    "fields": {
      "location": "Posizione",
      "price": "Prezzo",
      "private": "Privato",
      "properties": "Immobili contenuti",
      "public": "Pubblico",
      "status": "Stato",
      "title": "Titolo",
      "totalPrice": "Prezzo totale",
      "type": "Tipo",
      "timeline": "Timeline",
      "interested": "Interessenten"
    },
    "list": {
      "empty": {
        "description": "I teasers vengono creati automaticamente quando si aggiunge un immobile.",
        "title": "Nessun teaser trovato"
      }
    },
    "noAvailableProperties": "Nessun altro immobile disponibile",
    "propertyRemoved": "L'immobile e stato rimosso.",
    "removeProperty": "Rimuovi immobile",
    "resultsLabel": "Teasers",
    "selection": {
      "createBundle": "Commercializzare insieme",
      "selectMode": "Selezione",
      "selected": "{{count}} selezionato/i"
    },
    "single": "Singolo",
    "statuses": {
      "ACTIVE": "Attivo",
      "ARCHIVED": "Archiviato",
      "DRAFT": "Bozza",
      "SOLD": "Venduto"
    },
    "subtitle": "Gestisci teasers e pacchetti",
    "title": "Teasers",
    "saleMode": {
      "offerCollection": "Bieterverfahren",
      "fixedPrice": "Fixpreis"
    },
    "preview": {
      "title": "Anteprima teaser",
      "hint": "Così l'investitore vede l'immobile",
      "propertyPickerLabel": "Scegliere l'immobile per l'anteprima",
      "loadFailed": "Impossibile caricare l'anteprima."
    },
    "management": {
      "title": "Gestione acquirenti",
      "hint": "Aggiungere acquirenti in un secondo momento — tramite gruppi di investitori, suggerimenti IA o ricerca manuale.",
      "groupsTitle": "Gruppi di investitori",
      "groupsLoadFailed": "Impossibile caricare i gruppi di investitori.",
      "groupsEmpty": "Nessun gruppo di investitori disponibile.",
      "assignGroups": "Assegna {{count}} gruppo/i",
      "groupsAssigned": "Gruppi di investitori assegnati — i membri ricevono l'accesso.",
      "suggestionsTitle": "Suggerimenti IA per acquirenti",
      "load": "Carica suggerimenti acquirenti",
      "reload": "Ricalcola",
      "loading": "Calcolo dei suggerimenti …",
      "loadFailed": "Impossibile caricare i suggerimenti per acquirenti.",
      "retry": "Riprova",
      "empty": "Nessun acquirente corrispondente trovato.",
      "assignSelected": "Assegna {{count}} acquirente/i",
      "buyersAssigned": "{{count}} acquirente/i assegnato/i.",
      "manualTitle": "Ricerca persone",
      "manualHint": "Aggiungere manualmente contatti o aziende CRM come acquirenti.",
      "assignFailed": "Assegnazione non riuscita.",
      "conditionsPreview": "Condizioni di questo immobile: {{model}}"
    },
    "masterData": {
      "title": "Dati di base",
      "hint": "Titolo, stato, visibilità e prezzo totale del teaser. Modalità di vendita, prezzo e scadenze NBO/BO si definiscono nel Quality Gate.",
      "saved": "Dati di base salvati"
    },
    "stats": {
      "title": "Statistiche",
      "hint": "Aperture e download del teaser per investitore",
      "loadFailed": "Impossibile caricare le statistiche.",
      "retry": "Riprova",
      "empty": "Nessuna attività registrata finora.",
      "totalOpens": "Aperture totali",
      "uniqueVisitors": "Visitatori unici",
      "documentViews": "Visualizzazioni file",
      "downloads": "Download",
      "investor": "Investitore",
      "opens": "Aperture",
      "lastOpened": "Ultima apertura",
      "viewedDocuments": "File visualizzati",
      "downloadedDocuments": "File scaricati",
      "never": "—"
    }
  },
  "mandanten": {
    "accentColor": "Colore d'accento",
    "active": "Attivo",
    "addUser": "Aggiungi utente",
    "address": "Indirizzo",
    "allRoles": "Tutti i ruoli",
    "allUsers": "Tutti gli utenti",
    "brandColors": "Colori del marchio",
    "brandColorsHint": "Questi colori vengono utilizzati nella firma e-mail. Colore primario per testo e separatore, colore d'accento per i link.",
    "canton": "Cantone",
    "city": "Città",
    "confirmDeleteMandant": "Vuole davvero eliminare definitivamente «{{name}}»? Tutti i dati associati verranno rimossi.",
    "confirmDeleteUser": "Sei sicuro di voler eliminare questo utente? Questa azione non può essere annullata.",
    "confirmRemove": "Vuoi davvero rimuovere questo utente?",
    "createAndAssign": "Crea & Assegna",
    "createMandant": "Crea mandante",
    "createMandantSuccess": "Mandante creato",
    "createUser": "Crea utente",
    "createUserSuccess": "Utente creato e assegnato",
    "customTemplate": "Template personalizzato",
    "deleteConfirmBtn": "Elimina definitivamente",
    "deleteConfirmInput": "Inserire «{{name}}» per confermare:",
    "deleteKeys": {
      "campaign_recipients": "Destinatari campagna",
      "campaigns": "Campagne",
      "company_contacts": "Contatti aziendali",
      "contract_bundles": "Pacchetti di contratti",
      "contracts": "Contratti",
      "email_templates": "Modelli e-mail",
      "offers": "Offerte",
      "user_companies": "Assegnazioni utenti"
    },
    "deleteMandant": "Elimina mandante",
    "deleteNoRelated": "Nessun dato associato",
    "deletePreviewTitle": "I seguenti dati verranno eliminati:",
    "deleteSuccess": "Mandante «{{name}}» e tutti i dati associati eliminati",
    "deleteUser": "Elimina utente",
    "deleteUserSuccess": "Utente eliminato",
    "directPhone": "Telefono diretto",
    "directPhonePlaceholder": "es. +41 44 123 45 67",
    "editMandant": "Modifica mandante",
    "editMandantSuccess": "Mandante aggiornato",
    "editUser": "Modifica utente",
    "email": "E-mail",
    "empty": "Nessuna azienda interna trovata",
    "errors": {
      "loadFailed": "Impossibile caricare i mandanti",
      "loadUsersFailed": "Impossibile caricare gli utenti"
    },
    "filterByRole": "Filtra per ruolo",
    "function": "Funzione",
    "functionPlaceholder": "es. COO, Presidente del CdA",
    "houseNumber": "N.",
    "impersonate": "Accedi come utente",
    "impersonateAction": "Accedi",
    "impersonateHint": "Apre una sessione come questo utente",
    "impersonateSuccess": "Connesso come {{name}}",
    "inactive": "Inattivo",
    "legalForm": "Forma giuridica",
    "linkCompany": "Collega azienda",
    "linkCompanySuccess": "Azienda collegata come mandante",
    "logo": "Logo",
    "logoDragOrClick": "Trascina il logo qui o clicca per selezionare",
    "logoFormatError": "Solo PNG, JPG e WebP consentiti",
    "logoRemove": "Rimuovi logo",
    "logoSizeError": "Il file non deve superare 5 MB",
    "logoUploadError": "Caricamento logo non riuscito",
    "logoUploadSuccess": "Logo caricato con successo",
    "logoUploading": "Caricamento logo...",
    "mandantAssignment": "Assegnazione mandante",
    "noCompaniesAvailable": "Nessuna azienda disponibile",
    "noMandant": "–",
    "noPreference": "Nessuna preferenza",
    "noUsers": "Nessun utente assegnato",
    "pageSubtitle": "Gestisci mandanti, utenti e autorizzazioni",
    "pageTitle": "Gestione mandanti",
    "passwordReset": "Reset password",
    "passwordResetHint": "Invia un link di reset via e-mail",
    "phone": "Telefono",
    "preferredLanguage": "Lingua preferita",
    "primaryColor": "Colore primario",
    "removeFromMandant": "Rimuovi assegnazione",
    "removeSuccess": "Utente rimosso dal mandante",
    "resetLinkCopied": "Link copiato negli appunti",
    "resetSent": "Link di reset inviato via e-mail",
    "searchCompany": "Cerca azienda...",
    "searchUsers": "Cerca utenti...",
    "sectionAddress": "Indirizzo",
    "sectionCompany": "Dati aziendali",
    "sectionContact": "Contatto",
    "sectionSignature": "Firma e-mail",
    "selectUser": "Seleziona utente",
    "sendReset": "Invia link",
    "signatories": "Firmatari",
    "signaturePreview": "Anteprima firma",
    "signaturePreviewError": "Impossibile caricare l'anteprima",
    "signaturePreviewHint": "Fai clic su «Anteprima» per vedere la firma e-mail attuale.",
    "signatureText": "Testo firma",
    "signatureType": "Autorità di firma",
    "signatureTypes": {
      "COLLECTIVE_MORE": "Firma collettiva a più",
      "COLLECTIVE_TWO": "Firma collettiva a due",
      "NONE": "Nessuna",
      "SINGLE": "Firma singola"
    },
    "status": "Stato",
    "street": "Via",
    "subtitle": "Gestisci aziende interne e assegnazioni utenti",
    "tabCreate": "Crea nuovo",
    "tabExisting": "Esistente",
    "tabMandanten": "Mandanti",
    "tabManual": "Manuale",
    "tabUsers": "Utenti",
    "tabZefix": "Ricerca Zefix",
    "templateActive": "(attivo)",
    "templateDefault": "(predefinito)",
    "templateHint": "Variabili: {{ user_name }}, {{ user_function }}, {{ company_name }}, {{ company_logo_url }}, {{ disclaimer }}, {{ primary_color }}, {{ accent_color }} ecc.",
    "templatePlaceholder": "Template HTML Jinja2 (vuoto = template predefinito)",
    "title": "Mandanti",
    "updateUserSuccess": "Modifiche salvate",
    "userDetails": "Dati utente",
    "userEmail": "E-mail",
    "userIsActive": "Utente attivo",
    "userMandanten": "Mandante/i",
    "userName": "Nome",
    "userRole": "Ruolo",
    "users": "Utenti",
    "verbindlichkeitsklausel": "Clausola di non vincolo",
    "verbindlichkeitsklauselHint": "Mostra la clausola nella firma e-mail",
    "website": "Sito web",
    "zipCode": "CAP",
    "actions": "Aktionen"
  },
  "mapView": {
    "approximateLocation": "Posizione approssimativa",
    "cluster": "Gruppo",
    "exactLocation": "Posizione esatta",
    "gridView": "Griglia",
    "kmRadius": "ca. {{km}} km di raggio",
    "mapView": "Mappa",
    "showOnMap": "Mostra dettagli"
  },
  "media": {
    "confirmDelete": "Sei sicuro di voler eliminare questa immagine?",
    "copyUrl": "Copia URL",
    "delete": "Elimina",
    "deleteFailed": "Il file non ha potuto essere eliminato.",
    "deleteSuccess": "Immagine eliminata",
    "empty": "Nessun media caricato",
    "subtitle": "Gestisci immagini e file multimediali",
    "title": "Media",
    "upload": "Carica immagine",
    "uploadFailed": "Il caricamento non e riuscito.",
    "uploadSuccess": "Caricamento riuscito.",
    "uploadedAt": "Caricato il",
    "uploading": "Caricamento...",
    "urlCopied": "URL copiato negli appunti"
  },
  "missingConditions": {
    "title": "Nessuna condizione concordata",
    "assignDescription": "Per le seguenti persone non è concordata alcuna condizione su questo immobile. Senza condizione concordata non viene effettuata alcuna assegnazione.",
    "approveDescription": "Per il mandante di questo immobile non è concordata alcuna condizione venditore. Senza condizione concordata non viene rilasciata l'approvazione.",
    "blockedDescription": "L'approvazione è possibile solo quando per ogni acquirente è registrata una condizione. Il modo più rapido: definire un'unica condizione dell'immobile valida per tutti.",
    "roles": {
      "buyer": "Acquirente",
      "seller": "Venditore"
    },
    "entityCompany": "Azienda",
    "entityContact": "Persona",
    "checkedSources": "Verificato:",
    "sources": {
      "appendix_b": "Allegato B (rilascio immobile)",
      "appendix_b_buyer": "Allegato B per questo acquirente",
      "property": "Condizione dell'immobile",
      "framework": "Tasso del contratto quadro",
      "default_model": "Modello standard del mandante"
    },
    "setConditions": "Registrare la condizione",
    "setBuyerConditions": "Definisci la condizione per questo acquirente",
    "buyerContractPending": "Il contratto acquirente di {{name}} non è ancora controfirmato — la condizione può essere definita solo dopo.",
    "variableHint": "Contratto quadro «variabile»: le condizioni sono concordate per immobile — il modello standard non si applica qui. Inserisci una condizione dell'immobile oppure definiscila per questo acquirente.",
    "reasonLabel": "Motivazione (obbligatoria)",
    "reasonPlaceholder": "Perché procedere senza una condizione concordata?",
    "reasonHint": "Senza motivazione l'operazione non può essere confermata. La conferma consapevole viene annotata nel registro attività con utente e data/ora.",
    "assignAnyway": "Assegna comunque",
    "approveAnyway": "Approva comunque",
    "confirmed": "Operazione confermata nonostante la condizione mancante.",
    "retryFailed": "L'operazione non è riuscita. Riprovare.",
    "conditionsSetRetry": "Condizione definita — l'operazione è stata eseguita."
  },
  "myOffers": {
    "activeOffers": "Offerte attive",
    "columns": {
      "actions": "Azioni",
      "amount": "Importo",
      "date": "Data",
      "proof": "Prova",
      "property": "Immobile",
      "status": "Stato",
      "type": "Tipo"
    },
    "confirmWithdraw": "Vuoi davvero ritirare questa NBO?",
    "confirmWithdrawDescription": "E sicuro/a di voler ritirare questa offerta?",
    "detail": {
      "amount": "Importo",
      "expired": "Scaduta",
      "financingProof": "Prova di finanziamento",
      "loiSigned": "LOI firmata",
      "no": "No",
      "notUploaded": "In attesa",
      "offerType": "Tipo di offerta",
      "reservationExpires": "Prenotazione scade",
      "submittedAt": "Inviata il",
      "title": "Dettagli offerta",
      "uploaded": "Caricata",
      "yes": "Sì",
      "conditions": "Bedingungen"
    },
    "empty": "Nessuna offerta",
    "emptyHint": "Le tue offerte inviate appariranno qui",
    "filters": {
      "allStatuses": "Tutti gli stati",
      "allTypes": "Tutti i tipi",
      "status": "Stato",
      "title": "Filtri",
      "type": "Tipo di offerta"
    },
    "loadFailed": "Impossibile caricare le offerte",
    "statuses": {
      "CANCELLED": "Annullata",
      "COMPLETED": "Completata",
      "EXPIRED": "Scaduta",
      "LOST": "Non selezionata",
      "PROOF_PENDING": "Prova in attesa",
      "REJECTED": "Rifiutata",
      "RESERVED": "Riservata",
      "SUBMITTED": "Inviata",
      "UNDER_REVIEW": "In esame",
      "WITHDRAWN": "Ritirata",
      "WON": "Aggiudicata"
    },
    "title": "Le mie offerte",
    "types": {
      "BO": "BO",
      "FIXED_PRICE": "Prezzo fisso",
      "NBO": "NBO"
    },
    "withdraw": "Ritirare",
    "withdrawFailed": "Impossibile ritirare la NBO",
    "withdrawSuccess": "NBO ritirata con successo"
  },
  "navigation": {
    "activities": "Attività",
    "addresses": "Indirizzi",
    "admin": "Amministrazione",
    "aiJobs": "Processi IA",
    "aiLearning": "Modalita apprendimento",
    "aiUpload": "Caricamento IA",
    "bids": "Offerte",
    "campaigns": "Campagne",
    "ceoAgent": "Assistente attività",
    "companies": "Organizzazioni",
    "contactDedup": "Deduplicazione",
    "contacts": "Contatti",
    "contractExpiredTooltip": "Contratto scaduto — contattaci per il rinnovo",
    "contracts": "Contratti",
    "createProperty": "Crea immobile",
    "dashboard": "Dashboard",
    "deals": "Deals",
    "emailTemplates": "Modelli e-mail",
    "emails": "Emails",
    "favorites": "Lista preferiti",
    "fundRadar": "Radar dei fondi",
    "investorSettings": "Impostazioni",
    "investors": "Investitori",
    "linkedinImport": "Importazione LinkedIn",
    "listings": "Teasers",
    "myContracts": "I miei contratti",
    "myOffers": "Le mie offerte",
    "myProperties": "I miei immobili",
    "portfolio": "Portafoglio",
    "properties": "Proprietà",
    "qualityGate": "Quality Gate",
    "researchLeads": "Lead di ricerca",
    "schema": "Schema DB",
    "search": "Cerca",
    "sectionAI": "Intelligenza artificiale",
    "sectionAdmin": "Amministrazione",
    "sectionBroker": "Intermediario",
    "sectionCRM": "CRM",
    "sectionImmobilien": "Immobili",
    "sectionInvestor": "Investitore",
    "sectionSales": "Vendite",
    "sectionSeller": "Venditore",
    "sectionSystem": "Sistema",
    "sectionTransactions": "Transazioni",
    "settings": "Impostazioni",
    "users": "Utenti",
    "e2eReports": "E2E Reports",
    "menu": "Menü"
  },
  "nbobo": {
    "bo": {
      "amount": "Offerta d'acquisto",
      "amountPlaceholder": "Importo in CHF",
      "bindingNotice": "Questa offerta è giuridicamente vincolante. Con la presentazione vi impegnate all'acquisto.",
      "conditions": "Condizioni (opzionale)",
      "conditionsPlaceholder": "p.es. Data di acquisizione, richieste speciali",
      "description": "Presentate un'offerta d'acquisto vincolante. Questa offerta è giuridicamente vincolante.",
      "step1": "Offerta",
      "step2": "Firma LOI",
      "step3": "Prova di finanziamento",
      "step4": "Conferma",
      "submit": "Presentare offerta vincolante",
      "submitted": "Il vostro BO è stato presentato.",
      "title": "Offerta vincolante (BO)",
      "waitingDecision": "In attesa della decisione del venditore",
      "withdraw": "Ritirare BO",
      "withdrawn": "Il vostro BO è stato ritirato.",
      "stepAmount": "Angebot",
      "stepLoi": "LOI",
      "stepFinancing": "Nachweis",
      "stepConfirm": "Bestaetigung"
    },
    "boPhase": "Fase d'offerta vincolante (BO)",
    "boStatus": {
      "lost": "Non selezionato",
      "rejected": "Respinto",
      "submitted": "Presentato",
      "withdrawn": "Ritirato",
      "won": "Aggiudicato"
    },
    "countdown": {
      "ended": "Fase terminata",
      "endsIn": "Termina tra {{time}}"
    },
    "guidePrice": "Prezzo indicativo",
    "minimumPrice": "Prezzo minimo",
    "nbo": {
      "amount": "La vostra offerta",
      "amountPlaceholder": "Importo in CHF",
      "conditions": "Condizioni (opzionale)",
      "conditionsPlaceholder": "p.es. Riserva di finanziamento, due diligence",
      "description": "Presentate un'offerta di prezzo non vincolante. Serve come sondaggio di mercato.",
      "evaluation": "Valutazione NBO",
      "evaluationPending": "La valutazione delle offerte è in corso.",
      "median": "Mediana",
      "nonBindingNotice": "Questa offerta non è vincolante e non costituisce un obbligo d'acquisto.",
      "offers": "Offerte",
      "range": "Fascia",
      "submit": "Presentare NBO",
      "submitted": "Il vostro NBO è stato presentato.",
      "title": "Offerta indicativa (NBO)",
      "withdraw": "Ritirare NBO",
      "withdrawConfirm": "Volete davvero ritirare il vostro NBO?",
      "withdrawn": "Il vostro NBO è stato ritirato.",
      "stepAmount": "Angebot",
      "stepConditions": "Bedingungen",
      "stepFinancing": "Nachweis",
      "stepConfirm": "Unterschrift",
      "submittedDetail": "Ihr indikatives Angebot wurde erfolgreich eingereicht. Sie werden ueber den weiteren Verlauf informiert."
    },
    "nboPhase": "Fase d'offerta indicativa (NBO)",
    "nboStatus": {
      "lost": "Non qualificato",
      "outbid": "Superato",
      "rejected": "Respinto",
      "shortlisted": "Preselezionato",
      "submitted": "Presentato",
      "withdrawn": "Ritirato",
      "won": "Qualificato"
    },
    "phase": "Fase",
    "sales": {
      "amount": "Importo",
      "award": "Aggiudicare",
      "awardConfirm": "Volete aggiudicare a questo investitore?",
      "awardSuccess": "L'aggiudicazione è stata effettuata.",
      "awarded": "Aggiudicato",
      "boTab": "Fase BO",
      "date": "Data",
      "financingProof": "Prova fin.",
      "investor": "Investitore",
      "nboTab": "Fase NBO",
      "noOffers": "Nessuna offerta ancora",
      "status": "Stato",
      "title": "Offerte"
    },
    "status": {
      "closed": "Chiuso",
      "evaluating": "In valutazione",
      "open": "Aperto",
      "upcoming": "In arrivo"
    },
    "title": "Procedura d'offerta",
    "report": {
      "viewReport": "Auswertung anzeigen",
      "title": "NBO-Auswertung"
    },
    "myOffer": {
      "titleNbo": "Il vostro NBO presentato",
      "titleBo": "Il vostro BO presentato",
      "amount": "Importo dell'offerta",
      "status": "Stato",
      "submittedAt": "Presentato il",
      "updatedAt": "Ultima modifica",
      "deadline": "Termine del turno",
      "loiSigned": "LOI firmata",
      "financingProof": "Prova di finanziamento",
      "notAvailable": "Non disponibile",
      "conditions": "Condizioni e riserve",
      "noConditions": "Nessuna indicazione",
      "readOnlyHint": "Questa vista mostra l'offerta presentata. Qui non sono possibili modifiche."
    }
  },
  "notifications": {
    "allRead": "Tutte le notifiche lette",
    "empty": "Nessuna notifica",
    "filterAll": "Tutte",
    "filterUnread": "Non lette",
    "markAllRead": "Segna tutto come letto",
    "pushBlocked": "Push bloccato",
    "pushDisable": "Disattiva push",
    "pushEnable": "Attiva push",
    "pushEnabled": "Push attivo",
    "timeAgo": {
      "days": "{{count}}g fa",
      "hours": "{{count}}h fa",
      "justNow": "Proprio ora",
      "minutes": "{{count}} min fa"
    },
    "title": "Notifiche",
    "types": {
      "ACCESS_GRANTED": "Accesso concesso",
      "AI_EXTRACTION": "Estrazione IA completata",
      "AI_EXTRACTION_COMPLETE": "Estrazione IA completata",
      "BIDDING_ROUND_CLOSED": "Asta chiusa",
      "BIDDING_ROUND_CLOSING_SOON": "Asta in scadenza",
      "BIDDING_ROUND_OPENED": "Asta aperta",
      "BID_LOST": "Offerta non accettata",
      "BID_SUBMITTED": "Offerta inviata",
      "BID_SUBMITTED_SALES": "Nuova offerta ricevuta",
      "BID_WON": "Offerta accettata",
      "CONTRACT_SIGNED_SALES": "Contratto firmato",
      "CONTRACT_SIGNED_WELCOME": "Benvenuto – Contratto firmato",
      "COUNTERSIGN_READY": "Controfirma pronta",
      "COUNTERSIGN_REMINDER": "Promemoria controfirma",
      "DOSSIER_UPDATE": "Dossier aggiornato",
      "INTEREST_EXPRESSED": "Interesse espresso",
      "INTEREST_SALES_NOTIFY": "Nuovo interesse investitore",
      "NDA_CONFIRMED": "NDA confermato",
      "SIGNATURE_REQUIRED": "Firma richiesta"
    },
    "unreadCount": "non lette",
    "viewAll": "Mostra tutte"
  },
  "offer": {
    "confirm": {
      "bindingWarning": "Inviando, fa un'offerta d'acquisto vincolante al prezzo fisso. La prenotazione è valida per 14 giorni.",
      "financingProof": "Prova di finanziamento",
      "loiSigned": "LOI firmata",
      "nonBindingInfo": "Con l'invio, sta facendo un'offerta di acquisto non vincolante. Questo non è ancora un contratto di vendita.",
      "price": "Prezzo d'acquisto",
      "property": "Oggetto",
      "submit": "Invia offerta vincolante",
      "title": "Riepilogo",
      "uploadLater": "Verrà inviata successivamente"
    },
    "dialog": {
      "title": "Invia offerta",
      "yourPrice": "Ihr Angebot (CHF)",
      "stepsLabel": "Passaggi per l’invio dell’offerta",
      "steps": {
        "amount": "La sua offerta",
        "document": "Il suo documento",
        "review": "Verificare e inviare"
      },
      "amount": {
        "wholeFrancs": "Franchi interi, senza centesimi.",
        "fixedPrice": "Prezzo fisso: {{price}}",
        "guidePrice": "Prezzo indicativo: {{price}}",
        "minimumPrice": "Prezzo minimo: {{price}}"
      },
      "document": {
        "title": "Documento d’offerta",
        "description": "Utilizzi il modello standard oppure carichi un proprio documento d’offerta.",
        "standardOption": "Utilizzare il modello standard",
        "customOption": "Caricare un proprio documento",
        "customDescription": "Carichi il suo documento d’offerta in formato PDF. Sostituisce il modello standard.",
        "customHint": "Solo PDF, max. 50 MB",
        "dropHint": "Trascini qui il documento d’offerta oppure lo selezioni",
        "removeFile": "Rimuovere il file",
        "chooseHint": "Scelga dapprima come desidera presentare la sua offerta."
      },
      "reservations": {
        "title": "Riserve",
        "description": "Selezioni le riserve valide per la sua offerta. Nel documento compaiono solo i punti selezionati.",
        "templateTitle": "La sua offerta è soggetta alle seguenti riserve:",
        "none": "Nessuna riserva selezionata",
        "loadFailed": "Non è stato possibile caricare le riserve. Può presentare la sua offerta anche senza riserve."
      },
      "remarks": {
        "title": "Osservazioni",
        "description": "Indichi qui quanto va oltre le riserve — per esempio una consegna non prima di una determinata data. Il testo viene trasmesso invariato.",
        "placeholder": "p. es. consegna non prima del 1.1.2028"
      },
      "summary": {
        "document": "Documento d’offerta",
        "standardSigned": "Modello standard, firmato digitalmente",
        "noRemarks": "Nessuna osservazione"
      },
      "template": {
        "heading": "Dichiarazione d’intenti",
        "subtitleBinding": "Dichiarazione d’intenti d’acquisto vincolante",
        "subtitleNonBinding": "Dichiarazione d’intenti d’acquisto non vincolante",
        "date": "Data",
        "object": "Oggetto",
        "price": "Prezzo d’acquisto",
        "bodyBinding": "Con la presente dichiaro il mio interesse vincolante all’acquisto dell’oggetto sopra indicato al prezzo d’acquisto riportato. La presente dichiarazione costituisce la base per le ulteriori trattative e per la stipulazione di un contratto di compravendita notarile.",
        "bodyNonBinding": "Con la presente dichiaro il mio interesse all’acquisto dell’oggetto sopra indicato al prezzo d’acquisto riportato. La presente dichiarazione non è vincolante e non comporta alcun obbligo d’acquisto.",
        "note": "La dichiarazione funge da base per la bozza del contratto di compravendita redatta dal notaio.",
        "signatureLine": "Luogo, data / firma dell’acquirente"
      },
      "notice": {
        "binding": "Si tratta di un’offerta vincolante. Con l’invio si impegna all’acquisto alle condizioni indicate.",
        "nonBinding": "Si tratta di un’offerta non vincolante. Non si perfeziona ancora alcun contratto di compravendita."
      },
      "uploadFailed": "La sua offerta è stata inviata. Non è stato possibile trasmettere: {{files}}. La preghiamo di riprovare.",
      "retryUploads": "Trasmettere nuovamente i file",
      "success": {
        "title": "Offerta inviata",
        "message": "La sua offerta è stata inviata con successo. Riceverà una conferma per e-mail."
      }
    },
    "errors": {
      "alreadySubmitted": "Ha già inviato un'offerta per questo oggetto.",
      "noLongerAvailable": "Questo oggetto non è più disponibile.",
      "submitFailed": "L'offerta non ha potuto essere inviata. Riprovi."
    },
    "financing": {
      "browse": "Scegli file",
      "description": "Carichi una prova di finanziamento (es. conferma bancaria, impegno di finanziamento). Può anche inviarla successivamente.",
      "dropHint": "Trascini il file qui o faccia clic",
      "fileTooLarge": "Il file è troppo grande (max. 50 MB).",
      "hint": "PDF, PNG o JPG, max. 50 MB",
      "required": "Carichi una prova di finanziamento.",
      "skipForNow": "Invia più tardi",
      "title": "Prova di finanziamento",
      "upload": "Carica prova",
      "uploadFailed": "Caricamento fallito. Riprovi.",
      "uploadSuccess": "Prova di finanziamento caricata con successo.",
      "uploaded": "Caricato il {{date}}",
      "descriptionOptional": "Laden Sie einen Finanzierungsnachweis hoch (z.B. Bankbestaetigung). Sie koennen diesen auch spaeter nachreichen."
    },
    "loi": {
      "bindingNotice": "Con la sua firma conferma il suo interesse vincolante all'acquisto al prezzo fisso indicato. Questo non è ancora un contratto di vendita.",
      "description": "Firmi la lettera d'intenti (LOI) per confermare il suo interesse vincolante all'acquisto.",
      "nonBindingNotice": "Con la sua firma, conferma il suo interesse all'acquisto al prezzo indicato. Questo non è ancora un contratto di vendita e non è vincolante.",
      "signatoryHint": "Firmi qui",
      "signatureLabel": "La sua firma",
      "title": "Firma della lettera d'intenti"
    },
    "status": {
      "awarded": "Aggiudicato",
      "cancelled": "Annullato",
      "completed": "Completato",
      "expired": "Scaduto",
      "outbid": "Superato",
      "proofPending": "Prova in attesa",
      "rejected": "Rifiutato",
      "reserved": "Prenotato",
      "submitted": "Inviata",
      "withdrawn": "Ritirato"
    },
    "statusCard": {
      "expired": "Prenotazione scaduta",
      "expiresIn": "Scade tra {{time}}",
      "submittedAt": "Inviata il {{date}}",
      "title": "La sua offerta"
    },
    "submitButton": "Invia offerta",
    "success": {
      "message": "La sua offerta è stata inviata con successo. Riceverà una conferma via e-mail.",
      "proofReminder": "Carichi la prova di finanziamento entro la scadenza.",
      "reservationInfo": "La sua prenotazione è valida fino al {{date}}. Invii la prova di finanziamento in tempo.",
      "title": "Offerta inviata con successo"
    }
  },
  "organizations": {
    "accentColor": "Colore di accento",
    "addAddress": "Aggiungi indirizzo",
    "addContactToOrg": "Aggiungi contatto",
    "addEmail": "Aggiungi indirizzo e-mail",
    "addInfoOwner": "+ Aggiungi responsabile info",
    "addOrganization": "Aggiungi organizzazione",
    "addPhone": "Aggiungi numero di telefono",
    "addressAdded": "Indirizzo aggiunto",
    "addressDeleted": "Indirizzo eliminato",
    "addressUpdated": "Indirizzo aggiornato",
    "addresses": "Indirizzi",
    "allTypes": "Tutti i tipi",
    "bindingClauseEnabled": "Clausola di vincolatività attivata",
    "cancelResearch": "Annulla",
    "cannotDelete": "Eliminazione non possibile",
    "cannotDeleteSigned": "Impossibile eliminare: firme contrattuali esistenti",
    "canton": "Cantone",
    "city": "Città",
    "companyTab": "Azienda",
    "confirmDelete": "Sei sicuro di voler eliminare questa organizzazione? Tutte le associazioni verranno rimosse.",
    "contactCreateFailed": "Impossibile creare il contatto",
    "contacts": "Contatti",
    "contactsTab": "Contatti",
    "createSuccess": "Organizzazione creata con successo",
    "createUser": "Crea utente",
    "dataQuality": {
      "title": "Qualità dei dati",
      "scoreOutOf": "{{score}} su 100 punti",
      "openTitle": "Punti aperti ({{count}})",
      "fulfilledSummary": "{{count}} completati",
      "passedOfTotal": "{{passed}} su {{total}} completati",
      "filterIncomplete": "incompleto (< {{min}})",
      "assignedToMe": "Organizzazione assegnata a te",
      "duplicateRow": "Duplicato: {{name}} ({{reason}})",
      "status": {
        "ok": "Completo",
        "warn": "Da verificare",
        "missing": "Mancante",
        "alert": "Conflitto"
      },
      "actions": {
        "upload_logo": "Carica logo",
        "apply_research": "Applica proposta",
        "run_research": "Avvia ricerca",
        "sync_zefix": "Aggiorna da Zefix",
        "merge_contacts": "Unisci contatti",
        "merge_companies": "Unisci organizzazioni",
        "assign_owner": "Assegna a me",
        "choose_owner": "Scegli",
        "add_email": "Aggiungi e-mail",
        "add_address": "Aggiungi indirizzo",
        "edit_search_profile": "Inserisci profilo di ricerca"
      },
      "checks": {
        "logo": "Logo",
        "generic_email": "E-mail aziendale",
        "address": "Indirizzo",
        "phone": "Telefono",
        "zefix_age": "Registro di commercio",
        "research": "Ricerca investitore",
        "research_pending": "Proposta di ricerca",
        "contact_duplicates": "Duplicati contatti",
        "company_duplicates": "Duplicato",
        "owner": "Responsabilità",
        "search_profile": "Profilo di ricerca",
        "holdings": "Portafoglio proprio"
      }
    },
    "dedupBannerTitle": "Possibili duplicati rilevati:",
    "dedupReasonName": "nome simile",
    "dedupReasonUid": "stesso IDE",
    "dedupWarning": "Duplicato?",
    "deleteOrganization": "Elimina organizzazione",
    "deleteSuccess": "Organizzazione eliminata con successo",
    "description": "Descrizione",
    "discardResearch": "Elimina",
    "discardResearchConfirm": "I risultati della ricerca verranno rimossi dalla vista. Saranno ricaricati al prossimo aggiornamento.",
    "discardResearchTitle": "Eliminare la ricerca?",
    "duplicateUid": "Un'organizzazione con questo IDE esiste già",
    "editOrganization": "Modifica organizzazione",
    "editRole": "Modifica ruolo",
    "email": "E-mail",
    "emailAdded": "Indirizzo e-mail aggiunto",
    "emailAddresses": "Indirizzi e-mail",
    "emailDeleted": "Indirizzo e-mail eliminato",
    "emailSignatureTemplate": "Modello di firma e-mail (HTML)",
    "emailUpdated": "Indirizzo e-mail aggiornato",
    "filterContacts": "Filtra i contatti...",
    "hasBlockers": "non può essere eliminata perché esistono ancora dipendenze:",
    "hasProfile": "Profilo aziendale disponibile",
    "hideContacts": "Nascondi contatti",
    "houseNumber": "Numero civico",
    "infoOwner": "Responsabile info (più possibili)",
    "infoOwnerRole": "Info",
    "isTenant": "Mandante (interno)",
    "keyPersonsFromResearch": "Persone chiave (dalla ricerca)",
    "legalForm": "Forma giuridica",
    "logoAlt": "Logo di {{name}}",
    "logoDragOrClick": "Trascina il logo qui o clicca",
    "logoFormatError": "Sono ammessi solo PNG, JPG o WebP",
    "logoSizeError": "File troppo grande (max. 5 MB)",
    "logoUploadFailed": "Caricamento del logo non riuscito",
    "logoUploaded": "Logo caricato",
    "logoUploading": "Caricamento...",
    "logoUrlPlaceholder": "Oppure inserisci direttamente un URL: https://...",
    "mergeFailed": "Unione non riuscita",
    "mergeLinkMissing": "Collegamento a questa organizzazione non trovato",
    "mergeSuccess": "Organizzazioni unite con successo",
    "name": "Nome",
    "noContactsForOrg": "Nessun contatto assegnato",
    "noFilterResults": "Nessun contatto trovato",
    "noOrganizations": "Nessuna organizzazione trovata",
    "noOwner": "-- Nessuno assegnato --",
    "noUidDescription": "Questa organizzazione non ha un UID. Puoi collegarla a una voce Zefix.",
    "notesAutoSaveHint": "Le modifiche vengono salvate automaticamente.",
    "notesPlaceholder": "Note sull'organizzazione...",
    "openZefix": "Apri in Zefix",
    "owner": "Responsabile",
    "ownerRole": "Responsabile",
    "phone": "Telefono",
    "phoneAdded": "Numero di telefono aggiunto",
    "phoneDeleted": "Numero di telefono eliminato",
    "phoneNumbers": "Numeri di telefono",
    "phoneUpdated": "Numero di telefono aggiornato",
    "pin": "Fissa",
    "pinToggled": "Stato fissaggio modificato",
    "pinned": "Fissato",
    "possibleDuplicate": "Possibile duplicato",
    "possibleMatches": "Possibili corrispondenze:",
    "primaryAddress": "Indirizzo principale",
    "primaryColor": "Colore primario",
    "primaryContact": "Persona di contatto",
    "primaryEmail": "E-mail principale",
    "primaryPhone": "Numero principale",
    "profile": "Profilo",
    "removeBlockersHint": "Rimuovere o riassegnare le dipendenze elencate sopra prima di eliminare questa organizzazione.",
    "removeInfoOwner": "Rimuovi responsabile info",
    "removeInvestorGroup": "Rimuovi gruppo di investitori",
    "removePrimaryContact": "Rimuovi referente",
    "researchCancelled": "Ricerca annullata",
    "researchDiscarded": "Risultati della ricerca eliminati",
    "resultsLabel": "Organizzazioni",
    "revenue": "Fatturato",
    "sameUid": "stesso UID",
    "searchNameOrUid": "Cerca nome o UID...",
    "searchPlaceholder": "Cerca per nome, UID o città...",
    "selectMergeTarget": "Seleziona un'organizzazione da unire",
    "setPrimaryContact": "Imposta come referente",
    "showContacts": "Mostra contatti",
    "signatureAuth": "Diritto di firma",
    "similarName": "nome simile",
    "sourceManual": "Manuale",
    "street": "Via",
    "subtitle": "Tutte le aziende registrate nel registro di commercio",
    "syncAdded": "{{count}} aggiunto/i",
    "syncDeactivated": "{{count}} disattivato/i",
    "syncNoPersons": "Nessun firmatario autorizzato trovato nel registro di commercio",
    "syncNotFound": "Azienda non trovata nel registro di commercio — UID inesistente su Zefix",
    "syncReactivated": "{{count}} riattivato/i",
    "syncSkippedPinned": "{{count}} fissato/i (ignorati)",
    "syncSuccess": "Contatti aggiornati da Zefix",
    "syncUnchanged": "{{count}} invariato/i",
    "syncUpdated": "{{count}} aggiornato/i",
    "syncingContacts": "Caricamento contatti da Zefix...",
    "tabAddressContact": "Indirizzo e contatto",
    "tabCommercialRegister": "Registro di commercio",
    "tabMasterData": "Dati di base",
    "tabNotes": "Note",
    "tabResearch": "Ricerca",
    "tabResponsibility": "Responsabilità",
    "tabSignature": "Firma",
    "title": "Organizzazioni",
    "type": "Tipo",
    "typeNameOrUid": "Digita un nome o un UID...",
    "types": {
      "broker": "Intermediario",
      "buyer": "Acquirente",
      "other": "Altro",
      "partner": "Partner",
      "seller": "Venditore"
    },
    "uid": "UID",
    "unpin": "Rimuovi fissaggio",
    "updateSuccess": "Organizzazione aggiornata con successo",
    "viaZefixCreate": "Crea tramite Zefix",
    "website": "Sito web",
    "zefixAssign": "Assegna Zefix",
    "zefixAssigned": "Zefix assegnato",
    "zefixAssignFailed": "Associazione Zefix non riuscita",
    "zefixAutoMerged": "{{count}} contatti aggiornati automaticamente (funzione/firma)",
    "zefixContactCreated": "{{name}} creato",
    "zefixContactMerged": "{{name}} unito",
    "zefixCreated": "Organizzazione creata tramite Zefix",
    "zefixRefresh": "Aggiorna da Zefix",
    "zefixReviewDescription": "I seguenti contatti del registro di commercio non sono stati assegnati in modo univoco. Verifica l'assegnazione manualmente.",
    "zefixReviewTitle": "Verifica i contatti Zefix",
    "zefixSearchPlaceholder": "Cerca azienda nel registro di commercio...",
    "zefixSync": "Aggiorna da Zefix",
    "zefixSyncFailed": "Sincronizzazione Zefix non riuscita",
    "zefixSynced": "Dati Zefix aggiornati",
    "zipCode": "CAP",
    "capital": "Capitale",
    "quickProfile": "Profilo breve",
    "industry": "Settore",
    "employees": "Dipendenti",
    "parentCompany": "Società madre",
    "revenueEstimate": "Fatturato",
    "keyPersons": "Persone chiave",
    "contactImportFailed": "Importazione non riuscita",
    "contactAcknowledged": "Contatto confermato",
    "acknowledgeFailed": "Conferma non riuscita",
    "extractedContacts": "Contatti trovati",
    "alreadyExists": "Già presente",
    "acknowledge": "Conferma",
    "imported": "Importato",
    "importContact": "Importa",
    "researchComplete": "Ricerca completata",
    "researchFailed": "Ricerca non riuscita",
    "researchStarting": "Avvio della ricerca...",
    "discardFailed": "Operazione non riuscita",
    "purpose": "Scopo",
    "research": "Ricerca IA",
    "discard": "Scarta",
    "researching": "Ricerca in corso...",
    "updateResearch": "Aggiorna",
    "startResearch": "Avvia ricerca",
    "discardConfirmTitle": "Scartare i risultati della ricerca?",
    "discardConfirmText": "Tutti i dati di ricerca salvati (profilo, persone chiave, settore ecc.) verranno eliminati definitivamente.",
    "confirmDiscard": "Sì, scarta",
    "researchBackground": "Viene eseguita in background — puoi lasciare la pagina.",
    "noResearch": "Nessuna ricerca disponibile",
    "editSection": "Modifica {{section}}",
    "editMore": "Modifica altri dati",
    "addressLabel": "Etichetta",
    "phoneLabel": "Etichetta",
    "emailLabel": "Etichetta",
    "removeAddress": "Rimuovi l'indirizzo",
    "removePhone": "Rimuovi il numero di telefono",
    "removeEmail": "Rimuovi l'indirizzo e-mail",
    "contactData": {
      "title": "Dati di contatto dell’organizzazione",
      "webLinks": "Web",
      "badgePrimary": "Principale",
      "badgeCentral": "Centralino",
      "badgeRank": "Rango {{rank}}",
      "genericHint": "Gli indirizzi generici (investments@, info@) appartengono all’organizzazione, quelli personali al rispettivo contatto.",
      "updated": "Dati di contatto aggiornati"
    },
    "contactImported": "Contatto importato: {{name}}",
    "dedupInfo": "{{count}} delle persone trovate sono già registrate come contatti di questa organizzazione.",
    "revenuePlaceholder": "1-5 mio CHF",
    "keyFigures": {
      "title": "Cifre chiave",
      "empty": "—",
      "add": "Completa",
      "rows": {
        "capital": "Capitale",
        "founded": "Fondazione",
        "employees": "Collaboratori",
        "revenue": "Fatturato",
        "dealSize": "Dimensione della transazione",
        "relevance": "Punteggio di rilevanza"
      },
      "relevanceValue": "{{score}} su 100",
      "dealSizeFrom": "da {{min}}",
      "dealSizeUpTo": "fino a {{max}}",
      "sources": {
        "zefix": {
          "badge": "Z",
          "label": "Fonte: registro di commercio (Zefix)"
        },
        "research": {
          "badge": "IA",
          "label": "Fonte: ricerca IA"
        },
        "searchProfile": {
          "badge": "PR",
          "label": "Fonte: profilo di ricerca"
        }
      },
      "pendingHint": "AUM, portafoglio e transazioni seguiranno con Investor Research."
    },
    "searchProfile": {
      "title": "Profilo di ricerca",
      "empty": "—",
      "add": "Completa",
      "today": "oggi",
      "hardMin": "sotto il minimo escluso",
      "dealSizeRange": "{{min}} – {{max}} mio CHF",
      "dealSizeFrom": "da {{min}} mio CHF",
      "dealSizeUpTo": "fino a {{max}} mio CHF",
      "yieldGross": "lordo da {{value}}%",
      "columns": {
        "criterion": "Criterio",
        "sought": "Ricercato",
        "excluded": "Escluso",
        "source": "Fonte",
        "action": "Azione"
      },
      "rows": {
        "usage": "Destinazione",
        "region": "Regione / cantoni",
        "dealSize": "Dimensione dell'operazione",
        "yield": "Rendimento",
        "investmentForm": "Forma d'investimento",
        "conditionYear": "Stato / anno di costruzione",
        "ownershipForm": "Forma di proprietà",
        "minSize": "Dimensione minima",
        "noGos": "Criteri escludenti"
      },
      "sources": {
        "pitchdeck": {
          "badge": "PD",
          "label": "Fonte: ripresa dal pitch deck"
        },
        "ai": {
          "badge": "IA",
          "label": "Fonte: ricerca IA"
        },
        "manual": {
          "badge": "✎",
          "label": "Fonte: inserimento manuale"
        },
        "archive": {
          "badge": "Archivio",
          "label": "Fonte: ripresa di dati d'archivio"
        },
        "contract": {
          "badge": "MR",
          "label": "Fonte: mandato di ricerca"
        }
      }
    },
    "registerChecks": {
      "title": "Registri e verifiche",
      "empty": "—",
      "asOf": "Stato al {{date}}",
      "checkedAt": "verificato il {{date}}",
      "checks": {
        "zefix": "Registro di commercio",
        "seco": "Lista di sanzioni della SECO",
        "finma": "FINMA",
        "oak_bv": "CAV PP",
        "six": "SIX Swiss Exchange",
        "sro": "OAD (LRD)",
        "ubo": "Aventi economicamente diritto",
        "kyc": "Identificazione (LRD)",
        "memberships": "Associazioni / affiliazioni"
      },
      "status": {
        "ok": "Verificato e confermato",
        "unknown": "Non elencato / sconosciuto",
        "warn": "Aperto o più vecchio di 180 giorni",
        "alert": "Riscontro che richiede un intervento"
      },
      "actions": {
        "zefix_sync": "Aggiorna da Zefix",
        "zefix_search": "Associa a Zefix"
      }
    },
    "researchPortrait": {
      "portfolioTitle": "Portafoglio",
      "transactionsTitle": "Transazioni",
      "portfolioObjects_one": "{{count}} oggetto",
      "portfolioObjects_other": "{{count}} oggetti",
      "portfolioFocus": "Focus",
      "amountMillions": "{{value}} mln CHF",
      "amountBillions": "{{value}} mld CHF",
      "source": "Fonte",
      "empty": "Nessun dato utilizzabile"
    },
    "researchApply": {
      "openCta": "Verifica e applica la ricerca ({{count}})",
      "title": "Applicare il risultato della ricerca",
      "fieldsTitle": "Campi",
      "personsTitle": "Persone",
      "colMark": "Contrassegnato",
      "colField": "Campo",
      "colCurrent": "Attuale",
      "colProposal": "Proposta",
      "colConfidence": "Affidabilità",
      "colAction": "Azione",
      "markRow": "Contrassegna {{field}}",
      "actionFor": "Azione per {{field}}",
      "actions": {
        "keep": "mantenere",
        "accept": "applicare",
        "both": "entrambi"
      },
      "personActions": {
        "link": "collegare",
        "create": "creare nuovo",
        "link_auditor": "collegare come ufficio di revisione",
        "discard": "scartare"
      },
      "personMatch": "Corrispondenza: {{name}}",
      "empty": "—",
      "lowConfidence": "Dato incerto — da verificare prima di applicarlo",
      "applyAll": "Applica tutto",
      "applyMarked": "Solo contrassegnati",
      "applied": "Applicati {{fields}} campi e {{persons}} persone",
      "failed": "Applicazione non riuscita",
      "nothingMarked": "Nessuna riga contrassegnata",
      "noProposals": "Nessuna proposta in sospeso",
      "pendingTitle": "{{count}} proposte della ricerca in sospeso",
      "pendingHint": "Si decide nella finestra «Applicare il risultato della ricerca» — il pulsante si trova in alto in questa pagina.",
      "personsHint": "Collega, crea o scarta le persone nella finestra «Applicare il risultato della ricerca» in alto in questa pagina.",
      "nothingToApply": "Tutte le righe sono su «mantenere» — nulla da applicare."
    },
    "sourceBadge": {
      "ai": {
        "badge": "IA",
        "label": "Fonte: ricerca IA"
      },
      "zefix": {
        "badge": "Z",
        "label": "Fonte: registro di commercio (Zefix)"
      },
      "manual": {
        "badge": "✎",
        "label": "Fonte: inserimento manuale"
      },
      "public_data": {
        "badge": "PD",
        "label": "Fonte: dati pubblici"
      },
      "import": {
        "badge": "IMP",
        "label": "Fonte: importazione dati"
      },
      "research": {
        "badge": "IA",
        "label": "Fonte: ricerca IA"
      },
      "amtsblatt": {
        "badge": "FUSC",
        "label": "Fonte: foglio ufficiale svizzero di commercio (FUSC)"
      },
      "dateLabel": "Stato al {{date}}"
    },
    "hero": {
      "aiBadge": "IA",
      "aiSourceHint": "Ripreso dalla ricerca IA",
      "applyResearch": "Verifica e applica la ricerca",
      "applyResearchCount": "Verifica e applica la ricerca ({{count}})",
      "cantons": "Cantoni",
      "dataQuality": "Qualità dei dati {{value}}",
      "dataQualityComplete": "Dati completi",
      "dataQualityHint": "Vai ai punti aperti",
      "dataQualityOpen": "Dati: {{open}} da completare",
      "dealFrom": "Deal da CHF {{min}} mio",
      "dealRange": "Deal CHF {{min}}–{{max}} mio",
      "dealTo": "Deal fino a CHF {{max}} mio",
      "holdings": "Portafoglio: {{objects}} · CHF {{value}}",
      "holdingsObjects": "Portafoglio: {{objects}}",
      "holdingsHint": "Vai alla scheda Immobili",
      "more": "+{{n}}",
      "owner": "Responsabile: {{name}}",
      "ownerMissing": "Responsabile: —",
      "relevance": "Rilevanza {{score}}",
      "relevanceMissing": "Rilevanza — nessun profilo",
      "usages": "Utilizzi"
    },
    "holdings": {
      "title": "Portafoglio proprio",
      "objects": "{{count}} immobili",
      "objectsOne": "1 immobile",
      "objectFallback": "Immobile #{{id}}",
      "value": "CHF {{value}}",
      "valueMillions": "{{value}} mln",
      "valueBillions": "{{value}} mld",
      "asOf": "Stato al {{date}}",
      "groupBy": "Vista",
      "byFund": "Per veicolo/cluster",
      "byUsage": "Uso",
      "byCanton": "Cantone",
      "unassignedFund": "Senza veicolo",
      "fundFilter": "Solo veicolo «{{name}}»",
      "fundFilterClear": "Rimuovi filtro",
      "focusReason": "Candidati: {{reason}} ({{count}})",
      "focusReasonAny": "Candidati ({{count}})",
      "focusUsage": "Uso: {{usage}} ({{count}})",
      "focusCanton": "Cantone: {{canton}} ({{count}})",
      "focusClear": "Rimuovi filtro",
      "candidate": "Candidato alla transazione",
      "area": "{{value}} m²",
      "units": "{{count}} unità",
      "unitsOne": "1 unità",
      "since": "dal {{year}}",
      "transactions": "Transazioni",
      "columnDate": "Data",
      "columnObject": "Immobile",
      "columnPrice": "Prezzo",
      "columns": {
        "object": "Immobile",
        "place": "Località/indirizzo",
        "usage": "Uso",
        "size": "Unità/superficie",
        "value": "Valore",
        "acquired": "Acquisizione",
        "fund": "Veicolo",
        "flag": "Candidato",
        "source": "Fonte",
        "select": "Selezione"
      },
      "source": "Fonte",
      "sourceRef": "Fonte: {{ref}}",
      "empty": "Nessun portafoglio noto",
      "fundKpis": {
        "value": "Valore di mercato",
        "objects": "Immobili",
        "objectsSource": "{{count}} secondo la fonte",
        "objectsRecorded": "{{count}} registrati",
        "vacancy": "Sfitto",
        "yield": "Rendimento",
        "status": "Stato",
        "asOf": "Stato al",
        "empty": "{{name}} · nessun immobile registrato"
      },
      "transactionKinds": {
        "buy": "Acquisto",
        "sell": "Vendita",
        "stake": "Partecipazione"
      },
      "edit": {
        "start": "Modifica portafoglio proprio",
        "saved": "Portafoglio proprio aggiornato",
        "addFund": "Veicolo",
        "addCluster": "Gruppo",
        "addObject": "Registra oggetto",
        "fundName": "Nome del veicolo",
        "clusterName": "Nome del gruppo",
        "clusterKind": "Tipo di raggruppamento",
        "clusterKinds": {
          "region": "Regione",
          "usage": "Destinazione",
          "strategy": "Strategia",
          "size": "Dimensione",
          "custom": "Personalizzato"
        },
        "renameFund": "Rinomina veicolo",
        "renameCluster": "Rinomina gruppo",
        "deleteFund": "Elimina veicolo",
        "deleteCluster": "Elimina gruppo",
        "deleteFundTitle": "Eliminare il veicolo?",
        "deleteClusterTitle": "Eliminare il gruppo?",
        "deleteGroupHint": "«{{name}}» viene eliminato. Gli oggetti rimangono, ma perdono l'assegnazione.",
        "deleteObject": "Elimina oggetto",
        "deleteObjectTitle": "Eliminare l'oggetto?",
        "deleteObjectHint": "«{{name}}» viene rimosso dal portafoglio.",
        "editObject": "Modifica oggetto",
        "selectObject": "Seleziona {{name}}",
        "selectedCount": "{{count}} selezionati",
        "clearSelection": "Annulla selezione",
        "moveTo": "Sposta in",
        "moveToFund": "Sposta nel veicolo",
        "moveToCluster": "Sposta nel gruppo",
        "objectTitleNew": "Registra oggetto",
        "objectTitleEdit": "Modifica oggetto",
        "objectCreated": "Oggetto registrato",
        "objectUpdated": "Oggetto salvato",
        "sourceManual": "Fonte: inserimento manuale",
        "usage": "Destinazione",
        "usageDetail": "Destinazione, dettaglio",
        "usageOther": "Altra destinazione",
        "usageNone": "Nessuna indicazione",
        "area": "Superficie (m²)",
        "units": "Unità",
        "buildYear": "Anno di costruzione",
        "acquiredYear": "Anno di acquisizione",
        "value": "Valore (CHF)",
        "fund": "Veicolo",
        "cluster": "Gruppo",
        "noCluster": "Senza gruppo",
        "notes": "Nota",
        "cantonInvalid": "Cantone come sigla di 2 lettere, p. es. ZH",
        "yearInvalid": "Anno con 4 cifre, p. es. 1998",
        "numberInvalid": "Inserire un numero"
      }
    },
    "portfolioReview": {
      "title": "Pulizia del portafoglio",
      "headerCount": "{{candidates}} di {{objects}} oggetti",
      "reasonCount": "{{label}} {{count}}",
      "reasons": {
        "non_core": "Non-core",
        "small": "di piccole dimensioni",
        "old": "vecchio",
        "manual": "manuale"
      },
      "reasonHints": {
        "non_core": "non corrisponde al profilo di ricerca (utilizzo o cantone)",
        "small": "valore inferiore al 10 % dell’oggetto medio con lo stesso utilizzo",
        "old": "anno di costruzione oltre 25 anni più vecchio del portafoglio",
        "manual": "contrassegnato a mano"
      },
      "noProfileHint": "Nessun profilo di ricerca — valutati solo dimensione ed età",
      "shareOfObjects": "{{label}}: {{count}} di {{objects}} oggetti",
      "openProperties": "Vedi {{candidates}} candidati nella scheda Immobili",
      "empty": "Nessun candidato trovato",
      "pdf": "PDF",
      "pdfAria": "Scarica la razionalizzazione del portafoglio in PDF",
      "pdfFailed": "Impossibile caricare il PDF",
      "flagSet": "Contrassegna come candidato alla vendita",
      "flagRemove": "Rimuovi contrassegno",
      "flagSaved": "Contrassegno salvato",
      "noteTitle": "Contrassegna come candidato alla vendita",
      "noteHint": "«{{name}}» sarà contrassegnato come candidato alla vendita.",
      "noteLabel": "Nota (facoltativa)",
      "notePlaceholder": "Perché questo oggetto può essere ceduto?",
      "taskCreated": "Pendenza creata",
      "taskCreatedFor": "Pendenza creata per {{name}}"
    },
    "fundMonitor": {
      "title": "Veicoli d'investimento",
      "kpiAum": "AUM totale",
      "kpiProperties": "Immobili",
      "kpiLtv": "LTV medio / limite",
      "kpiVacancy": "Sfitto medio",
      "kpiSell": "Segnali di vendita",
      "kpiBuy": "Segnali d'acquisto",
      "colAum": "Patrimonio",
      "colProperties": "Oggetti",
      "colLtv": "LTV / limite",
      "colVacancy": "Sfitto",
      "colTerm": "Durata",
      "expand": "Espandi «{{name}}»",
      "collapse": "Comprimi «{{name}}»",
      "sellSignal": "Segnale di vendita",
      "buySignal": "Segnale d'acquisto",
      "moreSignals": "+{{count}} altri",
      "structureOpenEnd": "struttura aperta",
      "structureClosedEnd": "struttura chiusa",
      "termEnd": "fino al {{date}}",
      "inception": "dal {{year}}",
      "subscription": "Sottoscrizione",
      "subscriptionOpen": "aperta",
      "subscriptionClosed": "chiusa",
      "redemption": "Rimborso",
      "redemptionAnnounced": "annunciato {{value}}",
      "capitalIncrease": "Aumento di capitale",
      "performance": "Rendimento",
      "perfYtd": "Da inizio anno",
      "perf1y": "1 anno",
      "perf3y": "3 anni",
      "perf5y": "5 anni",
      "valuation": "Valutazione",
      "nav": "Valore netto",
      "gav": "Valore lordo",
      "propertyValue": "Valore immobili",
      "agio": "Aggio",
      "fiscalYearEnd": "Esercizio",
      "source": "Fonte",
      "sourceLink": "Rapporto",
      "openObjects": "Oggetti",
      "openObjectsAria": "Oggetti di «{{name}}» nella scheda Immobili",
      "noObjectList": "Elenco oggetti mancante – fonte: rapporto"
    },
    "qualification": {
      "action": "Qualifica",
      "blockedHint": "Settore e persona di contatto sono obbligatori",
      "chipHint": "Importata dall'imbuto indirizzi — non ancora qualificata",
      "contactExisting": "Scegli una persona esistente",
      "contactNew": "Registra una nuova persona",
      "dialogTitle": "Qualifica organizzazione",
      "failed": "Qualifica non riuscita",
      "filterAll": "Qualifica: tutte",
      "filterLabel": "Qualifica",
      "finish": "Concludi",
      "industryHint": "È necessario almeno un settore.",
      "nameMismatch": "Nel registro di commercio il nome è «{{register}}», registrato è «{{stored}}». Sincronizzare prima.",
      "noUid": "Assegnare prima un IDI",
      "noUidHint": "Senza IDI il registro di commercio non può essere confrontato. Collegare l'organizzazione a una voce Zefix.",
      "position": "Ruolo",
      "qualified": "Qualificata",
      "stepContact": "Registra persona di contatto",
      "stepIndustry": "Scegli il settore",
      "stepRegister": "Confermare il registro di commercio",
      "success": "Organizzazione qualificata",
      "unqualified": "Non qualificata"
    },
    "glossary": {
      "objects": {
        "title": "Oggetti",
        "what": "Immobili registrati di questa società (portafoglio proprio), in tutti i veicoli.",
        "how": "Conteggio degli oggetti nella scheda Immobili."
      },
      "units": {
        "title": "Unità",
        "what": "Appartamenti e unità commerciali di tutti gli oggetti registrati.",
        "how": "Somma delle unità; «—» se nessuna è registrata."
      },
      "value": {
        "title": "Valore",
        "what": "Somma dei valori di mercato degli oggetti registrati — non il patrimonio gestito (AUM).",
        "how": "Somma il valore stimato per oggetto."
      },
      "candidates": {
        "title": "Candidati",
        "what": "Oggetti che potrebbero essere venduti in una pulizia del portafoglio.",
        "how": "Non-core, piccolo e vecchio sono calcolati; ⚑ manuale viene salvato."
      },
      "funds": {
        "title": "Veicoli",
        "what": "Fondi, gruppi d'investimento e fondazioni d'investimento di questa società.",
        "how": "Tutti i veicoli registrati, anche senza oggetti assegnati."
      },
      "non_core": {
        "title": "Non-core",
        "what": "Non corrisponde alla strategia della società.",
        "how": "Uso o cantone fuori dal profilo di ricerca, oppure oggetto nel cluster «Non-core». Senza profilo il motivo decade."
      },
      "small": {
        "title": "piccolo",
        "what": "Troppo piccolo per il portafoglio.",
        "how": "Valore inferiore al 10 % dell'oggetto medio dello stesso uso."
      },
      "old": {
        "title": "vecchio",
        "what": "Molto più vecchio del resto del portafoglio.",
        "how": "Anno di costruzione oltre 25 anni più vecchio del portafoglio, nessun risanamento nelle note."
      },
      "manual": {
        "title": "manuale",
        "what": "Contrassegnato a mano come candidato (⚑).",
        "how": "Contrassegno nella scheda Immobili, con nota."
      },
      "sourceReport": "Rapporto/ritratto",
      "aum_chf": {
        "title": "AUM",
        "what": "Patrimonio gestito dal veicolo.",
        "how": "Secondo la fonte: immobili, liquidità e altri attivi."
      },
      "properties_count": {
        "title": "Oggetti",
        "what": "Immobili di questo veicolo, secondo la fonte.",
        "how": "Cifra dal rapporto o dal ritratto; se manca, la riga conta gli oggetti registrati da noi."
      },
      "ltv_pct": {
        "title": "LTV",
        "what": "Quota di ipoteche sul valore immobiliare. Alto = poco margine per acquisti.",
        "how": "Loan-to-value = ipoteche ÷ valore di mercato degli immobili, secondo la fonte."
      },
      "ltv_limit_pct": {
        "title": "Limite",
        "what": "Tetto massimo di indebitamento di questo veicolo.",
        "how": "Secondo regolamento o prospetto. Più il LTV si avvicina, meno acquisti sono possibili."
      },
      "vacancy_pct": {
        "title": "Sfitto",
        "what": "Perdita locativa in percentuale. Basso = portafoglio sano.",
        "how": "Secondo la fonte (definizione della fonte: reddito o superficie)."
      },
      "agio_pct": {
        "title": "Agio / Disagio",
        "what": "Prezzo di borsa rispetto al valore netto d'inventario (NAV), solo per veicoli quotati.",
        "how": "Disagio (negativo) = prezzo sotto il NAV → aumento di capitale poco attraente → compra poco, piuttosto vende."
      },
      "nav": {
        "title": "NAV",
        "what": "Patrimonio del veicolo dopo deduzione dei debiti.",
        "how": "Valore netto d'inventario secondo il rapporto."
      },
      "gav": {
        "title": "GAV",
        "what": "Patrimonio del veicolo prima della deduzione dei debiti.",
        "how": "Valore lordo d'inventario secondo il rapporto."
      },
      "signals_sell": {
        "title": "Segnale di vendita",
        "what": "Dichiarazione della fonte che indica vendite.",
        "how": "Citata dal rapporto o dal comunicato."
      },
      "signals_buy": {
        "title": "Segnale di acquisto",
        "what": "Dichiarazione della fonte che indica acquisti.",
        "how": "Ad es. sottoscrizione aperta, aumento di capitale previsto."
      },
      "subscription": {
        "title": "Sottoscrizione",
        "what": "Se si possono sottoscrivere nuove quote.",
        "how": "aperta = affluisce denaro, acquisti probabili; chiusa = nessun nuovo capitale."
      },
      "redemption": {
        "title": "Riscatto",
        "what": "Termine entro cui gli investitori possono restituire le quote.",
        "how": "Riscatti annunciati in CHF = denaro in uscita → pressione a vendere."
      },
      "structure": {
        "title": "Durata",
        "what": "Se il veicolo è a tempo determinato.",
        "how": "struttura aperta = illimitata; chiusa = durata fino a una data, poi vendita del portafoglio."
      },
      "capital_increase": {
        "title": "Aumento di capitale",
        "what": "Se il veicolo raccoglie nuovo capitale.",
        "how": "Ultimo e prossimo aumento secondo la fonte; previsto = acquisti probabili."
      },
      "sourceLine": "Fonte: {{source}} · al {{date}}"
    },
    "holdingsCard": {
      "title": "Immobili · Portafoglio proprio",
      "kpiObjects": "Oggetti",
      "kpiUnits": "Unità",
      "kpiUnitsKnown": "{{known}} su {{total}} con dato",
      "kpiValue": "Valore",
      "kpiCandidates": "Candidati",
      "kpiFunds": "Veicoli",
      "byUsage": "Per utilizzo",
      "byReason": "Pulizia del portafoglio",
      "byCanton": "Per cantone",
      "segment": "{{usage}}: {{count}} oggetti",
      "noCandidates": "Pulizia del portafoglio: 0 candidati — tutti gli oggetti corrispondono al profilo di ricerca",
      "noValue": "Nessun dato",
      "openProperties": "Scheda Immobili",
      "barLink": "{{label}}: mostra {{count}} oggetti nella scheda Immobili"
    },
    "uidSource": {
      "zefix": "UID: registro di commercio",
      "uid_register": "UID: registro UID",
      "manual": "UID: manuale",
      "fetchedAt": "{{label}} — consultato il {{date}}"
    }
  },
  "pagination": {
    "next": "Successivo",
    "page": "Pagina {{current}} di {{total}}",
    "previous": "Precedente",
    "rowsPerPage": "Righe per pagina",
    "showing": "Visualizzazione {{from}}-{{to}} di {{total}}"
  },
  "preferences": {
    "notifications": {
      "categories": {
        "contract_updates": "Aggiornamenti contratti",
        "favorites_updates": "Aggiornamenti preferiti",
        "new_matches": "Nuove corrispondenze",
        "offer_updates": "Aggiornamenti offerte",
        "platform_news": "Novità della piattaforma"
      },
      "descriptions": {
        "contract_updates": "Cambi di stato sui Suoi contratti, ad es. firma o scadenza.",
        "favorites_updates": "Modifiche agli immobili preferiti.",
        "new_matches": "Nuovi immobili che corrispondono al Suo profilo di ricerca.",
        "offer_updates": "Aggiornamenti importanti sulle Sue offerte.",
        "platform_news": "Novità e nuove funzionalità su Immotron."
      },
      "devices": {
        "empty": "Nessun dispositivo è ancora registrato per le notifiche push. Registri questo dispositivo per ricevere i messaggi push.",
        "namePlaceholder": "Nome del dispositivo (es. iPhone personale)",
        "permissionBlocked": "Ha bloccato le notifiche push per questo sito. Le attivi nelle impostazioni del browser.",
        "permissionDenied": "Autorizzazione negata. Attivi le notifiche nelle impostazioni del browser.",
        "registerAnother": "Registrare un altro dispositivo",
        "registerError": "Impossibile registrare il dispositivo",
        "registerSuccess": "Dispositivo registrato",
        "registerThis": "Registrare questo dispositivo",
        "registeredOn": "Registrato il {{date}}",
        "removeAria": "Rimuovere il dispositivo",
        "removeError": "Impossibile rimuovere il dispositivo",
        "removeSuccess": "Dispositivo rimosso",
        "renameAria": "Rinominare il dispositivo",
        "renameError": "Impossibile salvare il nome",
        "renameSuccess": "Nome aggiornato",
        "serverNotConfigured": "Le notifiche push non sono ancora configurate sul server. Le preferenze vengono salvate e i messaggi saranno recapitati non appena il push sarà disponibile.",
        "subtitle": "Gestisca i dispositivi su cui desidera ricevere notifiche push.",
        "testButton": "Invia test",
        "testError": "Impossibile inviare il test",
        "testNone": "Nessun dispositivo raggiungibile",
        "testSending": "Invio …",
        "testSent": "Push di test inviato a {{count}} dispositivo(i)",
        "title": "Dispositivi per notifiche push",
        "unnamedDevice": "Dispositivo senza nome",
        "unregisterError": "Impossibile disinscrivere il dispositivo",
        "unregisterSuccess": "Questo dispositivo è stato disinscritto",
        "unregisterThis": "Disinscrivere questo dispositivo",
        "unsupported": "Questo browser non supporta le notifiche push."
      },
      "emailColumn": "E-mail",
      "loadFailed": "Impossibile caricare le impostazioni di notifica",
      "locked": "Non disattivabile",
      "pushColumn": "Push",
      "pushRequiresDevice": "Registri prima un dispositivo per attivare le notifiche push.",
      "saveFailed": "Impossibile salvare l'impostazione",
      "subtitle": "Scelga come essere notificato per ogni evento.",
      "title": "Notifiche"
    },
    "privacy": {
      "activityTracking": {
        "description": "Consentici di analizzare il Suo utilizzo della piattaforma in forma anonima per migliorare l'usabilità.",
        "title": "Tracciamento attività"
      },
      "anonymizeActivity": "Anonimizza attività",
      "anonymizeDescription": "Le tue attività saranno mostrate in forma anonima agli altri utenti",
      "anonymous": "Anonimo",
      "anonymousDescription": "Il tuo profilo non è visibile agli altri utenti",
      "dataManagement": "Gestione dati",
      "deleteAccount": {
        "button": "Eliminare il conto",
        "description": "Il Suo conto e tutti i dati associati verranno eliminati in modo irreversibile.",
        "title": "Eliminare il conto"
      },
      "exportData": {
        "button": "Esportare",
        "description": "Scarichi una copia dei Suoi dati personali.",
        "error": "Esportazione dati non riuscita",
        "success": "Esportazione dati scaricata con successo",
        "title": "Esportare i dati"
      },
      "legal": "Informazioni legali",
      "loadFailed": "Impossibile caricare le impostazioni di privacy",
      "marketingEmails": {
        "description": "Riceva occasionalmente novità, consigli e offerte via e-mail.",
        "title": "E-mail di marketing"
      },
      "privacyPolicyLink": "Informativa sulla privacy",
      "profileVisibility": "Visibilità del profilo",
      "profileVisible": {
        "description": "Il Suo profilo è visibile agli altri utenti della piattaforma.",
        "title": "Profilo visibile"
      },
      "public": "Pubblico",
      "publicDescription": "Il tuo profilo è visibile agli altri utenti",
      "saveFailed": "Impossibile salvare l'impostazione",
      "settings": "Impostazioni sulla privacy",
      "termsLink": "Condizioni d'uso",
      "title": "Privacy"
    }
  },
  "profile": {
    "active": "Aktiv",
    "admin": {
      "backToUsers": "Zurück zur Benutzerliste",
      "impersonate": "Als Benutzer einloggen",
      "impersonateDescription": "Öffnet eine Session als dieser Benutzer",
      "loginAs": "Einloggen",
      "resetEmailSent": "Reset-E-Mail gesendet",
      "resetLinkCopied": "Reset-Link in Zwischenablage kopiert",
      "resetPassword": "Passwort zurücksetzen",
      "sendResetLink": "Reset-Link senden"
    },
    "companyAssignments": "Firmenzugehörigkeiten",
    "directPhone": "Direktnummer",
    "functionPlaceholder": "z.B. Geschäftsführer, Sales Manager",
    "functionTitle": "Funktion",
    "languageAuto": "Automatisch (Systemsprache)",
    "preferredLanguage": "Hauptsprache",
    "role": "Ruolo",
    "sections": {
      "compliance": "Compliance",
      "emailAccounts": "E-Mail-Konten",
      "passkeys": "Passkey",
      "password": "Password",
      "profile": "Profilo",
      "security": "Sicurezza"
    },
    "subtitle": "Gestisci le impostazioni personali e la sicurezza",
    "title": "Il mio profilo"
  },
  "properties": {
    "activate": "Attiva",
    "activated": "Immobile attivato.",
    "activeHighlights": "Aktive Highlights",
    "addProperty": "Aggiungi proprietà",
    "addRow": "Aggiungi riga",
    "address": "Indirizzo",
    "agentAnalysis": {
      "alreadyRunning": "Per questo oggetto è già in corso un'analisi.",
      "openPoints": "Punti aperti",
      "report": "Apri il rapporto",
      "start": "Avvia analisi completa",
      "started": "Analisi richiesta — l'agente oggetto è al lavoro.",
      "status": {
        "completed": "Completata",
        "failed": "Interrotta",
        "pending": "In attesa dell'agente",
        "processing": "In corso"
      },
      "title": "Analisi dell'oggetto"
    },
    "aiBanner": {
      "confidence": "Affidabilità",
      "hideHints": "Nascondi indicazioni",
      "hintsCount": "{{count}} indicazioni",
      "showHints": "Mostra indicazioni",
      "title": "Estrazione IA"
    },
    "aiConfidence": "Qualità dati IA",
    "approve": "Approva",
    "approved": "Immobile approvato.",
    "area": "Superficie",
    "availableData": "Verfügbare Daten",
    "backToList": "Torna alla lista",
    "bulk": {
      "affectedCount": "{{count}} immobili interessati",
      "confirmDelete": "Eliminare gli immobili?",
      "confirmStatus": "Cambiare lo stato?",
      "error": "Operazione di massa fallita",
      "newStatus": "Nuovo stato",
      "success": "Operazione di massa riuscita."
    },
    "city": "Città",
    "compactMode": "Compatto",
    "condition": {
      "EXCELLENT": "Eccellente",
      "FAIR": "Discreto",
      "GOOD": "Buono",
      "GUTTED": "Sventrato",
      "NEW": "Nuovo",
      "RENOVATION_NEEDED": "Da ristrutturare"
    },
    "conditions": {
      "EXCELLENT": "Eccellente",
      "FAIR": "Sufficiente",
      "GOOD": "Buono",
      "GUTTED": "Sventrato",
      "NEW": "Nuova costruzione",
      "RENOVATION_NEEDED": "Da ristrutturare"
    },
    "confirmDelete": "Vuole davvero eliminare questo immobile? Questa operazione è irreversibile.",
    "country": "Paese",
    "createSuccess": "Immobile creato con successo",
    "deleteFinal": "Eliminare definitivamente",
    "deleteProperty": "Eliminare immobile",
    "deleteSuccess": "Immobile eliminato con successo",
    "description": "Descrizione",
    "detail": {
      "activate": "Attivare",
      "archive": "Archiviare",
      "changeStatus": "Cambiare stato",
      "gallery": "Galleria immagini",
      "investorAccess": "Accesso investitori",
      "keyFacts": "Dati chiave",
      "noAccess": "Nessun investitore con accesso"
    },
    "diff": {
      "city": "Ort",
      "condition": "Zustand",
      "constructionYear": "Baujahr",
      "empty": "(leer)",
      "grossYield": "Bruttorendite",
      "heating": "Heizung",
      "lotSize": "Grundstücksflaeche",
      "marketValue": "Marktwert",
      "price": "Preis",
      "propertyType": "Immobilientyp",
      "rentalIncome": "Mieteinnahmen",
      "residentialUnits": "Wohneinheiten",
      "status": "Status",
      "street": "Strasse",
      "usableArea": "Nutzfläche",
      "zipCode": "PLZ"
    },
    "documents": "Documenti",
    "draft": {
      "discard": "Elimina",
      "found": "È stata trovata una bozza non salvata",
      "restore": "Ripristina",
      "restored": "Bozza ripristinata"
    },
    "duplicate": "Duplica",
    "duplicateSuccess": "Immobile preparato come copia",
    "editProperty": "Modifica proprietà",
    "errors": {
      "deleteFailed": "Impossibile eliminare l'immobile",
      "imageDeleteFailed": "Impossibile eliminare l'immagine",
      "imageRotateFailed": "Impossibile ruotare l'immagine",
      "imageTooLarge": "L'immagine «{{name}}» è troppo grande (max. 10 MB)",
      "imageUnsupportedType": "Formato immagine di «{{name}}» non supportato",
      "imageUploadFailed": "Impossibile caricare l'immagine",
      "loadFailed": "Impossibile caricare gli immobili",
      "saveFailed": "Impossibile salvare l'immobile",
      "submitFailed": "Fehler beim Einreichen",
      "unrealisticYield": "Unrealistischer Wert — bitte Eingabedaten prüfen",
      "updateFailed": "L'aggiornamento non e riuscito."
    },
    "externalLinks": "Externe Links",
    "favorites": {
      "empty": "Nessun preferito al momento",
      "impersonate": "Accedi come investitore",
      "loginAs": "Accedi",
      "showDetails": "Mostra dettagli",
      "title": "Preferiti degli investitori"
    },
    "fields": {
      "canton": "Cantone",
      "createdBy": "Creato da",
      "favorites": "Preferiti",
      "location": "Posizione",
      "name": "Denominazione",
      "price": "Prezzo min.",
      "status": "Stato",
      "type": "Tipo"
    },
    "filters": {
      "clearAll": "Cancella tutti i filtri",
      "max": "Max",
      "min": "Min",
      "priceRange": "Fascia di prezzo (CHF)",
      "results": "risultati",
      "sortBy": "Ordina per",
      "sortNewest": "Più recenti",
      "sortOldest": "Meno recenti",
      "sortPriceAsc": "Prezzo crescente",
      "sortPriceDesc": "Prezzo decrescente",
      "title": "Filtri"
    },
    "floor": "Piano",
    "form": {
      "addressPlaceholder": "Inserire indirizzo (es. Bahnhofstrasse 1, Zurigo)",
      "annualRentalIncome": "Reddito locativo annuo (CHF)",
      "anzahl_etagen": "Etagen",
      "assignedTo": "Assegnato a",
      "bruttorendite_pct": "Bruttorendite",
      "buildingCount": "Numero di edifici",
      "cadastralNumber": "N. catastale",
      "cadastreNumber": "N. catasto",
      "cadastre_number": "Kataster-Nr.",
      "calcAutoHint": "Calcolato automaticamente",
      "canton": "Cantone",
      "city": "Località",
      "commercialArea": "Superficie commerciale",
      "commercialAreaSqm": "Superficie commerciale (m²)",
      "commercialUnits": "Unità commerciali",
      "commercial_area_sqm": "Superficie commerciale",
      "commissionRate": "Onorario (%)",
      "condition": "Condizione",
      "conditionField": "Condizione",
      "constructionYear": "Anno di costruzione",
      "country": "Paese",
      "description": "Descrizione",
      "desiredPrice": "Prezzo desiderato (CHF)",
      "desiredPricePlaceholder": "es. 1800000",
      "desiredTimeline": "Tempistica desiderata",
      "desiredTimelinePlaceholder": "es. Vendita entro Q3 2026",
      "detailedDescription": "Descrizione",
      "dragToReorder": "Trascinare per riordinare",
      "egridNumber": "N. E-GRID",
      "energieklasse": "Classe energetica",
      "energyClassEnvelope": "Classe energetica (involucro)",
      "energyClassTotal": "Classe energetica (globale)",
      "equityYield": "Rendimento del capitale proprio",
      "floorAreaRatio": "Indice di sfruttamento",
      "floorCount": "Numero di piani",
      "garageParking": "Posti auto in garage",
      "garageParkingCount": "Posti auto in garage",
      "grossYield": "Rendimento lordo",
      "groundLeaseExpiration": "Scadenza diritto di superficie",
      "hasBuildingPermit": "Licenza edilizia disponibile",
      "hasBuildingRight": "Diritto di superficie",
      "hasGroundLease": "Diritto di superficie",
      "hasLift": "Lift vorhanden",
      "has_building_permit": "Baubewilligung",
      "has_ground_lease": "Baurecht",
      "has_lift": "Lift",
      "heatingSystem": "Impianto di riscaldamento",
      "heating_system": "Heizung",
      "highlightOrder": "Ordine",
      "highlights": "Punti di forza dell'investimento",
      "houseNumber": "Numero civico",
      "imageDragDrop": "Trascinare le immagini qui o cliccare per caricare",
      "imageHint": "JPG, PNG, WEBP. Max. 10 MB.",
      "imageUploading": "Caricamento immagine...",
      "investmentHighlights": "Punti salienti investimento",
      "isPrivateListing": "Offerta privata",
      "isPrivateListingHint": "Visibile solo agli investitori selezionati",
      "latitude": "Latitudine",
      "leerstand_pct": "Sfitto",
      "listingExpirationDate": "Data di scadenza",
      "longitude": "Longitudine",
      "lotSizeSqm": "Superficie del terreno (m²)",
      "macroLocation": "Macro posizione",
      "marketValueChf": "Valore di mercato (CHF)",
      "marketValueDate": "Data del valore di mercato",
      "marketValueSource": "Fonte del valore di mercato",
      "marketValueSourcePlaceholder": "IAZI, Wüest Partner",
      "marktwert_chf": "Valore di mercato",
      "max_building_height": "Altezza max. dell'edificio",
      "microLocation": "Micro posizione",
      "minimumPrice": "Prezzo minimo (CHF)",
      "multipleSelectionAllowed": "Selezione multipla possibile",
      "name": "Denominazione",
      "netYield": "Rendimento netto",
      "noDeposit": "Keine Kaution",
      "noImages": "Nessuna immagine caricata",
      "orderLost": "Mandato perso",
      "outdoorParking": "Posti auto esterni",
      "outdoorParkingCount": "Posti auto esterni",
      "ownershipType": "Tipo di proprietà",
      "ownership_type": "Eigentum",
      "parking": "Posti auto",
      "postalCode": "CAP",
      "price": "Prezzo",
      "pricePerSqm": "Prezzo al m²",
      "price_per_sqm": "Preis/m²",
      "primaryImage": "Immagine principale",
      "propertySubtype": "Sottotipo",
      "propertyType": "Tipo di immobile",
      "renovation": "Ristrutturazione",
      "renovationPlaceholder": "es. Ultima ristrutturazione 2018, tetto 2020",
      "residentialArea": "Superficie abitativa",
      "residentialAreaSqm": "Superficie abitabile (m²)",
      "residentialUnits": "Unità residenziali",
      "residential_area_sqm": "Superficie abitativa",
      "rotateImage": "Ruota di 90°",
      "saleEndDate": "Fine vendita",
      "saleStartDate": "Inizio vendita",
      "salesUserId": "Responsabile vendite",
      "salesUserIdPlaceholder": "Nessuna assegnazione",
      "sellerNotes": "Note del venditore",
      "sendExpirationReminder": "Invia promemoria prima della scadenza",
      "setPrimary": "Imposta come immagine principale",
      "status": "Stato",
      "street": "Via",
      "subheader": "Sottotitolo",
      "teaserHighlights": "Punti salienti teaser",
      "teaserHighlightsHint": "Seleziona i punti chiave mostrati sulla pagina teaser dell'investitore. Imposta l'ordine con i numeri.",
      "uploadImages": "Caricare immagini",
      "usableAreaSqm": "Superficie utile (m²)",
      "utilization_factor": "Indice di sfruttamento",
      "vacancyRate": "Sfitto (%)",
      "volume": "Volumen",
      "volumeM3": "Volume (m³)",
      "volume_m3": "Volumen",
      "vrTourUrl": "URL tour virtuale",
      "yearBuilt": "Anno di costruzione"
    },
    "heating": {
      "DISTRICT": "Teleriscaldamento",
      "ELECTRIC": "Riscaldamento elettrico",
      "GAS": "Riscaldamento a gas",
      "HEAT_PUMP": "Pompa di calore",
      "OIL": "Riscaldamento a gasolio",
      "OTHER": "Altro",
      "PELLETS": "Riscaldamento a pellet",
      "SOLAR": "Riscaldamento solare"
    },
    "highlights": {
      "annual_income": "Reddito locativo p.a.",
      "building_count": "Edifici",
      "building_permit": "Permesso di costruzione",
      "commercial_area": "Superficie commerciale",
      "commercial_units": "Unità commerciali",
      "condition": "Condizione",
      "construction_year": "Anno di costruzione",
      "energieklasse": "Classe energetica",
      "etagen": "Piani",
      "gross_yield": "Rendimento lordo",
      "heating_system": "Riscaldamento",
      "location": "Posizione",
      "lot_size": "Superficie del terreno",
      "marktwert": "Valore di mercato",
      "net_yield": "Rendimento netto",
      "ownership": "Tipo di proprietà",
      "parking": "Posti auto",
      "price": "Prezzo richiesto",
      "property_type": "Tipo di immobile",
      "residential_area": "Superficie abitabile",
      "residential_units": "Unità residenziali",
      "usable_area": "Superficie utile",
      "vacancy": "Sfitto",
      "volume": "Volume"
    },
    "highlightsAddHint": "Highlights aus der Liste unten hinzufügen...",
    "images": "Immagini",
    "list": {
      "companyLabel": "Mandante",
      "empty": {
        "description": "Aggiungi la tua prima proprietà per iniziare.",
        "title": "Nessuna proprietà trovata"
      },
      "emptyFiltered": "Nessun oggetto corrisponde ai filtri attivi: {{filters}}",
      "emptyFilteredTitle": "Nessun risultato",
      "resetFilters": "Reimposta filtri",
      "switchCompany": "Cambia mandante"
    },
    "listingPreview": "Anteprima teaser",
    "listingPreviewBanner": "Anteprima — Come gli investitori vedono questo teaser",
    "teaserViewToggle": {
      "ariaLabel": "Scegli la vista dell'anteprima",
      "web": "Vista web",
      "newsletter": "Newsletter e-mail",
      "delivery": "Invio e analisi"
    },
    "teaserDelivery": {
      "title": "Invio e analisi",
      "summary": {
        "sent": "Inviate",
        "delivered": "Consegnate",
        "opened": "Aperte",
        "clicked": "Cliccate"
      },
      "columns": {
        "recipient": "Destinatario",
        "mail": "E-mail",
        "sent": "Inviata",
        "delivered": "Consegnata",
        "opened": "Aperta",
        "clicked": "Cliccata"
      },
      "types": {
        "ACCESS_GRANTED": "E-mail di accesso",
        "BUYER_ONBOARDING_INVITE": "Invito",
        "ONBOARDING_CORRECTION": "Invito di correzione"
      },
      "bounced": "Non recapitabile",
      "empty": "Per questa offerta non è ancora stata inviata alcuna e-mail.",
      "loadError": "Non è stato possibile caricare l'analisi."
    },
    "sendAsCampaign": {
      "button": "Invia come campagna",
      "gateLocked": "Disponibile solo dopo il controllo qualità",
      "title": "Invia il teaser come campagna",
      "intro": "Il teaser diventa una campagna e-mail — con lo stesso contenuto che un investitore vede senza NDA. Potrai poi verificare contenuto e destinatari, inviare un test e procedere all'invio.",
      "gateChecking": "Verifica della barriera NDA …",
      "gateOk": "Barriera NDA superata — {{count}} immagine/i del teaser rilasciata/e",
      "gateBlocked": "La barriera NDA blocca l'invio",
      "gateLoadFailed": "Impossibile caricare l'anteprima del teaser.",
      "locationConfirm": "Rilascia deliberatamente le immagini sensibili alla posizione",
      "includeRecipients": "Aggiungi {{count}} destinatario/i dai gruppi di investitori",
      "includeRecipientsHint": "Membri dei gruppi di investitori assegnati a questo immobile.",
      "noRecipients": "Nessun destinatario dai gruppi di investitori — potrai caricare i destinatari tramite CSV nel passaggio successivo.",
      "create": "Crea campagna",
      "created": "Campagna creata — verifica il contenuto ed esegui un invio di prova.",
      "createFailed": "Impossibile creare la campagna.",
      "recipientsFailed": "Impossibile aggiungere i destinatari — aggiungili nel flusso della campagna."
    },
    "loading": "Caricamento in corso...",
    "map": {
      "noCoordinates": "{{count}} immobili senza coordinate (non visibili sulla mappa)"
    },
    "media": {
      "showArchive": "Mostra anche le immagini eliminate",
      "archiveTitle": "Archivio ({{count}})",
      "archiveEmpty": "Nessuna immagine eliminata.",
      "deletedOn": "Eliminata il {{date}}",
      "restore": "Ripristina",
      "restored": "Immagine ripristinata",
      "restoreError": "Ripristino non riuscito",
      "teaserText": {
        "label": "Testo breve del teaser",
        "placeholder": "p.es. Immobile completamente locato con reddito stabile e riserva di sviluppo ...",
        "hint": "Visibile prima dell'NDA — nessuna località, nessun n. immobile."
      }
    },
    "ownershipTypes": {
      "CORPORATE": "Società",
      "MULTIPLE": "Comproprietà",
      "SINGLE": "Proprietario unico",
      "TRUST": "Trust"
    },
    "price": "Prezzo",
    "propertyDetails": "Dettagli proprietà",
    "quarantine": {
      "badge": "Posizione mancante",
      "banner": {
        "action": "Verificare e completare manualmente i campi dell'indirizzo, quindi salvare.",
        "description": "La posizione non è stata determinata automaticamente. Mancano i dati dell'indirizzo (NPA/CAP, coordinate, EGRID/EGID).",
        "title": "Estrazione IA incompleta"
      }
    },
    "reject": "Rifiuta",
    "rejectReason": "Motivo del rifiuto",
    "rejected": "Immobile rifiutato.",
    "removeRow": "Zeile entfernen",
    "rentRoll": {
      "ancillaryCostsChf": "Spese accessorie CHF",
      "areaSqm": "Superficie m²",
      "floor": "Piano",
      "netRentChf": "Affitto netto CHF",
      "nutzungsart": "Tipo di utilizzo",
      "nutzungsartUnset": "Non impostato",
      "nutzungsartOptions": {
        "wohnung": "Abitazione",
        "gewerbe": "Commerciale",
        "parkplatz": "Posteggio",
        "werbeflaeche": "Spazio pubblicitario",
        "antenne": "Antenna",
        "sonstige": "Altro"
      },
      "rooms": "Locali",
      "status": "Status"
    },
    "rentalYield": "Rendimento locativo",
    "rooms": "Stanze",
    "saveSuccess": "Immobile salvato con successo",
    "search": {
      "placeholder": "Cerca per nome, città, indirizzo..."
    },
    "sections": {
      "address": "Indirizzo",
      "calculations": "Cifre chiave",
      "buildingRight": "Diritto di superficie",
      "classification": "Classificazione",
      "dealState": "Stato & fase della trattativa",
      "dossierDocuments": "Documenti del dossier",
      "images": "Immagini",
      "land": "Terreno",
      "objectDetails": "Dettagli dell'oggetto",
      "ownershipAndCadastre": "Proprietà & catasto",
      "pricingTerms": "Prezzi & Condizioni",
      "salesTimeline": "Vendita e cronologia",
      "sellerDesiredTerms": "Preferenze del venditore",
      "statusLegal": "Stato & Diritto",
      "teaserHighlights": "Punti chiave del teaser"
    },
    "states": {
      "CLOSED": "Chiuso",
      "CLOSING": "Chiusura",
      "DUE_DILIGENCE": "Due Diligence",
      "IDENTIFIED": "Identificato",
      "NEGOTIATION": "In trattativa",
      "UNDER_CONTRACT": "Sotto contratto"
    },
    "status": "Stato",
    "statusChanged": "Lo stato e stato modificato.",
    "statusDescriptions": {
      "ACTIVE": "Attivo: L'immobile è pubblicato e visibile agli investitori. Le offerte possono essere presentate.",
      "ARCHIVED": "Archiviato: L'immobile è stato disattivato e non è più visibile agli investitori.",
      "DRAFT": "Bozza: L'immobile è stato creato ma non ancora pubblicato. È visibile solo al personale interno e può ancora essere modificato.",
      "PENDING": "In sospeso: L'immobile è in attesa di approvazione tramite Quality Gate. Tutti i campi obbligatori e i documenti devono essere completi.",
      "SOLD": "Venduto: L'immobile è stato venduto con successo. Non sono possibili ulteriori offerte."
    },
    "statuses": {
      "ACTIVE": "Attivo",
      "ANALYSIS_DONE": "Analisi completata — da verificare",
      "ANALYSIS_REQUESTED": "Analisi in corso",
      "ARCHIVED": "Archiviato",
      "DRAFT": "Bozza",
      "PENDING": "In sospeso",
      "SOLD": "Venduto",
      "active": "Attivo",
      "archived": "Archiviato",
      "draft": "Bozza",
      "reserved": "Riservato",
      "sold": "Venduto",
      "IN_REVIEW": "In verifica"
    },
    "submitForReview": "Invia per la verifica",
    "submittedForReview": "Inviato per verifica.",
    "subtitle": "Gestisci le tue proprietà",
    "subtypes": {
      "AGRICULTURAL": "Terreno agricolo",
      "APARTMENT": "Appartamento / PPP",
      "AUTO_REPAIR": "Officina auto",
      "CONDOMINIUM": "Condominio",
      "DATA_CENTER": "Data Center",
      "DEVELOPMENT": "Terreno edificabile",
      "FACTORY": "Fabbrica / Stabilimento",
      "FITNESS_CENTER": "Centro fitness / Wellness",
      "GAS_STATION": "Stazione di servizio",
      "HOTEL": "Hotel",
      "LOGISTICS": "Immobile logistico",
      "MEDICAL_PRACTICE": "Studio medico / Centro sanitario",
      "MIXED_COMMERCIAL": "Superficie commerciale mista",
      "MULTI_FAMILY": "Casa plurifamiliare",
      "OFFICE": "Ufficio",
      "PARKING": "Parcheggio",
      "PRODUCTION": "Superficie di produzione",
      "RESTAURANT": "Ristorante / Gastronomia",
      "RETAIL": "Superficie commerciale",
      "SHOWROOM": "Superficie espositiva / Showroom",
      "SINGLE_FAMILY": "Casa unifamiliare",
      "VILLA": "Villa",
      "WAREHOUSE": "Magazzino",
      "WORKSHOP": "Officina / Artigianato"
    },
    "tabs": {
      "basicData": "Dati di base",
      "details": "Caratteristiche",
      "legal": "Aspetti legali",
      "media": "Media & Marketing",
      "pricing": "Prezzo & finanze",
      "translations": "Traduzioni"
    },
    "templates": {
      "deleted": "Modello eliminato",
      "empty": "Nessun modello salvato",
      "loaded": "Modello caricato",
      "namePrompt": "Nome del modello:",
      "saveAs": "Salva come modello...",
      "saved": "Modello salvato",
      "title": "Modelli"
    },
    "regenerateTexts": {
      "button": "Rigenera testi",
      "error": "Generazione testi non riuscita",
      "field": {
        "ariaLabel": "Rigenera {{field}}",
        "button": "Rigenera",
        "description": "Aggiungi facoltativamente una nota — verrà rigenerato solo questo campo (tedesco).",
        "instructionLabel": "Nota / istruzione (facoltativo)",
        "instructionPlaceholder": "es. più breve, più focalizzato sul rendimento",
        "loading": "Generazione...",
        "submit": "Rigenera",
        "success": "Il campo è stato rigenerato",
        "title": "Rigenera {{field}}"
      },
      "hint": "Rigenera sottotitolo, punti salienti, descrizione e macro/micro localizzazione tramite IA (tedesco). I testi esistenti verranno sovrascritti.",
      "loading": "Generazione testi...",
      "success": "I testi sono stati rigenerati"
    },
    "title": "Proprietà",
    "translations": {
      "autoTranslate": "Traduzione auto",
      "autoTranslateFailed": "Traduzione automatica non riuscita",
      "autoTranslateSuccess": "Traduzioni generate automaticamente",
      "autoTranslating": "Creazione delle traduzioni...",
      "compareTo": "Confronta con",
      "contentSection": "Contenuti",
      "hint": "I testi vengono salvati separatamente per ogni lingua. Compilare una lingua e utilizzare la traduzione automatica per le altre.",
      "locationSection": "Descrizione della posizione",
      "namePlaceholder": "es. Edificio per uffici Zurigo City",
      "noSourceContent": "Compilare prima almeno il titolo o la descrizione",
      "notFilled": "Non compilato",
      "outOfSync": "La lingua principale ({{lang}}) è stata modificata. Le traduzioni potrebbero non essere più aggiornate.",
      "sideBySide": "Confronta le lingue fianco a fianco",
      "sideBySideShort": "Confronta",
      "subheaderPlaceholder": "es. Posizione di prima classe nel quartiere degli affari"
    },
    "type": "Tipo",
    "types": {
      "COMMERCIAL": "Commerciale",
      "INDUSTRIAL": "Industriale",
      "LAND": "Terreno",
      "MIXED_USE": "Residenziale / Commerciale",
      "RESIDENTIAL": "Residenziale",
      "apartment": "Appartamento",
      "commercial": "Commerciale",
      "house": "Casa",
      "land": "Terreno",
      "office": "Ufficio",
      "retail": "Negozio"
    },
    "unitMix": {
      "addRange": "Intervallo",
      "area": "Superficie m²",
      "areaFrom": "Superficie m² da",
      "areaTo": "Superficie m² a",
      "removeRange": "Rimuovi intervallo",
      "rentedCount": "Affittati",
      "rooms": "Locali",
      "totalCount": "Totale"
    },
    "validation": {
      "fixErrors": "Compilare tutti i campi obbligatori",
      "required": "Campo obbligatorio"
    },
    "unifiedWizard": {
      "advancedFields": "Dati avanzati",
      "annualRentalIncome": "Reddito locativo annuo (CHF)",
      "anzahlEtagen": "Numero di piani",
      "areas": "Superfici",
      "buildingCount": "Numero di edifici",
      "cadastreNumber": "Numero catastale",
      "commercialAreaSqm": "Superficie commerciale (m²)",
      "commercialUnits": "Unità commerciali",
      "create": "Crea immobile",
      "createFailed": "Creazione fallita",
      "createSuccess": "Immobile creato con successo",
      "detailedDescription": "Descrizione dettagliata",
      "energyEnvelope": "Classe energetica involucro",
      "energyTotal": "Classe energetica complessiva",
      "garageParking": "Posti auto in garage",
      "groundLeaseExpiration": "Scadenza diritto di superficie",
      "hasBuildingPermit": "Permesso di costruzione disponibile",
      "hasGroundLease": "Diritto di superficie",
      "hasLift": "Ascensore disponibile",
      "imageUploadFailed": "{{count}} di {{total}} immagini non sono state caricate",
      "internalFields": "Dati interni",
      "investmentHighlights": "Punti di forza per investitori",
      "offerPrice": "Prezzo di offerta",
      "offerPriceHint": "Il prezzo di offerta viene mostrato agli investitori.",
      "outdoorParking": "Posti auto esterni",
      "ownershipType": "Forma di proprietà",
      "principal": {
        "blockedHint": "Mandante e tipo di mandato sono obbligatori prima di continuare con i prossimi passi.",
        "contactCreateFailed": "Impossibile creare il contatto.",
        "contactCreated": "Contatto creato con successo",
        "contactHint": "Seleziona un contatto CRM esistente o crea un nuovo mandante.",
        "contactLabel": "Mandante (contatto CRM)",
        "createNew": "Crea nuovo contatto",
        "email": "E-mail",
        "firstName": "Nome",
        "lastName": "Cognome",
        "lastNameRequired": "Inserisci il cognome",
        "optionalHint": "Il mandante è opzionale. Puoi inserirlo in qualsiasi momento tramite l'intestazione fissa della pagina di modifica.",
        "ready": "Mandante registrato — puoi continuare.",
        "saveContact": "Crea contatto",
        "searchPlaceholder": "Cerca contatto...",
        "subtitle": "Chi è il mandante per la commercializzazione di questo immobile?"
      },
      "principalRequired": "Inserisci prima il mandante e il tipo di mandato.",
      "renovation": "Rinnovamento",
      "residentialAreaSqm": "Superficie abitativa (m²)",
      "residentialUnits": "Unità abitative",
      "status": {
        "complete": "Completo",
        "incomplete": "Incompleto",
        "neutral": "Opzionale"
      },
      "steps": {
        "aiUpload": "Caricamento IA",
        "basicData": "Dati di base",
        "details": "Caratteristiche",
        "legal": "Aspetti legali",
        "media": "Media e marketing",
        "pricing": "Prezzo e commercializzazione",
        "principal": "Mandante",
        "summary": "Riepilogo"
      },
      "subtitle": "Inserisci il tuo immobile in 8 passi",
      "summaryHint": "Controlla i dati e crea l'immobile.",
      "title": "Inserire immobile",
      "virtualTourUrl": "URL tour virtuale (opzionale)",
      "volumeM3": "Volume (m³)"
    },
    "wizard": {
      "button": "Assistente",
      "create": "Crea immobile",
      "descriptionPlaceholder": "Descrizione dettagliata dell'immobile...",
      "imagesCount": "immagini",
      "investmentHighlightsPlaceholder": "es. Rendimento stabile del 4.5%, contratti di locazione a lungo termine...",
      "photosFormats": "JPG, PNG, WEBP — max. 20 MB per immagine",
      "photosHint": "Buone foto sono il miglior argomento di vendita. Caricate foto significative.",
      "photosUpload": "Trascina le foto qui o clicca per caricare",
      "primaryImage": "Immagine principale",
      "steps": {
        "address": "Indirizzo",
        "classification": "Classificazione",
        "details": "Dati oggetto",
        "land": "Terreno",
        "photos": "Foto",
        "pricing": "Prezzi",
        "summary": "Riepilogo",
        "teaser": "Teaser",
        "titleAddress": "Titolo & Indirizzo",
        "type": "Tipo"
      },
      "subtitle": "Assistente passo per passo",
      "summaryHint": "Dopo la creazione potrai modificare l'immobile in dettaglio, caricare documenti e aggiungere traduzioni.",
      "teaserHighlightsPlaceholder": "es. Posizione top a Zurigo, appena ristrutturato, completamente affittato...",
      "teaserHint": "Descrivete l'immobile per i potenziali investitori. Questi testi appaiono sul teaser.",
      "title": "Nuovo immobile",
      "virtualTourUrl": "URL tour virtuale (opzionale)"
    },
    "yearBuilt": "Anno di costruzione",
    "yield": "Rendimento",
    "activateProperty": "Immobilie aktivieren",
    "activateDescription": "Die Immobilie wird für Investoren sichtbar und kann in Angebotslisten (Listings) aufgenommen werden.",
    "activateChecklist": "Bitte stelle sicher, dass folgende Punkte erfüllt sind:",
    "activateCheck1": "Übersetzungen (Name, Beschreibung) vorhanden",
    "activateCheck2": "Mindestens ein Bild hochgeladen",
    "activateCheck3": "Mindestpreis gesetzt",
    "activateCheck4": "Adresse und Standort korrekt",
    "reviewSubmitted": "Immobilie zur Prüfung eingereicht",
    "ownerDraftHint": "Diese Immobilie ist noch nicht sichtbar für Investoren.",
    "ownerReviewHint": "Wird gerade vom Immotron-Team geprüft.",
    "ownerActiveHint": "Sichtbar für Investoren.",
    "saleMode": {
      "fixedPrice": "Fixpreis",
      "offerCollection": "Bieterverfahren"
    },
    "commissionConditions": {
      "title": "Condizioni",
      "hint": "Vale per tutti gli acquirenti di questo oggetto, salvo un allegato B individuale.",
      "currentModel": "Modello di onorario applicabile",
      "noModel": "Nessun modello di onorario definito",
      "noModelOption": "Nessun modello di onorario — nessuna condizione dell'oggetto",
      "specialConditions": "Condizioni particolari",
      "specialConditionsPlaceholder": "Disposizioni derogatorie per questo oggetto, ad es. ripartizione della provvigione o onorario minimo",
      "save": "Salva condizioni",
      "saved": "Condizioni salvate",
      "saveFailed": "Impossibile salvare le condizioni",
      "loading": "Caricamento delle condizioni …",
      "loadFailed": "Impossibile caricare le condizioni",
      "noneHint": "Nessuna condizione dell'oggetto. Per ogni acquirente vale l'aliquota del suo contratto quadro, altrimenti lo standard «{{model}}» — se il contratto acquirente indica «variabile», senza condizione dell'oggetto non è stato concordato nulla.",
      "noneHintNoDefault": "Nessuna condizione dell'oggetto. Per ogni acquirente vale l'aliquota del suo contratto quadro — se il contratto acquirente indica «variabile», senza condizione dell'oggetto non è stato concordato nulla.",
      "blocked": {
        "no_contract": {
          "title": "Nessun contratto quadro collegato",
          "hint": "Le condizioni dell’immobile dipendono dal contratto quadro del mandante. Creare o collegare prima il contratto, poi sarà possibile impostare le condizioni.",
          "cta": "Creare un contratto quadro"
        },
        "unsupported_contract": {
          "title": "Condizioni dell'oggetto non possibili su questo contratto",
          "hint": "L'allegato B (rilascio dell'oggetto) è previsto solo per un contratto quadro venditore. Fino ad allora valgono le condizioni mostrate."
        }
      }
    }
  },
  "propertyChat": {
    "askButton": "Fai una domanda",
    "disclaimer": "Generato da IA — non è consulenza legale",
    "error": "Spiacente, non ho potuto rispondere alla domanda. Riprova.",
    "placeholder": "Inserisci una domanda...",
    "suggestion1": "Qual è il rendimento?",
    "suggestion2": "Descrivi la posizione",
    "suggestion3": "Quando è stato costruito?",
    "title": "Domande sull'immobile",
    "welcome": "Fai una domanda su questo immobile — ad es. sulla posizione, il rendimento o le dotazioni."
  },
  "propertyDetail": {
    "approvalError": "Fehler bei der Genehmigung",
    "available": "Vorhanden",
    "buildingArea": "Superficie edificata",
    "buyNow": "Acquista ora",
    "description": "Descrizione",
    "documents": "Documenti",
    "documentsLocked": "Documenti disponibili dopo approvazione NDA",
    "download": "Download",
    "downloadFailed": "Download fehlgeschlagen",
    "energyEnvelope": "Hülle",
    "energyTotal": "Gesamt",
    "financialMetrics": "Finanzielle Kennzahlen",
    "floors": "Piani",
    "grossIncome": "Reddito locativo lordo",
    "imageCounter": "{{current}} / {{total}}",
    "investmentHighlights": "Punti di forza dell'investimento",
    "investorActivity": {
      "interested": "{{count}} investitori interessati",
      "ndaConfirmed": "{{count}} NDA confermati"
    },
    "keyFigures": "Cifre chiave",
    "location": "Posizione",
    "lotSize": "Terreno",
    "ndaRequired": "Conferma NDA necessaria per l'accesso ai documenti",
    "noDocuments": "Nessun documento disponibile",
    "noImages": "Nessuna immagine disponibile",
    "overview": "Panoramica",
    "parkingGarage": "Garage",
    "parkingOutdoor": "Aussen",
    "placeBid": "Fai un'offerta",
    "preview": "Vorschau",
    "priceLocked": "Prezzo dopo NDA",
    "pricePerSqm": "Prezzo/m²",
    "rejectionError": "Fehler bei der Ablehnung",
    "rentalYield": "Rendimento",
    "sections": {
      "details": "Details",
      "documents": "Documenti",
      "financials": "Finanze",
      "overview": "Panoramica",
      "timeline": "Cronologia",
      "offers": "Angebot"
    },
    "submitError": "Fehler beim Einreichen",
    "submitOffer": "Invia offerta",
    "technicalDetails": "Technische Details",
    "title": "Dettagli immobile",
    "totalPrice": "Prezzo totale",
    "units": "Unità",
    "uploadFailed": "Upload fehlgeschlagen",
    "yearBuilt": "Anno di costruzione",
    "building": {
      "floors": "Stockwerke",
      "lift": "Aufzug",
      "heating": "Heizung",
      "energyTotal": "Energieklasse",
      "energyEnvelope": "Gebäudehülle",
      "condition": "Zustand",
      "renovation": "Renovierung",
      "residentialArea": "Wohnfläche",
      "commercialArea": "Gewerbefläche",
      "parking": "Parkplätze",
      "groundLease": "Baurecht",
      "title": "Gebäudedetails"
    },
    "investmentMetrics": "Investitionskennzahlen",
    "metrics": {
      "grossYield": "Bruttorendite",
      "vacancyRate": "Leerstand",
      "marketValue": "Marktwert"
    },
    "auftraggeber": {
      "title": "Mandante",
      "subtitle": "Con chi posso parlare?",
      "openDrawer": "Mostra dettagli del mandante",
      "statusActive": "Incarico di commercializzazione attivo",
      "statusExpired": "Incarico di commercializzazione scaduto",
      "statusNone": "Nessun incarico di commercializzazione",
      "ownMandate": "Mandato proprio (fuori da Immotron)",
      "ownMandateShort": "Mandato proprio",
      "ownMandateHint": "L'incarico di vendita esiste al di fuori della piattaforma.",
      "company": "Azienda",
      "companyMissing": "Azienda non ancora registrata",
      "uid": "UID",
      "primaryContact": "Contatto principale",
      "contact": "Dati di contatto",
      "noContact": "Nessun dato di contatto disponibile. Aggiungere tramite \"Modifica\".",
      "phoneMissing": "Telefono non ancora registrato",
      "emailMissing": "E-mail non ancora registrata",
      "mandate": "Incarico di commercializzazione",
      "startDate": "Inizio",
      "endDate": "Fine",
      "minimumPrice": "Prezzo minimo",
      "noMandate": "Nessun dato di incarico registrato.",
      "contract": "Dettagli del contratto",
      "contractNumber": "Numero di contratto",
      "contractType": "Tipo",
      "signedAt": "Firmato",
      "expiresAt": "Scade",
      "duration": "Durata",
      "durationMonths": "{{count}} mesi",
      "openContract": "Apri contratto",
      "commission": "Onorario",
      "commissionModel": "Modello",
      "commissionFlatRate": "Forfettario",
      "commissionBrackets": "Scaglioni",
      "commissionBracketsCount": "{{count}} livelli",
      "wishes": "Desideri e note del venditore",
      "desiredPrice": "Prezzo desiderato",
      "desiredTimeline": "Tempi desiderati",
      "notes": "Note",
      "noWishes": "Nessun desiderio o nota registrata.",
      "quickActions": "Azioni rapide",
      "actionCall": "Chiamare",
      "actionEmail": "E-mail",
      "actionMeeting": "Appuntamento",
      "actionEdit": "Modifica",
      "comingSoon": "Presto disponibile",
      "search": {
        "title": "Cerca mandante",
        "subtitle": "Vengono mostrate solo aziende e contatti con un contratto di piattaforma attivo.",
        "placeholder": "Azienda, UID, nome o e-mail...",
        "hint": "Inserisci almeno 2 caratteri per cercare.",
        "empty": "Nessun risultato con un contratto di piattaforma attivo. Firma prima un mandato di commercializzazione.",
        "error": "Ricerca fallita. Riprova.",
        "saveSuccess": "Mandante salvato",
        "saveFailed": "Salvataggio fallito. Riprova.",
        "clearSuccess": "Collegamento rimosso",
        "current": "Collegamento attuale",
        "currentCompany": "Azienda collegata",
        "currentContact": "Contatto collegato",
        "unlink": "Rimuovi",
        "typeCompany": "Azienda",
        "typeContact": "Contatto",
        "linked": "Attivo",
        "noDetails": "Nessun ulteriore dettaglio",
        "contractActive": "Contratto attivo",
        "contractActiveHint": "Il contratto piattaforma (SELLER_FRAMEWORK) è firmato."
      }
    }
  },
  "publicHelp": {
    "badge": "Aiuto & Guida",
    "cta": {
      "button": "Registrati ora",
      "subtitle": "Crea il tuo account e scopri opportunità immobiliari esclusive.",
      "title": "Pronto per iniziare?"
    },
    "faq": {
      "items": [
        {
          "a": "La piattaforma è gratuita per gli investitori. Venditori e intermediari pagano un onorario basato sul successo al momento della conclusione.",
          "q": "L'utilizzo di Immotron è gratuito?"
        },
        {
          "a": "Tutti i dati sensibili sono protetti da accordi di riservatezza (NDA) e controlli di accesso basati sui ruoli. I documenti vengono archiviati in forma crittografata.",
          "q": "Come vengono protetti i miei dati?"
        },
        {
          "a": "Dopo il NDA ottieni immediatamente accesso al dossier completo con tutti i dettagli, l'indirizzo esatto e tutti gli indicatori finanziari.",
          "q": "Cosa succede dopo la conferma del NDA?"
        },
        {
          "a": "Sì, Immotron è completamente responsive e funziona su tutti i dispositivi — desktop, tablet e smartphone.",
          "q": "Posso usare Immotron sul telefono?"
        },
        {
          "a": "Carica un PDF e la nostra IA riconosce automaticamente superfici, redditi da locazione, anno di costruzione e altri indicatori chiave. Tu verifichi e confermi i risultati.",
          "q": "Come funziona l'estrazione dati tramite IA?"
        },
        {
          "a": "In un turno di offerta, più investitori possono presentare offerte entro un termine stabilito. Il venditore decide poi sull'aggiudicazione.",
          "q": "Cos'è un turno di offerta?"
        }
      ],
      "title": "Domande frequenti"
    },
    "features": {
      "automated": {
        "desc": "Estrazione dati tramite IA, e-mail automatiche e suggerimenti intelligenti per le clausole.",
        "title": "Workflow automatizzati"
      },
      "digital": {
        "desc": "Dal primo contatto alla firma — tutto online, senza carta e completamente tracciabile.",
        "title": "100% digitale"
      },
      "realtime": {
        "desc": "Notifiche push e aggiornamenti via e-mail a ogni passaggio importante del processo.",
        "title": "Notifiche in tempo reale"
      },
      "roles": {
        "desc": "Viste personalizzate per investitori, venditori, team commerciali e amministratori.",
        "title": "Ruoli per ogni esigenza"
      },
      "secure": {
        "desc": "Dossier protetti da NDA, documenti crittografati e controlli di accesso basati sui ruoli.",
        "title": "Sicuro e riservato"
      },
      "title": "Perché Immotron?",
      "transparent": {
        "desc": "Exposé e specchio degli affitti con tutti i dati finanziari rilevanti a colpo d'occhio.",
        "title": "Indicatori trasparenti"
      }
    },
    "footer": "Tutti i diritti riservati",
    "hero": {
      "subtitle": "Immotron collega investitori immobiliari e venditori su una piattaforma digitale sicura. Ecco come funziona il processo, passo dopo passo.",
      "title": "Come funziona Immotron"
    },
    "investor": {
      "steps": {
        "deal": {
          "desc": "In caso di aggiudicazione, ricevi la bozza del contratto per la firma digitale. L'intero processo è documentato in modo trasparente sulla timeline.",
          "title": "Conclusione della transazione"
        },
        "dossier": {
          "desc": "Il dossier include lo specchio degli affitti, l'exposé, le planimetrie, le foto e tutti gli indicatori finanziari rilevanti — disponibile per il download o l'anteprima online.",
          "title": "Esamina il dossier completo"
        },
        "nda": {
          "desc": "Interessato? Conferma il NDA digitalmente per ottenere l'accesso al dossier completo con tutti i dettagli e l'indirizzo esatto.",
          "title": "Accordo di riservatezza (NDA)"
        },
        "offer": {
          "desc": "Presenta un'offerta indicativa (NBO) o un'offerta vincolante (BO). Durante i turni di offerta puoi vedere la scadenza e adeguare la tua offerta di conseguenza.",
          "title": "Presenta un'offerta"
        },
        "search": {
          "desc": "Esplora gli immobili d'investimento disponibili con filtri per posizione, rendimento, tipo di immobile e fascia di prezzo. La vista mappa mostra la posizione approssimativa.",
          "title": "Cerca immobili"
        },
        "teaser": {
          "desc": "Ogni immobile dispone di un dossier teaser anonimizzato con i dati principali, foto e indicatori — senza rivelare l'indirizzo esatto.",
          "title": "Consulta il dossier teaser"
        }
      },
      "title": "Il processo per gli investitori"
    },
    "login": "Accedi",
    "seller": {
      "steps": {
        "contract": {
          "desc": "Crea contratti di vendita direttamente sulla piattaforma con il nostro assistente contrattuale. Le clausole vengono suggerite con il supporto dell'IA.",
          "title": "Creazione del contratto"
        },
        "matching": {
          "desc": "Immotron propone il tuo immobile a investitori qualificati. Puoi vedere in tempo reale chi ha mostrato interesse e firmato il NDA.",
          "title": "Matching con gli investitori"
        },
        "review": {
          "desc": "Verifica i dati estratti dall'IA e completa le informazioni mancanti. Un controllo qualità garantisce che tutti i campi obbligatori siano compilati.",
          "title": "Verifica e completa i dati"
        },
        "updates": {
          "desc": "Segui l'avanzamento della transazione sulla timeline. Le notifiche push ti tengono informato su ogni passaggio.",
          "title": "Aggiornamenti in tempo reale"
        },
        "upload": {
          "desc": "Carica foto e documenti — la nostra IA estrae automaticamente i dati principali come superfici, redditi da locazione e anno di costruzione.",
          "title": "Registra il tuo immobile"
        }
      },
      "title": "Il processo per i venditori"
    },
    "tabs": {
      "investor": "Per gli investitori",
      "seller": "Per i venditori"
    }
  },
  "onboarding": {
    "title": "Aprire un conto",
    "intro": "Verifica i dati in nostro possesso. Se sono corretti, confermali e procedi direttamente alla firma del contratto.",
    "footer": "Tutti i diritti riservati.",
    "loading": "Caricamento dei dati...",
    "validUntil": "Link valido fino al",
    "confirmHint": "Se tutti i dati sono corretti, confermali per procedere con la firma del contratto.",
    "confirm": "Aprire un conto →",
    "confirming": "Apertura del conto …",
    "reportCorrection": "Segnala una correzione",
    "legalNotice": "Confermando, dichiari che i dati visualizzati sono corretti.",
    "coSigner": {
      "title": "Seconda firma",
      "description": "La vostra società firma collettivamente. Il contratto richiede quindi una seconda persona autorizzata a firmare oltre alla vostra firma.",
      "selectLabel": "Seconda persona autorizzata a firmare",
      "otherPerson": "Indicare un'altra persona",
      "firstName": "Nome",
      "lastName": "Cognome",
      "email": "E-mail della seconda persona",
      "emailPlaceholder": "nome@azienda.ch",
      "emailHint": "Inviamo il link personale per la firma a questo indirizzo.",
      "bothSignHint": "Entrambe le persone ricevono un link per firmare.",
      "required": "Indicare la seconda persona autorizzata a firmare con un indirizzo e-mail valido.",
      "confirmedTitle": "Dati confermati",
      "confirmedDescription": "Entrambe le persone ricevono un link per firmare. Potete firmare subito.",
      "signatories": "Firmatari",
      "signNow": "Firma ora"
    },
    "company": {
      "title": "Dati aziendali",
      "name": "Azienda",
      "uid": "IDI",
      "address": "Indirizzo"
    },
    "person": {
      "title": "Persona di contatto",
      "name": "Nome",
      "function": "Funzione"
    },
    "conditions": {
      "title": "Le tue condizioni",
      "propertyHint": "Si tratta di {{hint}}.",
      "contractGroup": "Contratto",
      "feeGroup": "Onorario",
      "costLabel": "Costi",
      "buyerCommission": "Provvigione acquirente (a tuo carico)",
      "sellerCommission": "Provvigione venditore (a carico del venditore)",
      "transparencyHint": "Immotron rende note entrambe le provvigioni — nessuna commissione nascosta.",
      "matchHint": "Queste condizioni sono riportate parola per parola nel contratto che riceverai per la firma dopo la conferma.",
      "CONTRACT_TYPE_TEXT": "Contratto",
      "COMMISSION_TEXT": "Commissione"
    },
    "correction": {
      "title": "Segnala una correzione",
      "description": "Descrivi quali dati non sono corretti. Il nostro team esaminerà la tua segnalazione e ti ricontatterà.",
      "label": "La tua correzione",
      "placeholder": "Cosa deve essere corretto?",
      "submit": "Invia correzione",
      "submitting": "Invio in corso...",
      "cancel": "Annulla"
    },
    "correctionSent": {
      "title": "Segnalazione ricevuta",
      "description": "Grazie — verifichiamo i dati e le inviamo un nuovo link.",
      "descriptionWithAdvisor": "Grazie — il suo consulente {{advisor}} verifica i dati e le invia un nuovo link.",
      "yourMessage": "La sua segnalazione",
      "quotedMessage": "«{{message}}»",
      "advisorContact": "Il suo referente"
    },
    "actions": {
      "home": "Vai alla pagina iniziale",
      "close": "Chiudi finestra",
      "closeHint": "Il suo browser non consente la chiusura automatica. Chiuda la scheda manualmente."
    },
    "alreadyActive": {
      "title": "Già attivo",
      "description": "Esiste già un contratto attivo per te. Puoi consultare i tuoi contratti in qualsiasi momento nelle impostazioni."
    },
    "alreadyUsed": {
      "title": "Link già utilizzato",
      "description": "Questo link di conferma è già stato utilizzato. Per domande, contatta il tuo referente."
    },
    "verificationFailed": {
      "title": "Conferma non possibile",
      "description": "Non è stato possibile confermare automaticamente il tuo potere di firma. Il nostro team è stato informato e ti ricontatterà."
    },
    "expired": {
      "title": "Link scaduto",
      "description": "Purtroppo questo link di conferma è scaduto. Contatta il tuo referente per ottenere un nuovo link."
    },
    "error": {
      "title": "Errore",
      "generic": "Si è verificato un errore imprevisto. Riprova.",
      "invalidToken": "Link di conferma non valido o sconosciuto.",
      "loadFailed": "Non è stato possibile caricare i dati.",
      "confirmFailed": "Non è stato possibile elaborare la conferma. Riprova.",
      "correctionFailed": "Non è stato possibile inviare la correzione. Riprova."
    },
    "welcome": "Benvenuto, {{name}}",
    "invitedBy": "{{mandant}} ti invita a visionare immobili su Immotron.",
    "invitedGeneric": "Sei invitato a visionare immobili su Immotron.",
    "nextStep": "poi: una breve firma",
    "fullContract": "Mostra il contratto completo",
    "termsLink": "Leggi le condizioni d'uso",
    "benefits": {
      "title": "Questo è ciò che ottieni:",
      "account": "un conto gratuito",
      "view": "visionare immobili e consultare la documentazione",
      "offer": "presentare offerte"
    },
    "cost": {
      "title": "Quanto costa?",
      "text": "Niente. Paghi una provvigione solo se acquisti un immobile. L'importo è indicato per ogni immobile, prima che apra la documentazione."
    },
    "details": {
      "title": "I tuoi dati sono corretti?",
      "change": "modifica"
    }
  },
  "publicProvider": {
    "offeredBy": "Offerta di",
    "contact": "Il vostro contatto"
  },
  "publicTeaser": {
    "title": "Opportunità d'investimento esclusiva",
    "subtitle": "Una prima panoramica. Vedrai indirizzo, dossier e tutti i documenti appena avrai aperto il tuo conto gratuito.",
    "footer": "Tutti i diritti riservati.",
    "loading": "Caricamento del teaser...",
    "cta": {
      "loginTitle": "Hai già un accesso",
      "loginHint": "Accedi per consultare il dossier completo con indirizzo, posizione e tutti i documenti.",
      "loginButton": "Accedi",
      "startTitle": "Apri un conto",
      "startHint": "Inserisci il tuo indirizzo e-mail: ti portiamo direttamente all'apertura del conto e sblocchiamo poi indirizzo, posizione e l'intero dossier dell'immobile.",
      "createAccountTitle": "Crea account",
      "createAccountHint": "Per vedere indirizzo, posizione e il dossier completo, apri ora il tuo conto gratuito. Nel passaggio successivo verifichi i tuoi dati e firmi brevemente online.",
      "createAccountButton": "Crea account",
      "emailLabel": "Indirizzo e-mail",
      "emailHint": "Inserisci l'indirizzo e-mail al quale è stato inviato questo teaser.",
      "emailInvalid": "Inserisci un indirizzo e-mail valido.",
      "newHereToggle": "Sono nuovo qui",
      "firstName": "Nome",
      "lastName": "Cognome",
      "companyName": "Azienda",
      "companyUid": "Numero IDI",
      "continueButton": "Continua all'apertura del conto",
      "submitError": "Non è stato possibile avviare l'apertura del conto. Riprova più tardi.",
      "rateLimitError": "Troppi tentativi. Attendi un momento e riprova.",
      "sentTitle": "Ti abbiamo inviato il link",
      "sentHint": "Ti abbiamo inviato per e-mail il link per aprire il tuo conto. Controlla la tua casella di posta.",
      "hasContractTitle": "Hai già un conto",
      "hasContractHint": "Per questo indirizzo e-mail esiste già un conto. Accedi per consultare il dossier completo."
    },
    "expired": {
      "title": "Link scaduto",
      "description": "Questo link teaser è purtroppo scaduto. Contatta il tuo referente per ottenere un nuovo link."
    },
    "error": {
      "title": "Teaser non trovato",
      "description": "Questo link non è valido o non è più disponibile. Controlla il link ricevuto via e-mail o contatta il tuo referente."
    }
  },
  "publicSigning": {
    "accountLead": "Riceve un account per visionare gli oggetti e presentare offerte. Costi solo in caso di acquisto.",
    "accountTitle": "Aprire l'account: firma",
    "agb": {
      "accept": "Ho letto e accetto le condizioni della piattaforma di {{owner}}.",
      "acceptWithMandant": "Ho letto e accetto le condizioni della piattaforma di {{owner}} e le condizioni integrative di {{mandant}}.",
      "description": "La piattaforma «Immotron» è gestita da {{owner}}. Le sue condizioni di utilizzo si applicano in aggiunta al presente contratto con {{counterparty}}. Per onorari e condizioni prevale il contratto.",
      "descriptionNoCounterparty": "La piattaforma «Immotron» è gestita da {{owner}}. Le sue condizioni di utilizzo si applicano in aggiunta al presente contratto. Per onorari e condizioni prevale il contratto.",
      "mandantTerms": "Visualizza le condizioni integrative di {{mandant}}",
      "modalTitle": "Condizioni di utilizzo della piattaforma (CG)",
      "requiredHint": "Si prega di accettare le Condizioni Generali per firmare il contratto.",
      "title": "Condizioni di utilizzo della piattaforma (CG)",
      "viewAgb": "Visualizza le condizioni della piattaforma di {{owner}}"
    },
    "authority": {
      "manual": "verificato manualmente",
      "register": "verificato nel registro di commercio",
      "signatureType": {
        "COLLECTIVE_MORE": "Firma collettiva a più persone",
        "COLLECTIVE_TWO": "Firma collettiva a due",
        "NONE": "nessun diritto di firma",
        "SINGLE": "Firma individuale"
      },
      "unverified": "non verificato",
      "unverifiedHint": "Il diritto di firma non è ancora stato verificato nel registro di commercio. Con la sua firma conferma di essere autorizzato a firmare per {{company}}.",
      "unverifiedHintGeneric": "Il diritto di firma non è ancora stato verificato nel registro di commercio. Con la sua firma conferma di essere autorizzato a firmare questo contratto."
    },
    "alreadySigned": {
      "countersignHint": "La sua firma è stata registrata. Il contratto è in fase di controfirma da parte di Immotron. Sarà avvisato via e-mail e il suo account verrà attivato.",
      "countersignPending": "Controfirma in sospeso",
      "description": "Questo contratto è già stato firmato da lei.",
      "downloadPdf": "Scarica il contratto in PDF",
      "fullySigned": "Contratto completamente firmato",
      "fullySignedHint": "Tutte le parti hanno firmato. Riceverà le credenziali del suo account e potrà consultare i suoi contratti nelle impostazioni.",
      "noActionNeeded": "La sua firma è stata salvata. Non è necessaria alcuna ulteriore azione.",
      "othersPending": "Altre firme in sospeso",
      "othersPendingHint": "La sua firma è stata registrata. Sarà informato via e-mail sui prossimi passi una volta che tutte le parti avranno firmato.",
      "signedAt": "Firmato il",
      "signedAtValue": "{{date}} alle {{time}}",
      "title": "Ha già firmato"
    },
    "backToSigning": "Torna alla firma",
    "cancelled": {
      "description": "Non è più possibile firmarlo. Per domande rivolgiti al tuo referente.",
      "title": "Questo contratto è stato annullato"
    },
    "contractDetails": "Dettagli del contratto",
    "contractNumber": "Numero di contratto",
    "contractType": "Tipo di contratto",
    "downloadPdf": "Scarica il PDF",
    "error": {
      "generic": "Si è verificato un errore imprevisto. Riprovi.",
      "invalidToken": "Link di firma non valido o sconosciuto.",
      "kycRequired": "La preghiamo di completare prima la sua identificazione.",
      "loadFailed": "Il contratto non ha potuto essere caricato.",
      "submitFailed": "La firma non ha potuto essere trasmessa. Riprovi.",
      "title": "Errore"
    },
    "expired": {
      "description": "Questo link di firma è scaduto. La preghiamo di contattare il suo referente per un nuovo link.",
      "title": "Link scaduto"
    },
    "footer": "Tutti i diritti riservati.",
    "geo": {
      "allow": "Condividi posizione",
      "description": "Per la documentazione legale, la sua posizione può essere registrata. Questo è facoltativo.",
      "title": "Condivisione della posizione"
    },
    "legalNotice": "Con la sua firma, conferma di aver letto e compreso il contratto.",
    "loading": "Caricamento del contratto...",
    "newTabHint": "Si apre in una nuova scheda",
    "otp": {
      "description": "Per questa firma è necessario anche un codice di conferma (firma elettronica avanzata).",
      "error": {
        "channelUnavailable": "Il codice non ha potuto essere recapitato. La preghiamo di contattare il suo referente.",
        "cooldown": "Attenda un momento prima di richiedere un nuovo codice.",
        "expired": "Il codice è scaduto — richieda un nuovo codice.",
        "invalid": "Il codice non è corretto.",
        "locked": "Troppi tentativi errati — richieda un nuovo codice.",
        "notRequired": "Per questa firma non è necessario alcun codice di conferma.",
        "required": "La preghiamo di richiedere e inserire prima il codice.",
        "sendFailed": "Il codice non ha potuto essere inviato. Riprovi."
      },
      "label": "Codice a 6 cifre",
      "requiredHint": "Inserisca il codice di conferma a 6 cifre.",
      "resend": "Invia di nuovo il codice",
      "resendIn": "Invia di nuovo il codice ({{seconds}} s)",
      "send": "Invia codice",
      "sending": "Invio del codice ...",
      "sentHint": "Abbiamo inviato un codice a 6 cifre a {{hint}} (valido 5 minuti).",
      "sentHintGeneric": "Le abbiamo inviato un codice a 6 cifre (valido 5 minuti).",
      "title": "Codice di conferma"
    },
    "parties": "Parti contrattuali",
    "partiesCompact": "Chi firma",
    "partyStatus": {
      "pending": "In sospeso",
      "signed": "Firmato"
    },
    "pdfTitle": "Anteprima del contratto",
    "role": {
      "agent": "Procuratore",
      "broker": "Intermediario",
      "buyer": "Acquirente",
      "companyRep": "Rappresentante dell'azienda",
      "label": "Ruolo",
      "operator": "Gestore",
      "partner": "Partner",
      "seller": "Venditore",
      "user": "Utente"
    },
    "signatory": "Firmatario",
    "signatureLabel": "Firma",
    "signatureTitle": "La sua firma",
    "signedFor": "Firmato per conto di",
    "signingFor": "Lei firma per conto di",
    "steps": {
      "agb": "Accettare le condizioni di utilizzo",
      "contract": "Vedere il contratto",
      "otp": "Inserire il codice",
      "sign": "Firmare"
    },
    "submit": "Firma ora",
    "submitting": "Firma in corso...",
    "success": {
      "contractNumber": "Numero di contratto",
      "description": "La sua firma è stata trasmessa con successo. Riceverà una conferma via e-mail.",
      "title": "Firmato con successo!"
    },
    "title": "Firma del contratto",
    "validUntil": "Valido fino al",
    "viewPdf": "Mostra contratto",
    "youPrefix": "Lei:"
  },
  "qualityGate": {
    "buyerSuggestions": {
      "title": "Suggerimenti acquirenti IA",
      "hint": "Acquirenti suggeriti dall'IA, ordinati per idoneità. Quelli selezionati ottengono l'accesso al teaser all'approvazione.",
      "load": "Carica suggerimenti acquirenti",
      "reload": "Ricalcola",
      "loading": "Calcolo dei suggerimenti …",
      "loadFailed": "Impossibile caricare i suggerimenti acquirenti",
      "retry": "Riprova",
      "empty": "Nessun acquirente corrispondente trovato",
      "fitScore": "Idoneità: {{score}}%",
      "showReasoning": "Mostra motivazione",
      "hideReasoning": "Nascondi motivazione",
      "summary": "{{count}} acquirenti ottengono l'accesso all'approvazione",
      "assign": "Assegna {{count}} acquirente/i"
    },
    "address": "Indirizzo",
    "approve": "Approvare",
    "approveConfirm": "Vuoi davvero approvare questo immobile?",
    "approveSuccess": "Immobile approvato con successo",
    "approvedAt": "Approvato il",
    "approvedTitle": "Controllo qualità superato",
    "releaseInvitations": {
      "title": "Verranno inviate e-mail",
      "description": "Con l'approvazione, {{count}} acquirenti ricevono ora un'e-mail con il teaser e il link di onboarding:",
      "noEmail": "Nessuna e-mail registrata — questo destinatario verrà saltato.",
      "hint": "Attenzione: un'e-mail inviata non può essere richiamata.",
      "inviteTitle": "Invito ai nuovi acquirenti",
      "accessTitle": "E-mail di accesso agli acquirenti con contratto attivo",
      "groupTitle": "E-mail di accesso ai membri del gruppo",
      "accessHint": "Questi destinatari ricevono l'e-mail di accesso a ogni approvazione.",
      "approveAndSend": "Approvare e inviare",
      "approveOnly": "Solo approvare",
      "approveWithoutInvitations": "Approvare senza inviti",
      "sentToast": "{{count}} inviti inviati",
      "notSentToast": "Non inviato a {{count}} destinatari: {{names}}",
      "groupNotifiedToast_one": "E-mail di accesso inviata a {{names}}",
      "groupNotifiedToast_other": "E-mail di accesso inviata a {{count}} membri del gruppo: {{names}}",
      "groupAlreadyToast_one": "1 membro del gruppo aveva già accesso — nessuna nuova e-mail",
      "groupAlreadyToast_other": "{{count}} membri del gruppo avevano già accesso — nessuna nuova e-mail",
      "groupInvitedToast_one": "Invito inviato a {{names}}",
      "groupInvitedToast_other": "Invito inviato a {{count}} membri del gruppo: {{names}}",
      "groupInviteFailedToast": "Invito non inviato a {{names}}"
    },
    "checkpoints": {
      "canton": "Cantone indicato",
      "city": "Città indicata",
      "contractSigned": "Contratto firmato",
      "description": "Descrizione verificata",
      "documents": "Documenti completi",
      "images": "Almeno 1 immagine caricata",
      "minimumPrice": "Prezzo minimo definito",
      "minimumPricePositive": "Prezzo minimo superiore a 0",
      "pricing": "Prezzo definito",
      "propertyType": "Tipo di immobile definito",
      "requiredFields": "Campi obbligatori compilati",
      "translations": "Almeno 1 traduzione disponibile"
    },
    "autoCheckTitle": "Lista di controllo automatica",
    "autoCheckHint": "Questi punti vengono verificati automaticamente dai dati dell'immobile.",
    "autoChecks": {
      "required_fields": "Campi obbligatori compilati",
      "images": "Almeno 3 immagini caricate",
      "description": "Descrizione fornita",
      "pricing": "Prezzo definito",
      "documents": "Documenti caricati",
      "highlights": "Punti salienti d'investimento forniti",
      "location": "Descrizione dell'ubicazione fornita",
      "contract_signed": "Contratto di commercializzazione firmato"
    },
    "cannotApproveYet": "L'approvazione richiede che tutti i punti obbligatori siano verdi.",
    "approveBlocked": {
      "title": "Approvazione non ancora possibile — questi punti obbligatori sono aperti:"
    },
    "optional": "Facoltativo",
    "pendingReviews": "{{count}} da verificare",
    "morePropertiesPending": "{{count}} immobili in attesa di verifica — selezionane uno per cambiare.",
    "selectAnother": "Seleziona un altro immobile",
    "selectProperty": "Seleziona un immobile",
    "selectPropertyHint": "Seleziona un immobile a sinistra per visualizzare l'anteprima e la lista di controllo.",
    "teaserPreview": "Anteprima investitore",
    "teaserPreviewHint": "Anteprima come la vede l'investitore",
    "discretion": {
      "title": "Discrezione prima della NDA",
      "none": "Nessun elemento identificativo nel teaser",
      "edit": "Modifica i testi del teaser"
    },
    "newsletterPreview": {
      "description": "Come viene inviato questo teaser come e-mail/newsletter — l'anteprima corrisponde esattamente all'e-mail inviata.",
      "teaserImages": "{{count}} immagini del teaser",
      "hiddenImages": "{{count}} visibili solo dopo la NDA",
      "locationConfirm": "Rilasciare deliberatamente le immagini sensibili alla posizione per il teaser",
      "blocked": "Invio bloccato — risolvere prima i seguenti punti:",
      "refresh": "Aggiorna",
      "loadFailed": "Impossibile caricare l'anteprima della newsletter.",
      "retry": "Riprova",
      "iframeTitle": "Anteprima della newsletter come e-mail",
      "empty": "Nessuna anteprima della newsletter disponibile."
    },
    "contractNotSigned": "Nessun contratto firmato disponibile",
    "decideFailed": "Impossibile salvare la decisione",
    "empty": "Nessun immobile in attesa di verifica",
    "emptyHint": "Le nuove sottomissioni appariranno qui automaticamente",
    "images": "{{count}} immagini",
    "imagesNone": "Nessuna immagine",
    "investorGroups": {
      "createNew": "Crea nuovo gruppo",
      "empty": "Nessun gruppo di investitori disponibile",
      "hint": "Questi gruppi ricevono automaticamente l'accesso al teaser dopo l'approvazione.",
      "loadFailed": "Impossibile caricare i gruppi di investitori",
      "summary": "{{investors}} investitori da {{groups}} gruppi riceveranno l'accesso",
      "summaryPersons": "{{persons}} persone da {{groups}} gruppi riceveranno l'accesso",
      "title": "Gruppi di investitori",
      "showMembers": "Mostra i membri di {{name}}",
      "hideMembers": "Nascondi i membri di {{name}}",
      "noMembers": "Nessun membro",
      "unknownMember": "Membro sconosciuto",
      "assign": "Assegna {{count}} gruppo/i",
      "coversGroups": "Vale anche per i membri dei gruppi di investitori selezionati.",
      "missingHint": "Membri dei gruppi di investitori selezionati: una condizione dell'immobile impostata con «Definisci per tutti» copre ogni membro senza una condizione propria."
    },
    "loadFailed": "Impossibile caricare la coda di revisione",
    "owner": "Proprietario",
    "previewFailed": "Impossibile caricare l'anteprima",
    "previewListing": "Anteprima acquirente",
    "price": "Prezzo",
    "progress": "{{checked}}/{{total}} punti di controllo",
    "propertyDetails": "Dettagli immobile",
    "readOnlyAfterApproval": "Questo immobile è stato approvato e non può più essere modificato.",
    "readOnlyHint": "Questo immobile è stato approvato e può essere modificato solo da un amministratore.",
    "reject": "Rifiutare",
    "rejectReason": "Motivazione (obbligatorio)",
    "rejectReasonPlaceholder": "Indicare il motivo del rifiuto...",
    "rejectSuccess": "Immobile rifiutato",
    "required": "Obbligatorio",
    "reviewChecklist": "Lista di controllo",
    "sellerContract": {
      "active": "Contratto attivo",
      "activeSince": "Contratto attivo dal {{date}}",
      "changeContract": "Modifica contratto",
      "commission": "Condizione",
      "contractNumber": "Numero di contratto",
      "expiresAt": "Scade il {{date}}",
      "hideDetails": "Nascondi dettagli",
      "noActive": "Nessun contratto di piattaforma attivo",
      "noActiveHint": "Questo immobile non può essere approvato finché il venditore non ha un contratto di piattaforma firmato.",
      "openContract": "Apri contratto",
      "ownMandate": "Mandato proprio (fuori da Immotron)",
      "principal": "Mandante",
      "searchContract": "Cerca contratto",
      "showDetails": "Mostra dettagli",
      "signatoryTypes": {
        "BUYER": "Acquirente",
        "PLATFORM": "Piattaforma",
        "SELLER": "Venditore",
        "WITNESS": "Testimone"
      },
      "signedBy": "Firmato da",
      "title": "Contratto del venditore"
    },
    "statuses": {
      "ACTIVE": "Attivo",
      "APPROVED": "Approvato",
      "DRAFT": "Bozza",
      "IN_REVIEW": "In verifica",
      "REJECTED": "Rifiutato"
    },
    "submittedAt": "Inviato il {{date}}",
    "subtitle": "Approvazione immobili",
    "timeline": {
      "boDays": "Fase BO (giorni)",
      "boPhase": "Fase BO",
      "boReviewDays": "Revisione BO (giorni)",
      "boReviewPhase": "Revisione BO",
      "days": "giorni",
      "excludeLowestNbo": "Escludere la NBO più bassa dalla BO",
      "excludeLowestNboHint": "Se attivato, l'offerta NBO più bassa non viene considerata nella selezione dei candidati BO.",
      "durationPresetDays_one": "{{count}} giorno",
      "durationPresetDays_other": "{{count}} giorni",
      "durationPresets": "Durata rapida",
      "endDate": "Data di fine",
      "fixedPrice": "Prezzo fisso",
      "fixedPriceInfo": "Prezzo proposto",
      "fixedPriceLabel": "Prezzo di vendita",
      "guidePrice": "Prezzo indicativo",
      "nboDays": "Fase NBO (giorni)",
      "nboPhase": "Fase NBO",
      "nboReviewDays": "Revisione NBO (giorni)",
      "nboReviewPhase": "Revisione NBO",
      "offerCollection": "Procedura di offerta",
      "preview": "Anteprima calendario",
      "reservePrice": "Prezzo minimo",
      "reservePriceHint": "Interno. Non visibile agli investitori.",
      "saleMode": "Modalità di vendita",
      "startDate": "Data di inizio",
      "submissionDays": "Termine di presentazione (giorni)",
      "submissionPhase": "Termine di presentazione",
      "title": "Configurazione vendita",
      "totalDuration": "Durata totale"
    },
    "title": "Quality Gate",
    "translations": "{{count}} lingue",
    "translationsNone": "Nessuna traduzione",
    "viewProperty": "Modifica immobile",
    "zefix": {
      "autoLookup": "Caricamento dei dati del venditore...",
      "contractActive": "Contratto attivo",
      "contractActiveSince": "Contratto attivo dal {{date}}",
      "contractNumber": "Numero di contratto",
      "expiresAt": "Scade il {{date}}",
      "importContacts": "Importare {{count}} persone nel CRM",
      "importDone": "{{count}} contatti sono stati importati nel CRM",
      "importFailed": "Impossibile importare i contatti",
      "importSuccess": "{{count}} contatti importati con successo nel CRM",
      "imported": "Importato",
      "importing": "Importazione in corso...",
      "legalForm": "Forma giuridica",
      "lookupFailed": "Impossibile caricare i dati del venditore",
      "noActiveContract": "Nessun contratto venditore attivo",
      "noActiveContractHint": "Il Quality Gate mostra qui solo venditori con un contratto di piattaforma attivo. Si prega di creare e far firmare prima un contratto.",
      "noPersons": "Nessun firmatario autorizzato trovato",
      "noPersonsHint": "I dati FUSC non sono disponibili per questa azienda. Si prega di aggiungere i firmatari manualmente nel CRM.",
      "noUidActive": "L'azienda «{{company}}» non ha un IDI. I firmatari autorizzati non possono essere caricati dal registro di commercio.",
      "openContract": "Apri contratto",
      "registeredPersons": "Firmatari autorizzati (ZEFIX)",
      "signedBy": "Firmato da",
      "title": "Registro di commercio del venditore",
      "unknownSeller": "Venditore sconosciuto"
    },
    "personSearch": {
      "title": "Ricerca persone",
      "hint": "Assegnare manualmente contatti o aziende CRM come acquirenti. La classificazione appare subito: attivo o onboarding necessario."
    },
    "buyerConditions": {
      "setForAll": "Definisci per tutti",
      "setForBuyer": "Definisci per questo acquirente",
      "setForBuyerAria": "Definisci la condizione per {{name}}",
      "savedForBuyer": "Condizione definita per {{name}}",
      "modelRequired": "Per una condizione individuale dell'acquirente è necessario un modello di onorario.",
      "dialogTitle": "Definisci le condizioni per tutti",
      "dialogHint": "Le condizioni vengono salvate come allegato B dell'oggetto e valgono per tutti gli acquirenti assegnati senza una condizione propria.",
      "dialogTitleBuyer": "Definisci la condizione per {{name}}",
      "dialogHintBuyer": "Questo acquirente ha un contratto quadro (variabile). La condizione vale solo per questo oggetto e viene registrata come allegato B del suo contratto quadro acquirente.",
      "buyerObjectCondition": "Condizione di questo oggetto: {{model}}.",
      "buyerNoObjectCondition": "Per questo oggetto non è registrata alcuna condizione dell'oggetto.",
      "setPlannedForBuyer": "Definisci la condizione prevista",
      "setPlannedForBuyerAria": "Definisci la condizione prevista per {{name}}",
      "plannedSpecialCondition": "condizione speciale",
      "plannedNoModel": "Nessuna indicazione — vale la condizione dell'oggetto ({{model}})",
      "plannedNoModelMissing": "Nessuna indicazione — ATTENZIONE: questo oggetto non ha alcuna condizione dell'oggetto",
      "plannedNoObjectCondition": "Per questo oggetto non è registrata alcuna condizione dell'oggetto: senza un modello di onorario proprio, dopo la firma per questo acquirente non vale alcuna condizione.",
      "plannedSetObjectCondition": "Registra la condizione dell'oggetto",
      "dialogTitlePlanned": "Definisci la condizione prevista per {{name}}",
      "dialogHintPlanned": "Questo acquirente non ha ancora un contratto quadro. Senza un modello di onorario proprio vale per lui la condizione di questo oggetto. Con un modello di onorario ottiene una condizione propria per questo oggetto — viene annotata sulla sua assegnazione e ripresa automaticamente come allegato B dopo la firma.",
      "emailLabel": "Indirizzo e-mail dell'acquirente",
      "emailRequired": "Per questo acquirente non è registrato alcun indirizzo e-mail — senza di esso non può essere inviato alcun invito. Aggiungerlo ora."
    },
    "conditionObjections": {
      "title": "Obiezioni aperte sulle condizioni",
      "hint": "Acquirenti che hanno rifiutato le condizioni dell'oggetto e proposto un altro tasso.",
      "property": "Oggetto",
      "unknownProperty": "Oggetto #{{id}}",
      "unknownPerson": "Persona sconosciuta",
      "proposedRate": "Tasso desiderato",
      "noRate": "Nessun tasso indicato",
      "reason": "Motivazione",
      "date": "Ricevuta il",
      "accept": "Accettare",
      "acceptHint": "Il tasso concordato viene registrato come allegato B dell'oggetto.",
      "agreedRateLabel": "Tasso concordato (%)",
      "acceptConfirm": "Accettare",
      "accepted": "Obiezione accettata — allegato B creato con il tasso concordato.",
      "acceptFailed": "Non è stato possibile accettare l'obiezione.",
      "reject": "Rifiutare",
      "rejectHint": "La motivazione viene trasmessa all'acquirente.",
      "rejectReasonLabel": "Motivazione",
      "rejectReasonPlaceholder": "Perché la controproposta viene rifiutata?",
      "rejectConfirm": "Rifiutare",
      "rejected": "Obiezione rifiutata — l'acquirente è stato informato.",
      "rejectFailed": "Non è stato possibile rifiutare l'obiezione."
    }
  },
  "researchLeads": {
    "actions": {
      "approve": "Freigeben",
      "autoMatch": "Auto-Match",
      "import": "Importieren",
      "reject": "Ablehnen",
      "website": "Website"
    },
    "allProjects": "Alle Projekte",
    "batchMatch": "Auto-Match alle",
    "deleteTitle": "Lead löschen",
    "detail": {
      "assessment": "Bewertung",
      "businessModel": "Geschäftsmodell",
      "company": "Firma",
      "companyMatch": "Firma-Match",
      "contact": "Kontakt",
      "contactMatch": "Kontakt-Match",
      "created": "Erstellt",
      "email": "E-Mail",
      "employees": "Mitarbeiter",
      "industry": "Branche",
      "linkedin": "LinkedIn",
      "location": "Standort",
      "matching": "Matching",
      "nextSteps": "Nächste Schritte",
      "phone": "Telefon",
      "position": "Position",
      "profile": "Profil",
      "revenue": "Umsatz",
      "source": "Quelle"
    },
    "empty": "Nessun lead trovato",
    "reject": "Ablehnen",
    "rejectPlaceholder": "Grund für die Ablehnung...",
    "rejectTitle": "Lead ablehnen",
    "searchPlaceholder": "Cerca azienda o contatto...",
    "stats": {
      "approved": "Freigegeben",
      "imported": "Importiert",
      "matched": "Gematcht",
      "new": "Neu",
      "rejected": "Abgelehnt",
      "review": "Review",
      "total": "Gesamt"
    },
    "subtitle": "Area di staging per i lead ricercati",
    "table": {
      "companyContact": "Firma / Kontakt",
      "match": "Match",
      "project": "Projekt",
      "score": "Score",
      "status": "Status",
      "type": "Typ"
    },
    "title": "Lead di ricerca",
    "toast": {
      "approveError": "Fehler bei Freigabe",
      "approved": "Lead freigegeben",
      "batchError": "Batch-Matching fehlgeschlagen",
      "deleteError": "Fehler beim Löschen",
      "deleted": "Lead gelöscht",
      "importError": "Import fehlgeschlagen",
      "matchError": "Matching fehlgeschlagen",
      "noMatch": "Kein Match gefunden",
      "rejectError": "Fehler beim Ablehnen",
      "rejected": "Lead abgelehnt"
    }
  },
  "researchPanel": {
    "adoptContacts": "Acquisisci contatti",
    "cardAddContact": "Crea come contatto",
    "cardAddContactHint": "Crea come contatto (presto disponibile)",
    "cardAddOrg": "Crea come organizzazione",
    "cardAddOrgHint": "Crea come organizzazione (presto disponibile)",
    "cardPin": "Fissa",
    "cardPinHint": "Fissa come rilevante (presto disponibile)",
    "cardShowLess": "Mostra meno",
    "cardShowMore": "Mostra altro",
    "connections": "Rete & connessioni",
    "existingCrmCompanies": "Bestehende CRM-Firmen",
    "existingCrmContacts": "Bestehende CRM-Kontakte",
    "foundContacts": "Contatti trovati",
    "merge": "Zusammenführen",
    "mergeButtonEnrich": "Zusammenführen & Ergänzen",
    "mergeButtonLink": "Bestehenden verwenden",
    "mergeCompanyTitle": "Firma zusammenführen",
    "mergeContactTitle": "Kontakt zusammenführen",
    "mergeDraft": "Recherche",
    "mergeError": "Fehler beim Zusammenführen",
    "mergeExisting": "Bestand (CRM)",
    "mergeField": "Feld",
    "mergeLoadError": "Fehler beim Laden des Datensatzes",
    "mergeLoading": "Lade Vergleichsdaten...",
    "mergeSubtitle": "Recherche-Daten mit bestehendem Eintrag abgleichen",
    "mergeWhatHappens": "Was passiert?",
    "internEmpty": "Nessuna corrispondenza CRM interna. La ricerca non ha trovato contatti o organizzazioni esistenti.",
    "noContacts": "Nessun contatto trovato nella ricerca.",
    "overview": "Panoramica",
    "personProfile": "Profilo",
    "pinnedSection": "Fissato ({{count}})",
    "resultsCount": "{{count}} risultato/i",
    "searchingCrm": "Ricerca delle voci CRM esistenti...",
    "tabExtern": "Esterno",
    "tabIntern": "Interno",
    "tabsLabel": "Aree di ricerca",
    "unnamed": "Senza nome",
    "unnamedQuery": "Ricerca",
    "unpin": "Rimuovi pin"
  },
  "roles": {
    "admin": "Amministratore",
    "developer": "Sviluppatore",
    "investor": "Investitore",
    "sales": "Vendite"
  },
  "schema": {
    "columns": "Colonne",
    "primaryKeys": "Chiavi primarie",
    "relationships": "Relazioni",
    "subtitle": "Diagramma delle relazioni tra entità (ERD)",
    "tableList": "Panoramica delle tabelle",
    "tables": "Tabelle",
    "title": "Schema del database"
  },
  "seller": {
    "counts": {
      "bo": "BO",
      "interested": "Interessati",
      "nbo": "NBO",
      "nda": "NDA"
    },
    "detail": {
      "address": "Adresse",
      "aiHints": "KI-Hinweise",
      "allDetails": "Alle Objektdaten",
      "confidence": "KI-Konfidenz",
      "description": "Beschreibung",
      "downloadFailed": "Download fehlgeschlagen",
      "engagement": "Interesse degli investitori",
      "engagementHint": "Le statistiche dettagliate vengono aggiornate costantemente.",
      "grossYield": "Bruttorendite",
      "investmentMetrics": "Investment-Kennzahlen",
      "loadFailed": "Immobilie konnte nicht geladen werden",
      "location": "Standort",
      "noDocuments": "Noch keine Dokumente. Laden Sie relevante Unterlagen hoch (Grundbuchauszug, Mieterspiegel, etc.).",
      "pricePerSqm": "Preis/m²",
      "pricePerSqmLand": "Prezzo/m² terreno",
      "reviewHint": "Non appena tutti i dati sono completi, inviate l'immobile per la verifica. Il nostro team controlla i dati e pubblica l'annuncio.",
      "submitFailed": "Invio non riuscito. Riprovare.",
      "submitReview": "Invia per la verifica",
      "submitTitle": "Pronto per la verifica?",
      "submitting": "Invio in corso…",
      "uploadFailed": "Upload fehlgeschlagen"
    },
    "myProperties": {
      "addProperty": "Invia immobile",
      "clearFilter": "Rimuovi filtro",
      "empty": "Nessun immobile disponibile",
      "emptyHint": "Invia il tuo primo immobile per iniziare",
      "filterActive": "Filtrato per: {{status}}",
      "loadFailed": "Impossibile caricare gli immobili",
      "noResultsForFilter": "Nessun immobile corrisponde a questo filtro",
      "noResultsForFilterHint": "Non ci sono immobili con questo stato.",
      "subtitle": "Panoramica dei tuoi immobili",
      "title": "I miei immobili"
    },
    "wizard": {
      "aiAnalyze": "Avvia analisi IA",
      "aiComplete": "Analisi completata",
      "aiCompleteHint": "I dati rilevati sono stati importati nella procedura guidata. Verificate e completate le informazioni.",
      "aiPrefillSuccess": "Dati importati dall'IA — verificate e completate.",
      "aiPrefilled": "Precompilato dall'IA — verificate",
      "aiProcessing": "L'IA sta analizzando i vostri documenti...",
      "aiProcessingFailed": "Elaborazione IA fallita",
      "aiProcessingWait": "Questo può richiedere 1-2 minuti.",
      "aiSkip": "Continua senza analisi IA",
      "aiUploadDrop": "Trascinate qui documenti PDF o immagini",
      "aiUploadFailed": "Caricamento IA fallito",
      "aiUploadFormats": "PDF, JPG, PNG, WebP — max. 50 MB per file",
      "aiUploadHint": "Caricate i documenti rilevanti: specchio degli affitti attuale, descrizione dell'edificio, estratto del registro fondiario, attestato dell'assicurazione stabili, stime del valore di mercato (Wüest Partner, Fahrländer ecc.) — l'IA compilerà automaticamente la procedura guidata.",
      "classificationHint": "Selezionate il tipo e l'eventuale sottotipo del vostro immobile.",
      "contractDeadlineHint": "Nota bene: Il contratto ha una data di scadenza. Pianificate tempo sufficiente per la transazione.",
      "create": "Invia immobile",
      "createFailed": "Impossibile inviare l'immobile",
      "createSuccess": "Immobile inviato con successo",
      "desiredPrice": "Prezzo desiderato / Prezzo indicativo",
      "desiredPriceHint": "Il vostro prezzo desiderato — non vincolante, non pubblicato",
      "desiredPricePlaceholder": "es. 1'800'000",
      "desiredTimeline": "Tempistica desiderata",
      "desiredTimelineHint": "Quando desiderate idealmente vendere?",
      "desiredTimelinePlaceholder": "es. Vendita entro Q3 2026, flessibile da subito",
      "expectedPrice": "Prezzo previsto",
      "highlights": "Punti di forza",
      "highlightsHint": "Questi punti appaiono in evidenza nel teaser per gli investitori.",
      "highlightsPlaceholder": "es. Posizione top a Zurigo, appena ristrutturato, completamente affittato, rendimento stabile...",
      "imagesCount": "immagini",
      "namePlaceholder": "es. Appartamento Zurigo-Seefeld",
      "photosFormats": "JPG, PNG, WEBP — max. 20 MB per immagine",
      "photosHint": "Buone foto vendono! Caricate foto significative del vostro immobile.",
      "photosUpload": "Trascina le foto qui o clicca",
      "primaryImage": "Immagine principale",
      "saleEndDate": "Fine vendita desiderata",
      "saleStartDate": "Inizio vendita desiderato",
      "sellerNotes": "Note",
      "sellerNotesPlaceholder": "es. Circostanze particolari, durata del contratto, condizioni desiderate...",
      "steps": {
        "aiUpload": "Analisi IA",
        "classification": "Tipo di oggetto",
        "details": "Dati oggetto",
        "photos": "Foto",
        "pricing": "Dati chiave",
        "summary": "Riepilogo",
        "titleAddress": "Titolo & Indirizzo"
      },
      "subtitle": "Inserisci i dettagli del tuo immobile",
      "summaryHint": "Controlla i dati prima dell'invio",
      "timeline": "Periodo",
      "title": "Invia immobile"
    }
  },
  "settings": {
    "ai": "Assistente IA",
    "aiConfig": {
      "configured": "Configurato",
      "currentKey": "Chiave attuale",
      "enterKey": "Inserisci la chiave API",
      "notConfigured": "Non configurato",
      "replaceKey": "Sostituisci chiave API",
      "saveFailed": "Errore durante il salvataggio",
      "saved": "Chiave API salvata",
      "setKey": "Imposta chiave API",
      "status": "Stato",
      "testConnection": "Testa connessione",
      "testFailed": "Connessione fallita",
      "testSuccess": "Connessione riuscita ({{model}}, {{duration}}s)",
      "testing": "Test...",
      "title": "Claude AI"
    },
    "aiDescription": "Ambiente di test Claude AI",
    "apiTokens": {
      "confirmRevoke": "Revocare davvero?",
      "create": "Nuovo token",
      "createError": "Impossibile creare il token.",
      "createdTitle": "Token creato con successo",
      "createdWarning": "Copia il token ora — non verrà più visualizzato.",
      "description": "Crea token API persistenti per l'autenticazione machine-to-machine e i test E2E.",
      "dismiss": "Capito, chiudi",
      "empty": "Nessun token API creato.",
      "expiresAt": "Scade il",
      "generate": "Genera",
      "nameLabel": "Nome del token",
      "namePlaceholder": "es. Pipeline CI/CD, Test E2E",
      "revoke": "Revoca",
      "revokeError": "Impossibile revocare il token.",
      "revoked": "Token revocato",
      "tabLabel": "Token API",
      "title": "Token API"
    },
    "commissions": "Modelli di onorario",
    "commissionsDescription": "Creare e gestire i modelli di onorario",
    "displayMode": "Modalità",
    "e2e": {
      "autoGenerated": "Der Report wird automatisch nach jedem E2E-Testlauf generiert.",
      "duration": "Dauer",
      "environment": "Umgebung",
      "failed": "Fehlgeschlagen",
      "generated": "Generiert",
      "loadError": "E2E-Report konnte nicht geladen werden.",
      "noReport": "Kein E2E-Report verfügbar. Starte die Tests mit: npx playwright test",
      "passed": "Bestanden",
      "refresh": "Aktualisieren",
      "subtitle": "Ergebnisse der automatisierten Browser-Tests",
      "title": "E2E Test Reports"
    },
    "investorGroups": "Gruppi di investitori",
    "investorGroupsDescription": "Raggruppare investitori e gestire gli accessi",
    "kycReview": "Verificare le identificazioni",
    "mandanten": "Gestione mandanti",
    "mandantenDescription": "Gestisci utenti e assegnazioni aziendali",
    "media": "Media",
    "mediaDescription": "Gestisci immagini e file multimediali",
    "processVis": {
      "finale": {
        "duration": "Gesamtdauer: 6–12 Monate",
        "subtitle": "Transparenz, Effizienz und Professionalität — für Verkäufer und Investoren gleichermassen.",
        "title": "Deal abgeschlossen."
      },
      "hero": {
        "platform": "Immotron Plattform",
        "scrollHint": "Scroll für den Prozess",
        "subtitle": "Vom ersten Kontakt bis zum Closing — 14 Schritte, 3 Akteure, 1 Plattform.",
        "titleLine1": "Der Weg zum",
        "titleLine2": "erfolgreichen Deal"
      },
      "personas": {
        "employee": "Mitarbeiter",
        "investor": "Investor",
        "vendor": "Verkäufer"
      },
      "scrollMore": "Scroll weiter"
    },
    "processes": "Panoramica processi",
    "processesDescription": "Visualizzazione interattiva dei 3 processi principali",
    "schema": "Schema database",
    "schemaDescription": "Visualizza diagramma delle relazioni",
    "signatories": "Firmatari",
    "signatoriesDescription": "Gestisci i firmatari autorizzati interni",
    "subtitle": "Configurazione e gestione del sistema",
    "system": "Sistema",
    "systemDescription": "Personalizza aspetto e schema colori",
    "theme": {
      "preset": "Schema colori",
      "presets": {
        "default-blue": "Blu predefinito",
        "immotron-red": "Immotron Rosso"
      },
      "preview": "Anteprima",
      "saved": "Schema colori salvato",
      "title": "Aspetto"
    },
    "title": "Impostazioni",
    "users": "Gestione utenti",
    "usersDescription": "Crea, modifica e gestisci gli utenti",
    "regulatedWhitelist": "Elenchi di vigilanza",
    "regulatedWhitelistDescription": "Importare gli elenchi delle controparti vigilate e verificare le corrispondenze",
    "zefixSync": "Zefix Sync",
    "zefixSyncDescription": "Gestisci la sincronizzazione con il registro di commercio",
    "e2eReports": "E2E Tests",
    "e2eReportsDescription": "Automatisierte Browser-Tests und Ergebnisse",
    "aiBalances": {
      "title": "API-Kontostände",
      "monthCost": "Monat",
      "calls": "Aufrufe"
    },
    "profile": "Profil"
  },
  "signatories": {
    "addSignatory": "Aggiungi firmatario",
    "addSuccess": "Firmatario aggiunto con successo",
    "confirmRemove": "Sei sicuro di voler rimuovere questa associazione?",
    "editSignatory": "Modifica firmatario",
    "function": "Funzione",
    "noInternalCompanies": "Nessuna azienda interna disponibile",
    "noSignatories": "Nessun firmatario assegnato",
    "removeSignatory": "Rimuovi firmatario",
    "removeSuccess": "Firmatario rimosso con successo",
    "selectContact": "Seleziona contatto",
    "signatureText": "Testo della firma",
    "signatureType": "Potere di firma",
    "subtitle": "Gestisci i firmatari autorizzati delle aziende interne",
    "title": "Firmatari interni",
    "updateSuccess": "Firmatario aggiornato con successo"
  },
  "signature": {
    "collectiveMore": "Firma collettiva a più",
    "collectiveTwo": "Firma collettiva a due",
    "none": "Nessuna",
    "single": "Firma individuale"
  },
  "signaturePad": {
    "handoff": {
      "close": "Chiudi",
      "done": "Firma acquisita ✓",
      "doneHint": "La firma si trova ora nel campo. Invii qui dal computer.",
      "expired": "Il codice è scaduto.",
      "failed": "Non è stato possibile generare il codice.",
      "lead": "Scansioni il codice con la fotocamera del cellulare e firmi lì. Il codice è valido {{minutes}} minuti.",
      "open": "Firmare su cellulare o tablet",
      "qrAlt": "Codice QR per la firma sul cellulare",
      "regenerate": "Genera un nuovo codice",
      "remaining": "Codice valido ancora {{time}}",
      "retry": "Riprova",
      "title": "Firmare sul cellulare",
      "waiting": "In attesa della firma dal cellulare …"
    },
    "mobile": {
      "doneText": "Può tornare al computer.",
      "doneTitle": "Firma acquisita ✓",
      "error": "Non è stato possibile acquisire la firma. Riprovi.",
      "expired": "Il codice è scaduto. Ne generi uno nuovo sul computer.",
      "invalid": "Il codice non è valido.",
      "lead": "Firmi qui con il dito. Poi può proseguire sul computer.",
      "loading": "Un momento, stiamo aprendo il campo firma …",
      "padLabel": "La sua firma",
      "submit": "Acquisisci",
      "title": "Firmare",
      "used": "Qui è già stata apposta una firma."
    }
  },
  "subTaskTabs": {
    "ariaLabel": "Schede sotto-attività",
    "create": "Nuova sotto-attività",
    "createAriaLabel": "Crea nuova sotto-attività",
    "defaultTitle": "Nuova sotto-attività",
    "discardAriaLabel": "Scarta sotto-attività",
    "discardConfirm": "Scartare la sotto-attività con contenuto? Questa azione non può essere annullata.",
    "discardError": "Impossibile scartare la sotto-attività",
    "discarded": "Sotto-attività scartata",
    "loading": "Caricamento sotto-attività...",
    "mainFallback": "Attività principale",
    "untitled": "Senza titolo"
  },
  "tasks": {
    "actions": {
      "action": "Aktion",
      "apply": "Übernehmen",
      "backToOverview": "Zurück zur Übersicht...",
      "callNote": "Anruf-Notiz",
      "dashMeansEmpty": "— = bisher leer",
      "dataWillBeAdded": "Folgende Daten werden ergänzt:",
      "description": "Beschreibung",
      "dismiss": "Verwerfen",
      "executed": "Aktion ausgeführt!",
      "meetingNote": "Meeting-Notiz",
      "noteLabel": "Notiz",
      "noteWillBeCreated": "Folgende Notiz wird erstellt:",
      "phone": "Telefon",
      "subject": "Betreff",
      "subtaskWillBeCreated": "Folgende Sub-Pendenz wird erstellt:",
      "title": "Titel"
    },
    "addAttachment": "Aggiungi",
    "addDescription": "Nota",
    "aiApply": "Applica",
    "aiSuggestion": "Suggerimento IA",
    "attachments": "Allegati",
    "clickToEdit": "Klick zum Bearbeiten",
    "completed": "erledigt",
    "context": "Kontext",
    "createSuccess": "Attività creata",
    "delete": "Elimina",
    "deleteConfirm": "Eliminare questa attività?",
    "deleteSuccess": "Attività eliminata",
    "descriptionPlaceholder": "Aggiungi una nota...",
    "done": "Erledigt",
    "editTask": "Modifica attività",
    "errors": {
      "deleteFailed": "L'attività non può essere eliminata",
      "downloadFailed": "Download non riuscito",
      "loadFailed": "Le attività non possono essere caricate",
      "titleSaveFailed": "Titel konnte nicht gespeichert werden",
      "updateFailed": "Lo stato non può essere modificato",
      "uploadFailed": "Caricamento non riuscito"
    },
    "fields": {
      "assignedTo": "Assegnato a",
      "attachments": "Anhänge",
      "company": "Azienda",
      "completedAt": "Erledigt",
      "contact": "Contatto",
      "createdAt": "Creato il",
      "createdBy": "Creato da",
      "description": "Descrizione",
      "dueDate": "Scadenza",
      "listing": "Inserzione",
      "priority": "Priorità",
      "property": "Immobile",
      "status": "Stato",
      "title": "Titolo",
      "unassigned": "Nicht zugewiesen",
      "visibility": "Sichtbarkeit",
      "descriptionPlaceholder": "Beschreibung hinzufügen..."
    },
    "goal": {
      "label": "Obiettivo",
      "prompt": "Qual è il tuo obiettivo per questa pendenza?",
      "hint": "L'obiettivo guida l'agente in tutte le azioni.",
      "placeholder": "es. Contattare il cliente e fissare un sopralluogo",
      "edit": "Modifica obiettivo",
      "remove": "Rimuovi obiettivo",
      "removed": "Obiettivo rimosso",
      "saved": "Obiettivo salvato",
      "saveFailed": "Impossibile salvare l'obiettivo",
      "shortcut": "Cmd/Ctrl + Invio per salvare",
      "setAriaLabel": "Imposta obiettivo per questa pendenza",
      "chips": {
        "contact": "Contatto",
        "company": "Azienda",
        "property": "Immobile",
        "listing": "Annuncio",
        "campaign": "Campagna",
        "teaser": "Teaser",
        "removeAriaLabel": "Rimuovi {{label}}"
      },
      "contextEmpty": "Nessun contesto collegato",
      "createTask": "Crea pendenza dall'obiettivo",
      "createTaskSuccess": "Pendenza creata dall'obiettivo",
      "createTaskFailed": "Impossibile creare la pendenza",
      "editClick": "Clicca per modificare",
      "stats": {
        "chunks_one": "{{count}} nota",
        "chunks_other": "{{count}} note",
        "chunksTooltip": "Note collegate a questa pendenza",
        "pins_one": "{{count}} nota",
        "pins_other": "{{count}} note",
        "pinsTooltip": "Risposte chat appuntate come note"
      }
    },
    "groups": {
      "completed": "Completato",
      "later": "Più tardi",
      "overdue": "In ritardo",
      "thisWeek": "Questa settimana",
      "today": "Oggi"
    },
    "linkedCompany": "Azienda",
    "linkedContact": "Contatto",
    "lock": {
      "inProgress": "In corso",
      "inputDisabled": "Inserimento bloccato — l'attività è in lavorazione da qualcun altro",
      "readOnlyBanner": "In lavorazione da {{name}} — solo visualizzazione",
      "unknownUser": "un altro utente"
    },
    "markDone": "Segna come completato",
    "newTask": "Nuova attività",
    "noAttachments": "Nessun allegato",
    "noTasks": "Nessuna attività trovata",
    "noTasksHint": "Crea una nuova attività con il pulsante sopra.",
    "open": "Offen",
    "overview": {
      "email": "Email",
      "emails": "E-mail",
      "emailNoSubject": "Senza oggetto",
      "emailStatusDraft": "Bozza",
      "emailStatusSent": "Inviata",
      "enrich": "Arricchisci",
      "note": "Nota",
      "quickActions": "Azioni rapide",
      "removePin": "Rimuovi pin",
      "searchCommercialRegister": "Cerca nel registro di commercio",
      "propertyResidential": "Resid.",
      "propertyCommercial": "Comm.",
      "propertyLot": "Lotto",
      "propertyFloors": "Piani",
      "propertyYear": "Anno",
      "propertyOpen": "Apri immobile",
      "propertyLoading": "Caricamento immobile...",
      "propertyDocuments": "Documenti",
      "propertyDocsLoading": "Caricamento documenti...",
      "propertyImages": "Immagini",
      "propertyImagesShowAll": "Mostra tutte ({{count}})",
      "propertyImagesShowLess": "Mostra meno",
      "attachToEmail": "Allega all'e-mail",
      "attachToEmailShort": "All'e-mail",
      "docAttached": "{{name}} allegato all'e-mail",
      "docAttachedShort": "Allegato",
      "emailDiscard": "Scarta bozza",
      "emailArchive": "Archivia e-mail",
      "emailUnarchive": "Ripristina",
      "emailDiscarded": "Bozza scartata",
      "emailUndo": "Annulla",
      "emailArchivedToast": "E-mail archiviata",
      "emailUnarchivedToast": "E-mail ripristinata",
      "emailArchivedSection": "Archiviate ({{count}})",
      "emailSentOn": "Inviata il {{date}}",
      "emailsAllArchived": "Tutte le e-mail archiviate"
    },
    "compactHeader": {
      "addContact": "+ Contatto",
      "addCompany": "+ Azienda",
      "addProperty": "+ Immobile",
      "removeContact": "Rimuovi contatto",
      "removeCompany": "Rimuovi azienda",
      "removeProperty": "Rimuovi immobile",
      "removeContactFailed": "Impossibile rimuovere il contatto",
      "removeCompanyFailed": "Impossibile rimuovere l'azienda",
      "removeFailed": "Impossibile rimuovere il collegamento",
      "attachContactFailed": "Impossibile collegare il contatto",
      "attachCompanyFailed": "Impossibile collegare l'azienda",
      "attachFailed": "Impossibile collegare l'immobile",
      "details": "Dettagli / Modifica"
    },
    "priority": {
      "HIGH": "Alto",
      "LOW": "Basso",
      "MEDIUM": "Medio",
      "URGENT": "Urgente"
    },
    "private": "Privato",
    "public": "Pubblico",
    "quickAdd": "Aggiunta rapida",
    "reopen": "Riaprire",
    "resetChat": "Chat zurücksetzen",
    "search": {
      "placeholder": "Cerca pendenze — nome, e-mail, telefono, azienda, immobile...",
      "aria": "Ricerca testuale nelle pendenze",
      "clear": "Cancella ricerca",
      "noResults": "Nessun risultato",
      "noResultsHint": "Nessuna pendenza trovata per «{{query}}»."
    },
    "smartCreate": {
      "hint": "Qual è il tuo obiettivo? Descrivi la pendenza — aziende, contatti e immobili vengono riconosciuti automaticamente.",
      "placeholder": "es. \"E-mail di vendita al CEO di Mansory per l'Industriestrasse 11 a Dielsdorf\"",
      "analyzing": "Analisi in corso...",
      "proposalTitle": "Proposta",
      "steps": "passi",
      "manual": "Crea manualmente",
      "smartMode": "Modalità Smart",
      "adjust": "Modifica",
      "create": "Crea",
      "error": "Analisi fallita",
      "goalPrefix": "Obiettivo"
    },
    "sort": {
      "createdAt": "Data di creazione",
      "dueDate": "Data di scadenza",
      "priority": "Priorità",
      "title": "Titolo"
    },
    "stats": {
      "done": "Completato",
      "inProgress": "In corso",
      "open": "Aperto",
      "overdue": "In ritardo",
      "total": "Totale"
    },
    "status": {
      "CANCELLED": "Annullato",
      "DONE": "Completato",
      "IN_PROGRESS": "In corso",
      "OPEN": "Aperto",
      "cancelled": "Abgebrochen",
      "done": "Erledigt",
      "inProgress": "In Bearbeitung",
      "open": "Offen"
    },
    "statuses": {
      "CANCELLED": "Abgebrochen",
      "DONE": "Erledigt",
      "IN_PROGRESS": "In Arbeit",
      "OPEN": "Offen"
    },
    "subtasks": {
      "create": "Crea sotto-attività",
      "done": "completato",
      "empty": "Nessuna sotto-attività",
      "progress": "Fortschritt",
      "short": "Sotto",
      "title": "Sub-Pendenzen"
    },
    "subtitle": "Gestisci attività e pendenze",
    "title": "Attività",
    "updateSuccess": "Attività aggiornata",
    "widget": {
      "empty": "Nessuna attività aperta",
      "showAll": "Mostra tutto",
      "title": "Le mie attività"
    },
    "workflow": {
      "customize": "Anpassen",
      "dismiss": "Ignorieren",
      "exit": "Workflow verlassen",
      "exitShort": "Verlassen",
      "start": "Workflow starten"
    },
    "saveError": "Speichern fehlgeschlagen",
    "deleteError": "Löschen fehlgeschlagen",
    "purge": "Elimina definitivamente",
    "purging": "Eliminazione definitiva …",
    "purged": "Pendenza eliminata definitivamente",
    "purgeError": "Eliminazione definitiva non riuscita",
    "purgeForbidden": "Nessuna autorizzazione: solo un amministratore o il creatore può eliminare definitivamente questa pendenza.",
    "purgeNotFound": "Pendenza non trovata — potrebbe essere già stata eliminata.",
    "purgeConfirmTitle": "Eliminare definitivamente la pendenza?",
    "purgeConfirmDescription": "Questa azione è irreversibile. Chat, cronologia, elementi di conoscenza e TUTTE le sotto-pendenze verranno rimossi completamente e in modo permanente. A differenza dell'eliminazione normale, non è possibile alcun ripristino.",
    "purgeConfirmButton": "Elimina definitivamente",
    "purgeHint": "Irreversibile – senza cestino, non ripristinabile.",
    "uploadError": "Upload fehlgeschlagen",
    "deleteAttachmentError": "Anhang löschen fehlgeschlagen",
    "toggleError": "Status ändern fehlgeschlagen",
    "saved": "Pendenz gespeichert",
    "deleted": "Pendenz gelöscht",
    "deleting": "Löschen...",
    "searchProperty": "Immobilie suchen...",
    "noPropertiesFound": "Keine Immobilien gefunden"
  },
  "teaser": {
    "salesContact": "Contatto commerciale"
  },
  "teaserCard": {
    "accessGranted": "Accesso concesso",
    "clubDeal": "Club Deal",
    "noAccess": "Nessun accesso",
    "priceLocked": "Prezzo dopo NDA",
    "yieldLocked": "Rendimento dopo NDA"
  },
  "timeline": {
    "activities": "Attività",
    "activityCreated": "Attività creata",
    "addCall": "Registra chiamata",
    "addMeeting": "Registra riunione",
    "addNote": "Aggiungi nota",
    "all": "Tutti",
    "createContact": "Crea contatto",
    "createContactFor": "Crea contatto per {{name}}",
    "descriptionPlaceholder": "Dettagli (opzionale)...",
    "dueDate": "Scadenza",
    "durationPlaceholder": "Durata in minuti",
    "emailFrom": "Da:",
    "emailHasAttachments": "Allegato",
    "emailInbound": "Ricevuta",
    "emailOutbound": "Inviata",
    "emailTo": "A:",
    "emails": "E-mail",
    "empty": "Nessuna voce",
    "entries": "voci",
    "handledBy": "gestito da {{name}}",
    "mailbox": "Casella {{label}}",
    "mailboxPersonal": "Casella personale",
    "mailboxShared": "Casella condivisa",
    "newCall": "Registra chiamata",
    "newMeeting": "Registra riunione",
    "newNote": "Nuova nota",
    "subjectPlaceholder": "Oggetto...",
    "tasks": "Compiti",
    "thread": {
      "label": "Conversazione",
      "last": "ultima {{date}}",
      "mails": "{{n}} e-mail",
      "moreContacts": "+{{n}}",
      "noSubject": "(Nessun oggetto)",
      "participantsLabel": "Partecipanti:",
      "unknownParticipant": "Sconosciuto"
    },
    "title": "Cronologia",
    "unanswered": "senza risposta",
    "activity": "Attività",
    "activity_one": "{{count}} attività",
    "activity_other": "{{count}} attività",
    "daysLeft_one": "Ancora 1 giorno",
    "daysLeft_other": "Ancora {{count}} giorni",
    "endsToday": "Termina oggi!",
    "today": "Oggi",
    "lastHours": "Ultime {{count}} ore — {{phase}} termina presto!",
    "onlyDaysLeft": "Ancora {{count}} giorni — {{phase}} termina presto!",
    "phases": {
      "marketing": "Commercializzazione esclusiva",
      "nbo": "Tornata di offerte",
      "evaluation": "Valutazione",
      "bo": "Tornata finale",
      "closing": "Chiusura",
      "sale": "Venduto"
    }
  },
  "users": {
    "addCompany": "Aggiungi azienda",
    "addUser": "Aggiungi utente",
    "allRoles": "Tutti i ruoli",
    "allStatuses": "Tutti gli stati",
    "companyAdded": "Azienda aggiunta con successo",
    "companyRemoved": "Associazione rimossa",
    "companyRoles": "Associazioni aziendali",
    "companyUpdated": "Associazione aggiornata",
    "confirmDelete": "Sei sicuro di voler eliminare questo utente?",
    "confirmRemoveCompany": "Sei sicuro di voler rimuovere questa associazione?",
    "contact": "Contatto collegato",
    "createGroupDescLabel": "Descrizione (facoltativo)",
    "createGroupFromSelection": "Crea gruppo",
    "createGroupNameLabel": "Nome del gruppo",
    "createGroupSuccess": "Gruppo «{{name}}» creato con {{count}} investitori",
    "createGroupTitle": "Crea gruppo di investitori",
    "createSuccess": "Utente creato con successo",
    "createdAt": "Creato il",
    "creatingFromContact": "Creazione utente dal contatto «{{name}}». Verrà collegato automaticamente.",
    "deleteSuccess": "Utente eliminato con successo",
    "deleteUser": "Elimina utente",
    "editUser": "Modifica utente",
    "email": "Email",
    "emailExists": "Indirizzo email già in uso",
    "firstName": "Nome",
    "function": "Funzione",
    "isActive": "Attivo",
    "lastLogin": "Ultimo accesso",
    "lastName": "Cognome",
    "noContact": "Nessun contatto collegato",
    "noInvestorsSelected": "Nessun investitore nella selezione",
    "password": "Password",
    "passwordReset": "Reimpostazione password",
    "passwordResetHint": "Invia un link di reimpostazione via email",
    "removeContact": "Rimuovi collegamento",
    "resetLinkCopied": "Link di reimpostazione copiato negli appunti",
    "resetSent": "Link di reimpostazione inviato via email",
    "resultsLabel": "Utenti",
    "role": "Ruolo",
    "saveSuccess": "Utente salvato con successo",
    "searchContacts": "Cerca contatto...",
    "selectContact": "Seleziona contatto",
    "selectedCount": "{{count}} selezionato/i",
    "sendReset": "Invia reimpostazione",
    "signatureType": "Potere di firma",
    "status": "Stato",
    "title": "Gestione utenti",
    "updateSuccess": "Utente aggiornato con successo"
  },
  "validation": {
    "email": "Inserisci un indirizzo email valido",
    "maxLength": "Massimo {{max}} caratteri consentiti",
    "minLength": "Almeno {{min}} caratteri richiesti",
    "passwordMismatch": "Le password non corrispondono",
    "required": "Questo campo è obbligatorio"
  },
  "regulatedWhitelist": {
    "category": {
      "LISTED": "Quotata",
      "PUBLIC_LAW": "Diritto pubblico",
      "REGULATED": "Vigilata"
    },
    "columnCategory": "Categoria",
    "columnCompany": "Azienda",
    "columnCount": "Voci",
    "columnDate": "Data",
    "columnEntry": "Voce dell'elenco",
    "columnLastImport": "Ultimo import",
    "columnList": "Elenco",
    "columnMatch": "Corrispondenza",
    "confirm": "Conferma",
    "confirmFailed": "Conferma non riuscita.",
    "confirmSuccess": "Azienda confermata come controparte vigilata.",
    "forbidden": "Nessuna autorizzazione — questa pagina è riservata agli amministratori.",
    "hint": "Le corrispondenze IDI vengono confermate automaticamente durante l'esecuzione mensile. Le corrispondenze per nome vanno verificate qui. Casse pensioni aziendali senza voce nell'elenco: autodichiarazione nel profilo dell'azienda.",
    "importBtn": "Importa ora gli elenchi",
    "importFailed": "Import non riuscito.",
    "importListError": "Elenco {{list}}: {{error}}",
    "importSuccess": "Import completato: {{created}} nuove, {{updated}} aggiornate, {{removed}} rimosse.",
    "listsEmpty": "Nessun elenco importato finora.",
    "listsTitle": "Elenchi importati",
    "matchRunBtn": "Avvia confronto",
    "matchRunFailed": "Confronto non riuscito.",
    "matchRunSuccess": "Confronto completato: {{confirmed}} confermate automaticamente, {{pending}} da verificare, {{stale}} obsolete.",
    "matchType": {
      "name_exact": "Nome esatto",
      "name_fuzzy": "Nome approssimativo",
      "uid": "IDI"
    },
    "never": "Mai",
    "noMatches": "Nessuna voce in questa vista.",
    "queueTitle": "Corrispondenze da verificare",
    "reject": "Rifiuta",
    "rejectFailed": "Rifiuto non riuscito.",
    "rejectSuccess": "Corrispondenza rifiutata.",
    "staleHint": "Voce dell'elenco non più presente — verificare manualmente lo stato dell'azienda.",
    "subtitle": "Controparti vigilate (FINMA, SIX, CAV PP): importare gli elenchi e verificare le corrispondenze.",
    "tabs": {
      "CONFIRMED": "Confermate",
      "PENDING": "Aperte",
      "REJECTED": "Rifiutate",
      "STALE": "Obsolete"
    },
    "title": "Elenchi di vigilanza"
  },
  "zefixSync": {
    "companies": "Organizzazioni",
    "companiesProcessed": "aziende elaborate",
    "configFailed": "La configurazione Zefix non e riuscita.",
    "configSaved": "Configurazione salvata",
    "configuration": "Configurazione",
    "duration": "Durata",
    "errors": "Errori",
    "history": "Cronologia",
    "interval": "Intervallo",
    "lastRun": "Ultimo avvio",
    "mockModeWarning": "Modalità simulazione attiva — nessun dato Zefix reale viene recuperato",
    "noLogs": "Nessuna sincronizzazione effettuata",
    "rateLimit": "Limite di velocità",
    "result": "Risultato",
    "running": "Sincronizzazione in corso...",
    "startedAt": "Avviato",
    "status": {
      "completed": "Completato",
      "failed": "Fallito",
      "running": "In corso"
    },
    "subtitle": "Sincronizzazione automatica con il registro di commercio",
    "syncFailed": "La sincronizzazione Zefix non e riuscita.",
    "syncStarted": "Sincronizzazione Zefix avviata.",
    "title": "Zefix Sync",
    "trigger": "Trigger",
    "triggerManual": "Manuale",
    "triggerScheduler": "Automatico",
    "triggerSync": "Avvia sincronizzazione",
    "revert": "Annulla",
    "revertTitle": "Annulla sincronizzazione",
    "revertConfirm": "{{added}} contatti aggiunti e {{updated}} contatti aggiornati verranno ripristinati. Continuare?",
    "revertFailed": "Annullamento non riuscito"
  },
  "research": {
    "applyFailed": "Applicazione non riuscita",
    "proposalTitle": "Proposta di ricerca",
    "new": "nuovo",
    "changed": "modificato",
    "selectAll": "Tutti",
    "selectOnlyNew": "Solo nuovi",
    "field": "Campo",
    "currentValue": "Attuale (CRM)",
    "proposedValue": "Proposta (ricerca)",
    "applyHtmlReport": "Applica il report HTML",
    "applyKeyPersons": "Sincronizza i contatti",
    "applySelected": "Applica",
    "applied": "{{count}} campi applicati"
  },
  "researchCard": {
    "location": "Sede"
  },
  "emailTemplatePicker": {
    "uncategorized": "Allgemein",
    "loading": "Vorlagen laden...",
    "noTemplate": "Ohne Vorlage",
    "preview": "Vorschau"
  },
  "softDelete": {
    "showDeleted": "Mostra eliminati",
    "archived": "Archiviato",
    "restore": "Ripristina",
    "restoreSuccess": "Ripristinato con successo"
  },
  "unifiedProcess": {
    "heading": {
      "create": "Crea nuovo immobile",
      "edit": "Modifica immobile — {{name}}",
      "editStatic": "Modifica immobile",
      "untitled": "Immobile senza titolo"
    },
    "loadError": "Impossibile caricare l'immobile",
    "tabsAriaLabel": "Schede di modifica",
    "skeletonNote": "Questa scheda verrà compilata in un passo successivo.",
    "tabs": {
      "ai": "Acquisizione IA",
      "object": "Oggetto",
      "location": "Ubicazione",
      "pricing": "Prezzo e affitto",
      "media": "Media e testi",
      "review": "Mandato e commercializzazione",
      "protocol": "Registro estrazione IA",
      "knowledge": "Conoscenza",
      "aiInsights": "Note IA"
    },
    "tabHints": {
      "ai": "Carica documenti — l'IA estrae i campi automaticamente.",
      "object": "Superfici, locali, condizioni e classi energetiche.",
      "location": "Mappa, dati del registro degli edifici (REE) e restrizioni ambientali.",
      "pricing": "Prezzo di offerta, tipo di mandato e condizioni.",
      "media": "Immagini, tour virtuale, punti forti e descrizioni.",
      "review": "Mandante, configurazione vendite e quality gate.",
      "protocol": "Panoramica di tutti i job di estrazione IA per questo immobile.",
      "knowledge": "Note fissate su questo immobile dalle pendenze."
    },
    "protocol": {
      "title": "Registro estrazione IA",
      "subtitle": "Panoramica di tutti i job IA che hanno fornito dati per questo immobile.",
      "empty": "Nessuna estrazione IA per questo immobile.",
      "loadFailed": "Impossibile caricare il registro di estrazione.",
      "jobLabel": "Job #{{id}}",
      "confidenceLabel": "Confidenza:",
      "kpi": {
        "confidence": "Confidenza",
        "documents": "Documenti",
        "images": "Immagini",
        "fields": "Campi",
        "tokens": "Token"
      },
      "documents": {
        "title": "Classificazione dei documenti"
      },
      "location": {
        "title": "Dati di localizzazione",
        "summary": "{{found}} di {{total}} rilevati",
        "fields": {
          "address": "Indirizzo",
          "zip": "CAP",
          "city": "Località",
          "municipality": "Comune",
          "canton": "Cantone",
          "country": "Paese",
          "coordinates": "Coordinate"
        }
      },
      "fields": {
        "title": "Campi rilevati ({{count}})"
      },
      "images": {
        "title": "Classificazione delle immagini",
        "summary": "{{kept}} di {{total}} immagini mantenute"
      },
      "coverage": {
        "title": "Copertura dei dati",
        "summary": "{{found}} di {{total}} campi rilevati ({{pct}}%)",
        "found": "Rilevato",
        "missing": "Mancante",
        "none": "Nessuna voce"
      },
      "warnings": {
        "title": "{{count}} avviso/i"
      },
      "technical": {
        "title": "Dettagli tecnici"
      }
    },
    "location": {
      "readOnlyHint": "Tutti i dati sono compilati automaticamente — tramite caricamento IA o inserimento dell'indirizzo. Non è possibile modificarli direttamente qui.",
      "notAvailable": "non disponibile",
      "sections": {
        "basics": "Dati di ubicazione",
        "energy": "Energia e ambiente",
        "gwr": "Registro degli edifici (REE)",
        "taxLaw": "Fisco e diritto",
        "environment": "Ambiente e restrizioni"
      },
      "fields": {
        "map": "Mappa",
        "municipality": "Comune",
        "inhabitants": "Abitanti",
        "coordinates": "Coordinate (lat / lon)",
        "zoneType": "Zona edificabile",
        "zoneRegulations": "Regolamento di zona",
        "egid": "EGID (identificatore edificio)",
        "egrid": "EGRID (identificatore particella)",
        "constructionYear": "Anno di costruzione (registro)",
        "noiseSensitivity": "Grado di sensibilità al rumore (GS)",
        "groundwaterZone": "Zona di protezione delle acque sotterranee",
        "naturalHazard": "Pericoli naturali",
        "floodRisk": "Zona a rischio di inondazione",
        "earthquakeZone": "Zona sismica",
        "contaminatedSite": "Sito contaminato",
        "heritageProtection": "Protezione del patrimonio",
        "co2Emissions": "Emissioni di CO₂ (edificio)",
        "minergie": "Certificato Minergie",
        "solarPotential": "Potenziale solare (tetto)",
        "taxRateMunicipality": "Aliquota fiscale comunale",
        "taxRateCanton": "Aliquota fiscale cantonale",
        "taxRateMunicipalityLegal": "Aliquota fiscale comunale (persone giuridiche)",
        "taxRateCantonLegal": "Aliquota fiscale cantonale (persone giuridiche)",
        "zoning": "Zona di utilizzo (comunale + cantonale)",
        "bauzone": "Zona edificabile (categoria)",
        "oevQuality": "Qualità del servizio TP",
        "noiseDb": "Rumore stradale (giorno, dB)"
      },
      "taxRateValue": "Reddito: {{income}} · Patrimonio: {{wealth}}",
      "taxRateLegalValue": "Utile: {{profit}} · Capitale: {{capital}}",
      "tooltip": {
        "showDetails": "Mostra dettagli",
        "rawValue": "Valore originale: {{raw}}"
      },
      "noiseClassify": {
        "es1": {
          "label": "Zona di quiete (GS I)",
          "description": "Area ricreativa. Limiti di rumore più severi — ideale per usi sensibili al rumore come ospedali o scuole."
        },
        "es2": {
          "label": "Zona residenziale (GS II)",
          "description": "Aree puramente residenziali. Buona protezione dal rumore — uso residenziale standard senza restrizioni."
        },
        "es3": {
          "label": "Zona mista (GS III)",
          "description": "Residenziale mista con attività moderatamente disturbanti. Possibile rumore commerciale — di solito accettabile per l'abitare."
        },
        "es4": {
          "label": "Zona industriale (GS IV)",
          "description": "Attività molto disturbanti / industria. Scarsa protezione dal rumore — non adatta a uso puramente residenziale."
        },
        "db_quiet": {
          "label": "Molto tranquillo (<45 dB)",
          "description": "Posizione rurale, nessun rumore di traffico. Ambiente abitativo ideale."
        },
        "db_calm": {
          "label": "Tranquillo (45–54 dB)",
          "description": "Situazione residenziale normale, rumore di fondo basso."
        },
        "db_moderate": {
          "label": "Moderato (55–64 dB)",
          "description": "Percepibile — consigliato tenere le finestre chiuse di notte."
        },
        "db_loud": {
          "label": "Rumoroso (65–74 dB)",
          "description": "Strada principale o vicinanza ferroviaria. Consigliate finestre fonoassorbenti."
        },
        "db_very_loud": {
          "label": "Molto rumoroso (≥75 dB)",
          "description": "Autostrada o aeroporto. Abitare solo con misure complete di isolamento acustico."
        },
        "unknown": {
          "label": "Classificazione sconosciuta",
          "description": "Il valore del rumore non ha potuto essere classificato chiaramente."
        }
      },
      "hazardClassify": {
        "none": {
          "label": "Nessun pericolo",
          "description": "Nessun registro di pericoli naturali — nessun rischio noto."
        },
        "low": {
          "label": "Basso",
          "description": "Rischio minimo. Nessuna misura di protezione particolare richiesta."
        },
        "medium": {
          "label": "Medio",
          "description": "Frana, caduta massi o inondazione possibili. Verificare la copertura assicurativa."
        },
        "high": {
          "label": "Notevole",
          "description": "Possibili misure di protezione o prescrizioni ufficiali. Considerare l'impatto sul valore."
        },
        "severe": {
          "label": "Elevato",
          "description": "Divieto di costruzione o prescrizioni severe probabili. Da prevedere una significativa decurtazione del valore."
        },
        "unknown": {
          "label": "Classificazione sconosciuta",
          "description": "Il valore di pericolo naturale non ha potuto essere classificato chiaramente."
        }
      },
      "earthquakeClassify": {
        "z1": {
          "label": "Zona sismica bassa (Z1)",
          "description": "Minor pericolo in Svizzera. Costruzione standard sufficiente."
        },
        "z2": {
          "label": "Zona sismica moderata (Z2)",
          "description": "Maggiori requisiti costruttivi secondo SIA 261."
        },
        "z3a": {
          "label": "Zona sismica elevata (Z3a)",
          "description": "Richiesto dimensionamento più severo — possibili costi di costruzione più alti."
        },
        "z3b": {
          "label": "Zona sismica molto elevata (Z3b)",
          "description": "Massimo pericolo svizzero (Vallese, Basilea). Costruzione antisismica obbligatoria."
        }
      },
      "groundwaterClassify": {
        "none": {
          "label": "Nessuna zona di protezione",
          "description": "Nessuna restrizione di protezione delle acque sotterranee per costruzione o ristrutturazione."
        },
        "au": {
          "label": "Settore di protezione Au",
          "description": "Settore di protezione generale per acque sotterranee utilizzabili. Requisiti lievi per progetti edilizi."
        },
        "s3": {
          "label": "Zona di protezione S3",
          "description": "Zona di protezione esterna — restrizioni su scavo, infiltrazione e stoccaggio di sostanze inquinanti."
        },
        "s2": {
          "label": "Zona di protezione S2",
          "description": "Zona di protezione interna — requisiti significativi, la maggior parte delle costruzioni richiede autorizzazione."
        },
        "s1": {
          "label": "Zona di captazione S1",
          "description": "Area diretta attorno al captaggio dell'acqua potabile. Praticamente divieto di costruzione."
        },
        "unknown": {
          "label": "Classificazione sconosciuta",
          "description": "La zona di protezione delle acque sotterranee non ha potuto essere classificata chiaramente."
        }
      },
      "co2Classify": {
        "neutral": {
          "label": "Neutro in CO₂",
          "description": "Energia rinnovabile (pompa di calore, teleriscaldamento, legna). Nessuna necessità di ristrutturazione dovuta alla CO₂."
        },
        "low": {
          "label": "Basse emissioni",
          "description": "Sotto la media svizzera — nessun obbligo di ristrutturazione a breve termine previsto."
        },
        "high": {
          "label": "Emissioni elevate",
          "description": "Tipico di riscaldamento a olio o gas. Legge sul CO₂: obbligo di ristrutturazione previsto nei prossimi anni."
        },
        "unknown": {
          "label": "Emissioni sconosciute",
          "description": "Il valore di CO₂ non ha potuto essere classificato chiaramente."
        }
      },
      "co2Tone": {
        "green": "Basse emissioni di CO₂ (rinnovabile)",
        "yellow": "Emissioni di CO₂ moderate",
        "red": "Emissioni di CO₂ elevate",
        "gray": "Emissioni di CO₂ sconosciute"
      },
      "hazardTone": {
        "green": "Basso",
        "yellow": "Moderato",
        "red": "Elevato / Notevole",
        "gray": "Sconosciuto"
      },
      "noiseTone": {
        "green": "Tranquillo",
        "yellow": "Moderato",
        "red": "Rumoroso",
        "gray": "Sconosciuto"
      },
      "zoneRegulationsDocuments": "Documenti normativi",
      "zoneRegulationsDocument": "Documento",
      "minergie": {
        "none": "Nessun certificato"
      },
      "oevClassify": {
        "a": {
          "label": "TP A (ottima)",
          "description": "Ottimo collegamento — tram o stazione ad alta frequenza nelle immediate vicinanze (posizione urbana di pregio)."
        },
        "b": {
          "label": "TP B (buona)",
          "description": "Buon collegamento — orario denso a breve distanza a piedi. Tipico di quartieri urbani ben serviti."
        },
        "c": {
          "label": "TP C (media)",
          "description": "Collegamento medio — bus o treno con frequenza circa oraria."
        },
        "d": {
          "label": "TP D (scarsa)",
          "description": "Collegamento scarso — poche corse al giorno. L'auto è di fatto necessaria."
        },
        "e": {
          "label": "TP E (marginale)",
          "description": "Collegamento marginale — quasi nessun trasporto pubblico. Posizione periferica o rurale."
        },
        "none": {
          "label": "Nessun collegamento TP",
          "description": "Nessun trasporto pubblico a distanza utile."
        },
        "unknown": {
          "label": "Classe TP sconosciuta",
          "description": "La classe di qualità TP non ha potuto essere determinata chiaramente."
        }
      },
      "bauzoneInfo": {
        "wohnen": "Zone residenziali — destinate principalmente all'abitazione (da bassi a più piani).",
        "arbeit": "Zone di lavoro — per industria, artigianato e servizi. L'abitazione è di solito limitata.",
        "misch": "Zone miste — abitazione e attività moderatamente disturbanti ammesse in egual misura.",
        "zentrum": "Zone di centro — zone centrali e di città vecchia ad alta densità e carattere urbano.",
        "oeffentlich": "Zone d'utilità pubblica — scuole, amministrazione, ospedali, impianti sportivi.",
        "tourismus": "Zone turistiche e per il tempo libero — alberghi, resort, sport e svago.",
        "eingeschraenkt": "Zone edificabili limitate — p. es. agglomerati o oggetti protetti con edificazione limitata.",
        "generic": "Categoria di zona edificabile secondo la statistica federale delle zone edificabili (ARE)."
      },
      "links": {
        "googleMaps": "Apri Google Maps",
        "geoAdmin": "Fonte: map.geo.admin.ch",
        "geodienste": "Fonte: geodienste.ch",
        "housingStat": "Fonte: housing-stat.ch (REE)",
        "cadastre": "Fonte: cadastre.ch",
        "oereb": "Fonte: Catasto RDPP",
        "bfs": "Fonte: UST",
        "bafu": "Fonte: UFAM (catasto CO₂)",
        "minergie": "Fonte: minergie.ch",
        "sonnendach": "Fonte: sonnendach.ch",
        "estv": "Fonte: AFC calcolatore d'imposta",
        "bauzone": "Fonte: ARE statistica zone edificabili",
        "oevQuality": "Fonte: ARE classi di qualità TP"
      }
    },
    "ai": {
      "upload": {
        "title": "Carica documenti per l'acquisizione IA",
        "subtitle": "Carica la documentazione di vendita, estratti del registro fondiario, planimetrie o immagini — l'IA compila quindi automaticamente le schede successive.",
        "dragDrop": "Trascina i file qui o fai clic",
        "hint": "PDF, immagini o documenti Office (max. 250 MB per file)",
        "chooseFiles": "Scegli file",
        "chooseDirectory": "Scegli cartella",
        "noSupportedInDirectory": "Nessun file supportato trovato nella cartella (PDF, immagini o documenti Office)",
        "selectedFiles": "{{count}} file selezionato(i)",
        "removeFile": "Rimuovi {{name}}",
        "fileTooLarge": "{{name}}: file troppo grande (max. 250 MB)",
        "startButton": "Avvia acquisizione IA",
        "starting": "Caricamento…",
        "started": "Analisi avviata",
        "uploadFailed": "Caricamento non riuscito",
        "startHint": "L'analisi viene eseguita in background — il progresso è mostrato qui.",
        "attachImagesLabel": "Aggiungi le immagini dei documenti alla galleria",
        "attachImagesHint": "Disattivato per impostazione predefinita — più veloce, l'IA non analizza le foto quando le immagini sono disattivate. È meglio caricare le immagini dell'immobile separatamente."
      },
      "processing": {
        "title": "L'IA sta elaborando i documenti",
        "hint": "Attendere — il risultato apparirà automaticamente."
      },
      "result": {
        "title": "Acquisizione completata",
        "subtitle": "Controlla il riepilogo e accetta i dati.",
        "confidenceLabel": "Affidabilità",
        "documentsLabel": "Documenti rilevati",
        "imagesLabel": "Immagini",
        "warningsLabel": "{{count}} avviso(i)",
        "warningsMore": "+{{count}} altri…",
        "confirmButton": "Accetta dati e continua",
        "confirming": "Creazione…",
        "confirmed": "Immobile creato — {{count}} campi compilati.",
        "confirmedRecovered": "L'oggetto #{{id}} è stato creato (la connessione si è interrotta brevemente).",
        "confirmFailed": "Impossibile accettare i dati",
        "cancelButton": "Scarta e ricomincia"
      },
      "failed": {
        "title": "Acquisizione IA non riuscita",
        "retryButton": "Ricomincia"
      },
      "history": {
        "title": "Cronologia acquisizione IA",
        "subtitle": "I seguenti job IA hanno fornito dati a questo immobile.",
        "empty": "Nessuna acquisizione IA per questo immobile.",
        "loadFailed": "Impossibile caricare la cronologia.",
        "editNoUploadHint": "In modalità modifica non è possibile un nuovo caricamento IA. Usa le schede successive per aggiungere dati manualmente.",
        "openInJobs": "Apri in Job IA",
        "jobLabel": "Job #{{id}}",
        "summary": "{{docs}} documento(i) · {{date}}",
        "confidenceLabel": "Affidabilità:"
      }
    },
    "save": {
      "idle": "Sincronizzato",
      "pending": "Modifiche in sospeso",
      "saving": "Salvataggio…",
      "saved": "Salvato",
      "error": "Salvataggio non riuscito"
    },
    "aiHints": {
      "title": "Note IA",
      "toggleAria": "Mostra o nascondi le note IA"
    },
    "pricing": {
      "groups": {
        "pricing": "Prezzi & Condizioni",
        "rentSituation": "Situazione locativa",
        "rentSituationToggle": "Mostra o nascondi la situazione locativa"
      },
      "sections": {
        "financialKpis": "Indicatori finanziari",
        "unitMix": "Mix delle unità",
        "rentRoll": "Stato locativo"
      },
      "tablesUnavailableInCreateMode": "Il mix delle unità e lo stato locativo possono essere modificati dopo il primo salvataggio.",
      "unitMixSellerHint": "Il mix delle unità è gestito dal broker — sola lettura qui.",
      "rentRollSellerHint": "Puoi aggiornare tu stesso lo stato locativo — ricordati di salvare dopo le modifiche.",
      "saveUnitMix": "Salva mix delle unità",
      "saveRentRoll": "Salva stato locativo",
      "noUnitMix": "Nessuna voce nel mix delle unità.",
      "noRentRoll": "Nessuna voce nello stato locativo."
    },
    "media": {
      "requiresProperty": "Salva prima i dati di base — successivamente potrai caricare i media.",
      "images": {
        "title": "Immagini",
        "hint": "Contrassegna l'immagine principale e riordina le altre con drag & drop. Visualizzazioni, foto, planimetrie e mappe vengono raggruppate automaticamente.",
        "noFilterMatch": "Nessuna immagine corrisponde al filtro selezionato.",
        "filters": {
          "ariaLabel": "Filtra le immagini per tipo",
          "all": "Tutte",
          "photo": "Foto",
          "visualisierung": "Visualizzazioni",
          "plan": "Planimetrie",
          "karte": "Mappe",
          "other": "Altri"
        },
        "teaser": {
          "teaserOption": "Teaser",
          "ndaOption": "Solo NDA",
          "toggleAria": "Visibilità teaser",
          "riskBadge": "Posizione",
          "riskTitle": "Permette di dedurre la posizione esatta",
          "confirmUpgrade": "Questa immagine rivela la posizione. Mostrarla comunque nel teaser (prima dell’NDA)?",
          "confirmYes": "Mostra comunque",
          "captionEmpty": "Nessuna descrizione IA",
          "showFull": "Mostra descrizione completa",
          "summaryTeaser": "{{count}} nel teaser",
          "summaryNda": "{{count}} solo NDA",
          "summaryRisk": "{{count}} con rischio posizione",
          "previewToggle": "Anteprima teaser",
          "previewHint": "Mostra solo le immagini visibili agli acquirenti senza NDA",
          "previewEmpty": "Nessuna immagine è abilitata per il teaser."
        },
        "mediumLabels": {
          "photo": "Foto",
          "visualisierung": "3D",
          "plan": "Plan.",
          "karte": "Mappa",
          "scan": "Scan",
          "logo": "Logo"
        },
        "subjectLabels": {
          "fassade": "Facciata",
          "wohnraum": "Soggiorno",
          "kueche": "Cucina",
          "bad": "Bagno",
          "schlafzimmer": "Camera",
          "buero": "Ufficio",
          "treppenhaus": "Vano scale",
          "keller": "Cantina",
          "garten": "Giardino",
          "umgebung": "Dintorni",
          "luftbild": "Vista aerea",
          "grundriss": "Planimetria",
          "schnitt": "Sezione",
          "ansicht": "Prospetto",
          "lageplan": "Planimetria area"
        }
      },
      "dossier": {
        "title": "Documenti del dossier",
        "hint": "Carica i documenti di vendita per categoria (registro fondiario, trasferimento, …)."
      },
      "accessLog": {
        "title": "Registro degli accessi",
        "hint": "Chi ha visualizzato o scaricato quale documento e quando — prova per l'accordo di riservatezza.",
        "count": "{{count}} accessi registrati",
        "filterLabel": "Acquirente",
        "filterAll": "Tutti gli acquirenti",
        "empty": "Nessun accesso ai documenti registrato finora.",
        "loadError": "Impossibile caricare il registro degli accessi.",
        "pageOf": "Pagina {{page}} di {{total}}",
        "typeDownload": "Download",
        "typePreview": "Anteprima",
        "typePreviewPage": "Anteprima pagina {{page}}",
        "mayanDocument": "Documento {{id}}",
        "columns": {
          "time": "Ora",
          "buyer": "Acquirente",
          "document": "Documento",
          "type": "Tipo",
          "ip": "IP"
        }
      },
      "identifyLeak": {
        "button": "Attribuisci la fuga",
        "title": "Attribuisci la fuga",
        "description": "Carica il file divulgato — l'impronta invisibile rivela quale acquirente lo ha ricevuto.",
        "fileLabel": "File divulgato",
        "fileHint": "Immagine o PDF, massimo 30 MB. Funziona anche con estratti o copie compresse.",
        "submit": "Attribuisci",
        "tooLarge": "Il file è troppo grande (massimo 30 MB).",
        "error": "Attribuzione non riuscita. Riprovare.",
        "resultFound": "Appartiene a: {{buyer}}, {{document}}, {{time}}",
        "resultNotFound": "Nessuna impronta trovata.",
        "unknownDocument": "Documento sconosciuto"
      },
      "immotron": {
        "title": "Documenti Immotron",
        "hint": "Documenti generati dal sistema — visibili solo internamente."
      },
      "highlights": {
        "title": "Punti forti e descrizione",
        "hint": "Mostra al massimo 5 punti forti — riordina con drag & drop."
      },
      "vrTour": {
        "title": "Tour virtuale e link",
        "hint": "Incolla un URL esterno del tour (Matterport, Kuula, …)."
      },
      "translations": {
        "title": "Traduzioni",
        "hint": "Mantieni i testi in DE/EN/FR/IT — i campi vuoti possono essere tradotti automaticamente.",
        "cards": {
          "title": "Titolo",
          "description": "Descrizione",
          "location": "Posizione"
        },
        "placeholders": {
          "name": "es. Edificio residenziale e commerciale Zurigo-Seefeld",
          "subheader": "es. Posizione di prima classe nel quartiere degli affari",
          "highlights": "es. • Completamente affittato • Ristrutturato nel 2021 • Trasporti pubblici classe A",
          "description": "Descrizione dettagliata dell'immobile: posizione, stato, dotazione, particolarità e possibilità d'uso ...",
          "macro": "es. Posizione centrale nella città di Zurigo, area economica consolidata ...",
          "micro": "es. Tranquilla via laterale, negozi e trasporti pubblici a distanza pedonale ..."
        },
        "aiBadge": "Suggerimento IA",
        "aiTitle": "Questo testo è stato suggerito dall'IA. Modificalo per rimuovere l'indicazione.",
        "translated": "Tradotto",
        "notTranslated": "Non tradotto",
        "copyFromMaster": "Copia da DE",
        "reference": "Versione originale tedesca",
        "charCount": "{{count}} caratteri",
        "charCountMax": "{{count}}/{{max}} caratteri"
      }
    },
    "object": {
      "sections": {
        "classification": "Classificazione e stato",
        "address": "Indirizzo e ubicazione",
        "land": "Terreno",
        "building": "Edificio",
        "energy": "Energia e condizioni"
      },
      "fields": {
        "dealState": "Stato della trattativa",
        "dealStateNotSet": "Non definito",
        "inhabitants": "Abitanti (comune)",
        "coordinates": "Coordinate",
        "minGroundFloorHeight": "Altezza min. piano terra",
        "egidNumber": "Numero EGID (identificatore edificio)",
        "egidPlaceholder": "p.es. 100123456",
        "energyClassPlaceholder": "p.es. A, B, C…"
      },
      "noSubtypes": "Nessun sottotipo disponibile per questo tipo."
    },
    "review": {
      "sections": {
        "auftraggeber": "Mandante",
        "sales": "Configurazione vendite",
        "listing": "Configurazione annuncio",
        "qualityGate": "Quality gate",
        "timeline": "Timeline del deal"
      },
      "timeline": {
        "subtitle": "Fase attuale e attività in un colpo d'occhio."
      },
      "auftraggeber": {
        "subtitle": "Chi ha conferito il mandato di commercializzazione?",
        "contactLabel": "Mandante",
        "contactPlaceholder": "Cerca un contatto esistente…",
        "contactHint": "Utilizzato nel mandato di commercializzazione e nei contratti.",
        "sellerReadOnly": "Questi dati sono gestiti dal broker.",
        "notSet": "Non ancora definito",
        "searchButton": "Cerca contratto",
        "changeButton": "Modifica contratto",
        "removeButton": "Rimuovi",
        "removeConfirmTitle": "Rimuovere il mandante?",
        "removeConfirmText": "«{{name}}» verrà rimosso come mandante di questo immobile. I contratti esistenti restano validi; è possibile collegare un nuovo mandante in qualsiasi momento.",
        "removeConfirmTextNoName": "Il mandante verrà rimosso da questo immobile. I contratti esistenti restano validi; è possibile collegare un nuovo mandante in qualsiasi momento.",
        "removeSuccess": "Mandante rimosso",
        "removeFailed": "Non è stato possibile rimuovere il mandante",
        "saveFirstHint": "Salvare prima l'immobile per collegare un mandante."
      },
      "sales": {
        "subtitle": "Consulente responsabile e durata del mandato.",
        "salesUserLabel": "Consulente responsabile",
        "salesUserPlaceholder": "Seleziona un consulente…",
        "saleStartDate": "Inizio del mandato",
        "saleEndDate": "Fine del mandato",
        "assignedTo": "Attualmente assegnato: {{name}}"
      },
      "listing": {
        "subtitle": "Visibilità e impostazioni di pubblicazione.",
        "privateLabel": "Annuncio privato",
        "privateHint": "Solo gli investitori o gruppi selezionati vedono questo immobile.",
        "expirationLabel": "L'annuncio scade il",
        "expirationHint": "Dopo questa data l'annuncio viene disattivato automaticamente.",
        "investorGroupHint": "Gestisci l'accesso di investitori e gruppi nella pagina di dettaglio dell'immobile.",
        "openDetailPage": "Apri pagina di dettaglio"
      },
      "qualityGate": {
        "subtitle": "Stato e invio per la verifica interna.",
        "statusLabel": "Stato attuale",
        "submitButton": "Invia per la verifica",
        "submitting": "Invio in corso…",
        "submitted": "Inviato per la verifica.",
        "submitFailed": "Invio non riuscito. Riprova.",
        "submitHint": "Dopo l'invio un membro interno del team verifica l'immobile.",
        "inReviewHint": "L'immobile è in fase di verifica. Puoi continuare ad aggiornare i dati fino alla decisione.",
        "sellerStateHint": "Lo stato attuale è gestito dal broker.",
        "submittedAt": "Inviato il {{date}}",
        "reviewedAt": "Verificato il {{date}}",
        "rejectedTitle": "Motivo del rifiuto",
        "rejectedHint": "Correggi i punti indicati e invia di nuovo."
      }
    },
    "aiInsights": {
      "title": "Note IA",
      "description": "Tutte le informazioni IA su questo immobile in un unico posto: note dall'estrazione, registro di estrazione e conoscenza appuntata.",
      "sectionsAriaLabel": "Note IA: sezioni",
      "warningIndicatorAria": "Contiene avvertenze",
      "sections": {
        "hints": {
          "label": "Note",
          "description": "Note dall'estrazione IA (proprietari, servitù, pegni immobiliari, conflitti). Le voci con ⚠️ sono evidenziate.",
          "empty": "Nessuna nota IA disponibile per questo immobile."
        },
        "protocol": {
          "label": "Registro di estrazione"
        },
        "knowledge": {
          "label": "Conoscenza",
          "description": "Note appuntate a questo immobile dalle pendenze."
        }
      }
    }
  },
  "knowledgeBoard": {
    "pageTitle": "Disporre le note",
    "pageSubtitle": "Trascina le note dalla ricerca all'area obiettivo e riordinale.",
    "instructions": "Trascina e rilascia — oppure usa spazio / frecce per la tastiera.",
    "reset": "Reimposta",
    "sourceTitle": "Ricerca",
    "sourceHint": "Pool di note raccolte.",
    "sourceEmpty": "Nessun'altra nota nella ricerca.",
    "targetTitle": "Obiettivo",
    "targetHint": "Area di lavoro — rilascia e ordina le note qui.",
    "targetEmpty": "Trascina una nota qui per aggiungerla all'obiettivo.",
    "dragHandle": "Trascina la nota «{{title}}»",
    "a11y": {
      "start": "Nota {{id}} presa.",
      "over": "Nota {{id}} sopra {{target}}.",
      "outside": "Nota {{id}} fuori da un'area valida.",
      "end": "Nota {{id}} rilasciata su {{target}}.",
      "cancel": "Spostamento della nota {{id}} annullato."
    },
    "samples": {
      "market": {
        "title": "Analisi di mercato Zurigo Ovest",
        "summary": "Il prezzo medio al m² è salito del 3,2 % nell'ultimo trimestre a CHF 11'400.",
        "source": "Ricerca · Dati di mercato"
      },
      "location": {
        "title": "Valutazione quartiere industriale",
        "summary": "Ottimi collegamenti pubblici, riqualificazione prevista con nuovo parco urbano.",
        "source": "Ricerca · Posizione"
      },
      "zefix": {
        "title": "Profilo azienda Musterhaus AG",
        "summary": "Attiva dal 1998, 24 dipendenti, settore costruzione e ristrutturazione.",
        "source": "Zefix"
      },
      "news": {
        "title": "News: nuova linea tram 17 dal 2027",
        "summary": "Collegamento diretto con la stazione centrale — probabile rivalutazione degli immobili lungo il corridoio.",
        "source": "Ricerca · Notizie"
      }
    }
  },
  "buyerSearch": {
    "placeholder": "Cerca nome, azienda o e-mail …",
    "hint": "Inserire almeno 2 caratteri per cercare contatti, aziende nel CRM e nel registro di commercio.",
    "empty": "Nessun risultato trovato nel CRM né nel registro di commercio.",
    "searchFailed": "Ricerca non riuscita. Riprovare.",
    "assign": "Assegna",
    "assignFailed": "Assegnazione non riuscita",
    "alreadyAssigned": "Assegnato",
    "typeContact": "Contatto",
    "typeCompany": "Azienda",
    "statusActive": "Attivo",
    "statusPending": "Onboarding necessario",
    "zefixBadge": "Zefix",
    "createFromZefix": "Crea azienda",
    "createdFromZefix": "{{name}} e {{count}} persone create",
    "createFromZefixFailed": "Impossibile creare l’azienda",
    "noZefixHint": "Non nel registro di commercio?",
    "noZefixHintLink": "Crea una nuova organizzazione nel CRM",
    "inactiveAt": "inattivo presso {{company}}",
    "inactiveAssignBlocked": "Ruolo presso {{company}} terminato",
    "noEmailAssignBlocked": "Nessun indirizzo e-mail — non assegnabile"
  },
  "emailConflict": {
    "duplicateContactTitle": "E-mail già associata a un contatto",
    "duplicateCompanyTitle": "E-mail già associata a un'organizzazione",
    "existingEntry": "Voce esistente",
    "switchToContact": "Vai al contatto",
    "switchToCompany": "Vai all'organizzazione",
    "merge": "Unisci",
    "mergeTitle": "Unisci contatti",
    "matchReasonEmail": "Stesso indirizzo e-mail",
    "genericTitle": "Indirizzo generico — trasferirlo all'organizzazione?",
    "genericDescription": "Questo indirizzo appartiene a un'organizzazione, non a una singola persona.",
    "moveToCompany": "Trasferisci a {{name}}",
    "moveToCompanyHint": "L'indirizzo viene registrato presso l'organizzazione e rimosso dal contatto.",
    "saveAnyway": "Salva comunque",
    "noCompany": "Questo contatto non è associato a nessuna organizzazione.",
    "movedToCompany": "E-mail trasferita all'organizzazione",
    "moveFailed": "Trasferimento all'organizzazione non riuscito"
  }
}
